import {isUserHasScan, processQRCode, ensureTokenAndQRCode } from './vtoUtils.js';
import { productPageScanInit } from './product-scan.js';
import { buildQueryParams } from './utils.js';
import {
  getCustomerScan,
  getCustomerGuestId,
  setPrescription,
  getPrescription,
  setDefaultPrescription,
  getWishlist,
  getCollection,
  getVTOModels,
  deleteAccount
} from './proxyApp.js';
import ImageLightbox from './imageLightbox.js';
import {TabsManager} from './tabs-manager.js';

let customCatalog;
let productScan;
let vtoPopupInit;
let vtoModels;
let prescriptionFlow;
let productCounter=0;
let scanBySku;

function ownKeys$1(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2$1(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys$1(Object(source), !0).forEach(function (key) {
      _defineProperty$1(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$1(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}

function _defineProperty$1(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _toConsumableArray$1(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

var SECTION_ID_ATTR$1 = 'data-section-id';

function Section(container, properties) {
  this.container = validateContainerElement(container);
  this.id = container.getAttribute(SECTION_ID_ATTR$1);
  this.extensions = [];

  // eslint-disable-next-line es5/no-es6-static-methods
  Object.assign(this, validatePropertiesObject(properties));

  this.onLoad();
}

Section.prototype = {
  onLoad: Function.prototype,
  onUnload: Function.prototype,
  onSelect: Function.prototype,
  onDeselect: Function.prototype,
  onBlockSelect: Function.prototype,
  onBlockDeselect: Function.prototype,

  extend: function extend(extension) {
    this.extensions.push(extension); // Save original extension

    // eslint-disable-next-line es5/no-es6-static-methods
    var extensionClone = Object.assign({}, extension);
    delete extensionClone.init; // Remove init function before assigning extension properties

    // eslint-disable-next-line es5/no-es6-static-methods
    Object.assign(this, extensionClone);

    if (typeof extension.init === 'function') {
      extension.init.apply(this);
    }
  }
};

function validateContainerElement(container) {
  if (!(container instanceof Element)) {
    throw new TypeError(
      'Theme Sections: Attempted to load section. The section container provided is not a DOM element.'
    );
  }
  if (container.getAttribute(SECTION_ID_ATTR$1) === null) {
    throw new Error(
      'Theme Sections: The section container provided does not have an id assigned to the ' +
        SECTION_ID_ATTR$1 +
        ' attribute.'
    );
  }

  return container;
}

function validatePropertiesObject(value) {
  if (
    (typeof value !== 'undefined' && typeof value !== 'object') ||
    value === null
  ) {
    throw new TypeError(
      'Theme Sections: The properties object provided is not a valid'
    );
  }

  return value;
}

// Object.assign() polyfill from https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/assign#Polyfill
if (typeof Object.assign != 'function') {
  // Must be writable: true, enumerable: false, configurable: true
  Object.defineProperty(Object, 'assign', {
    value: function assign(target) {
      if (target == null) {
        // TypeError if undefined or null
        throw new TypeError('Cannot convert undefined or null to object');
      }

      var to = Object(target);

      for (var index = 1; index < arguments.length; index++) {
        var nextSource = arguments[index];

        if (nextSource != null) {
          // Skip over if undefined or null
          for (var nextKey in nextSource) {
            // Avoid bugs when hasOwnProperty is shadowed
            if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
              to[nextKey] = nextSource[nextKey];
            }
          }
        }
      }
      return to;
    },
    writable: true,
    configurable: true
  });
}

/*
 * @shopify/theme-sections
 * -----------------------------------------------------------------------------
 *
 * A framework to provide structure to your Shopify sections and a load and unload
 * lifecycle. The lifecycle is automatically connected to theme editor events so
 * that your sections load and unload as the editor changes the content and
 * settings of your sections.
 */

var SECTION_TYPE_ATTR = 'data-section-type';
var SECTION_ID_ATTR = 'data-section-id';

window.Shopify = window.Shopify || {};
window.Shopify.theme = window.Shopify.theme || {};
window.Shopify.theme.sections = window.Shopify.theme.sections || {};

var registered = (window.Shopify.theme.sections.registered =
  window.Shopify.theme.sections.registered || {});
var instances = (window.Shopify.theme.sections.instances =
  window.Shopify.theme.sections.instances || []);

function register(type, properties) {
  if (typeof type !== 'string') {
    throw new TypeError(
      'Theme Sections: The first argument for .register must be a string that specifies the type of the section being registered'
    );
  }

  if (typeof registered[type] !== 'undefined') {
    throw new Error(
      'Theme Sections: A section of type "' +
        type +
        '" has already been registered. You cannot register the same section type twice'
    );
  }

  function TypedSection(container) {
    Section.call(this, container, properties);
  }

  TypedSection.constructor = Section;
  TypedSection.prototype = Object.create(Section.prototype);
  TypedSection.prototype.type = type;

  return (registered[type] = TypedSection);
}

function load(types, containers) {
  types = normalizeType(types);

  if (typeof containers === 'undefined') {
    containers = document.querySelectorAll('[' + SECTION_TYPE_ATTR + ']');
  }

  containers = normalizeContainers(containers);

  types.forEach(function(type) {
    var TypedSection = registered[type];

    if (typeof TypedSection === 'undefined') {
      return;
    }

    containers = containers.filter(function(container) {
      // Filter from list of containers because container already has an instance loaded
      if (isInstance(container)) {
        return false;
      }

      // Filter from list of containers because container doesn't have data-section-type attribute
      if (container.getAttribute(SECTION_TYPE_ATTR) === null) {
        return false;
      }

      // Keep in list of containers because current type doesn't match
      if (container.getAttribute(SECTION_TYPE_ATTR) !== type) {
        return true;
      }

      instances.push(new TypedSection(container));

      // Filter from list of containers because container now has an instance loaded
      return false;
    });
  });
}

function unload(selector) {
  var instancesToUnload = getInstances(selector);

  instancesToUnload.forEach(function(instance) {
    var index = instances
      .map(function(e) {
        return e.id;
      })
      .indexOf(instance.id);
    instances.splice(index, 1);
    instance.onUnload();
  });
}

function getInstances(selector) {
  var filteredInstances = [];

  // Fetch first element if its an array
  if (NodeList.prototype.isPrototypeOf(selector) || Array.isArray(selector)) {
    var firstElement = selector[0];
  }

  // If selector element is DOM element
  if (selector instanceof Element || firstElement instanceof Element) {
    var containers = normalizeContainers(selector);

    containers.forEach(function(container) {
      filteredInstances = filteredInstances.concat(
        instances.filter(function(instance) {
          return instance.container === container;
        })
      );
    });

    // If select is type string
  } else if (typeof selector === 'string' || typeof firstElement === 'string') {
    var types = normalizeType(selector);

    types.forEach(function(type) {
      filteredInstances = filteredInstances.concat(
        instances.filter(function(instance) {
          return instance.type === type;
        })
      );
    });
  }

  return filteredInstances;
}

function getInstanceById(id) {
  var instance;

  for (var i = 0; i < instances.length; i++) {
    if (instances[i].id === id) {
      instance = instances[i];
      break;
    }
  }
  return instance;
}

function isInstance(selector) {
  return getInstances(selector).length > 0;
}

function normalizeType(types) {
  // If '*' then fetch all registered section types
  if (types === '*') {
    types = Object.keys(registered);

    // If a single section type string is passed, put it in an array
  } else if (typeof types === 'string') {
    types = [types];

    // If single section constructor is passed, transform to array with section
    // type string
  } else if (types.constructor === Section) {
    types = [types.prototype.type];

    // If array of typed section constructors is passed, transform the array to
    // type strings
  } else if (Array.isArray(types) && types[0].constructor === Section) {
    types = types.map(function(TypedSection) {
      return TypedSection.prototype.type;
    });
  }

  types = types.map(function(type) {
    return type.toLowerCase();
  });

  return types;
}

function normalizeContainers(containers) {
  // Nodelist with entries
  if (NodeList.prototype.isPrototypeOf(containers) && containers.length > 0) {
    containers = Array.prototype.slice.call(containers);

    // Empty Nodelist
  } else if (
    NodeList.prototype.isPrototypeOf(containers) &&
    containers.length === 0
  ) {
    containers = [];

    // Handle null (document.querySelector() returns null with no match)
  } else if (containers === null) {
    containers = [];

    // Single DOM element
  } else if (!Array.isArray(containers) && containers instanceof Element) {
    containers = [containers];
  }

  return containers;
}

if (window.Shopify.designMode) {
  document.addEventListener('shopify:section:load', function(event) {
    var id = event.detail.sectionId;
    var container = event.target.querySelector(
      '[' + SECTION_ID_ATTR + '="' + id + '"]'
    );

    if (container !== null) {
      load(container.getAttribute(SECTION_TYPE_ATTR), container);
    }
  });

  document.addEventListener('shopify:section:unload', function(event) {
    var id = event.detail.sectionId;
    var container = event.target.querySelector(
      '[' + SECTION_ID_ATTR + '="' + id + '"]'
    );
    var instance = getInstances(container)[0];

    if (typeof instance === 'object') {
      unload(container);
    }
  });

  document.addEventListener('shopify:section:select', function(event) {
    var instance = getInstanceById(event.detail.sectionId);

    if (typeof instance === 'object') {
      instance.onSelect(event);
    }
  });

  document.addEventListener('shopify:section:deselect', function(event) {
    var instance = getInstanceById(event.detail.sectionId);

    if (typeof instance === 'object') {
      instance.onDeselect(event);
    }
  });

  document.addEventListener('shopify:block:select', function(event) {
    var instance = getInstanceById(event.detail.sectionId);

    if (typeof instance === 'object') {
      instance.onBlockSelect(event);
    }
  });

  document.addEventListener('shopify:block:deselect', function(event) {
    var instance = getInstanceById(event.detail.sectionId);

    if (typeof instance === 'object') {
      instance.onBlockDeselect(event);
    }
  });
}

function n$2(n,t){return void 0===t&&(t=document),t.querySelector(n)}function t$2(n,t){return void 0===t&&(t=document),[].slice.call(t.querySelectorAll(n))}function c$1(n,t){return Array.isArray(n)?n.forEach(t):t(n)}function r$2(n){return function(t,r,e){return c$1(t,function(t){return t[n+"EventListener"](r,e)})}}function e$2(n,t,c){return r$2("add")(n,t,c),function(){return r$2("remove")(n,t,c)}}function o$2(n){return function(t){var r=arguments;return c$1(t,function(t){var c;return (c=t.classList)[n].apply(c,[].slice.call(r,1))})}}function u$1(n){o$2("add").apply(void 0,[n].concat([].slice.call(arguments,1)));}function i$1(n){o$2("remove").apply(void 0,[n].concat([].slice.call(arguments,1)));}function l(n){o$2("toggle").apply(void 0,[n].concat([].slice.call(arguments,1)));}function a$1(n,t){return n.classList.contains(t)}

function getDefaultExportFromCjs (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

var isMobile$2 = {exports: {}};

isMobile$2.exports = isMobile;
isMobile$2.exports.isMobile = isMobile;
isMobile$2.exports.default = isMobile;

var mobileRE = /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series[46]0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i;

var tabletRE = /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series[46]0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino|android|ipad|playbook|silk/i;

function isMobile (opts) {
  if (!opts) opts = {};
  var ua = opts.ua;
  if (!ua && typeof navigator !== 'undefined') ua = navigator.userAgent;
  if (ua && ua.headers && typeof ua.headers['user-agent'] === 'string') {
    ua = ua.headers['user-agent'];
  }
  if (typeof ua !== 'string') return false

  var result = opts.tablet ? tabletRE.test(ua) : mobileRE.test(ua);

  if (
    !result &&
    opts.tablet &&
    opts.featureDetect &&
    navigator &&
    navigator.maxTouchPoints > 1 &&
    ua.indexOf('Macintosh') !== -1 &&
    ua.indexOf('Safari') !== -1
  ) {
    result = true;
  }

  return result
}

var isMobile$1 = isMobile$2.exports;

var browser = {exports: {}};

(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

/**
 * DOM event delegator
 *
 * The delegator will listen
 * for events that bubble up
 * to the root node.
 *
 * @constructor
 * @param {Node|string} [root] The root node or a selector string matching the root node
 */
function Delegate(root) {
  /**
   * Maintain a map of listener
   * lists, keyed by event name.
   *
   * @type Object
   */
  this.listenerMap = [{}, {}];

  if (root) {
    this.root(root);
  }
  /** @type function() */


  this.handle = Delegate.prototype.handle.bind(this); // Cache of event listeners removed during an event cycle

  this._removedListeners = [];
}
/**
 * Start listening for events
 * on the provided DOM element
 *
 * @param  {Node|string} [root] The root node or a selector string matching the root node
 * @returns {Delegate} This method is chainable
 */


Delegate.prototype.root = function (root) {
  var listenerMap = this.listenerMap;
  var eventType; // Remove master event listeners

  if (this.rootElement) {
    for (eventType in listenerMap[1]) {
      if (listenerMap[1].hasOwnProperty(eventType)) {
        this.rootElement.removeEventListener(eventType, this.handle, true);
      }
    }

    for (eventType in listenerMap[0]) {
      if (listenerMap[0].hasOwnProperty(eventType)) {
        this.rootElement.removeEventListener(eventType, this.handle, false);
      }
    }
  } // If no root or root is not
  // a dom node, then remove internal
  // root reference and exit here


  if (!root || !root.addEventListener) {
    if (this.rootElement) {
      delete this.rootElement;
    }

    return this;
  }
  /**
   * The root node at which
   * listeners are attached.
   *
   * @type Node
   */


  this.rootElement = root; // Set up master event listeners

  for (eventType in listenerMap[1]) {
    if (listenerMap[1].hasOwnProperty(eventType)) {
      this.rootElement.addEventListener(eventType, this.handle, true);
    }
  }

  for (eventType in listenerMap[0]) {
    if (listenerMap[0].hasOwnProperty(eventType)) {
      this.rootElement.addEventListener(eventType, this.handle, false);
    }
  }

  return this;
};
/**
 * @param {string} eventType
 * @returns boolean
 */


Delegate.prototype.captureForType = function (eventType) {
  return ['blur', 'error', 'focus', 'load', 'resize', 'scroll'].indexOf(eventType) !== -1;
};
/**
 * Attach a handler to one
 * event for all elements
 * that match the selector,
 * now or in the future
 *
 * The handler function receives
 * three arguments: the DOM event
 * object, the node that matched
 * the selector while the event
 * was bubbling and a reference
 * to itself. Within the handler,
 * 'this' is equal to the second
 * argument.
 *
 * The node that actually received
 * the event can be accessed via
 * 'event.target'.
 *
 * @param {string} eventType Listen for these events
 * @param {string|undefined} selector Only handle events on elements matching this selector, if undefined match root element
 * @param {function()} handler Handler function - event data passed here will be in event.data
 * @param {boolean} [useCapture] see 'useCapture' in <https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener>
 * @returns {Delegate} This method is chainable
 */


Delegate.prototype.on = function (eventType, selector, handler, useCapture) {
  var root;
  var listenerMap;
  var matcher;
  var matcherParam;

  if (!eventType) {
    throw new TypeError('Invalid event type: ' + eventType);
  } // handler can be passed as
  // the second or third argument


  if (typeof selector === 'function') {
    useCapture = handler;
    handler = selector;
    selector = null;
  } // Fallback to sensible defaults
  // if useCapture not set


  if (useCapture === undefined) {
    useCapture = this.captureForType(eventType);
  }

  if (typeof handler !== 'function') {
    throw new TypeError('Handler must be a type of Function');
  }

  root = this.rootElement;
  listenerMap = this.listenerMap[useCapture ? 1 : 0]; // Add master handler for type if not created yet

  if (!listenerMap[eventType]) {
    if (root) {
      root.addEventListener(eventType, this.handle, useCapture);
    }

    listenerMap[eventType] = [];
  }

  if (!selector) {
    matcherParam = null; // COMPLEX - matchesRoot needs to have access to
    // this.rootElement, so bind the function to this.

    matcher = matchesRoot.bind(this); // Compile a matcher for the given selector
  } else if (/^[a-z]+$/i.test(selector)) {
    matcherParam = selector;
    matcher = matchesTag;
  } else if (/^#[a-z0-9\-_]+$/i.test(selector)) {
    matcherParam = selector.slice(1);
    matcher = matchesId;
  } else {
    matcherParam = selector;
    matcher = Element.prototype.matches;
  } // Add to the list of listeners


  listenerMap[eventType].push({
    selector: selector,
    handler: handler,
    matcher: matcher,
    matcherParam: matcherParam
  });
  return this;
};
/**
 * Remove an event handler
 * for elements that match
 * the selector, forever
 *
 * @param {string} [eventType] Remove handlers for events matching this type, considering the other parameters
 * @param {string} [selector] If this parameter is omitted, only handlers which match the other two will be removed
 * @param {function()} [handler] If this parameter is omitted, only handlers which match the previous two will be removed
 * @returns {Delegate} This method is chainable
 */


Delegate.prototype.off = function (eventType, selector, handler, useCapture) {
  var i;
  var listener;
  var listenerMap;
  var listenerList;
  var singleEventType; // Handler can be passed as
  // the second or third argument

  if (typeof selector === 'function') {
    useCapture = handler;
    handler = selector;
    selector = null;
  } // If useCapture not set, remove
  // all event listeners


  if (useCapture === undefined) {
    this.off(eventType, selector, handler, true);
    this.off(eventType, selector, handler, false);
    return this;
  }

  listenerMap = this.listenerMap[useCapture ? 1 : 0];

  if (!eventType) {
    for (singleEventType in listenerMap) {
      if (listenerMap.hasOwnProperty(singleEventType)) {
        this.off(singleEventType, selector, handler);
      }
    }

    return this;
  }

  listenerList = listenerMap[eventType];

  if (!listenerList || !listenerList.length) {
    return this;
  } // Remove only parameter matches
  // if specified


  for (i = listenerList.length - 1; i >= 0; i--) {
    listener = listenerList[i];

    if ((!selector || selector === listener.selector) && (!handler || handler === listener.handler)) {
      this._removedListeners.push(listener);

      listenerList.splice(i, 1);
    }
  } // All listeners removed


  if (!listenerList.length) {
    delete listenerMap[eventType]; // Remove the main handler

    if (this.rootElement) {
      this.rootElement.removeEventListener(eventType, this.handle, useCapture);
    }
  }

  return this;
};
/**
 * Handle an arbitrary event.
 *
 * @param {Event} event
 */


Delegate.prototype.handle = function (event) {
  var i;
  var l;
  var type = event.type;
  var root;
  var phase;
  var listener;
  var returned;
  var listenerList = [];
  var target;
  var eventIgnore = 'ftLabsDelegateIgnore';

  if (event[eventIgnore] === true) {
    return;
  }

  target = event.target; // Hardcode value of Node.TEXT_NODE
  // as not defined in IE8

  if (target.nodeType === 3) {
    target = target.parentNode;
  } // Handle SVG <use> elements in IE


  if (target.correspondingUseElement) {
    target = target.correspondingUseElement;
  }

  root = this.rootElement;
  phase = event.eventPhase || (event.target !== event.currentTarget ? 3 : 2); // eslint-disable-next-line default-case

  switch (phase) {
    case 1:
      //Event.CAPTURING_PHASE:
      listenerList = this.listenerMap[1][type];
      break;

    case 2:
      //Event.AT_TARGET:
      if (this.listenerMap[0] && this.listenerMap[0][type]) {
        listenerList = listenerList.concat(this.listenerMap[0][type]);
      }

      if (this.listenerMap[1] && this.listenerMap[1][type]) {
        listenerList = listenerList.concat(this.listenerMap[1][type]);
      }

      break;

    case 3:
      //Event.BUBBLING_PHASE:
      listenerList = this.listenerMap[0][type];
      break;
  }

  var toFire = []; // Need to continuously check
  // that the specific list is
  // still populated in case one
  // of the callbacks actually
  // causes the list to be destroyed.

  l = listenerList.length;

  while (target && l) {
    for (i = 0; i < l; i++) {
      listener = listenerList[i]; // Bail from this loop if
      // the length changed and
      // no more listeners are
      // defined between i and l.

      if (!listener) {
        break;
      }

      if (target.tagName && ["button", "input", "select", "textarea"].indexOf(target.tagName.toLowerCase()) > -1 && target.hasAttribute("disabled")) {
        // Remove things that have previously fired
        toFire = [];
      } // Check for match and fire
      // the event if there's one
      //
      // TODO:MCG:20120117: Need a way
      // to check if event#stopImmediatePropagation
      // was called. If so, break both loops.
      else if (listener.matcher.call(target, listener.matcherParam, target)) {
          toFire.push([event, target, listener]);
        }
    } // TODO:MCG:20120117: Need a way to
    // check if event#stopPropagation
    // was called. If so, break looping
    // through the DOM. Stop if the
    // delegation root has been reached


    if (target === root) {
      break;
    }

    l = listenerList.length; // Fall back to parentNode since SVG children have no parentElement in IE

    target = target.parentElement || target.parentNode; // Do not traverse up to document root when using parentNode, though

    if (target instanceof HTMLDocument) {
      break;
    }
  }

  var ret;

  for (i = 0; i < toFire.length; i++) {
    // Has it been removed during while the event function was fired
    if (this._removedListeners.indexOf(toFire[i][2]) > -1) {
      continue;
    }

    returned = this.fire.apply(this, toFire[i]); // Stop propagation to subsequent
    // callbacks if the callback returned
    // false

    if (returned === false) {
      toFire[i][0][eventIgnore] = true;
      toFire[i][0].preventDefault();
      ret = false;
      break;
    }
  }

  return ret;
};
/**
 * Fire a listener on a target.
 *
 * @param {Event} event
 * @param {Node} target
 * @param {Object} listener
 * @returns {boolean}
 */


Delegate.prototype.fire = function (event, target, listener) {
  return listener.handler.call(target, event, target);
};
/**
 * Check whether an element
 * matches a tag selector.
 *
 * Tags are NOT case-sensitive,
 * except in XML (and XML-based
 * languages such as XHTML).
 *
 * @param {string} tagName The tag name to test against
 * @param {Element} element The element to test with
 * @returns boolean
 */


function matchesTag(tagName, element) {
  return tagName.toLowerCase() === element.tagName.toLowerCase();
}
/**
 * Check whether an element
 * matches the root.
 *
 * @param {?String} selector In this case this is always passed through as null and not used
 * @param {Element} element The element to test with
 * @returns boolean
 */


function matchesRoot(selector, element) {
  if (this.rootElement === window) {
    return (// Match the outer document (dispatched from document)
      element === document || // The <html> element (dispatched from document.body or document.documentElement)
      element === document.documentElement || // Or the window itself (dispatched from window)
      element === window
    );
  }

  return this.rootElement === element;
}
/**
 * Check whether the ID of
 * the element in 'this'
 * matches the given ID.
 *
 * IDs are case-sensitive.
 *
 * @param {string} id The ID to test against
 * @param {Element} element The element to test with
 * @returns boolean
 */


function matchesId(id, element) {
  return id === element.id;
}
/**
 * Short hand for off()
 * and root(), ie both
 * with no parameters
 *
 * @return void
 */


Delegate.prototype.destroy = function () {
  this.off();
  this.root();
};

var _default = Delegate;
exports.default = _default;
module.exports = exports.default;
}(browser, browser.exports));

var Delegate = /*@__PURE__*/getDefaultExportFromCjs(browser.exports);

var pageTransition = (function () {
  var pageTransitionOverlay = document.querySelector("#page-transition-overlay");
  var animationDuration = 200;

  if (pageTransitionOverlay) {
    pageTransitionOverlay.classList.remove("skip-transition");
    setTimeout(function () {
      pageTransitionOverlay.classList.remove("active");
    }, 0);
    setTimeout(function () {
      // Prevent the theme editor from seeing this
      pageTransitionOverlay.classList.remove("active");
    }, animationDuration);
    var delegate = new Delegate(document.body);
    delegate.on("click", 'a[href]:not([href^="#"]):not(.no-transition):not([href^="mailto:"]):not([href^="tel:"]):not([target="_blank"])', onClickedToLeave);

    window.onpageshow = function (e) {
      if (e.persisted) {
        pageTransitionOverlay.classList.remove("active");
      }
    };
  }

  function onClickedToLeave(event, target) {
    // avoid interupting open-in-new-tab click
    if (event.ctrlKey || event.metaKey) return;
    event.preventDefault(); // Hint to browser to prerender destination

    var linkHint = document.createElement("link");
    linkHint.setAttribute("rel", "prerender");
    linkHint.setAttribute("href", target.href);
    document.head.appendChild(linkHint);
    setTimeout(function () {
      window.location.href = target.href;
    }, animationDuration);
    pageTransitionOverlay.classList.add("active");
  }
});

/*!
* tabbable 5.2.1
* @license MIT, https://github.com/focus-trap/tabbable/blob/master/LICENSE
*/
var candidateSelectors = ['input', 'select', 'textarea', 'a[href]', 'button', '[tabindex]', 'audio[controls]', 'video[controls]', '[contenteditable]:not([contenteditable="false"])', 'details>summary:first-of-type', 'details'];
var candidateSelector = /* #__PURE__ */candidateSelectors.join(',');
var matches = typeof Element === 'undefined' ? function () {} : Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;

var getCandidates = function getCandidates(el, includeContainer, filter) {
  var candidates = Array.prototype.slice.apply(el.querySelectorAll(candidateSelector));

  if (includeContainer && matches.call(el, candidateSelector)) {
    candidates.unshift(el);
  }

  candidates = candidates.filter(filter);
  return candidates;
};

var isContentEditable = function isContentEditable(node) {
  return node.contentEditable === 'true';
};

var getTabindex = function getTabindex(node) {
  var tabindexAttr = parseInt(node.getAttribute('tabindex'), 10);

  if (!isNaN(tabindexAttr)) {
    return tabindexAttr;
  } // Browsers do not return `tabIndex` correctly for contentEditable nodes;
  // so if they don't have a tabindex attribute specifically set, assume it's 0.


  if (isContentEditable(node)) {
    return 0;
  } // in Chrome, <details/>, <audio controls/> and <video controls/> elements get a default
  //  `tabIndex` of -1 when the 'tabindex' attribute isn't specified in the DOM,
  //  yet they are still part of the regular tab order; in FF, they get a default
  //  `tabIndex` of 0; since Chrome still puts those elements in the regular tab
  //  order, consider their tab index to be 0.


  if ((node.nodeName === 'AUDIO' || node.nodeName === 'VIDEO' || node.nodeName === 'DETAILS') && node.getAttribute('tabindex') === null) {
    return 0;
  }

  return node.tabIndex;
};

var sortOrderedTabbables = function sortOrderedTabbables(a, b) {
  return a.tabIndex === b.tabIndex ? a.documentOrder - b.documentOrder : a.tabIndex - b.tabIndex;
};

var isInput = function isInput(node) {
  return node.tagName === 'INPUT';
};

var isHiddenInput = function isHiddenInput(node) {
  return isInput(node) && node.type === 'hidden';
};

var isDetailsWithSummary = function isDetailsWithSummary(node) {
  var r = node.tagName === 'DETAILS' && Array.prototype.slice.apply(node.children).some(function (child) {
    return child.tagName === 'SUMMARY';
  });
  return r;
};

var getCheckedRadio = function getCheckedRadio(nodes, form) {
  for (var i = 0; i < nodes.length; i++) {
    if (nodes[i].checked && nodes[i].form === form) {
      return nodes[i];
    }
  }
};

var isTabbableRadio = function isTabbableRadio(node) {
  if (!node.name) {
    return true;
  }

  var radioScope = node.form || node.ownerDocument;

  var queryRadios = function queryRadios(name) {
    return radioScope.querySelectorAll('input[type="radio"][name="' + name + '"]');
  };

  var radioSet;

  if (typeof window !== 'undefined' && typeof window.CSS !== 'undefined' && typeof window.CSS.escape === 'function') {
    radioSet = queryRadios(window.CSS.escape(node.name));
  } else {
    try {
      radioSet = queryRadios(node.name);
    } catch (err) {
      // eslint-disable-next-line no-console
      console.error('Looks like you have a radio button with a name attribute containing invalid CSS selector characters and need the CSS.escape polyfill: %s', err.message);
      return false;
    }
  }

  var checked = getCheckedRadio(radioSet, node.form);
  return !checked || checked === node;
};

var isRadio = function isRadio(node) {
  return isInput(node) && node.type === 'radio';
};

var isNonTabbableRadio = function isNonTabbableRadio(node) {
  return isRadio(node) && !isTabbableRadio(node);
};

var isHidden = function isHidden(node, displayCheck) {
  if (getComputedStyle(node).visibility === 'hidden') {
    return true;
  }

  var isDirectSummary = matches.call(node, 'details>summary:first-of-type');
  var nodeUnderDetails = isDirectSummary ? node.parentElement : node;

  if (matches.call(nodeUnderDetails, 'details:not([open]) *')) {
    return true;
  }

  if (!displayCheck || displayCheck === 'full') {
    while (node) {
      if (getComputedStyle(node).display === 'none') {
        return true;
      }

      node = node.parentElement;
    }
  } else if (displayCheck === 'non-zero-area') {
    var _node$getBoundingClie = node.getBoundingClientRect(),
        width = _node$getBoundingClie.width,
        height = _node$getBoundingClie.height;

    return width === 0 && height === 0;
  }

  return false;
}; // form fields (nested) inside a disabled fieldset are not focusable/tabbable
//  unless they are in the _first_ <legend> element of the top-most disabled
//  fieldset


var isDisabledFromFieldset = function isDisabledFromFieldset(node) {
  if (isInput(node) || node.tagName === 'SELECT' || node.tagName === 'TEXTAREA' || node.tagName === 'BUTTON') {
    var parentNode = node.parentElement;

    while (parentNode) {
      if (parentNode.tagName === 'FIELDSET' && parentNode.disabled) {
        // look for the first <legend> as an immediate child of the disabled
        //  <fieldset>: if the node is in that legend, it'll be enabled even
        //  though the fieldset is disabled; otherwise, the node is in a
        //  secondary/subsequent legend, or somewhere else within the fieldset
        //  (however deep nested) and it'll be disabled
        for (var i = 0; i < parentNode.children.length; i++) {
          var child = parentNode.children.item(i);

          if (child.tagName === 'LEGEND') {
            if (child.contains(node)) {
              return false;
            } // the node isn't in the first legend (in doc order), so no matter
            //  where it is now, it'll be disabled


            return true;
          }
        } // the node isn't in a legend, so no matter where it is now, it'll be disabled


        return true;
      }

      parentNode = parentNode.parentElement;
    }
  } // else, node's tabbable/focusable state should not be affected by a fieldset's
  //  enabled/disabled state


  return false;
};

var isNodeMatchingSelectorFocusable = function isNodeMatchingSelectorFocusable(options, node) {
  if (node.disabled || isHiddenInput(node) || isHidden(node, options.displayCheck) || // For a details element with a summary, the summary element gets the focus
  isDetailsWithSummary(node) || isDisabledFromFieldset(node)) {
    return false;
  }

  return true;
};

var isNodeMatchingSelectorTabbable = function isNodeMatchingSelectorTabbable(options, node) {
  if (!isNodeMatchingSelectorFocusable(options, node) || isNonTabbableRadio(node) || getTabindex(node) < 0) {
    return false;
  }

  return true;
};

var tabbable = function tabbable(el, options) {
  options = options || {};
  var regularTabbables = [];
  var orderedTabbables = [];
  var candidates = getCandidates(el, options.includeContainer, isNodeMatchingSelectorTabbable.bind(null, options));
  candidates.forEach(function (candidate, i) {
    var candidateTabindex = getTabindex(candidate);

    if (candidateTabindex === 0) {
      regularTabbables.push(candidate);
    } else {
      orderedTabbables.push({
        documentOrder: i,
        tabIndex: candidateTabindex,
        node: candidate
      });
    }
  });
  var tabbableNodes = orderedTabbables.sort(sortOrderedTabbables).map(function (a) {
    return a.node;
  }).concat(regularTabbables);
  return tabbableNodes;
};

var focusableCandidateSelector = /* #__PURE__ */candidateSelectors.concat('iframe').join(',');

var isFocusable = function isFocusable(node, options) {
  options = options || {};

  if (!node) {
    throw new Error('No node provided');
  }

  if (matches.call(node, focusableCandidateSelector) === false) {
    return false;
  }

  return isNodeMatchingSelectorFocusable(options, node);
};

/*!
* focus-trap 6.7.1
* @license MIT, https://github.com/focus-trap/focus-trap/blob/master/LICENSE
*/

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var activeFocusTraps = function () {
  var trapQueue = [];
  return {
    activateTrap: function activateTrap(trap) {
      if (trapQueue.length > 0) {
        var activeTrap = trapQueue[trapQueue.length - 1];

        if (activeTrap !== trap) {
          activeTrap.pause();
        }
      }

      var trapIndex = trapQueue.indexOf(trap);

      if (trapIndex === -1) {
        trapQueue.push(trap);
      } else {
        // move this existing trap to the front of the queue
        trapQueue.splice(trapIndex, 1);
        trapQueue.push(trap);
      }
    },
    deactivateTrap: function deactivateTrap(trap) {
      var trapIndex = trapQueue.indexOf(trap);

      if (trapIndex !== -1) {
        trapQueue.splice(trapIndex, 1);
      }

      if (trapQueue.length > 0) {
        trapQueue[trapQueue.length - 1].unpause();
      }
    }
  };
}();

var isSelectableInput = function isSelectableInput(node) {
  return node.tagName && node.tagName.toLowerCase() === 'input' && typeof node.select === 'function';
};

var isEscapeEvent = function isEscapeEvent(e) {
  return e.key === 'Escape' || e.key === 'Esc' || e.keyCode === 27;
};

var isTabEvent = function isTabEvent(e) {
  return e.key === 'Tab' || e.keyCode === 9;
};

var delay = function delay(fn) {
  return setTimeout(fn, 0);
}; // Array.find/findIndex() are not supported on IE; this replicates enough
//  of Array.findIndex() for our needs


var findIndex = function findIndex(arr, fn) {
  var idx = -1;
  arr.every(function (value, i) {
    if (fn(value)) {
      idx = i;
      return false; // break
    }

    return true; // next
  });
  return idx;
};
/**
 * Get an option's value when it could be a plain value, or a handler that provides
 *  the value.
 * @param {*} value Option's value to check.
 * @param {...*} [params] Any parameters to pass to the handler, if `value` is a function.
 * @returns {*} The `value`, or the handler's returned value.
 */


var valueOrHandler = function valueOrHandler(value) {
  for (var _len = arguments.length, params = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    params[_key - 1] = arguments[_key];
  }

  return typeof value === 'function' ? value.apply(void 0, params) : value;
};

var getActualTarget = function getActualTarget(event) {
  // NOTE: If the trap is _inside_ a shadow DOM, event.target will always be the
  //  shadow host. However, event.target.composedPath() will be an array of
  //  nodes "clicked" from inner-most (the actual element inside the shadow) to
  //  outer-most (the host HTML document). If we have access to composedPath(),
  //  then use its first element; otherwise, fall back to event.target (and
  //  this only works for an _open_ shadow DOM; otherwise,
  //  composedPath()[0] === event.target always).
  return event.target.shadowRoot && typeof event.composedPath === 'function' ? event.composedPath()[0] : event.target;
};

var createFocusTrap = function createFocusTrap(elements, userOptions) {
  var doc = (userOptions === null || userOptions === void 0 ? void 0 : userOptions.document) || document;

  var config = _objectSpread2({
    returnFocusOnDeactivate: true,
    escapeDeactivates: true,
    delayInitialFocus: true
  }, userOptions);

  var state = {
    // @type {Array<HTMLElement>}
    containers: [],
    // list of objects identifying the first and last tabbable nodes in all containers/groups in
    //  the trap
    // NOTE: it's possible that a group has no tabbable nodes if nodes get removed while the trap
    //  is active, but the trap should never get to a state where there isn't at least one group
    //  with at least one tabbable node in it (that would lead to an error condition that would
    //  result in an error being thrown)
    // @type {Array<{ container: HTMLElement, firstTabbableNode: HTMLElement|null, lastTabbableNode: HTMLElement|null }>}
    tabbableGroups: [],
    nodeFocusedBeforeActivation: null,
    mostRecentlyFocusedNode: null,
    active: false,
    paused: false,
    // timer ID for when delayInitialFocus is true and initial focus in this trap
    //  has been delayed during activation
    delayInitialFocusTimer: undefined
  };
  var trap; // eslint-disable-line prefer-const -- some private functions reference it, and its methods reference private functions, so we must declare here and define later

  var getOption = function getOption(configOverrideOptions, optionName, configOptionName) {
    return configOverrideOptions && configOverrideOptions[optionName] !== undefined ? configOverrideOptions[optionName] : config[configOptionName || optionName];
  };

  var containersContain = function containersContain(element) {
    return !!(element && state.containers.some(function (container) {
      return container.contains(element);
    }));
  };
  /**
   * Gets the node for the given option, which is expected to be an option that
   *  can be either a DOM node, a string that is a selector to get a node, `false`
   *  (if a node is explicitly NOT given), or a function that returns any of these
   *  values.
   * @param {string} optionName
   * @returns {undefined | false | HTMLElement | SVGElement} Returns
   *  `undefined` if the option is not specified; `false` if the option
   *  resolved to `false` (node explicitly not given); otherwise, the resolved
   *  DOM node.
   * @throws {Error} If the option is set, not `false`, and is not, or does not
   *  resolve to a node.
   */


  var getNodeForOption = function getNodeForOption(optionName) {
    var optionValue = config[optionName];

    if (typeof optionValue === 'function') {
      for (var _len2 = arguments.length, params = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        params[_key2 - 1] = arguments[_key2];
      }

      optionValue = optionValue.apply(void 0, params);
    }

    if (!optionValue) {
      if (optionValue === undefined || optionValue === false) {
        return optionValue;
      } // else, empty string (invalid), null (invalid), 0 (invalid)


      throw new Error("`".concat(optionName, "` was specified but was not a node, or did not return a node"));
    }

    var node = optionValue; // could be HTMLElement, SVGElement, or non-empty string at this point

    if (typeof optionValue === 'string') {
      node = doc.querySelector(optionValue); // resolve to node, or null if fails

      if (!node) {
        throw new Error("`".concat(optionName, "` as selector refers to no known node"));
      }
    }

    return node;
  };

  var getInitialFocusNode = function getInitialFocusNode() {
    var node = getNodeForOption('initialFocus'); // false explicitly indicates we want no initialFocus at all

    if (node === false) {
      return false;
    }

    if (node === undefined) {
      // option not specified: use fallback options
      if (containersContain(doc.activeElement)) {
        node = doc.activeElement;
      } else {
        var firstTabbableGroup = state.tabbableGroups[0];
        var firstTabbableNode = firstTabbableGroup && firstTabbableGroup.firstTabbableNode; // NOTE: `fallbackFocus` option function cannot return `false` (not supported)

        node = firstTabbableNode || getNodeForOption('fallbackFocus');
      }
    }

    if (!node) {
      throw new Error('Your focus-trap needs to have at least one focusable element');
    }

    return node;
  };

  var updateTabbableNodes = function updateTabbableNodes() {
    state.tabbableGroups = state.containers.map(function (container) {
      var tabbableNodes = tabbable(container);

      if (tabbableNodes.length > 0) {
        return {
          container: container,
          firstTabbableNode: tabbableNodes[0],
          lastTabbableNode: tabbableNodes[tabbableNodes.length - 1]
        };
      }

      return undefined;
    }).filter(function (group) {
      return !!group;
    }); // remove groups with no tabbable nodes
    // throw if no groups have tabbable nodes and we don't have a fallback focus node either

    if (state.tabbableGroups.length <= 0 && !getNodeForOption('fallbackFocus') // returning false not supported for this option
    ) {
      throw new Error('Your focus-trap must have at least one container with at least one tabbable node in it at all times');
    }
  };

  var tryFocus = function tryFocus(node) {
    if (node === false) {
      return;
    }

    if (node === doc.activeElement) {
      return;
    }

    if (!node || !node.focus) {
      tryFocus(getInitialFocusNode());
      return;
    }

    node.focus({
      preventScroll: !!config.preventScroll
    });
    state.mostRecentlyFocusedNode = node;

    if (isSelectableInput(node)) {
      node.select();
    }
  };

  var getReturnFocusNode = function getReturnFocusNode(previousActiveElement) {
    var node = getNodeForOption('setReturnFocus', previousActiveElement);
    return node ? node : node === false ? false : previousActiveElement;
  }; // This needs to be done on mousedown and touchstart instead of click
  // so that it precedes the focus event.


  var checkPointerDown = function checkPointerDown(e) {
    var target = getActualTarget(e);

    if (containersContain(target)) {
      // allow the click since it ocurred inside the trap
      return;
    }

    if (valueOrHandler(config.clickOutsideDeactivates, e)) {
      // immediately deactivate the trap
      trap.deactivate({
        // if, on deactivation, we should return focus to the node originally-focused
        //  when the trap was activated (or the configured `setReturnFocus` node),
        //  then assume it's also OK to return focus to the outside node that was
        //  just clicked, causing deactivation, as long as that node is focusable;
        //  if it isn't focusable, then return focus to the original node focused
        //  on activation (or the configured `setReturnFocus` node)
        // NOTE: by setting `returnFocus: false`, deactivate() will do nothing,
        //  which will result in the outside click setting focus to the node
        //  that was clicked, whether it's focusable or not; by setting
        //  `returnFocus: true`, we'll attempt to re-focus the node originally-focused
        //  on activation (or the configured `setReturnFocus` node)
        returnFocus: config.returnFocusOnDeactivate && !isFocusable(target)
      });
      return;
    } // This is needed for mobile devices.
    // (If we'll only let `click` events through,
    // then on mobile they will be blocked anyways if `touchstart` is blocked.)


    if (valueOrHandler(config.allowOutsideClick, e)) {
      // allow the click outside the trap to take place
      return;
    } // otherwise, prevent the click


    e.preventDefault();
  }; // In case focus escapes the trap for some strange reason, pull it back in.


  var checkFocusIn = function checkFocusIn(e) {
    var target = getActualTarget(e);
    var targetContained = containersContain(target); // In Firefox when you Tab out of an iframe the Document is briefly focused.

    if (targetContained || target instanceof Document) {
      if (targetContained) {
        state.mostRecentlyFocusedNode = target;
      }
    } else {
      // escaped! pull it back in to where it just left
      e.stopImmediatePropagation();
      tryFocus(state.mostRecentlyFocusedNode || getInitialFocusNode());
    }
  }; // Hijack Tab events on the first and last focusable nodes of the trap,
  // in order to prevent focus from escaping. If it escapes for even a
  // moment it can end up scrolling the page and causing confusion so we
  // kind of need to capture the action at the keydown phase.


  var checkTab = function checkTab(e) {
    var target = getActualTarget(e);
    updateTabbableNodes();
    var destinationNode = null;

    if (state.tabbableGroups.length > 0) {
      // make sure the target is actually contained in a group
      // NOTE: the target may also be the container itself if it's tabbable
      //  with tabIndex='-1' and was given initial focus
      var containerIndex = findIndex(state.tabbableGroups, function (_ref) {
        var container = _ref.container;
        return container.contains(target);
      });

      if (containerIndex < 0) {
        // target not found in any group: quite possible focus has escaped the trap,
        //  so bring it back in to...
        if (e.shiftKey) {
          // ...the last node in the last group
          destinationNode = state.tabbableGroups[state.tabbableGroups.length - 1].lastTabbableNode;
        } else {
          // ...the first node in the first group
          destinationNode = state.tabbableGroups[0].firstTabbableNode;
        }
      } else if (e.shiftKey) {
        // REVERSE
        // is the target the first tabbable node in a group?
        var startOfGroupIndex = findIndex(state.tabbableGroups, function (_ref2) {
          var firstTabbableNode = _ref2.firstTabbableNode;
          return target === firstTabbableNode;
        });

        if (startOfGroupIndex < 0 && state.tabbableGroups[containerIndex].container === target) {
          // an exception case where the target is the container itself, in which
          //  case, we should handle shift+tab as if focus were on the container's
          //  first tabbable node, and go to the last tabbable node of the LAST group
          startOfGroupIndex = containerIndex;
        }

        if (startOfGroupIndex >= 0) {
          // YES: then shift+tab should go to the last tabbable node in the
          //  previous group (and wrap around to the last tabbable node of
          //  the LAST group if it's the first tabbable node of the FIRST group)
          var destinationGroupIndex = startOfGroupIndex === 0 ? state.tabbableGroups.length - 1 : startOfGroupIndex - 1;
          var destinationGroup = state.tabbableGroups[destinationGroupIndex];
          destinationNode = destinationGroup.lastTabbableNode;
        }
      } else {
        // FORWARD
        // is the target the last tabbable node in a group?
        var lastOfGroupIndex = findIndex(state.tabbableGroups, function (_ref3) {
          var lastTabbableNode = _ref3.lastTabbableNode;
          return target === lastTabbableNode;
        });

        if (lastOfGroupIndex < 0 && state.tabbableGroups[containerIndex].container === target) {
          // an exception case where the target is the container itself, in which
          //  case, we should handle tab as if focus were on the container's
          //  last tabbable node, and go to the first tabbable node of the FIRST group
          lastOfGroupIndex = containerIndex;
        }

        if (lastOfGroupIndex >= 0) {
          // YES: then tab should go to the first tabbable node in the next
          //  group (and wrap around to the first tabbable node of the FIRST
          //  group if it's the last tabbable node of the LAST group)
          var _destinationGroupIndex = lastOfGroupIndex === state.tabbableGroups.length - 1 ? 0 : lastOfGroupIndex + 1;

          var _destinationGroup = state.tabbableGroups[_destinationGroupIndex];
          destinationNode = _destinationGroup.firstTabbableNode;
        }
      }
    } else {
      // NOTE: the fallbackFocus option does not support returning false to opt-out
      destinationNode = getNodeForOption('fallbackFocus');
    }

    if (destinationNode) {
      e.preventDefault();
      tryFocus(destinationNode);
    } // else, let the browser take care of [shift+]tab and move the focus

  };

  var checkKey = function checkKey(e) {
    if (isEscapeEvent(e) && valueOrHandler(config.escapeDeactivates, e) !== false) {
      e.preventDefault();
      trap.deactivate();
      return;
    }

    if (isTabEvent(e)) {
      checkTab(e);
      return;
    }
  };

  var checkClick = function checkClick(e) {
    if (valueOrHandler(config.clickOutsideDeactivates, e)) {
      return;
    }

    var target = getActualTarget(e);

    if (containersContain(target)) {
      return;
    }

    if (valueOrHandler(config.allowOutsideClick, e)) {
      return;
    }

    e.preventDefault();
    e.stopImmediatePropagation();
  }; //
  // EVENT LISTENERS
  //


  var addListeners = function addListeners() {
    if (!state.active) {
      return;
    } // There can be only one listening focus trap at a time


    activeFocusTraps.activateTrap(trap); // Delay ensures that the focused element doesn't capture the event
    // that caused the focus trap activation.

    state.delayInitialFocusTimer = config.delayInitialFocus ? delay(function () {
      tryFocus(getInitialFocusNode());
    }) : tryFocus(getInitialFocusNode());
    doc.addEventListener('focusin', checkFocusIn, true);
    doc.addEventListener('mousedown', checkPointerDown, {
      capture: true,
      passive: false
    });
    doc.addEventListener('touchstart', checkPointerDown, {
      capture: true,
      passive: false
    });
    doc.addEventListener('click', checkClick, {
      capture: true,
      passive: false
    });
    doc.addEventListener('keydown', checkKey, {
      capture: true,
      passive: false
    });
    return trap;
  };

  var removeListeners = function removeListeners() {
    if (!state.active) {
      return;
    }

    doc.removeEventListener('focusin', checkFocusIn, true);
    doc.removeEventListener('mousedown', checkPointerDown, true);
    doc.removeEventListener('touchstart', checkPointerDown, true);
    doc.removeEventListener('click', checkClick, true);
    doc.removeEventListener('keydown', checkKey, true);
    return trap;
  }; //
  // TRAP DEFINITION
  //


  trap = {
    activate: function activate(activateOptions) {
      if (state.active) {
        return this;
      }

      var onActivate = getOption(activateOptions, 'onActivate');
      var onPostActivate = getOption(activateOptions, 'onPostActivate');
      var checkCanFocusTrap = getOption(activateOptions, 'checkCanFocusTrap');

      if (!checkCanFocusTrap) {
        updateTabbableNodes();
      }

      state.active = true;
      state.paused = false;
      state.nodeFocusedBeforeActivation = doc.activeElement;

      if (onActivate) {
        onActivate();
      }

      var finishActivation = function finishActivation() {
        if (checkCanFocusTrap) {
          updateTabbableNodes();
        }

        addListeners();

        if (onPostActivate) {
          onPostActivate();
        }
      };

      if (checkCanFocusTrap) {
        checkCanFocusTrap(state.containers.concat()).then(finishActivation, finishActivation);
        return this;
      }

      finishActivation();
      return this;
    },
    deactivate: function deactivate(deactivateOptions) {
      if (!state.active) {
        return this;
      }

      clearTimeout(state.delayInitialFocusTimer); // noop if undefined

      state.delayInitialFocusTimer = undefined;
      removeListeners();
      state.active = false;
      state.paused = false;
      activeFocusTraps.deactivateTrap(trap);
      var onDeactivate = getOption(deactivateOptions, 'onDeactivate');
      var onPostDeactivate = getOption(deactivateOptions, 'onPostDeactivate');
      var checkCanReturnFocus = getOption(deactivateOptions, 'checkCanReturnFocus');

      if (onDeactivate) {
        onDeactivate();
      }

      var returnFocus = getOption(deactivateOptions, 'returnFocus', 'returnFocusOnDeactivate');

      var finishDeactivation = function finishDeactivation() {
        delay(function () {
          if (returnFocus) {
            tryFocus(getReturnFocusNode(state.nodeFocusedBeforeActivation));
          }

          if (onPostDeactivate) {
            onPostDeactivate();
          }
        });
      };

      if (returnFocus && checkCanReturnFocus) {
        checkCanReturnFocus(getReturnFocusNode(state.nodeFocusedBeforeActivation)).then(finishDeactivation, finishDeactivation);
        return this;
      }

      finishDeactivation();
      return this;
    },
    pause: function pause() {
      if (state.paused || !state.active) {
        return this;
      }

      state.paused = true;
      removeListeners();
      return this;
    },
    unpause: function unpause() {
      if (!state.paused || !state.active) {
        return this;
      }

      state.paused = false;
      updateTabbableNodes();
      addListeners();
      return this;
    },
    updateContainerElements: function updateContainerElements(containerElements) {
      var elementsAsArray = [].concat(containerElements).filter(Boolean);
      state.containers = elementsAsArray.map(function (element) {
        return typeof element === 'string' ? doc.querySelector(element) : element;
      });

      if (state.active) {
        updateTabbableNodes();
      }

      return this;
    }
  }; // initialize container elements

  trap.updateContainerElements(elements);
  return trap;
};

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

// Older browsers don't support event options, feature detect it.

// Adopted and modified solution from Bohdan Didukh (2017)
// https://stackoverflow.com/questions/41594997/ios-10-safari-prevent-scrolling-behind-a-fixed-overlay-and-maintain-scroll-posi

var hasPassiveEvents = false;
if (typeof window !== 'undefined') {
  var passiveTestOptions = {
    get passive() {
      hasPassiveEvents = true;
      return undefined;
    }
  };
  window.addEventListener('testPassive', null, passiveTestOptions);
  window.removeEventListener('testPassive', null, passiveTestOptions);
}

var isIosDevice = typeof window !== 'undefined' && window.navigator && window.navigator.platform && (/iP(ad|hone|od)/.test(window.navigator.platform) || window.navigator.platform === 'MacIntel' && window.navigator.maxTouchPoints > 1);


var locks = [];
var documentListenerAdded = false;
var initialClientY = -1;
var previousBodyOverflowSetting = void 0;
var previousBodyPaddingRight = void 0;

// returns true if `el` should be allowed to receive touchmove events.
var allowTouchMove = function allowTouchMove(el) {
  return locks.some(function (lock) {
    if (lock.options.allowTouchMove && lock.options.allowTouchMove(el)) {
      return true;
    }

    return false;
  });
};

var preventDefault$1 = function preventDefault(rawEvent) {
  var e = rawEvent || window.event;

  // For the case whereby consumers adds a touchmove event listener to document.
  // Recall that we do document.addEventListener('touchmove', preventDefault, { passive: false })
  // in disableBodyScroll - so if we provide this opportunity to allowTouchMove, then
  // the touchmove event on document will break.
  if (allowTouchMove(e.target)) {
    return true;
  }

  // Do not prevent if the event has more than one touch (usually meaning this is a multi touch gesture like pinch to zoom).
  if (e.touches.length > 1) return true;

  if (e.preventDefault) e.preventDefault();

  return false;
};

var setOverflowHidden = function setOverflowHidden(options) {
  // If previousBodyPaddingRight is already set, don't set it again.
  if (previousBodyPaddingRight === undefined) {
    var _reserveScrollBarGap = !!options && options.reserveScrollBarGap === true;
    var scrollBarGap = window.innerWidth - document.documentElement.clientWidth;

    if (_reserveScrollBarGap && scrollBarGap > 0) {
      previousBodyPaddingRight = document.body.style.paddingRight;
      document.body.style.paddingRight = scrollBarGap + 'px';
    }
  }

  // If previousBodyOverflowSetting is already set, don't set it again.
  if (previousBodyOverflowSetting === undefined) {
    previousBodyOverflowSetting = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
  }
};

var restoreOverflowSetting = function restoreOverflowSetting() {
  if (previousBodyPaddingRight !== undefined) {
    document.body.style.paddingRight = previousBodyPaddingRight;

    // Restore previousBodyPaddingRight to undefined so setOverflowHidden knows it
    // can be set again.
    previousBodyPaddingRight = undefined;
  }

  if (previousBodyOverflowSetting !== undefined) {
    document.body.style.overflow = previousBodyOverflowSetting;

    // Restore previousBodyOverflowSetting to undefined
    // so setOverflowHidden knows it can be set again.
    previousBodyOverflowSetting = undefined;
  }
};

// https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollHeight#Problems_and_solutions
var isTargetElementTotallyScrolled = function isTargetElementTotallyScrolled(targetElement) {
  return targetElement ? targetElement.scrollHeight - targetElement.scrollTop <= targetElement.clientHeight : false;
};

var handleScroll = function handleScroll(event, targetElement) {
  var clientY = event.targetTouches[0].clientY - initialClientY;

  if (allowTouchMove(event.target)) {
    return false;
  }

  if (targetElement && targetElement.scrollTop === 0 && clientY > 0) {
    // element is at the top of its scroll.
    return preventDefault$1(event);
  }

  if (isTargetElementTotallyScrolled(targetElement) && clientY < 0) {
    // element is at the bottom of its scroll.
    return preventDefault$1(event);
  }

  event.stopPropagation();
  return true;
};

var disableBodyScroll = function disableBodyScroll(targetElement, options) {
  // targetElement must be provided
  if (!targetElement) {
    // eslint-disable-next-line no-console
    console.error('disableBodyScroll unsuccessful - targetElement must be provided when calling disableBodyScroll on IOS devices.');
    return;
  }

  // disableBodyScroll must not have been called on this targetElement before
  if (locks.some(function (lock) {
    return lock.targetElement === targetElement;
  })) {
    return;
  }

  var lock = {
    targetElement: targetElement,
    options: options || {}
  };

  locks = [].concat(_toConsumableArray(locks), [lock]);

  if (isIosDevice) {
    targetElement.ontouchstart = function (event) {
      if (event.targetTouches.length === 1) {
        // detect single touch.
        initialClientY = event.targetTouches[0].clientY;
      }
    };
    targetElement.ontouchmove = function (event) {
      if (event.targetTouches.length === 1) {
        // detect single touch.
        handleScroll(event, targetElement);
      }
    };

    if (!documentListenerAdded) {
      //document.addEventListener('touchmove', preventDefault$1, hasPassiveEvents ? { passive: false } : undefined);
      documentListenerAdded = true;
    }
  } else {
    setOverflowHidden(options);
  }
};

var enableBodyScroll = function enableBodyScroll(targetElement) {
  if (!targetElement) {
    // eslint-disable-next-line no-console
    console.error('enableBodyScroll unsuccessful - targetElement must be provided when calling enableBodyScroll on IOS devices.');
    return;
  }

  locks = locks.filter(function (lock) {
    return lock.targetElement !== targetElement;
  });

  if (isIosDevice) {
    targetElement.ontouchstart = null;
    targetElement.ontouchmove = null;

    if (documentListenerAdded && locks.length === 0) {
      //document.removeEventListener('touchmove', preventDefault$1, hasPassiveEvents ? { passive: false } : undefined);
      documentListenerAdded = false;
    }
  } else if (!locks.length) {
    restoreOverflowSetting();
  }
};

var n$1=function(n){if("object"!=typeof(t=n)||Array.isArray(t))throw "state should be an object";var t;},
t$1=function(n,t,e,c){return (r=n,r.reduce(function(n,t,e){return n.indexOf(t)>-1?n:n.concat(t)},[])).reduce(function(n,e){return n.concat(t[e]||[])},[]).map(function(n){return n(e,c)});var r;},
e$1=a(),c=e$1.on,
r$1=e$1.emit,
o$1=e$1.hydrate;
function a(e){void 0===e&&(e={});var c={};return {getState:function(){return Object.assign({},e)},hydrate:function(r){return n$1(r),Object.assign(e,r),function(){var n=["*"].concat(Object.keys(r));t$1(n,c,e);}},on:function(n,t){return (n=[].concat(n)).map(function(n){return c[n]=(c[n]||[]).concat(t)}),function(){return n.map(function(n){return c[n].splice(c[n].indexOf(t),1)})}},emit:function(r,o,u){var a=("*"===r?[]:["*"]).concat(r);(o="function"==typeof o?o(e):o)&&(n$1(o),Object.assign(e,o),a=a.concat(Object.keys(o))),t$1(a,c,e,u);}}}

function wrapIframes () {
  var elements = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  elements.forEach(function (el) {
    var wrapper = document.createElement("div");
    wrapper.classList.add("rte__iframe");
    el.parentNode.insertBefore(wrapper, el);
    wrapper.appendChild(el);
    el.src = el.src;
  });
}

function wrapTables () {
  var elements = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  elements.forEach(function (el) {
    var wrapper = document.createElement("div");
    wrapper.classList.add("rte__table-wrapper");
    wrapper.tabIndex = 0;
    el.parentNode.insertBefore(wrapper, el);
    wrapper.appendChild(el);
  });
}

var classes$F = {
  visible: "is-visible",
  active: "active",
  fixed: "is-fixed"
};
var selectors$1G = {
  closeBtn: "[data-modal-close]",
  wash: ".modal__wash",
  modalContent: ".modal__content"
};

var modal = function modal(node) {
  var focusTrap = createFocusTrap(node, {
    allowOutsideClick: true
  });
  var modalContent = n$2(selectors$1G.modalContent, node);
  var delegate = new Delegate(document);
  delegate.on("click", selectors$1G.wash, function () {
    return _close();
  });
  var events = [e$2(n$2(selectors$1G.closeBtn, node), "click", function (e) {
    e.preventDefault();

    _close();
  }), e$2(node, "keydown", function (_ref) {
    var keyCode = _ref.keyCode;
    if (keyCode === 27) _close();
  }), c("modal:open", function (state, _ref2) {
    var modalContent = _ref2.modalContent,
        _ref2$narrow = _ref2.narrow,
        narrow = _ref2$narrow === void 0 ? false : _ref2$narrow;
    l(node, "modal--narrow", narrow);

    _renderModalContent(modalContent);

    _open();
  })];

  var _renderModalContent = function _renderModalContent(content) {
    var clonedContent = content.cloneNode(true);
    modalContent.innerHTML = "";
    modalContent.appendChild(clonedContent);
    wrapIframes(t$2("iframe", modalContent));
    wrapTables(t$2("table", modalContent));
  };

  var _open = function _open() {
    // Due to this component being shared between templates we have to
    // animate around it being fixed to the window
    u$1(node, classes$F.active);
    document.body.setAttribute("data-fluorescent-overlay-open", "true");
    focusTrap.activate();
    disableBodyScroll(node, {
      allowTouchMove: function allowTouchMove(el) {
        while (el && el !== document.body) {
          if (el.getAttribute("data-scroll-lock-ignore") !== null) {
            return true;
          }

          el = el.parentNode;
        }
      },
      reserveScrollBarGap: true
    });
  };

  var _close = function _close() {
    focusTrap.deactivate();
    i$1(node, classes$F.active);
    document.body.setAttribute("data-fluorescent-overlay-open", "false");
    enableBodyScroll(node);
    setTimeout(function () {
      modalContent.innerHTML = "";
    }, 300);
  };

  var unload = function unload() {
    events.forEach(function (unsubscribe) {
      return unsubscribe();
    });
  };

  return {
    unload: unload
  };
};

/*var AnimateProductItem = (function (items) {
  items.forEach((item) => {
    let productImages = item.querySelectorAll(".product-item__image");
    let swatches = item.querySelectorAll(".product-swatches-options__item--swatch");
    
    // Initialize index for the current image
    let currentIndex = 0;

    function switchImage() {
      // Hide the current visible image
      productImages[currentIndex].classList.remove('active');
  
      // Increment the index for the next iteration
      currentIndex = (currentIndex + 1) % productImages.length;
  
      // Show the next image
      productImages[currentIndex].classList.add('active');
    }

    t$2(".product-item-options__list", item);


    item.addEventListener("mouseenter", () => {
      enterItemAnimation(item);
    })

    item.addEventListener("mouseleave", () => {
      leaveItemAnimation(item);
    })

    swatches.forEach(swatch => {
      let selectedClassName = "product-swatches-options__item--selected";

      swatch.addEventListener("mouseenter", function(e){
        e.stopPropagation();
        const selected = item.querySelector(`.${selectedClassName}`);
        const color = this.dataset.color;
        const sku = this.dataset.sku;
        item.querySelector('.product-item__images.active').classList.remove("active");
        item.querySelector(`.product-item__images--${sku}`).classList.add("active");

        if(selected) selected.classList.remove(selectedClassName);

        this.classList.add(selectedClassName);
        const productWrapper = this.parentNode.parentNode.parentNode.parentNode.parentNode;
        const link = productWrapper.querySelector("a");

        link.href = link.dataset[color.replace(/-/g, "")] ? link.dataset[color.replace(/-/g, "")] : link.dataset.href;

        const activePrice = productWrapper.querySelector(".product-item__price--active");
        if(activePrice) activePrice.classList.remove("product-item__price--active");
        const newPrice = productWrapper.querySelector(`.product-item__price[data-sku="${sku}"]`);
        if(newPrice) newPrice.classList.add("product-item__price--active");
      })
    })
  });

  function enterItemAnimation(image) {
    u$1(image, "scale");
  }

  function leaveItemAnimation(image) {
    i$1(image, "scale");
  }
});*/

function getMediaQuery(querySize) {
  var value = getComputedStyle(document.documentElement).getPropertyValue("--media-".concat(querySize));

  if (!value) {
    console.warn("Invalid querySize passed to getMediaQuery");
    return false;
  }

  return value;
}

var intersectionWatcher = (function (node) {
  var instant = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var margin = window.matchMedia(getMediaQuery("above-720")).matches ? 200 : 100;
  var threshold = 0;

  if (!instant) {
    threshold = Math.min(margin / node.offsetHeight, 0.5);
  }

  var observer = new IntersectionObserver(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 1),
        visible = _ref2[0].isIntersecting;

    if (visible) {
      u$1(node, "is-visible");
      observer.disconnect();
    }
  }, {
    threshold: threshold
  });
  observer.observe(node);
  return {
    destroy: function destroy() {
      observer === null || observer === void 0 ? void 0 : observer.disconnect();
    }
  };
});

/**
 * delayOffset takes an array of selectors and sets the `--delay-offset-multiplier` variable in the correct order
 * @param {node} element The section element
 * @param {items} array Array of animation items
 */

var delayOffset = (function (node, items) {
  var offsetStart = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  var delayOffset = offsetStart;
  items.forEach(function (selector) {
    var items = t$2(selector, node);
    items.forEach(function (item) {
      item.style.setProperty("--delay-offset-multiplier", delayOffset);
      delayOffset++;
    });
  });
});

var shouldAnimate = (function (node) {
  return a$1(node, "animation") && !a$1(document.documentElement, "prefers-reduced-motion");
});

var selectors$1F = {
  sectionBlockItems: ".section-blocks > *",
  image: ".image-with-text__image .image__img",
  imageSmall: ".image-with-text__small-image .image__img",
  imageCaption: ".image-with-text__image-caption"
};
var animateImageWithText = (function (node) {
  // Add the animation delay offset variables
  delayOffset(node, [selectors$1F.image, selectors$1F.imageSmall, selectors$1F.imageCaption]);
  delayOffset(node, [selectors$1F.sectionBlockItems], 6);
  var observer = intersectionWatcher(node);
  return {
    destroy: function destroy() {
      observer === null || observer === void 0 ? void 0 : observer.destroy();
    }
  };
});

var selectors$1E = {
  sectionBlockItems: ".section-blocks > *",
  image: ".image-with-text-split__image .image__img"
};
var animateImageWithTextSplit = (function (node) {
  // Add the animation delay offset variables
  delayOffset(node, [selectors$1E.image]);
  delayOffset(node, [selectors$1E.sectionBlockItems], 6);
  var observer = intersectionWatcher(node);
  return {
    destroy: function destroy() {
      observer === null || observer === void 0 ? void 0 : observer.destroy();
    }
  };
});

var selectors$1D = {
  content: ".testimonials__item-content > *",
  image: ".testimonials__item-product-image",
  imageCaption: ".testimonials__item-product-title",
  item: ".animation--item"
};
var classes$E = {
  imageRight: "testimonials__item--image-placement-right"
};
var animateTestimonials = (function (node) {
  var delayItems = []; // Create an array of selectors for the animation elements
  // in the order they should animate in

  if (a$1(node, classes$E.imageRight)) {
    delayItems.push(selectors$1D.content);
    delayItems.push(selectors$1D.image);
    delayItems.push(selectors$1D.imageCaption);
  } else {
    delayItems.push(selectors$1D.image);
    delayItems.push(selectors$1D.imageCaption);
    delayItems.push(selectors$1D.content);
  } // Add the animation delay offset variables


  delayOffset(node, delayItems, 2);
  delayOffset(node, [selectors$1D.item]);
});

var selectors$1C = {
  content: ".quote__item-inner > *"
};
var animateQuotes = (function (node) {
  // Add the animation delay offset variables
  delayOffset(node, [selectors$1C.content]);
});

var selectors$1B = {
  sectionBlockItems: ".animation--section-introduction > *",
  controls: ".animation--controls",
  items: ".animation--item"
};
var animateListSlider = (function (node) {
  var delayItems = [selectors$1B.sectionBlockItems, selectors$1B.controls, selectors$1B.items]; // Add the animation delay offset variables

  delayOffset(node, delayItems);
  var observer = intersectionWatcher(node);
  return {
    destroy: function destroy() {
      observer === null || observer === void 0 ? void 0 : observer.destroy();
    }
  };
});

var selectors$1A = {
  introductionItems: ".section-introduction > *",
  image: ".complete-the-look__image-wrapper .image__img",
  product: ".complete-the-look__product",
  products: ".complete-the-look__products"
};
var classes$D = {
  imageLeft: "complete-the-look--image-left"
};
var animateCompleteTheLook = (function (node) {
  var delayItems = [];
  delayItems.push(selectors$1A.introductionItems); // Create an array of selectors for the animation elements
  // in the order they should animate in

  if (a$1(node, classes$D.imageLeft) || window.matchMedia(getMediaQuery("below-720")).matches) {
    delayItems.push(selectors$1A.image);
    delayItems.push(selectors$1A.products);
    delayItems.push(selectors$1A.product);
  } else {
    delayItems.push(selectors$1A.products);
    delayItems.push(selectors$1A.product);
    delayItems.push(selectors$1A.image);
  } // Add the animation delay offset variables


  delayOffset(node, delayItems);
  var observer = intersectionWatcher(node);
  return {
    destroy: function destroy() {
      observer.destroy();
    }
  };
});

var selectors$1z = {
  introductionItems: ".section-introduction > *",
  image: ".shoppable-image__image-wrapper .image__img",
  hotspots: ".shoppable-item__hotspot-wrapper"
};
var animateShoppableImage = (function (node) {
  // Add the animation delay offset variables
  delayOffset(node, [selectors$1z.introductionItems, selectors$1z.image, selectors$1z.hotspots]);
  var observer = intersectionWatcher(node);
  return {
    destroy: function destroy() {
      observer.destroy();
    }
  };
});

var selectors$1y = {
  introductionItems: ".section-introduction > *",
  carousel: ".shoppable-feature__secondary-content .shoppable-feature__carousel-outer",
  hotspots: ".shoppable-item__hotspot-wrapper",
  mobileDrawerItems: ".animation--shoppable-feature-mobile-drawer  .shoppable-feature__carousel-outer > *:not(.swiper-pagination)"
};
var animateShoppableFeature = (function (node) {
  // Add the animation delay offset variables
  delayOffset(node, [selectors$1y.introductionItems, selectors$1y.carousel], 1);
  delayOffset(node, [selectors$1y.hotspots], 1); // Add separate delay offsets for mobile drawer

  delayOffset(node, [selectors$1y.mobileDrawerItems], 1);
  var observer = intersectionWatcher(node);
  return {
    destroy: function destroy() {
      observer.destroy();
    }
  };
});

var selectors$1x = {
  textContent: ".image-hero-split-item__text-container-inner > *"
};
var animateImageHeroSplit = (function (node) {
  // Add the animation delay offset variables
  delayOffset(node, [selectors$1x.textContent], 1);
});

var selectors$1w = {
  textContent: ".image-hero__text-container-inner > *"
};
var animateImageHero = (function (node) {
  // Add the animation delay offset variables
  delayOffset(node, [selectors$1w.textContent], 3);
  var observer = intersectionWatcher(node);
  return {
    destroy: function destroy() {
      observer === null || observer === void 0 ? void 0 : observer.destroy();
    }
  };
});

var classes$C = {
  animation: "animation--image-compare"
};
var selectors$1v = {
  introductionItems: ".animation--section-introduction > *",
  image: ".image_compare__image-wrapper .image__img",
  labels: ".image-compare__label-container",
  sliderLine: ".image-compare__slider-line",
  sliderButton: ".image-compare__slider-button"
};
var animateImageCompare = (function (node) {
  delayOffset(node, [selectors$1v.introductionItems, selectors$1v.image, selectors$1v.labels, selectors$1v.sliderLine, selectors$1v.sliderButton]);
  var margin = window.matchMedia(getMediaQuery("above-720")).matches ? 200 : 100;
  var threshold = Math.min(margin / node.offsetHeight, 0.5);
  var observer = new IntersectionObserver(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 1),
        visible = _ref2[0].isIntersecting;

    if (visible) {
      u$1(node, "is-visible"); // Enable slider controls by removing animation class after animation duration

      setTimeout(function () {
        i$1(node, classes$C.animation);
      }, 1200);
      observer.disconnect();
    }
  }, {
    threshold: threshold
  });
  observer.observe(node);
  return {
    destroy: function destroy() {
      observer.destroy();
    }
  };
});

var selectors$1u = {
  textContent: ".video__text-container > *"
};
var animateVideo = (function (node) {
  // Add the animation delay offset variables
  delayOffset(node, [selectors$1u.textContent], 3);
  var observer = intersectionWatcher(node);
  return {
    destroy: function destroy() {
      observer === null || observer === void 0 ? void 0 : observer.destroy();
    }
  };
});

var selectors$1t = {
  textContent: ".video-hero__text-container > *"
};
var animateVideoHero = (function (node) {
  // Add the animation delay offset variables
  delayOffset(node, [selectors$1t.textContent], 3);
  var observer = intersectionWatcher(node);
  return {
    destroy: function destroy() {
      observer === null || observer === void 0 ? void 0 : observer.destroy();
    }
  };
});

var selectors$1s = {
  articleHeading: "\n    .article__image-container,\n    .article__header-inner > *\n  ",
  articleContent: ".article__content"
};
var animateArticle = (function (node) {
  // Add the animation delay offset variables
  delayOffset(node, [selectors$1s.articleHeading, selectors$1s.articleContent]);
  var articleHeading = t$2(selectors$1s.articleHeading, node);
  var articleContent = n$2(selectors$1s.articleContent, node);
  var observers = articleHeading.map(function (item) {
    return intersectionWatcher(item);
  });
  observers.push(intersectionWatcher(articleContent));
  return {
    destroy: function destroy() {
      observers.forEach(function (observer) {
        return observer.destroy();
      });
    }
  };
});

var selectors$1r = {
  image: ".collection-banner__image-container",
  content: ".collection-banner__text-container-inner > *"
};
var animateCollectionBanner = (function (node) {
  // Add the animation delay offset variables
  delayOffset(node, [selectors$1r.image, selectors$1r.content]);
  var observer = intersectionWatcher(node);
  return {
    destroy: function destroy() {
      observer === null || observer === void 0 ? void 0 : observer.destroy();
    }
  };
});

var selectors$1q = {
  partial: "[data-partial]",
  filterBar: "[data-filter-bar]",
  mobileFilterBar: "[data-mobile-filters]",
  productItems: ".animation--item:not(.animation--item-revealed)"
};
var classes$B = {
  hideProducts: "animation--collection-products-hide",
  itemRevealed: "animation--item-revealed"
};
var animateCollection = (function (node) {
  var partial = n$2(selectors$1q.partial, node);
  var filterbarEl = n$2(selectors$1q.filterBar, node);
  var mobileFilterBarEl = n$2(selectors$1q.mobileFilterBar, node);
  var filterbarObserver = null;

  if (filterbarEl) {
    filterbarObserver = intersectionWatcher(filterbarEl, true);
  }

  var mobileFilterBarObserver = null;

  if (mobileFilterBarEl) {
    mobileFilterBarObserver = intersectionWatcher(mobileFilterBarEl, true);
  }

  setupProductItem();

  function setupProductItem() {
    var productItems = t$2(selectors$1q.productItems, node);
    delayOffset(node, [selectors$1q.productItems]);
    setTimeout(function () {
      u$1(productItems, classes$B.itemRevealed);
    }, 0);
  } // Scroll to top of collection grid after applying filters
  // to show the newly filtered list of products


  function _scrollIntoView() {
    var y = partial.getBoundingClientRect().top + window.pageYOffset - filterbarEl.getBoundingClientRect().height;
    window.scrollTo({
      top: y,
      behavior: "smooth"
    });
  }

  function updateContents() {
    setupProductItem(); // Remove the fade out class

    i$1(partial, classes$B.hideProducts);

    _scrollIntoView();
  }

  function infiniteScrollReveal() {
    setupProductItem();
  }

  return {
    updateContents: updateContents,
    infiniteScrollReveal: infiniteScrollReveal,
    destroy: function destroy() {
      var _filterbarObserver, _mobileFilterBarObser;

      (_filterbarObserver = filterbarObserver) === null || _filterbarObserver === void 0 ? void 0 : _filterbarObserver.destroy();
      (_mobileFilterBarObser = mobileFilterBarObserver) === null || _mobileFilterBarObser === void 0 ? void 0 : _mobileFilterBarObser.destroy();
    }
  };
});

var selectors$1p = {
  saleAmount: ".animation--sale-amount",
  sectionBlockItems: ".animation--section-blocks > *",
  saleItems: ".sale-promotion .sale-promotion__type,\n  .sale-promotion .sale-promotion__unit-currency,\n  .sale-promotion .sale-promotion__unit-percent,\n  .sale-promotion .sale-promotion__unit-off,\n  .sale-promotion .sale-promotion__amount,\n  .sale-promotion .sale-promotion__per-month,\n  .sale-promotion .sale-promotion__per-year,\n  .sale-promotion .sale-promotion__terms,\n  .sale-promotion .sales-banner__button"
};
var animateSalesBanner = (function (node) {
  var leftColumnDelayItems = [selectors$1p.saleAmount, selectors$1p.saleItems];
  var rightColumnDelayItems = [selectors$1p.sectionBlockItems]; // Add the animation delay offset variables

  delayOffset(node, leftColumnDelayItems);
  delayOffset(node, rightColumnDelayItems, 1);
  var observer = intersectionWatcher(node);
  return {
    destroy: function destroy() {
      observer === null || observer === void 0 ? void 0 : observer.destroy();
    }
  };
});

var selectors$1o = {
  sectionBlockItems: ".section-blocks > *"
};
var animateCountdownBanner = (function (node) {
  var observer = intersectionWatcher(node);
  delayOffset(node, [selectors$1o.sectionBlockItems]);
  return {
    destroy: function destroy() {
      observer === null || observer === void 0 ? void 0 : observer.destroy();
    }
  };
});

var selectors$1n = {
  items: "\n  .sales-banner__bar-item--heading,\n  .sales-banner__bar-text,\n  .sales-banner__button,\n  .countdown-banner__bar-item--heading,\n  .countdown-banner__bar-item--timer,\n  .countdown-banner__bar-text,\n  .countdown-banner__button"
};
var animateCountdownBar = (function (node) {
  var observer = intersectionWatcher(node);
  delayOffset(node, [selectors$1n.items]);
  return {
    destroy: function destroy() {
      observer === null || observer === void 0 ? void 0 : observer.destroy();
    }
  };
});

var animatePromotionBar = (function (node) {
  var observer = intersectionWatcher(node);
  return {
    destroy: function destroy() {
      observer === null || observer === void 0 ? void 0 : observer.destroy();
    }
  };
});

var selectors$1m = {
  headerItems: ".animation--blog-header > *",
  articleItem: ".article-item",
  pagination: ".blog__pagination"
};
var animateBlog = (function (node) {
  delayOffset(node, [selectors$1m.headerItems, selectors$1m.articleItem, selectors$1m.pagination]);
  var observer = intersectionWatcher(node, true);
  return {
    destroy: function destroy() {
      observer === null || observer === void 0 ? void 0 : observer.destroy();
    }
  };
});

var selectors$1l = {
  flyouts: "[data-filter-modal]",
  animationFilterDrawerItem: ".animation--filter-drawer-item"
};
var classes$A = {
  animationRevealed: "animation--filter-bar-revealed",
  animationFilterDrawerItem: "animation--filter-drawer-item"
};
var animateFilterDrawer = (function (node) {
  var flyouts = t$2(selectors$1l.flyouts, node);
  flyouts.forEach(_setupItemOffsets); // Set the position offset on each time to be animated

  function _setupItemOffsets(flyout) {
    delayOffset(flyout, [selectors$1l.animationFilterDrawerItem]);
  } // Trigger the reveal animation when the drawer is opened


  function open(flyout) {
    u$1(flyout, classes$A.animationRevealed);
  } // Reset the reveal animation when the drawer is closed


  function close(flyouts) {
    i$1(flyouts, classes$A.animationRevealed);
  }

  return {
    open: open,
    close: close
  };
});

var selectors$1k = {
  animationItem: ".animation--drawer-menu-item"
};
var classes$z = {
  animationRevealed: "animation--drawer-menu-revealed"
};
var animateDrawerMenu = (function (node) {
  delayOffset(node, [selectors$1k.animationItem]); // Trigger the reveal animation when the drawer is opened

  function open() {
    if (shouldAnimate(node)) {
      u$1(node, classes$z.animationRevealed);
    }
  } // Trigger the reveal animation when the drawer is opened


  function close() {
    if (shouldAnimate(node)) {
      i$1(node, classes$z.animationRevealed);
    }
  }

  return {
    open: open,
    close: close
  };
});

var selectors$1j = {
  animationItem: ".animation--quick-cart-items > *, .animation--quick-cart-footer"
};
var classes$y = {
  animationRevealed: "animation--quick-cart-revealed"
};
var animateQuickCart = (function (node) {
  setup(); // Trigger the reveal animation when the drawer is opened

  function open() {
    u$1(node, classes$y.animationRevealed);
  } // Reset the reveal animation when the drawer is closed


  function close() {
    i$1(node, classes$y.animationRevealed);
  } // Setup delay offsets


  function setup() {
    delayOffset(node, [selectors$1j.animationItem]);
  }

  return {
    open: open,
    close: close,
    setup: setup
  };
});

var selectors$1i = {
  animationItems: ".animation--quick-view-items > *"
};
var classes$x = {
  animationRevealed: "animation--quick-view-revealed"
};
var animateQuickView = (function (node) {
  function animate() {
    // Add the animation delay offset variables
    delayOffset(node, [selectors$1i.animationItems]); // Trigger the reveal animation when the quick view is opened.
    // We can't use the `.is-visible` class added in `quick-view-modal.js`
    // because it can be added before the content is fetched.

    setTimeout(function () {
      u$1(node, classes$x.animationRevealed);
    }, 0);
  }

  function reset() {
    i$1(node, classes$x.animationRevealed);
  }

  return {
    animate: animate,
    reset: reset
  };
});

var selectors$1h = {
  columns: ".meganav__list-parent > li",
  image: ".meganav__promo-image .image__img",
  overlay: ".meganav__secondary-promo-overlay",
  promoItems: ".meganav__secondary-promo-text > *",
  hasPromo: "meganav--has-promo",
  promoLeft: "meganav--promo-position-left"
};
var animateMeganav = (function (node) {
  var delayItems = [];
  var columnItems = t$2(selectors$1h.columns, node);

  if (a$1(node, selectors$1h.hasPromo)) {
    delayOffset(node, [selectors$1h.image, selectors$1h.overlay, selectors$1h.promoItems]);

    if (a$1(node, selectors$1h.promoLeft)) {
      // Set columnItem initial delay to i + 1 of previously delayed
      assignColumnDelays(columnItems, 4);
    } else {
      assignColumnDelays(columnItems);
    }
  } else {
    assignColumnDelays(columnItems);
  } // Add the animation delay offset variables


  delayOffset(node, delayItems);

  function assignColumnDelays(items) {
    var delayMultiplier = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var columnOffset;
    items.forEach(function (item, i) {
      var leftOffset = item.getBoundingClientRect ? item.getBoundingClientRect().left : item.offsetLeft;
      if (i === 0) columnOffset = leftOffset;

      if (columnOffset != leftOffset) {
        columnOffset = leftOffset;
        delayMultiplier++;
      }

      item.style.setProperty("--delay-offset-multiplier", delayMultiplier);
    });
  }
});

var selectors$1g = {
  heading: ".list-collections__heading",
  productItems: ".animation--item"
};
var animateListCollections = (function (node) {
  delayOffset(node, [selectors$1g.heading, selectors$1g.productItems]);
  var observer = intersectionWatcher(node, true);
  return {
    destroy: function destroy() {
      observer.destroy();
    }
  };
});

var selectors$1f = {
  gridItems: ".grid-item"
};
var animateGrid = (function (node) {
  delayOffset(node, [selectors$1f.gridItems]);
  var observer = intersectionWatcher(node);
  return {
    destroy: function destroy() {
      observer.destroy();
    }
  };
});

var selectors$1e = {
  animationItems: ".animation--purchase-confirmation-item",
  animationFooterItems: ".animation--purchase-confirmation-footer-item"
};
var classes$w = {
  animationRevealed: "animation--purchase-confirmation-revealed"
};
var animatePurchaseConfirmation = (function (node) {
  function animate() {
    // Add the animation delay offset variables
    delayOffset(node, [selectors$1e.animationItems]);
    delayOffset(node, [selectors$1e.animationFooterItems]); // Trigger the reveal animation when the quick view is opened.

    setTimeout(function () {
      u$1(node, classes$w.animationRevealed);
    }, 0);
  }

  function reset() {
    i$1(node, classes$w.animationRevealed);
  }

  return {
    animate: animate,
    reset: reset
  };
});

var selectors$1d = {
  pageItems: ".page-section__inner > *"
};
var animatePage = (function (node) {
  // Add the animation delay offset variables
  delayOffset(node, [selectors$1d.pageItems]);
  var observer = intersectionWatcher(node, true);
  return {
    destroy: function destroy() {
      observer.forEach(function (observer) {
        return observer.destroy();
      });
    }
  };
});

var selectors$1c = {
  items: ".collapsible-row-list__inner > *"
};
var animateCollapsibleRowList = (function (node) {
  // Add the animation delay offset variables
  delayOffset(node, [selectors$1c.items]);
  var observer = intersectionWatcher(node);
  return {
    destroy: function destroy() {
      observer === null || observer === void 0 ? void 0 : observer.destroy();
    }
  };
});

var selectors$1b = {
  items: ".animation--section-blocks > *"
};
var animateRichText = (function (node) {
  delayOffset(node, [selectors$1b.items]);
  var observer = intersectionWatcher(node, true);
  return {
    destroy: function destroy() {
      observer === null || observer === void 0 ? void 0 : observer.destroy();
    }
  };
});

var selectors$1a = {
  headerItems: ".animation--section-introduction > *",
  articleItem: ".article-item"
};
var animateBlogPosts = (function (node) {
  delayOffset(node, [selectors$1a.headerItems, selectors$1a.articleItem]);
  var observer = intersectionWatcher(node, true);
  return {
    destroy: function destroy() {
      observer === null || observer === void 0 ? void 0 : observer.destroy();
    }
  };
});

var selectors$19 = {
  intro: ".animation--section-introduction > *",
  items: ".animation--item"
};
var animateFeaturedCollectionGrid = (function (node) {
  delayOffset(node, [selectors$19.intro, selectors$19.items]);
  var observer = intersectionWatcher(node);
  return {
    destroy: function destroy() {
      observer === null || observer === void 0 ? void 0 : observer.destroy();
    }
  };
});

var selectors$18 = {
  productItems: ".animation--item",
  introductionItems: ".animation--section-introduction > *"
};
var animateCollectionListGrid = (function (node) {
  delayOffset(node, [selectors$18.introductionItems, selectors$18.productItems]);
  var observer = intersectionWatcher(node);
  return {
    destroy: function destroy() {
      observer === null || observer === void 0 ? void 0 : observer.destroy();
    }
  };
});

var selectors$17 = {
  animationItems: ".animation--store-availability-drawer-items > *"
};
var classes$v = {
  animationRevealed: "animation--store-availability-drawer-revealed"
};
var animateStoreAvailabilityDrawer = (function (node) {
  function animate() {
    // Set the position offset on each time to be animated
    var items = t$2(selectors$17.animationItems, node);
    items.forEach(function (item, i) {
      item.style.setProperty("--position-offset-multiplier", i);
    }); // Trigger the reveal animation when the quick view is opened.
    // We can't use the `.is-visible` class added in `quick-view-modal.js`
    // because it can be added before the content is fetched.

    setTimeout(function () {
      u$1(node, classes$v.animationRevealed);
    }, 0);
  }

  function reset() {
    i$1(node, classes$v.animationRevealed);
  }

  return {
    animate: animate,
    reset: reset
  };
});

var selectors$16 = {
  media: ".animation--product-media"
};
var animateProduct = (function (node) {
  // Add the animation delay offset variables
  delayOffset(node, [selectors$16.media]);
  var observer = intersectionWatcher(node, true);
  return {
    destroy: function destroy() {
      observer === null || observer === void 0 ? void 0 : observer.destroy();
    }
  };
});

var selectors$15 = {
  headerItems: ".animation--section-introduction > *",
  animationItem: ".animation--item"
};
var animateContactForm = (function (node) {
  delayOffset(node, [selectors$15.headerItems, selectors$15.animationItem]);
  var observer = intersectionWatcher(node, true);
  return {
    destroy: function destroy() {
      observer === null || observer === void 0 ? void 0 : observer.destroy();
    }
  };
});

var selectors$14 = {
  partial: "[data-partial]",
  filterBar: "[data-filter-bar]",
  mobileFilterBar: "[data-mobile-filters]",
  productItems: ".animation--item:not(.animation--item-revealed)"
};
var classes$u = {
  hideProducts: "animation--search-products-hide",
  itemRevealed: "animation--item-revealed"
};
var animateSearch = (function (node) {
  var partial = n$2(selectors$14.partial, node);
  var filterbarEl = n$2(selectors$14.filterBar, node);
  var mobileFilterBarEl = n$2(selectors$14.mobileFilterBar, node);
  var filterbarObserver = null;

  if (filterbarEl) {
    filterbarObserver = intersectionWatcher(filterbarEl, true);
  }

  var mobileFilterBarObserver = null;

  if (mobileFilterBarEl) {
    mobileFilterBarObserver = intersectionWatcher(mobileFilterBarEl, true);
  }

  _setupProductItem();

  function _setupProductItem() {
    var productItems = t$2(selectors$14.productItems, node);
    delayOffset(node, [selectors$14.productItems]);
    setTimeout(function () {
      u$1(productItems, classes$u.itemRevealed);
    }, 0);
  } // Scroll to top of search grid after applying filters
  // to show the newly filtered list of products


  function _scrollIntoView() {
    var y = partial.getBoundingClientRect().top + window.pageYOffset - filterbarEl.getBoundingClientRect().height;
    window.scrollTo({
      top: y,
      behavior: "smooth"
    });
  }

  function updateContents() {
    _setupProductItem(); // Remove the fade out class


    i$1(partial, classes$u.hideProducts);

    _scrollIntoView();
  }

  function infiniteScrollReveal() {
    _setupProductItem();
  }

  return {
    updateContents: updateContents,
    infiniteScrollReveal: infiniteScrollReveal,
    destroy: function destroy() {
      var _filterbarObserver, _mobileFilterBarObser;

      (_filterbarObserver = filterbarObserver) === null || _filterbarObserver === void 0 ? void 0 : _filterbarObserver.destroy();
      (_mobileFilterBarObser = mobileFilterBarObserver) === null || _mobileFilterBarObser === void 0 ? void 0 : _mobileFilterBarObser.destroy();
    }
  };
});

var selectors$13 = {
  content: ".animation--section-blocks > *"
};
var animateSearchBanner = (function (node) {
  // Add the animation delay offset variables
  delayOffset(node, [selectors$13.content]);
  var observer = intersectionWatcher(node);
  return {
    destroy: function destroy() {
      observer === null || observer === void 0 ? void 0 : observer.destroy();
    }
  };
});

var selectors$12 = {
  headerItems: ".animation--section-introduction > *",
  columnItems: ".multi-column__grid-item"
};
var animateMultiColumn = (function (node) {
  delayOffset(node, [selectors$12.headerItems, selectors$12.columnItems]);
  var observer = intersectionWatcher(node);
  return {
    destroy: function destroy() {
      observer.destroy();
    }
  };
});

var selectors$11 = {
  textContent: ".password__text-container-inner > *"
};
var animatePassword = (function (node) {
  // Add the animation delay offset variables
  delayOffset(node, [selectors$11.textContent], 3);
  var observer = intersectionWatcher(node);
  return {
    destroy: function destroy() {
      observer === null || observer === void 0 ? void 0 : observer.destroy();
    }
  };
});

var selectors$10 = {
  animationItem: ".animation--popup-item"
};
var classes$t = {
  animationRevealed: "animation--popup-revealed"
};
var animatePopup = (function (node) {
  delayOffset(node, [selectors$10.animationItem]); // Trigger the reveal animation when the drawer is opened

  function open() {
    if (shouldAnimate(node)) {
      u$1(node, classes$t.animationRevealed);
    }
  } // Trigger the reveal animation when the drawer is opened


  function close() {
    if (shouldAnimate(node)) {
      i$1(node, classes$t.animationRevealed);
    }
  }

  return {
    open: open,
    close: close
  };
});

var selectors$$ = {
  items: ".animation--section-blocks > *"
};
var animateNewsletter = (function (node) {
  delayOffset(node, [selectors$$.items]);
  var observer = intersectionWatcher(node, true);
  return {
    destroy: function destroy() {
      observer === null || observer === void 0 ? void 0 : observer.destroy();
    }
  };
});

var selectors$_ = {
  items: ".animation--section-blocks > *"
};
var animateNewsletterCompact = (function (node) {
  delayOffset(node, [selectors$_.items]);
  var observer = intersectionWatcher(node, true);
  return {
    destroy: function destroy() {
      observer === null || observer === void 0 ? void 0 : observer.destroy();
    }
  };
});

var selectors$Z = {
  headerItems: ".animation--section-introduction > *",
  eventItems: ".event-item"
};
var animateEvents = (function (node) {
  delayOffset(node, [selectors$Z.headerItems]);
  var observer = intersectionWatcher(node, true);

  function animateEventItems() {
    delayOffset(node, [selectors$Z.eventItems]);
    setTimeout(function () {
      u$1(node, "animate-event-items");
    }, 50);
  }

  return {
    animateEventItems: animateEventItems,
    destroy: function destroy() {
      observer === null || observer === void 0 ? void 0 : observer.destroy();
    }
  };
});

var selectors$Y = {
  giantHeading: ".animation--giant-heading",
  sectionBlockItems: ".animation--section-blocks > *"
};
var animatePromoBanner = (function (node) {
  // Add the animation delay offset variables
  delayOffset(node, [selectors$Y.giantHeading, selectors$Y.sectionBlockItems]);
  var observer = intersectionWatcher(node);
  return {
    destroy: function destroy() {
      observer === null || observer === void 0 ? void 0 : observer.destroy();
    }
  };
});

var selectors$X = {
  controls: ".product-tabs__tab-buttons",
  items: ".product-tabs__tab-list-wrapper",
  accordionItems: ".accordion"
};
var animateProductTabs = (function (node) {
  // Add the animation delay offset variables
  delayOffset(node, [selectors$X.controls, selectors$X.items]);
  delayOffset(node, [selectors$X.accordionItems]);
  var observer = intersectionWatcher(node);
  return {
    destroy: function destroy() {
      observer === null || observer === void 0 ? void 0 : observer.destroy();
    }
  };
});

var selectors$W = {
  intro: ".animation--section-introduction > *",
  items: ".animation--item"
};
var animateApps = (function (node) {
  delayOffset(node, [selectors$W.intro, selectors$W.items]);
  var observer = intersectionWatcher(node);
  return {
    destroy: function destroy() {
      observer === null || observer === void 0 ? void 0 : observer.destroy();
    }
  };
});

function makeRequest(method, url) {
  return new Promise(function (resolve, reject) {
    var xhr = new XMLHttpRequest();
    xhr.open(method, url);

    xhr.onload = function () {
      if (this.status >= 200 && this.status < 300) {
        resolve(xhr.response);
      } else {
        reject(new Error(this.status));
      }
    };

    xhr.onerror = function () {
      reject(new Error(this.status));
    };

    xhr.send();
  });
}

var classes$s = {
  active: "active"
};
var selectors$V = {
  drawerTrigger: "[data-store-availability-drawer-trigger]",
  closeBtn: "[data-store-availability-close]",
  productTitle: "[data-store-availability-product-title]",
  variantTitle: "[data-store-availability-variant-title]",
  storeListContainer: "[data-store-list-container]",
  storeListContent: "[data-store-availability-list-content]",
  wash: "[data-store-availability-drawer-wash]",
  parentWrapper: "[data-store-availability-container]"
};

var storeAvailabilityDrawer = function storeAvailabilityDrawer(node) {
  var focusTrap = createFocusTrap(node, {
    allowOutsideClick: true
  });
  var wash = n$2(selectors$V.wash, node.parentNode);
  var productTitleContainer = n$2(selectors$V.productTitle);
  var variantTitleContainer = n$2(selectors$V.variantTitle);
  var storeListContainer = n$2(selectors$V.storeListContainer, node);
  var storeAvailabilityDrawerAnimate = null;

  if (shouldAnimate(node)) {
    storeAvailabilityDrawerAnimate = animateStoreAvailabilityDrawer(node);
  }

  var events = [e$2([n$2(selectors$V.closeBtn, node), wash], "click", function (e) {
    e.preventDefault();

    _close();
  }), e$2(node, "keydown", function (_ref) {
    var keyCode = _ref.keyCode;
    if (keyCode === 27) _close();
  })];

  var _handleClick = function _handleClick(target) {
    var parentContainer = target.closest(selectors$V.parentWrapper);
    var _parentContainer$data = parentContainer.dataset,
        baseUrl = _parentContainer$data.baseUrl,
        variantId = _parentContainer$data.variantId,
        productTitle = _parentContainer$data.productTitle,
        variantTitle = _parentContainer$data.variantTitle;
    var variantSectionUrl = "".concat(baseUrl, "/variants/").concat(variantId, "/?section_id=store-availability");
    makeRequest("GET", variantSectionUrl).then(function (storeAvailabilityHTML) {
      var container = document.createElement("div");
      container.innerHTML = storeAvailabilityHTML;
      productTitleContainer.innerText = productTitle; // Shopify returns string null on variant titles for products without varians

      variantTitleContainer.innerText = variantTitle === "null" ? "" : variantTitle;
      var storeList = n$2(selectors$V.storeListContent, container);
      storeListContainer.innerHTML = "";
      storeListContainer.appendChild(storeList);
    }).then(_open);
  };

  var _open = function _open() {
    u$1(node, classes$s.active);

    if (shouldAnimate(node)) {
      storeAvailabilityDrawerAnimate.animate();
    }

    node.setAttribute("aria-hidden", "false");
    focusTrap.activate();
    document.body.setAttribute("data-fluorescent-overlay-open", "true");
    disableBodyScroll(node, {
      allowTouchMove: function allowTouchMove(el) {
        while (el && el !== document.body) {
          if (el.getAttribute("data-scroll-lock-ignore") !== null) {
            return true;
          }

          el = el.parentNode;
        }
      },
      reserveScrollBarGap: true
    });
  };

  var _close = function _close() {
    focusTrap.deactivate();
    i$1(node, classes$s.active);
    node.setAttribute("aria-hidden", "true");
    setTimeout(function () {
      if (shouldAnimate(node)) {
        storeAvailabilityDrawerAnimate.reset();
      }

      document.body.setAttribute("data-fluorescent-overlay-open", "false");
      enableBodyScroll(node);
    }, 500);
  };

  var delegate = new Delegate(document.body);
  delegate.on("click", selectors$V.drawerTrigger, function (_, target) {
    return _handleClick(target);
  });

  var unload = function unload() {
    events.forEach(function (unsubscribe) {
      return unsubscribe();
    });
  };

  return {
    unload: unload
  };
};

var strings$7 = window.theme.strings.accessibility;

var handleTab = function handleTab() {
  var tabHandler = null;
  var formElments = ["INPUT", "TEXTAREA", "SELECT"]; // Determine if the user is a mouse or keyboard user

  function handleFirstTab(e) {
    if (e.keyCode === 9 && !formElments.includes(document.activeElement.tagName)) {
      document.body.classList.add("user-is-tabbing");
      tabHandler();
      tabHandler = e$2(window, "mousedown", handleMouseDownOnce);
    }
  }

  function handleMouseDownOnce() {
    document.body.classList.remove("user-is-tabbing");
    tabHandler();
    tabHandler = e$2(window, "keydown", handleFirstTab);
  }

  tabHandler = e$2(window, "keydown", handleFirstTab);
};

var focusFormStatus = function focusFormStatus(node) {
  var formStatus = n$2(".form-status", node);
  if (!formStatus) return;
  var focusElement = n$2("[data-form-status]", formStatus);
  if (!focusElement) return;
  focusElement.focus();
};

var prefersReducedMotion = function prefersReducedMotion() {
  return window.matchMedia("(prefers-reduced-motion: reduce)").matches;
};

function backgroundVideoHandler(container) {
  var pause = n$2(".video-pause", container);
  var video = container.getElementsByTagName("VIDEO")[0];
  if (!pause || !video) return;

  var pauseVideo = function pauseVideo() {
    video.pause();
    pause.innerText = strings$7.play_video;
  };

  var playVideo = function playVideo() {
    video.play();
    pause.innerText = strings$7.pause_video;
  };

  if (prefersReducedMotion()) {
    pauseVideo();
  }

  var pauseListener = e$2(pause, "click", function (e) {
    e.preventDefault();

    if (video.paused) {
      playVideo();
    } else {
      pauseVideo();
    }
  });
  return function () {
    return pauseListener();
  };
}

var classes$r = {
  hidden: "hidden"
};
var sectionClasses = (function () {
  function adjustClasses() {
    var sections = t$2(".main .shopify-section");
    sections.forEach(function (section) {
      var child = section.firstElementChild; // Specific to recommended hidden products

      if (child && child.classList.contains(classes$r.hidden)) {
        u$1(section, classes$r.hidden);
      }
    });
  }

  adjustClasses();
  e$2(document, "shopify:section:load", adjustClasses);
});

var dispatchCustomEvent = function dispatchCustomEvent(eventName) {
  var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var detail = {
    detail: data
  };
  var event = new CustomEvent(eventName, data ? detail : null);
  document.dispatchEvent(event);
};

/**
 * Returns a product JSON object when passed a product URL
 * @param {*} url
 */

/**
 * Find a match in the project JSON (using a ID number) and return the variant (as an Object)
 * @param {Object} product Product JSON object
 * @param {Number} value Accepts Number (e.g. 6908023078973)
 * @returns {Object} The variant object once a match has been successful. Otherwise null will be return
 */
function getVariantFromId(product, value) {
  _validateProductStructure(product);

  if (typeof value !== 'number') {
    throw new TypeError(value + ' is not a Number.');
  }

  var result = product.variants.filter(function(variant) {
    return variant.id === value;
  });

  return result[0] || null;
}

/**
 * Convert the Object (with 'name' and 'value' keys) into an Array of values, then find a match & return the variant (as an Object)
 * @param {Object} product Product JSON object
 * @param {Object} collection Object with 'name' and 'value' keys (e.g. [{ name: "Size", value: "36" }, { name: "Color", value: "Black" }])
 * @returns {Object || null} The variant object once a match has been successful. Otherwise null will be returned
 */
function getVariantFromSerializedArray(product, collection) {
  _validateProductStructure(product);

  // If value is an array of options
  var optionArray = _createOptionArrayFromOptionCollection(product, collection);
  return getVariantFromOptionArray(product, optionArray);
}

/**
 * Find a match in the project JSON (using Array with option values) and return the variant (as an Object)
 * @param {Object} product Product JSON object
 * @param {Array} options List of submitted values (e.g. ['36', 'Black'])
 * @returns {Object || null} The variant object once a match has been successful. Otherwise null will be returned
 */
function getVariantFromOptionArray(product, options) {
  _validateProductStructure(product);
  _validateOptionsArray(options);

  var result = product.variants.filter(function(variant) {
    return options.every(function(option, index) {
      return variant.options[index] === option;
    });
  });

  return result[0] || null;
}

/**
 * Creates an array of selected options from the object
 * Loops through the project.options and check if the "option name" exist (product.options.name) and matches the target
 * @param {Object} product Product JSON object
 * @param {Array} collection Array of object (e.g. [{ name: "Size", value: "36" }, { name: "Color", value: "Black" }])
 * @returns {Array} The result of the matched values. (e.g. ['36', 'Black'])
 */
function _createOptionArrayFromOptionCollection(product, collection) {
  _validateProductStructure(product);
  _validateSerializedArray(collection);

  var optionArray = [];

  collection.forEach(function(option) {
    for (var i = 0; i < product.options.length; i++) {
      if (product.options[i].name.toLowerCase() === option.name.toLowerCase()) {
        optionArray[i] = option.value;
        break;
      }
    }
  });

  return optionArray;
}

/**
 * Check if the product data is a valid JS object
 * Error will be thrown if type is invalid
 * @param {object} product Product JSON object
 */
function _validateProductStructure(product) {
  if (typeof product !== 'object') {
    throw new TypeError(product + ' is not an object.');
  }

  if (Object.keys(product).length === 0 && product.constructor === Object) {
    throw new Error(product + ' is empty.');
  }
}

/**
 * Validate the structure of the array
 * It must be formatted like jQuery's serializeArray()
 * @param {Array} collection Array of object [{ name: "Size", value: "36" }, { name: "Color", value: "Black" }]
 */
function _validateSerializedArray(collection) {
  if (!Array.isArray(collection)) {
    throw new TypeError(collection + ' is not an array.');
  }

  if (collection.length === 0) {
    return [];
  }

  if (collection[0].hasOwnProperty('name')) {
    if (typeof collection[0].name !== 'string') {
      throw new TypeError(
        'Invalid value type passed for name of option ' +
          collection[0].name +
          '. Value should be string.'
      );
    }
  } else {
    throw new Error(collection[0] + 'does not contain name key.');
  }
}

/**
 * Validate the structure of the array
 * It must be formatted as list of values
 * @param {Array} collection Array of object (e.g. ['36', 'Black'])
 */
function _validateOptionsArray(options) {
  if (Array.isArray(options) && typeof options[0] === 'object') {
    throw new Error(options + 'is not a valid array of options.');
  }
}

// Public Methods
// -----------------------------------------------------------------------------

/**
 * Returns a URL with a variant ID query parameter. Useful for updating window.history
 * with a new URL based on the currently select product variant.
 * @param {string} url - The URL you wish to append the variant ID to
 * @param {number} id  - The variant ID you wish to append to the URL
 * @returns {string} - The new url which includes the variant ID query parameter
 */

function getUrlWithVariant(url, id) {
  if (/variant=/.test(url)) {
    return url.replace(/(variant=)[^&]+/, '$1' + id);
  } else if (/\?/.test(url)) {
    return url.concat('&variant=').concat(id);
  }

  return url.concat('?variant=').concat(id);
}

var selectors$U = {
  sentinal: ".scroll-sentinal",
  scrollButtons: ".scroll-button",
  scrollViewport: "[data-scroll-container-viewport]"
};

var scrollContainer = function scrollContainer(node) {
  var sentinals = t$2(selectors$U.sentinal, node);
  var buttons = t$2(selectors$U.scrollButtons, node);
  var _node$dataset = node.dataset,
      axis = _node$dataset.axis,
      startAtEnd = _node$dataset.startAtEnd;
  var scrollerViewport = n$2(selectors$U.scrollViewport, node);
  window.addEventListener("load", function () {
    u$1(node, "scroll-container-initialized");

    if (startAtEnd === "true") {
      _startAtEnd();
    }
  }, {
    once: true
  });
  var events = [e$2(buttons, "click", function (e) {
    var button = e.currentTarget;
    var scrollAttribute = axis == "vertical" ? "scrollTop" : "scrollLeft";
    var scrollOffset = 100;

    if (button.dataset.position === "start") {
      if (scrollerViewport[scrollAttribute] < scrollOffset * 1.5) {
        scrollerViewport[scrollAttribute] = 0;
      } else {
        scrollerViewport[scrollAttribute] -= scrollOffset;
      }
    } else {
      scrollerViewport[scrollAttribute] += scrollOffset;
    }
  })];
  var ioOptions = {
    root: scrollerViewport
  };
  var intersectionObserver = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      var position = entry.target.dataset.position;
      var visible = entry.isIntersecting;
      node.setAttribute("data-at-".concat(position), visible ? "true" : "false");
    });
  }, ioOptions);
  sentinals.forEach(function (sentinal) {
    intersectionObserver.observe(sentinal);
  });

  var unload = function unload() {
    sentinals.forEach(function (sentinal) {
      intersectionObserver.unobserve(sentinal);
    });
    events.forEach(function (unsubscribe) {
      return unsubscribe();
    });
  };

  function _startAtEnd() {
    var scrollAttribute = axis == "vertical" ? "scrollTop" : "scrollLeft";
    var scrollDirection = axis == "vertical" ? "scrollHeight" : "scrollWidth";
    scrollerViewport[scrollAttribute] = scrollerViewport[scrollDirection] * 2;
    node.dataset.startAtEnd = false;
  }

  return {
    unload: unload
  };
};

var n,e,i,o,t,r,f,d,p,u=[];function w(n,a){return e=window.pageXOffset,o=window.pageYOffset,r=window.innerHeight,d=window.innerWidth,void 0===i&&(i=e),void 0===t&&(t=o),void 0===p&&(p=d),void 0===f&&(f=r),(a||o!==t||e!==i||r!==f||d!==p)&&(!function(n){for(var w=0;w<u.length;w++)u[w]({x:e,y:o,px:i,py:t,vh:r,pvh:f,vw:d,pvw:p},n);}(n),i=e,t=o,f=r,p=d),requestAnimationFrame(w)}function srraf(e){return u.indexOf(e)<0&&u.push(e),n=n||w(performance.now()),{update:function(){return w(performance.now(),!0),this},destroy:function(){u.splice(u.indexOf(e),1);}}}

var atBreakpointChange = function atBreakpointChange(breakpointToWatch, callback) {
  var _screenUnderBP = function _screenUnderBP() {
    var viewportWidth = window.innerWidth || document.documentElement.clientWidth;
    return viewportWidth <= breakpointToWatch;
  };

  var screenUnderBP = _screenUnderBP();

  var widthWatcher = srraf(function (_ref) {
    var vw = _ref.vw;
    var currentScreenWidthUnderBP = vw <= breakpointToWatch;

    if (currentScreenWidthUnderBP !== screenUnderBP) {
      screenUnderBP = currentScreenWidthUnderBP;
      return callback();
    }
  });

  var unload = function unload() {
    widthWatcher.destroy();
  };

  return {
    unload: unload
  };
};

var sel$3 = {
  container: ".social-share",
  button: ".social-share__button",
  popup: ".social-sharing__popup",
  copyURLButton: ".social-share__copy-url",
  successMessage: ".social-share__success-message"
};
var classes$q = {
  hidden: "hidden",
  linkCopied: "social-sharing__popup--success"
};
var SocialShare = (function (node) {
  if (!node) return Function();
  var button = n$2(sel$3.button, node);
  var popup = n$2(sel$3.popup, node);
  var copyURLButton = n$2(sel$3.copyURLButton, node);
  var successMessage = n$2(sel$3.successMessage, node);
  var clickListener = e$2(window, "click", handleClick); // Hide copy button on old browsers

  if (!navigator.clipboard || !navigator.clipboard.writeText) {
    u$1(copyURLButton, classes$q.hidden);
  }

  function handleClick(evt) {
    var buttonClicked = evt.target.closest(sel$3.button) === button;
    var popupClicked = evt.target.closest(sel$3.popup) === popup;
    var copyURLClicked = evt.target.closest(sel$3.copyURLButton) === copyURLButton;
    var isActive = false;

    if (buttonClicked) {
      isActive = button.getAttribute("aria-expanded") === "true";
    } // click happend outside of this popup


    if (!popupClicked) {
      close();
    } // click happend in this social button and the button is not active


    if (buttonClicked && !isActive) {
      open();
    }

    if (copyURLClicked) {
      var url = copyURLButton.dataset.url;
      writeToClipboard(url).then(showSuccessMessage, showErrorMessage);
    }
  }

  function close() {
    button.setAttribute("aria-expanded", false);
    popup.setAttribute("aria-hidden", true);
  }

  function open() {
    button.setAttribute("aria-expanded", true);
    popup.setAttribute("aria-hidden", false);
  }

  function writeToClipboard(str) {
    return navigator.clipboard.writeText(str);
  }

  function showMessage(message) {
    successMessage.innerHTML = message;
    i$1(successMessage, classes$q.hidden);
    u$1(popup, classes$q.linkCopied);
    setTimeout(function () {
      u$1(successMessage, classes$q.hidden);
      i$1(popup, classes$q.linkCopied);
    }, 2000);
  }

  function showSuccessMessage() {
    var successMessage = copyURLButton.dataset.successMessage;
    showMessage(successMessage);
  }

  function showErrorMessage() {
    var errorMessage = copyURLButton.dataset.errorMessage;
    showMessage(errorMessage || "Error copying link.");
  }

  function destroy() {
    close();
    clickListener();
  }

  return destroy;
});

function localStorageAvailable() {
  var test = "test";

  try {
    localStorage.setItem(test, test);

    if (localStorage.getItem(test) !== test) {
      return false;
    }

    localStorage.removeItem(test);
    return true;
  } catch (e) {
    return false;
  }
}

var PREFIX = "fluco_";

function getStorage(key) {
  if (!localStorageAvailable()) return null;
  return JSON.parse(localStorage.getItem(PREFIX + key));
}

function removeStorage(key) {
  if (!localStorageAvailable()) return null;
  localStorage.removeItem(PREFIX + key);
  return true;
}

function setStorage(key, val) {
  if (!localStorageAvailable()) return null;
  localStorage.setItem(PREFIX + key, val);
  return true;
}

var routes = window.theme.routes.cart || {};
var paths = {
  base: "".concat(routes.base || "/cart", ".js"),
  add: "".concat(routes.add || "/cart/add", ".js"),
  change: "".concat(routes.change || "/cart/change", ".js"),
  clear: "".concat(routes.clear || "/cart/clear", ".js"),
  update: "".concat(routes.update || "/cart/update", ".js")
};
var strings$6 = window.theme.strings.cart; // Add a `sorted` key that orders line items
// in the order the customer added them if possible

function sortCart(cart) {
  var order = getStorage("cart_order") || [];

  if (order.length) {
    cart.sorted = _toConsumableArray$1(cart.items).sort(function (a, b) {
      return order.indexOf(a.variant_id) - order.indexOf(b.variant_id);
    });
    return cart;
  }

  cart.sorted = cart.items;
  return cart;
}

async function updateItem(key, quantity, updateCartView = true) {
  const cart = await get();
  const items = cart.items;

  for (let i = 0; i < items.length; i++) {
    if (items[i].key === key) {
      return changeItem(i + 1, key, quantity, updateCartView); // shopify cart is a 1-based index
    }
  }
}

async function updateItemByRandomId(id, quantity) {
  const cart = await get();
  const items = cart.items;

  for (var i = 0; i < items.length; i++) {
    if (items[i].properties["_id"] == +id && items[i].product_type == "Lenses") {
      return changeItemByRandomId(i + 1, quantity); // shopify cart is a 1-based index
    }
  }
}

function changeItemByRandomId(line, quantity) {
  return fetch(paths.change, {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify({
      line: line,
      quantity: quantity
    })
  }).then(function (res) {
    return res.json();
  }).then(function (cart) {
    if(!cart.items) return;
    r$1("cart:updated", {
      cart: cart
    });
    r$1("quick-cart:updated");
    return sortCart(cart);
  });
}

function changeItem(line, itemKey, quantity, updateCartView) {
  return fetch(paths.change, {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify({
      line: line,
      quantity: quantity
    })
  }).then(function (res) {
    return res.json();
  }).then(function (cart) {
    if(!updateCartView) return;
    if(!cart.items) return;

    var item = cart.items.find(function (_ref2) {
      var key = _ref2.key;
      return key === itemKey;
    }); // Throw error only if the quantity returned is less by one
    // then the quantity change request. This is triggered when a
    // increase quantity button is pressed when insufficient quantity
    // exists.
    // item will not exist if it has been removed from the cart.

    if (item && item.quantity === quantity - 1) {
      var errorMessage = {
        code: 422,
        message: strings$6.quantityError
      };
      dispatchCustomEvent("cart:error", {
        errorMessage: strings$6.quantityError
      });
      r$1("quick-cart:error", null, {
        key: itemKey,
        errorMessage: strings$6.quantityError
      });
      r$1("cart:error", null, {
        key: itemKey,
        errorMessage: strings$6.quantityError
      });
      throw errorMessage;
    }

    r$1("cart:updated", {
      cart: cart
    });
    r$1("quick-cart:updated");
    return sortCart(cart);
  });
}

function addItemById(id, quantity, properties = {}) {
  r$1("cart:updating");
  var data = {
    items: [{
      id,
      quantity,
      properties
    }]
  };
  return fetch(paths.add, {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify(data)
  }).then(function (r) {
    return r.json();
  }).then(function (res) {
    if (res.status == "422") {
      var errorMessage = {
        code: 422,
        message: res.description
      };
      dispatchCustomEvent("cart:error", {
        errorMessage: res.description
      });
      r$1("quick-cart:error", null, {
        id: id
      });
      r$1("cart:error", null, {
        id: id
      });
      throw errorMessage;
    }

    return get().then(function (cart) {
      r$1("quick-cart:updated");
      r$1("cart:updated", {
        cart: cart
      });
      return {
        res: res,
        cart: cart
      };
    });
  });
}

function get() {
  return fetch(paths.base, {
    method: "GET",
    credentials: "include"
  }).then(function (res) {
    return res.json();
  }).then(function (data) {
    var sortedData = sortCart(data);
    return sortedData;
  });
}

function addItem(form) {
  let body = serialize(form);
  let formData = new FormData(form);

  const selector = document.querySelector("#variant-selector");
  const index = selector.selectedIndex;

  if(index == -1){
    document.querySelector("#variant-selector option[selected]").selected = true;
  }
  
  const selectedId = selector.options[selector.selectedIndex].value;

  if(!formData.get("id")) body = body.replace("&id=", `&id=${selectedId}`);

  r$1("cart:updating");
  return fetch(paths.add, {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
      "X-Requested-With": "XMLHttpRequest"
    },
    body
  }).then(function (r) {
    return r.json();
  }).then(function (res) {
    if (res.status == "422") {
      var errorMessage = {
        code: 422,
        message: res.description
      };
      dispatchCustomEvent("cart:error", {
        errorMessage: res.description
      });
      throw errorMessage;
    }

    return get().then(function (cart) {
      var order = getStorage("cart_order") || [];
      var newOrder = [res.variant_id].concat(_toConsumableArray$1(order.filter(function (i) {
        return i !== res.variant_id;
      })));
      setStorage("cart_order", JSON.stringify(newOrder));
      r$1("cart:updated", {
        cart: sortCart(cart)
      });
      r$1("quick-cart:updated");
      r$1("quick-view:close");
      dispatchCustomEvent("cart:updated", {
        cart: sortCart(cart)
      });
      return {
        item: res,
        cart: sortCart(cart)
      };
    });
  });
} // !
//  Serialize all form data into a SearchParams string
//  (c) 2020 Chris Ferdinandi, MIT License, https://gomakethings.com
//  @param  {Node}   form The form to serialize
//  @return {String}      The serialized form data
//


function serialize(form) {
  var arr = [];
  Array.prototype.slice.call(form.elements).forEach(function (field) {
    if (!field.name || field.disabled || ["file", "reset", "submit", "button"].indexOf(field.type) > -1) {
      return;
    }

    if (field.type === "select-multiple") {
      Array.prototype.slice.call(field.options).forEach(function (option) {
        if (!option.selected) return;
        arr.push(encodeURIComponent(field.name) + "=" + encodeURIComponent(option.value));
      });
      return;
    }

    if (["checkbox", "radio"].indexOf(field.type) > -1 && !field.checked) {
      return;
    }

    arr.push(encodeURIComponent(field.name) + "=" + encodeURIComponent(field.value));
  });
  return arr.join("&");
}

var cart = {
  addItem: addItem,
  get: get,
  updateItem: updateItem,
  addItemById: addItemById,
  updateItemByRandomId: updateItemByRandomId
};

/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 */

const moneyFormat = '${{amount}}';

const locale = document.documentElement.getAttribute('lang');
const localeKey = window.location.pathname.split("/")?.[1].length == 2 ? window.location.pathname.split("/")?.[1] : "";
var langCountry = "en-CA";
if(locale == "fr" || locale == "fr-CA"){
  langCountry = "fr-CA";
}

/**
 * Format money values based on your shop currency settings
 * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
 * or 3.00 dollars
 * @param  {String} format - shop money_format setting
 * @return {String} value - formatted value
 */
function formatMoney$1(cents, format) {
  if (typeof cents === 'string') {
    cents = cents.replace('.', '');
  }
  let value = '';
  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  const formatString = format || moneyFormat;

  function formatWithDelimiters(
    number,
    precision = 2,
    thousands = ',',
    decimal = '.'
  ) {
    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    const parts = number.split('.');
    const dollarsAmount = parts[0].replace(
      /(\d)(?=(\d\d\d)+(?!\d))/g,
      `$1${thousands}`
    );
    const centsAmount = parts[1] ? decimal + parts[1] : '';

    return dollarsAmount + centsAmount;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return new Intl.NumberFormat(langCountry, { style: 'currency', currency: 'CAD' }).format(value);
}

var formatMoney = (function (val) {
  return formatMoney$1(val, window.theme.moneyFormat || "${{amount}}");
});

// Fetch the product data from the .js endpoint because it includes
// more data than the .json endpoint.
var getProduct = (function (handle) {
  return function (cb) {
    return fetch("".concat(window.theme.routes.products, "/").concat(handle, ".js")).then(function (res) {
      return res.json();
    }).then(function (data) {
      return cb(data);
    }).catch(function (err) {
      return console.log(err.message);
    });
  };
});

/*!
 * slide-anim
 * https://github.com/yomotsu/slide-anim
 * (c) 2017 @yomotsu
 * Released under the MIT License.
 */
var global = window;
var isPromiseSuppoted = typeof global.Promise === 'function';
var PromiseLike = isPromiseSuppoted ? global.Promise : (function () {
    function PromiseLike(executor) {
        var callback = function () { };
        var resolve = function () {
            callback();
        };
        executor(resolve);
        return {
            then: function (_callback) {
                callback = _callback;
            }
        };
    }
    return PromiseLike;
}());

var pool = [];
var inAnimItems = {
    add: function (el, defaultStyle, timeoutId, onCancelled) {
        var inAnimItem = { el: el, defaultStyle: defaultStyle, timeoutId: timeoutId, onCancelled: onCancelled };
        this.remove(el);
        pool.push(inAnimItem);
    },
    remove: function (el) {
        var index = inAnimItems.findIndex(el);
        if (index === -1)
            return;
        var inAnimItem = pool[index];
        clearTimeout(inAnimItem.timeoutId);
        inAnimItem.onCancelled();
        pool.splice(index, 1);
    },
    find: function (el) {
        return pool[inAnimItems.findIndex(el)];
    },
    findIndex: function (el) {
        var index = -1;
        pool.some(function (item, i) {
            if (item.el === el) {
                index = i;
                return true;
            }
            return false;
        });
        return index;
    }
};

var CSS_EASEOUT_EXPO = 'cubic-bezier( 0.19, 1, 0.22, 1 )';
function slideDown(el, options) {
    if (options === void 0) { options = {}; }
    return new PromiseLike(function (resolve) {
        if (inAnimItems.findIndex(el) !== -1)
            return;
        var _isVisible = isVisible(el);
        var hasEndHeight = typeof options.endHeight === 'number';
        var display = options.display || 'block';
        var duration = options.duration || 400;
        var onCancelled = options.onCancelled || function () { };
        var defaultStyle = el.getAttribute('style') || '';
        var style = window.getComputedStyle(el);
        var defaultStyles = getDefaultStyles(el, display);
        var isBorderBox = /border-box/.test(style.getPropertyValue('box-sizing'));
        var contentHeight = defaultStyles.height;
        var minHeight = defaultStyles.minHeight;
        var paddingTop = defaultStyles.paddingTop;
        var paddingBottom = defaultStyles.paddingBottom;
        var borderTop = defaultStyles.borderTop;
        var borderBottom = defaultStyles.borderBottom;
        var cssDuration = duration + "ms";
        var cssEasing = CSS_EASEOUT_EXPO;
        var cssTransition = [
            "height " + cssDuration + " " + cssEasing,
            "min-height " + cssDuration + " " + cssEasing,
            "padding " + cssDuration + " " + cssEasing,
            "border-width " + cssDuration + " " + cssEasing
        ].join();
        var startHeight = _isVisible ? style.height : '0px';
        var startMinHeight = _isVisible ? style.minHeight : '0px';
        var startPaddingTop = _isVisible ? style.paddingTop : '0px';
        var startPaddingBottom = _isVisible ? style.paddingBottom : '0px';
        var startBorderTopWidth = _isVisible ? style.borderTopWidth : '0px';
        var startBorderBottomWidth = _isVisible ? style.borderBottomWidth : '0px';
        var endHeight = (function () {
            if (hasEndHeight)
                return options.endHeight + "px";
            return !isBorderBox ?
                contentHeight - paddingTop - paddingBottom + "px" :
                contentHeight + borderTop + borderBottom + "px";
        })();
        var endMinHeight = minHeight + "px";
        var endPaddingTop = paddingTop + "px";
        var endPaddingBottom = paddingBottom + "px";
        var endBorderTopWidth = borderTop + "px";
        var endBorderBottomWidth = borderBottom + "px";
        if (startHeight === endHeight &&
            startPaddingTop === endPaddingTop &&
            startPaddingBottom === endPaddingBottom &&
            startBorderTopWidth === endBorderTopWidth &&
            startBorderBottomWidth === endBorderBottomWidth) {
            resolve();
            return;
        }
        requestAnimationFrame(function () {
            el.style.height = startHeight;
            el.style.minHeight = startMinHeight;
            el.style.paddingTop = startPaddingTop;
            el.style.paddingBottom = startPaddingBottom;
            el.style.borderTopWidth = startBorderTopWidth;
            el.style.borderBottomWidth = startBorderBottomWidth;
            el.style.display = display;
            el.style.overflow = 'hidden';
            el.style.visibility = 'visible';
            el.style.transition = cssTransition;
            el.style.webkitTransition = cssTransition;
            requestAnimationFrame(function () {
                el.style.height = endHeight;
                el.style.minHeight = endMinHeight;
                el.style.paddingTop = endPaddingTop;
                el.style.paddingBottom = endPaddingBottom;
                el.style.borderTopWidth = endBorderTopWidth;
                el.style.borderBottomWidth = endBorderBottomWidth;
            });
        });
        var timeoutId = setTimeout(function () {
            resetStyle(el);
            el.style.display = display;
            if (hasEndHeight) {
                el.style.height = options.endHeight + "px";
                el.style.overflow = "hidden";
            }
            inAnimItems.remove(el);
            resolve();
        }, duration);
        inAnimItems.add(el, defaultStyle, timeoutId, onCancelled);
    });
}
function slideUp(el, options) {
    if (options === void 0) { options = {}; }
    return new PromiseLike(function (resolve) {
        if (inAnimItems.findIndex(el) !== -1)
            return;
        var _isVisible = isVisible(el);
        var display = options.display || 'block';
        var duration = options.duration || 400;
        var onCancelled = options.onCancelled || function () { };
        if (!_isVisible) {
            resolve();
            return;
        }
        var defaultStyle = el.getAttribute('style') || '';
        var style = window.getComputedStyle(el);
        var isBorderBox = /border-box/.test(style.getPropertyValue('box-sizing'));
        var minHeight = pxToNumber(style.getPropertyValue('min-height'));
        var paddingTop = pxToNumber(style.getPropertyValue('padding-top'));
        var paddingBottom = pxToNumber(style.getPropertyValue('padding-bottom'));
        var borderTop = pxToNumber(style.getPropertyValue('border-top-width'));
        var borderBottom = pxToNumber(style.getPropertyValue('border-bottom-width'));
        var contentHeight = el.scrollHeight;
        var cssDuration = duration + 'ms';
        var cssEasing = CSS_EASEOUT_EXPO;
        var cssTransition = [
            "height " + cssDuration + " " + cssEasing,
            "padding " + cssDuration + " " + cssEasing,
            "border-width " + cssDuration + " " + cssEasing
        ].join();
        var startHeight = !isBorderBox ?
            contentHeight - paddingTop - paddingBottom + "px" :
            contentHeight + borderTop + borderBottom + "px";
        var startMinHeight = minHeight + "px";
        var startPaddingTop = paddingTop + "px";
        var startPaddingBottom = paddingBottom + "px";
        var startBorderTopWidth = borderTop + "px";
        var startBorderBottomWidth = borderBottom + "px";
        requestAnimationFrame(function () {
            el.style.height = startHeight;
            el.style.minHeight = startMinHeight;
            el.style.paddingTop = startPaddingTop;
            el.style.paddingBottom = startPaddingBottom;
            el.style.borderTopWidth = startBorderTopWidth;
            el.style.borderBottomWidth = startBorderBottomWidth;
            el.style.display = display;
            el.style.overflow = 'hidden';
            el.style.transition = cssTransition;
            el.style.webkitTransition = cssTransition;
            requestAnimationFrame(function () {
                el.style.height = '0';
                el.style.minHeight = '0';
                el.style.paddingTop = '0';
                el.style.paddingBottom = '0';
                el.style.borderTopWidth = '0';
                el.style.borderBottomWidth = '0';
            });
        });
        var timeoutId = setTimeout(function () {
            resetStyle(el);
            el.style.display = 'none';
            inAnimItems.remove(el);
            resolve();
        }, duration);
        inAnimItems.add(el, defaultStyle, timeoutId, onCancelled);
    });
}
function slideStop(el) {
    var elementObject = inAnimItems.find(el);
    if (!elementObject)
        return;
    var style = window.getComputedStyle(el);
    var height = style.height;
    var paddingTop = style.paddingTop;
    var paddingBottom = style.paddingBottom;
    var borderTopWidth = style.borderTopWidth;
    var borderBottomWidth = style.borderBottomWidth;
    resetStyle(el);
    el.style.height = height;
    el.style.paddingTop = paddingTop;
    el.style.paddingBottom = paddingBottom;
    el.style.borderTopWidth = borderTopWidth;
    el.style.borderBottomWidth = borderBottomWidth;
    el.style.overflow = 'hidden';
    inAnimItems.remove(el);
}
function isVisible(el) {
    return el.offsetHeight !== 0;
}
function resetStyle(el) {
    el.style.visibility = '';
    el.style.height = '';
    el.style.minHeight = '';
    el.style.paddingTop = '';
    el.style.paddingBottom = '';
    el.style.borderTopWidth = '';
    el.style.borderBottomWidth = '';
    el.style.overflow = '';
    el.style.transition = '';
    el.style.webkitTransition = '';
}
function getDefaultStyles(el, defaultDisplay) {
    if (defaultDisplay === void 0) { defaultDisplay = 'block'; }
    var defaultStyle = el.getAttribute('style') || '';
    var style = window.getComputedStyle(el);
    el.style.visibility = 'hidden';
    el.style.display = defaultDisplay;
    var width = pxToNumber(style.getPropertyValue('width'));
    el.style.position = 'absolute';
    el.style.width = width + "px";
    el.style.height = '';
    el.style.minHeight = '';
    el.style.paddingTop = '';
    el.style.paddingBottom = '';
    el.style.borderTopWidth = '';
    el.style.borderBottomWidth = '';
    var minHeight = pxToNumber(style.getPropertyValue('min-height'));
    var paddingTop = pxToNumber(style.getPropertyValue('padding-top'));
    var paddingBottom = pxToNumber(style.getPropertyValue('padding-bottom'));
    var borderTop = pxToNumber(style.getPropertyValue('border-top-width'));
    var borderBottom = pxToNumber(style.getPropertyValue('border-bottom-width'));
    var height = el.scrollHeight;
    el.setAttribute('style', defaultStyle);
    return {
        height: height,
        minHeight: minHeight,
        paddingTop: paddingTop,
        paddingBottom: paddingBottom,
        borderTop: borderTop,
        borderBottom: borderBottom
    };
}
function pxToNumber(px) {
    return +px.replace(/px/, '');
}

function accordion(node, options) {
  var labels = t$2(".accordion__label", node);
  var content = t$2(".accordion__content", node); // Make it accessible by keyboard

  labels.forEach(function (label) {
    label.href = "#";
  });
  content.forEach(function (t) {
    return u$1(t, "measure");
  });
  var labelClick = e$2(labels, "click", function (e) {
    e.preventDefault();
    var label = e.currentTarget;
    var group = label.parentNode,
        content = label.nextElementSibling;
    slideStop(content);

    if (isVisible(content)) {
      _close(label, group, content);
    } else {
      _open(label, group, content);
    }
  });

  function _open(label, group, content) {
    slideDown(content);
    group.setAttribute("data-open", true);
    label.setAttribute("aria-expanded", true);
    content.setAttribute("aria-hidden", false);
  }

  function _close(label, group, content) {
    slideUp(content);
    group.setAttribute("data-open", false);
    label.setAttribute("aria-expanded", false);
    content.setAttribute("aria-hidden", true);
  }

  if (options.firstOpen) {
    // Open first accordion label
    var _labels$ = labels[0],
        group = _labels$.parentNode,
        _content = _labels$.nextElementSibling;

    _open(labels[0], group, _content);
  }

  function destroy() {
    return function () {
      return labelClick();
    };
  }

  return {
    destroy: destroy
  };
}

function Accordions(elements) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  if (Array.isArray(elements) && !elements.length) return;
  var defaultOptions = {
    firstOpen: true
  };
  var opts = Object.assign(defaultOptions, options);
  var accordions = [];

  if (elements.length) {
    accordions = elements.map(function (node) {
      return accordion(node, opts);
    });
  } else {
    accordions.push(accordion(elements, opts));
  }

  function unload() {
    accordions.forEach(function (accordion) {
      return accordion.destroy();
    });
  }

  return {
    unload: unload
  };
}

function Media(node) {
  if (!node) return;
  var _window = window,
      Shopify = _window.Shopify,
      YT = _window.YT;
  var elements = t$2("[data-interactive]", node);
  if (!elements.length) return;
  var acceptedTypes = ["video", "model", "external_video"];
  var activeMedia = null;
  var featuresLoaded = false;
  var instances = {};

  if (featuresLoaded) {
    elements.forEach(initElement);
  }

  window.Shopify.loadFeatures([{
    name: "model-viewer-ui",
    version: "1.0"
  }, {
    name: "shopify-xr",
    version: "1.0"
  }, {
    name: "video-ui",
    version: "1.0"
  }], function () {
    featuresLoaded = true;

    if ("YT" in window && Boolean(YT.loaded)) {
      elements.forEach(initElement);
    } else {
      window.onYouTubeIframeAPIReady = function () {
        elements.forEach(initElement);
      };
    }
  });

  function initElement(el) {
    var _el$dataset = el.dataset,
        mediaId = _el$dataset.mediaId,
        mediaType = _el$dataset.mediaType;
    if (!mediaType || !acceptedTypes.includes(mediaType)) return;
    if (Object.keys(instances).includes(mediaId)) return;
    var instance = {
      id: mediaId,
      type: mediaType,
      container: el,
      media: el.children[0]
    };

    switch (instance.type) {
      case "video":
        instance.player = new Shopify.Plyr(instance.media, {
          loop: {
            active: el.dataset.loop == "true"
          }
        });
        break;

      case "external_video":
        {
          instance.player = new YT.Player(instance.media); // This overlay makes it possible to swipe video embeds in carousels

          var overlay = n$2(".external-video-overlay", el);

          if (overlay) {
            e$2(overlay, "click", function (e) {
              var _instance$player;

              e.preventDefault(); // in some situations the iframe-js-api can't communicate and this is undef,
              // in this case lets faily quietly and remove the overlay (it won't come back)

              if ((_instance$player = instance.player) !== null && _instance$player !== void 0 && _instance$player.playVideo) {
                instance.player.playVideo();
              }

              u$1(overlay, "hidden");
            });
            instance.player.addEventListener("onStateChange", function (event) {
              if (event.data === 2) {
                i$1(overlay, "hidden");
              }
            });
          }

          break;
        }

      case "model":
        instance.viewer = new Shopify.ModelViewerUI(n$2("model-viewer", el));
        e$2(n$2(".model-poster", el), "click", function (e) {
          e.preventDefault();
          playModel(instance);
        });
        break;
    }

    instances[mediaId] = instance;

    if (instance.player) {
      if (instance.type === "video") {
        instance.player.on("playing", function () {
          pauseActiveMedia(instance);
          activeMedia = instance;
        });
      } else if (instance.type === "external_video") {
        instance.player.addEventListener("onStateChange", function (event) {
          if (event.data === 1) {
            pauseActiveMedia(instance);
            activeMedia = instance;
          }
        });
      }
    }
  }

  function playModel(instance) {
    pauseActiveMedia(instance);
    instance.viewer.play();
    u$1(instance.container, "model-active");
    activeMedia = instance;
    setTimeout(function () {
      n$2("model-viewer", instance.container).focus();
    }, 300);
  }

  function pauseActiveMedia(instance) {
    if (!activeMedia || instance == activeMedia) return;

    if (activeMedia.player) {
      if (activeMedia.type === "video") {
        activeMedia.player.pause();
      } else if (activeMedia.type === "external_video") {
        activeMedia.player.pauseVideo();
      }

      activeMedia = null;
      return;
    }

    if (activeMedia.viewer) {
      i$1(activeMedia.container, "model-active");
      activeMedia.viewer.pause();
      activeMedia = null;
    }
  }

  return {
    pauseActiveMedia: pauseActiveMedia
  };
}

const stepTitles = {
  en:{
    selectprescription: "Select valid prescription",
    addPrescription: "Add a new prescription",
    prescriptionPhoto: "photo of prescription",
    checkout: "Checkout",
    nextStep: " Next step:"
  },
  fr:{
    selectprescription: "Sélectionnez une ordonnance valide",
    addPrescription: "Ajouter une nouvelle ordonnance",
    prescriptionPhoto: "photo de prescription",
    checkout: "Vérifier",
    nextStep: " Prochaine étape :"
  }
 }

const updateProgressBar =(container, tab)=> {
  if (!container) return
  const popupContent = container.closest("[data-popup-container]");
  
  if (!popupContent) return
  const progressBarCurrentStep = popupContent.querySelectorAll(".progress-bar__current-step");
  const progressBarNextStep = popupContent.querySelectorAll(".progress-next-step");
  const progressBarpercentage = popupContent.querySelector(".progress-bar");
  const progressBarWrapper = popupContent.querySelector(".progress-bar-wrapper");
  progressBarCurrentStep.forEach(title =>title.innerHTML =tab.number + tab.progressBarTitle); 
  progressBarNextStep.forEach(title => {
    if (tab.nexStepProgressBarTitle) {
      title.innerHTML = stepTitles[locale]?.nextStep + tab.nexStepProgressBarTitle
      progressBarWrapper.classList.remove("mobile-hidden");
    } else {
      progressBarWrapper.classList.add("mobile-hidden");
      title.innerHTML = ""
    }
  }); 
  progressBarpercentage.style.width = `${tab.progressPercentage}%`
}

var selectors$T = {
  idInput: '[name="id"]',
  optionInput: '[name^="options"]',
  quantityInput: "[data-quantity-input]",
  formQuantity: '[name="quantity"]',
  propertyInput: '[name^="properties"]'
};

const popupSelectors = {
  popup: ".purchase-flow-popup",
  activePopup: "purchase-flow-popup--active",
  popupClose: ".purchase-flow-popup__close",
  formSubmitButton: ".product-form__cart-submit",
  popupBack: ".purchase-flow-popup__back",
  popupBackActive: "purchase-flow-popup__back--active",
  addToCartNoPrescription: "[data-add-to-cart-no-prescription]",
  prescriptionTypeOptions: "[data-option-type='prescription_type']",
  lensesTypeOptions: "[data-option-type='lenses_type']",
  thinningOptions: "[data-option-type='thinning']",
  protectionsOptions: "[data-option-type='protection']",
  option: ".purchase-flow-popup__step-option",
  tab: ".purchase-flow-popup__tab",
  activeTab: "purchase-flow-popup__tab--active",
  selectedOption: "purchase-flow-popup__step-option--selected",
  activeStep: "purchase-flow-popup__step--active",
  lensColorItem: ".purchase-flow-popup__lens-color-item",
  lensColorItemSelected: "purchase-flow-popup__lens-color-item--selected",
  finishFlowButton: "[data-finish-purchase-flow]",
  finishPrescriptionFlow: "[data-finish-prescription-flow]",
  productPrice: ".purchase-flow-popup__product-price",
  changeSelections: "[data-change-selections]",
  sunglassesSwitcher: "[data-sunglasses-flow-switcher]",
  submitActive: "product-form__cart-submit--active",
  switcher: ".purchase-flow-popup__switcher",
  switcherBox: ".purchase-flow-popup__switcher-box",
  switcherBoxActive: "purchase-flow-popup__switcher-box--on",
  switcherOnText: "purchase-flow-popup__switcher-on-text",
  switcherOffText: "purchase-flow-popup__switcher-off-text",
  popupProductInfo: ".purchase-flow-popup__product"
}

const selectorsToVariables = (selectors) => {
  const obj = {};
  for(let key in selectors){
    obj[key] = document.querySelectorAll(selectors[key]).length <= 1 ? document.querySelector(selectors[key]) : document.querySelectorAll(selectors[key]);
  }
  return obj;
}

const stepTypes = {
  prescriptionType: "prescription-type",
  selectLenses: "select-lenses",
  thinning: "thinning",
  protections: "protections",
  lensColor: "lens-color",
  review: "review"
}

const stepTypesSunglasses = {
  prescriptionType: "prescription-type",
  selectLenses: "select-lenses-sunglasses",
  thinning: "thinning-sunglasses",
  lensColor: "lens-color-sunglasses",
  review: "review-sunglasses"
}

const clearFlow = [
  {
    step: stepTypes.prescriptionType,
    isActive: true,
    title: window['flowTitles'] ? window['flowTitles']['prescription_type'] : '',
    stepIndex: 1
  },
  {
    step: stepTypes.selectLenses,
    priceKey: "lensType",
    title: window['flowTitles'] ? window['flowTitles']['select_lenses'] : '',
    stepIndex: 2
  },
  {
    step: stepTypes.protections,
    priceKey: "protection",
    title: window['flowTitles'] ? window['flowTitles']['protections'] : '',
    stepIndex: 3
  },
  {
    step: stepTypes.lensColor,
    isOptional: true,
    title: window['flowTitles'] ? window['flowTitles']['lens_color'] : '',
    stepIndex: 3
  },
  {
    step: stepTypes.thinning,
    priceKey: "thinning",
    title: window['flowTitles'] ? window['flowTitles']['thinning'] : '',
    stepIndex: 4
  },
  {
    step: stepTypes.review,
    title: window['flowTitles'] ? window['flowTitles']['review'] : '',
    stepIndex: 5
  }
]

const sunglassesFlow = [
  {
    step: stepTypesSunglasses.prescriptionType,
    isActive: true,
    title: window['flowTitles'] ? window['flowTitles']['prescription_type'] : '',
    stepIndex: 1
  },
  {
    step: stepTypesSunglasses.selectLenses,
    priceKey: "lensType",
    title: window['flowTitles'] ? window['flowTitles']['select_lenses'] : '',
    stepIndex: 2
  },
  {
    step: stepTypesSunglasses.lensColor,
    title: window['flowTitles'] ? window['flowTitles']['lens_color'] : '',
    stepIndex: 3
  },
  {
    step: stepTypesSunglasses.thinning,
    priceKey: "thinning",
    title: window['flowTitles'] ? window['flowTitles']['thinning'] : '',
    stepIndex: 4
  },
  {
    step: stepTypesSunglasses.review,
    title: window['flowTitles'] ? window['flowTitles']['review'] : '',
    stepIndex: 5
  }
]

const flowPrices = {
  lensType: 0,
  thinning: 0,
  protection: 0,
}

const customerJourney = {
  prescriptionType: null,
  lensesType: null,
  thinning: null,
  protection: null,
  lensColor: null
}

const customerJourneySunglasses = {
  prescriptionType: null,
  lensesType: null,
  lensColor: null,
  thinning: null,
}

const prescriptionData = {
  checkoutProperty: null,
  prescriptionNote: null
}

const prescriptionNoteKey = window["prescriptionNoteKey"];

const selectedOptions = {
  prescriptionType: null,
  lensesType: null,
  protections: null,
  lensColor: null,
  thinning: null,
  isColorsAvailable: false,
  defaultClicked: []
}


function ProductForm(container, form, prod) {
  var config = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var product = validateProductObject(prod);
  var listeners = [];
  const productType = document.querySelector(".product").dataset.productType;
  let flow = productType === "eyeglasses" ? clearFlow : sunglassesFlow;
  
  let formSubmitButton,
  popup,
  popupBack;

  const initVariables = () => {
    let obj = selectorsToVariables(popupSelectors);

    formSubmitButton = obj['formSubmitButton'];
    popup = obj['popup'];
    popupBack = obj['popupBack'];
  }

  initVariables();

  const {
    popupClose,
    addToCartNoPrescription,
    finishFlowButton,
    changeSelections,
    sunglassesSwitcher
  } = popupSelectors;

  formSubmitButton.classList.add(popupSelectors.submitActive);

  const showPopup = () => {
    initVariables();
    document.body.style.overflow = "hidden";
    popup.classList.add(popupSelectors.activePopup);
    makeStepUnactive();
    makeStepActive();
  }

  const closePopup = () => {
    document.body.style.overflow = "";
    popup.classList.remove(popupSelectors.activePopup);
    makeStepUnactive();
    makeStepActive();
  }

  const makeStepUnactive = ({
    index
  } = {}) => {
    if(index === undefined) index = flow.findIndex(x => x.isActive === true);
    
    flow[index].isActive = false;
  }

  const toggleBackButton = (index) => {
    if(index == 0) popupBack.classList.remove(popupSelectors.popupBackActive);
    else popupBack.classList.add(popupSelectors.popupBackActive);
  }

  const managePoductInfoVisibility = (newStep)=>{
    const popupProductInfo = document.querySelector(popupSelectors.popupProductInfo);

    popupProductInfo.style.display = ["review", "review-sunglasses"].includes(newStep.dataset.step) ? "none" : "flex";
  }

  const makeStepActive = (index) => {
    if(!index) index = 0;
    const step = flow[index];
    step.isActive = true;

    const activeStep = document.querySelector(`.${popupSelectors.activeStep}`);
    const newStep = document.querySelector(`.purchase-flow-popup__step--${step.step}`);

    if(activeStep) activeStep.classList.remove(popupSelectors.activeStep);
    if(newStep) newStep.classList.add(popupSelectors.activeStep);
    managePoductInfoVisibility(newStep)
    toggleBackButton(index);

    const journey = flow.length == clearFlow.length ? customerJourney : customerJourneySunglasses;

    let key = Object.values(journey)?.[index - 1] ? Object.values(journey)?.[index - 1] : "";

    if(key && step.step == "protections"){
      const tab = newStep.querySelector(`.purchase-flow-popup__tab--${key}`);
      
      const option = tab ? tab.querySelector(`.${popupSelectors.selectedOption}`) : null;
      if(option) option.classList.remove(popupSelectors.selectedOption);
      const firstOption = tab ? tab.querySelector(popupSelectors.option) : null;
      if(firstOption){
        firstOption.classList.add(popupSelectors.selectedOption);
        firstOption.click();
      }
    }
    
    updateProgressBar(newStep, { 
      number: `${step.stepIndex}. `,
      progressBarTitle: step.title,
      nexStepProgressBarTitle: flow[index + 1]?.title,
      progressPercentage: (step.stepIndex) * (100 / flow[flow.length - 1].stepIndex)
    });
  }


  const clearSelectedOption = (keyValue, isBeforeOptionalStep)=>{
  keysAdapterNew[keyValue] && (selectedOptions[keysAdapterNew[keyValue]] = null);
  const filteredDefaultClicked = selectedOptions.defaultClicked.filter(item => item !==keysAdapterNew[keyValue])
  selectedOptions.defaultClicked = filteredDefaultClicked
  !isBeforeOptionalStep && (selectedOptions.isColorsAvailable = isBeforeOptionalStep)
}

  const goToPreviousStep = () => {

    const index = flow.findIndex(x => x.isActive);
    const optionalIndex = flow.findIndex(x => x.isOptional);
    const prevIndex = index - 1;
    const beforePrevIndex = prevIndex - 1;
    const isBeforeOptionalStep =  prevIndex >=  optionalIndex
    makeStepUnactive({
      index
    });
    const { step:prewStepName } = flow[prevIndex];
    const { isColorsAvailable, defaultClicked} = selectedOptions;
    const selectedOptionsKey = keysAdapterNew[prewStepName];
    const isPrevKeyDefaultClicked = defaultClicked.includes(selectedOptionsKey)
    if(!!flow[prevIndex]?.isOptional && !isColorsAvailable ){
      const { step:beforePrewStepName } = flow[beforePrevIndex]
      makeStepActive(beforePrevIndex);
      clearSelectedOption(beforePrewStepName, isBeforeOptionalStep)
    }else if (isPrevKeyDefaultClicked){
      const { step:beforePrewStepName } = flow[beforePrevIndex]
      makeStepActive(beforePrevIndex);
      
      clearSelectedOption(beforePrewStepName, isBeforeOptionalStep)
    }else{
      makeStepActive(prevIndex);
    }
    clearSelectedOption(prewStepName, isBeforeOptionalStep)
  }

  const goToNextStep = () => {
    const index = flow.findIndex(x => x.isActive );
    const nextIndex = index + 1;
    const isColorOptional = !selectedOptions.isColorsAvailable;
    const isNextStepColor = flow[nextIndex].step === 'lens-color';
    const isNextStepColorOptional =  flow[nextIndex].isOptional
    makeStepUnactive({
      index
    });
    if(isColorOptional && isNextStepColor && isNextStepColorOptional){

      makeStepActive(nextIndex+1);
    } else {

      makeStepActive(nextIndex);
    }
  }

  const onFinishFlow = async (e) => {
    closePopup();

    const button = e.target;
    const lenseProductId = +button.dataset.lenseProductVariantId;
    const quantityError = document.querySelector("[data-quantity-error]");
    const technicalError = document.querySelector("[data-technical-error]");
    const taxableProductId = +document.querySelector('.store-availability-container__wrapper').dataset.variantId;
    const nonTaxableProductId = +document.querySelector("[data-non-taxable-variant-id]").getAttribute("data-non-taxable-variant-id");
    let lenseAndFrameId = `${lenseProductId}-${taxableProductId}`;
    const nonTaxableLenseAndFrameId = `${lenseProductId}-${nonTaxableProductId}`;

    const cart_object = await cart.get();

    const productId = nonTaxableProductId;
    lenseAndFrameId = nonTaxableLenseAndFrameId;
    const id = Date.now();

    const properties = {
      "_lenseAndFrameId": lenseAndFrameId,
      "_id": id,
      "_rx": true,
    }

    if (prescriptionData.prescriptionNote && !!prescriptionNoteKey) {
      properties[prescriptionNoteKey] = prescriptionData.prescriptionNote;
    }

    if (prescriptionData.checkoutProperty) {
      properties[`_${prescriptionData.checkoutProperty}`] = true;
    }
    
    var item = cart_object.items.find((cart_item) => {
      return productId == cart_item.variant_id;
    });

    const itemKey = item?.key;

    try{
      await cart.addItemById(productId, 1, {...properties, "_type": "frame"});
      await cart.addItemById(lenseProductId, 1, {...properties, "_type": "lens"});
      if(quantityError) quantityError.classList.add("hidden");
      if(technicalError) technicalError.classList.add("hidden");

      setTimeout(function () { // Need a delay to allow quick-cart to refresh
        r$1("quick-cart:open");
      }, 400);
    }catch(e){
      const errorProperties = itemKey ? {
        key: itemKey,
        errorMessage: strings$6.quantityError
      } : {
        id: productId
      }
  
      dispatchCustomEvent("cart:error", {
        errorMessage: strings$6.quantityError
      });
      
      r$1("quick-cart:error", null, errorProperties);
      r$1("cart:error", null, errorProperties);

      if(quantityError && e.code == 422) quantityError.classList.remove("hidden");
      if(technicalError && e.code == 404) technicalError.classList.remove("hidden");

      throw e;
    }
  }

  const addItemToCartWithNoPrescription = async () => {
    closePopup();
    const productId = +document.querySelector('.store-availability-container__wrapper').dataset.variantId;
    const id = Date.now();
    const properties = {
      "_id": id
    }
    await cart.addItemById(productId, 1, properties);
    setTimeout(function () { // Need a delay to allow quick-cart to refresh
      r$1("quick-cart:open");
    }, 400);
  }

  const onChangeSelectionsClick = () => {
    resetSelectedOptions()
    makeStepUnactive();
    makeStepActive();
  }
 
 const keysAdapterNew = {
  "prescription_type":"prescriptionType",
  "prescription-type":"prescriptionType",
  "lenses_type":"lensesType",
  "lens-color":"lensColor",
  "lens-color-sunglasses":"lensColor",
  "thinning-sunglasses":"thinning",
  "thinning":"thinning",
  "protections":"protections",
  "select-lenses":"lensesType",
  "select-lenses-sunglasses":"lensesType",
 }
 const objectsComparing = (firstObject, secondObject)=> JSON.stringify(firstObject) === JSON.stringify(secondObject);

 const checkIfSingleOptionTab = (tab)=>{
  const tabOptions = tab.querySelectorAll(".purchase-flow-popup__step-option");
  if (tabOptions.length === 1){
    selectedOptionAction(tabOptions[0]);
    const optionType = tabOptions[0].dataset.optionType;
    const selectedOptionKey = keysAdapterNew[`${optionType}`];
  selectedOptions.defaultClicked = [...selectedOptions.defaultClicked,selectedOptionKey]
  }
  
 }
 const renderStepContent = (selectedOptionsObject)=>{
   const activeStep = document.querySelector(`.${popupSelectors.activeStep}`);
   const stepAvailableTabsList = activeStep.querySelectorAll(popupSelectors.tab);
   let atLeastOneExists = true;
   stepAvailableTabsList.forEach(tab=>{
     tab.classList.remove(popupSelectors.activeTab);
     const persriptionTypeData = tab.dataset.prescriptionType;
     const categoryData = tab.dataset.category || null;
     const protectionData = tab.dataset.protection || null;
     const thinningData = tab.dataset.thinning || null;
     const colorData = tab.dataset.lensColor || null;
     const tabColorAvailability = tab.dataset.colorAvailability == "true";
     const tabOptionObject = {
       prescriptionType: persriptionTypeData,
       lensesType: categoryData,
       protections: protectionData,
       lensColor: colorData,
       thinning: thinningData,
       isColorsAvailable: tabColorAvailability,
       defaultClicked:selectedOptionsObject.defaultClicked
      }
      
      if (objectsComparing(selectedOptionsObject, tabOptionObject) && atLeastOneExists) {
      tab.classList.add(popupSelectors.activeTab);
      atLeastOneExists = false
      checkIfSingleOptionTab(tab)
    }

   })
 }
  const updatePrescriptionData = (option) => {
    prescriptionData.prescriptionNote = option.dataset.prescriptionNote;
    prescriptionData.checkoutProperty = option.dataset.checkoutProperty;
  }
  const selectedOptionAction = (option) => {
    const optionType = option.dataset.optionType;
    const optionValue = option.dataset.optionValue;
    const hasColorsData = option.dataset.hasColors === "true";
    optionType === "prescription_type" && updatePrescriptionData(option)
    const defaultColor = !hasColorsData ? option.dataset.defaultColor : null;
    const selectedOptionKey = keysAdapterNew[`${optionType}`] || optionType;
    selectedOptionKey && (selectedOptions[`${selectedOptionKey}`] = optionValue)
    option.dataset.hasColors && (selectedOptions.isColorsAvailable = hasColorsData);
    defaultColor && (selectedOptions.lensColor = defaultColor)
    goToNextStep();
    renderStepContent(selectedOptions)
  }
  const optionClick = (e)=>{
    const parrentWrapper = e.target.closest(".purchase-flow-popup__step-option");
    selectedOptionAction(parrentWrapper)
  }

  const resetSelectedOptions = ()=>{
    for (const property in selectedOptions) {
      if ( property !== "prescriptionType"){
        selectedOptions[property] =  null
      }
      if (property == "isColorsAvailable") {
        selectedOptions[property] = false;
      }
      if (property == "defaultClicked") {
        selectedOptions[property] = [];
      }
    }
  }

  const onSunglassesSwitcherClick = (e) => {
    const switcher = e.target;
    const parentWrapper = switcher.closest(popupSelectors.switcherBox);
    const isTurnedOn = parentWrapper.classList.contains(popupSelectors.switcherBoxActive);
    flow = isTurnedOn ? clearFlow : sunglassesFlow;
    let steps = isTurnedOn ? stepTypes : stepTypesSunglasses;

    flow.find(x => x.isActive === true).isActive = false;
    flow.find(x => x.step === steps.selectLenses).isActive = true;
    resetSelectedOptions()
    makeStepUnactive();
    makeStepActive(1);
    renderStepContent(selectedOptions)
  }

  const setListeners = () => {
    let handlers = [
      {
        container: popupClose,
        listener: closePopup
      },
      {
        container: popupSelectors.popupBack,
        listener: goToPreviousStep
      },
      {
        container: addToCartNoPrescription,
        listener: addItemToCartWithNoPrescription
      },
      {
        container: finishFlowButton,
        listener: onFinishFlow
      },
      {
        container: changeSelections,
        listener: onChangeSelectionsClick
      },
      {
        container: sunglassesSwitcher,
        listener: onSunglassesSwitcherClick
      },
      {
        container: popupSelectors.option,
        listener: optionClick
      }
    ]

    formSubmitButton.addEventListener("click", openPurchaseFlow);

    document.addEventListener("click", (e) => {
      const { target } = e;

      handlers.forEach(({ container, listener }) => {
        if(target.classList.contains(container) || target.closest(container)) listener(e);
      });
    })
  }

  const openPurchaseFlow = (e) => {
    let variant = window.currentPDPVariant;

    if(!variant) return;

    const isSelectLensesFlow = variant.is_select_lenses_flow;
    
    if(!isSelectLensesFlow) return;

    e.preventDefault();
    e.stopPropagation();

    showPopup();
  }
  
  setListeners();

  var getOptions = function getOptions() {
    return _serializeOptionValues(optionInputs, function (item) {
      var regex = /(?:^(options\[))(.*?)(?:\])/;
      item.name = regex.exec(item.name)[2]; // Use just the value between 'options[' and ']'

      return item;
    });
  };

  var getVariant = function getVariant() {
    return getVariantFromSerializedArray(product, getOptions());
  };

  var getProperties = function getProperties() {
    var properties = _serializePropertyValues(propertyInputs, function (propertyName) {
      var regex = /(?:^(properties\[))(.*?)(?:\])/;
      var name = regex.exec(propertyName)[2]; // Use just the value between 'properties[' and ']'

      return name;
    });

    return Object.entries(properties).length === 0 ? null : properties;
  };

  var getQuantity = function getQuantity() {
    return formQuantityInput[0] ? Number.parseInt(formQuantityInput[0].value, 10) : 1;
  };

  var getProductFormEventData = function getProductFormEventData() {
    return {
      options: getOptions(),
      variant: getVariant(),
      properties: getProperties(),
      quantity: getQuantity()
    };
  };

  var onFormEvent = function onFormEvent(cb) {
    if (typeof cb === "undefined") return;
    return function (event) {
      event.dataset = getProductFormEventData();
      cb(event);
    };
  };

  var setIdInputValue = function setIdInputValue(value) {
    var idInputElement = form.querySelector(selectors$T.idInput);

    if (!idInputElement) {
      idInputElement = document.createElement("input");
      idInputElement.type = "hidden";
      idInputElement.name = "id";
      form.appendChild(idInputElement);
    }

    idInputElement.value = value.toString();
  };

  var onSubmit = function onSubmit(event) {
    event.dataset = getProductFormEventData();
    setIdInputValue(event.dataset.variant.id);
    if (config.onFormSubmit) {
      config.onFormSubmit(event);
    }
  };

  var initInputs = function initInputs(selector, cb) {
    var elements = _toConsumableArray$1(container.querySelectorAll(selector));

    return elements.map(function (element) {
      listeners.push(e$2(element, "change", onFormEvent(cb)));
      return element;
    });
  };
  listeners.push(e$2(form, "submit", onSubmit));
  var optionInputs = initInputs(selectors$T.optionInput, config.onOptionChange);
  var formQuantityInput = initInputs(selectors$T.quantityInput, config.onQuantityChange);
  var propertyInputs = initInputs(selectors$T.propertyInput, config.onPropertyChange);

  var destroy = function destroy() {
    listeners.forEach(function (unsubscribe) {
      return unsubscribe();
    });
  };

  return {
    getVariant: getVariant,
    destroy: destroy
  };
}

function validateProductObject(product) {
  if (_typeof(product) !== "object") {
    throw new TypeError(product + " is not an object.");
  }

  if (typeof product.variants[0].options === "undefined") {
    throw new TypeError("Product object is invalid. Make sure you use the product object that is output from {{ product | json }} or from the http://[your-product-url].js route");
  }

  return product;
}

function _serializeOptionValues(inputs, transform) {
  return inputs.reduce(function (options, input) {
    if (input.checked || // If input is a checked (means type radio or checkbox)
    input.type !== "radio" && input.type !== "checkbox" // Or if its any other type of input
    ) {
      options.push(transform({
        name: input.name,
        value: input.value
      }));
    }

    return options;
  }, []);
}

function _serializePropertyValues(inputs, transform) {
  return inputs.reduce(function (properties, input) {
    if (input.checked || // If input is a checked (means type radio or checkbox)
    input.type !== "radio" && input.type !== "checkbox" // Or if its any other type of input
    ) {
      properties[transform(input.name)] = input.value;
    }

    return properties;
  }, {});
}

var preventDefault = (function (fn) {
  return function (e) {
    e.preventDefault();
    fn();
  };
});

var selectors$S = {
  imageById: function imageById(id) {
    return "[data-media-item-id='".concat(id, "']");
  },
  imageWrapper: "[data-product-media-wrapper]",
  inYourSpace: "[data-in-your-space]"
};
var classes$p = {
  hidden: "hidden"
};
function switchImage (container, imageId, inYourSpaceButton) {
  var newImage = n$2(selectors$S.imageWrapper + selectors$S.imageById(imageId), container);
  var otherImages = t$2("".concat(selectors$S.imageWrapper, ":not(").concat(selectors$S.imageById(imageId), ")"), container);
  i$1(newImage, classes$p.hidden); // Update view in space button

  if (inYourSpaceButton) {
    if (newImage.dataset.mediaType === "model") {
      inYourSpaceButton.setAttribute("data-shopify-model3d-id", newImage.dataset.mediaItemId);
    }
  }

  otherImages.forEach(function (image) {
    return u$1(image, classes$p.hidden);
  });
}

// This loads the polyfill chunk if necessary
function provideResizeObserver() {
  if (window.ResizeObserver) {
    return Promise.resolve({
      ResizeObserver: ResizeObserver
    });
  }

  return import(flu.chunks.polyfillResizeObserver);
}

function quantityInput (container) {
  var quantityWrapper = n$2(".quantity-input", container);
  if (!quantityWrapper) return;
  var quantityInput = n$2("[data-quantity-input]", quantityWrapper);
  var addQuantity = n$2("[data-add-quantity]", quantityWrapper);
  var subtractQuantity = n$2("[data-subtract-quantity]", quantityWrapper);

  var handleAddQuantity = function handleAddQuantity() {
    var currentValue = parseInt(quantityInput.value);
    var newValue = currentValue + 1;
    quantityInput.value = newValue;
    quantityInput.dispatchEvent(new Event("change"));
  };

  var handleSubtractQuantity = function handleSubtractQuantity() {
    var currentValue = parseInt(quantityInput.value);
    if (currentValue === 1) return;
    var newValue = currentValue - 1;
    quantityInput.value = newValue;
    quantityInput.dispatchEvent(new Event("change"));
  };

  var events = [e$2(addQuantity, "click", handleAddQuantity), e$2(subtractQuantity, "click", handleSubtractQuantity)];

  var unload = function unload() {
    events.forEach(function (unsubscribe) {
      return unsubscribe();
    });
  };

  return {
    unload: unload
  };
}

var selectors$R = {
  popupTrigger: "[data-popup-trigger]"
};

var informationPopup = function informationPopup(node) {
  var events = [];
  var popupTriggers = t$2(selectors$R.popupTrigger, node);

  if (!popupTriggers.length) {
    return;
  }

  var listener = e$2(popupTriggers, "click", function (e) {
    e.preventDefault();
    e.stopPropagation();
    var modalContentId = e.target.dataset.modalContentId;
    var content = n$2("#".concat(modalContentId), node);
    r$1("modal:open", null, {
      modalContent: content
    });
  });
  events.push(listener);

  function unload() {
    events.forEach(function (evt) {
      return evt();
    });
  }

  return {
    unload: unload
  };
};

var selectors$Q = {
  moreButton: "[data-more-media]",
  moreBar: "[data-more-media-bar]",
  productMedia: "[data-product-media]"
};
var states = {
  closed: "closed",
  beforeOpen: "beforeOpen",
  opening: "opening",
  open: "open"
};

var moreMedia = function moreMedia(node) {
  var moreButton = n$2(selectors$Q.moreButton, node);

  if (!moreButton) {
    return;
  }

  var moreBar = n$2(selectors$Q.moreBar, node);
  var productMedia = n$2(selectors$Q.productMedia, node);
  var initialAR = parseFloat(window.getComputedStyle(productMedia).aspectRatio);
  var isOpen = false;

  var updateText = function updateText(open) {
    moreButton.innerHTML = moreButton.dataset[open ? "langLessMedia" : "langMoreMedia"];
  };

  var close = function close() {
    if (!isOpen) return;

    if (!isFinite(initialAR)) {
      // If AR is NaN it's either 'auto' or unsupported by the browser,
      // in which case we can't transition it. Instead, jump directly to
      // the final state.
      productMedia.dataset.productMedia = states.closed;
      isOpen = false;
      updateText(false);
      return;
    }

    productMedia.dataset.productMedia = states.opening;
    window.requestAnimationFrame(function () {
      var transitionEnd = e$2(productMedia, "transitionend", function () {
        transitionEnd();
        productMedia.dataset.productMedia = states.closed;
        isOpen = false;
      });
      productMedia.dataset.productMedia = states.beforeOpen;
      updateText(false);
    });
  };

  var open = function open() {
    if (isOpen) return;

    if (!isFinite(initialAR)) {
      // If AR is NaN it's either 'auto' or unsupported by the browser,
      // in which case we can't transition it. Instead, jump directly to
      // the final state.
      productMedia.dataset.productMedia = states.open;
      isOpen = true;
      updateText(true);
      return;
    }

    productMedia.dataset.productMedia = states.beforeOpen;
    window.requestAnimationFrame(function () {
      var _productMedia$getBoun = productMedia.getBoundingClientRect(),
          width = _productMedia$getBoun.width;

      var scrollHeight = productMedia.scrollHeight;
      var gridGap = parseInt(window.getComputedStyle(productMedia).rowGap, 10);
      var barBottom = parseInt(window.getComputedStyle(moreBar).bottom, 10);
      var openAspectRatio = width / (scrollHeight - gridGap - barBottom);
      productMedia.style.setProperty("--overflow-gallery-aspect-ratio-open", openAspectRatio);
      var transitionEnd = e$2(productMedia, "transitionend", function (e) {
        if (e.target !== productMedia) {
          // Ignore any bubbled up event from image load transitions, etc.
          return;
        }

        transitionEnd();
        productMedia.dataset.productMedia = states.open;
        isOpen = true;
      });
      productMedia.dataset.productMedia = states.opening;
      updateText(true);
    });
  };

  var clickListener = e$2(moreButton, "click", function () {
    isOpen ? close() : open();
  });
  var resizeListener = e$2(window, "resize", function () {
    return close();
  });
  var events = [clickListener, resizeListener];

  var unload = function unload() {
    events.forEach(function (evt) {
      return evt();
    });
  };

  return {
    unload: unload
  };
};

var strings$5 = window.theme.strings.products;
var selectors$P = {
  price: "[data-price]",
  comparePrice: "[data-compare-price]"
};
function updatePrices (container, variant) {
  var price = t$2(selectors$P.price, container);
  var comparePrice = t$2(selectors$P.comparePrice, container);
  var unavailableString = strings$5.product.unavailable;

  if (!variant) {
    price.forEach(function (el) {
      return el.innerHTML = unavailableString;
    });
    comparePrice.forEach(function (el) {
      return el.innerHTML = "";
    });
    return;
  }

  price.forEach(function (el) {
    return el.innerHTML = formatMoney(variant.price);
  });
  comparePrice.forEach(function (el) {
    return el.innerHTML = variant.compare_at_price > variant.price ? formatMoney(variant.compare_at_price) : "";
  });
}

var selectors$O = {
  productSku: "[data-product-sku]",
  productSkuContainer: ".product__vendor_and_sku"
};
var strings$4 = window.theme.strings.products;
function updateSku (container, variant) {
  var skuElement = n$2(selectors$O.productSku, container);
  var skuContainer = n$2(selectors$O.productSkuContainer, container);
  if (!skuElement) return;
  var sku = strings$4.product.sku;

  var skuString = function skuString(value) {
    return "".concat(sku, ": ").concat(value);
  };

  if (!variant || !variant.sku) {
    skuElement.innerText = "";
    skuContainer.setAttribute("data-showing-sku", false);
    return;
  }

  skuElement.innerText = skuString(variant.sku);
  skuContainer.setAttribute("data-showing-sku", true);
}

function updateVarintMeasures (variant) {
  if(!variant) return;

  const json = document.querySelector(`#ProductVariant-${variant?.id}-Json`);
  let metafields = JSON.parse(json?.innerHTML ?? "{}");

  const lensWidth = document.querySelector(".frame-size-lens-width");
  const bridgeWidth = document.querySelector(".frame-size-bridge-width");
  const branchLength = document.querySelector(".frame-size-branch-length");

  const postfix = "mm";

  const updateConfig = [
    {
      container: lensWidth,
      value: metafields.dimension_circle
    },
    {
      container: bridgeWidth,
      value: metafields.dimension_bridgesize
    },
    {
      container: branchLength,
      value: metafields.dimension_templelength
    }
  ]

  updateConfig.forEach(({ container, value }) => {
    if(container) container.textContent = `${value}${postfix}`;
  })
}

function updateSpecificationsBlock(variant){
  if(!variant) return; 

  const container = document.querySelector(".product__specifications-item--face-size .product__specifications-item-value");
  
  if(container) container.textContent = variant.option2;
}

function updateBuyButton (btn, variant) {
  var text = n$2("[data-add-to-cart-text]", btn);
  var _btn$dataset = btn.dataset,
      langAvailable = _btn$dataset.langAvailable,
      langUnavailable = _btn$dataset.langUnavailable,
      langSoldOut = _btn$dataset.langSoldOut,
      langSelectLenses = _btn$dataset.langSelectLenses,
      langBookAnAppointment = _btn$dataset.langBookAnAppointment;

  let productMetafields = JSON.parse(document.querySelector("#ProductMetafieldsJson")?.innerHTML ?? "{}");
  let variantMetafields = JSON.parse(document.querySelector(`#ProductVariant-${variant?.id}-Json`)?.innerHTML ?? "{}");
  const isRXable = productMetafields.rxable === "true" ? true : false;
  const isAvailableInWebStock = variantMetafields.is_available_in_web_stock === "true" ? true : false;
  const isAvailableOffline = variantMetafields.is_available_offline === "true" ? true : false;
  const isDigitized = variantMetafields.is_digitized === "true" ? true : false;
   
  if (!variant || !isAvailableInWebStock) {

    if(isAvailableOffline){
      text.textContent = langBookAnAppointment;
      btn.removeAttribute("disabled");
    }else{
      btn.setAttribute("disabled", "disabled");
      text.textContent = langUnavailable;
    }
  } else if (isAvailableInWebStock) {
    btn.removeAttribute("disabled");

    if(isRXable && isDigitized){
      text.textContent = langSelectLenses;
    }else{
      text.textContent = langAvailable;
    }
  } else {
    if(isAvailableOffline){
      text.textContent = langBookAnAppointment;
      btn.removeAttribute("disabled");
    }else{
      btn.setAttribute("disabled", "disabled");
      text.textContent = langSoldOut;
    }
  }
}

var selectors$N = {
  accordionShell: ".accordion.product-reviews",
  accordionContent: ".accordion__content"
};
var classes$o = {
  hidden: "hidden",
  accordion: "accordion"
};
function reviewsHandler (node, container) {
  if (!node) return;
  var parentAppBlockContainer = node.parentNode;
  var accordion = n$2(selectors$N.accordionShell, container);
  var accordionContent = n$2(selectors$N.accordionContent, accordion); // Move the contents of the reviews app into the accordion shell
  // Then move the contents with the accrdion back into the original
  // location.

  accordionContent.appendChild(node);
  parentAppBlockContainer.appendChild(accordion);
  u$1(parentAppBlockContainer, classes$o.accordion);
  i$1(accordion, classes$o.hidden);
}

function OptionButtons(els) {
  var groups = els.map(createOptionGroup);

  function destroy() {
    groups && groups.forEach(function (group) {
      return group();
    });
  }

  return {
    groups: groups,
    destroy: destroy
  };
}

function createOptionGroup(el) {
  var select = n$2("select", el);
  var buttons = t$2("[data-button]", el);
  var buttonClick = e$2(buttons, "click", function (e) {
    e.preventDefault();
    var buttonEl = e.currentTarget;
    var optionHandle = buttonEl.dataset.optionHandle;
    buttons.forEach(function (btn) {
      l(btn, "selected", btn.dataset.optionHandle === optionHandle);
    });
    var opt = n$2("[data-value-handle=\"".concat(optionHandle, "\"]"), select);
    opt.selected = true;
    select.dispatchEvent(new Event("change"));
  });
  return function () {
    return buttonClick();
  };
}

var selectors$M = {
  counterContainer: "[data-inventory-counter]",
  inventoryMessage: ".inventory-counter__message",
  countdownBar: ".inventory-counter__bar",
  progressBar: ".inventory-counter__bar-progress"
};
var classes$n = {
  hidden: "hidden",
  inventoryLow: "inventory--low",
  inventoryEmpty: "inventory--empty",
  inventoryUnavailable: "inventory--unavailable"
};

var inventoryCounter = function inventoryCounter(container, config) {
  var variantsInventories = config.variantsInventories;
  var counterContainer = n$2(selectors$M.counterContainer, container);
  var inventoryMessageElement = n$2(selectors$M.inventoryMessage, container);
  var progressBar = n$2(selectors$M.progressBar, container);
  var _counterContainer$dat = counterContainer.dataset,
      lowInventoryThreshold = _counterContainer$dat.lowInventoryThreshold,
      showUntrackedQuantity = _counterContainer$dat.showUntrackedQuantity,
      stockCountdownMax = _counterContainer$dat.stockCountdownMax,
      unavailableText = _counterContainer$dat.unavailableText; // If the threshold or countdownmax contains anything but numbers abort

  if (!lowInventoryThreshold.match(/^[0-9]+$/) || !stockCountdownMax.match(/^[0-9]+$/)) {
    return;
  }

  var threshold = parseInt(lowInventoryThreshold, 10);
  var countDownMax = parseInt(stockCountdownMax, 10);
  l(counterContainer, classes$n.hidden, !productIventoryValid(variantsInventories[config.id]));
  checkThreshold(variantsInventories[config.id]);
  setProgressBar(variantsInventories[config.id].inventory_quantity, variantsInventories[config.id].inventory_management);
  setInventoryMessage(variantsInventories[config.id].inventory_message);

  function checkThreshold(_ref) {
    var inventory_policy = _ref.inventory_policy,
        inventory_quantity = _ref.inventory_quantity,
        inventory_management = _ref.inventory_management,
        is_available_offline = _ref.is_available_offline;
    i$1(counterContainer, classes$n.inventoryLow);

    if (inventory_management !== null) {
      if (inventory_quantity <= 0 && inventory_policy === "deny") {
        if(is_available_offline == true || is_available_offline == "true"){
          counterContainer.setAttribute("data-stock-category", "sufficient");
        }else{
          u$1(counterContainer, classes$n.inventoryEmpty);
          counterContainer.setAttribute("data-stock-category", "empty");
        }
      } else if (inventory_quantity <= threshold || inventory_quantity <= 0 && inventory_policy === "continue") {
        counterContainer.setAttribute("data-stock-category", "low");
      } else {
        counterContainer.setAttribute("data-stock-category", "sufficient");
      }
    } else if (inventory_management === null && showUntrackedQuantity == "true") {
      counterContainer.setAttribute("data-stock-category", "sufficient");
    }
  }

  function setProgressBar(inventoryQuantity, inventoryManagement) {
    if (inventoryManagement === null && showUntrackedQuantity == "true") {
      progressBar.style.width = "".concat(100, "%");
      return;
    }

    if (inventoryQuantity <= 0) {
      progressBar.style.width = "".concat(0, "%");
      return;
    }

    var progressValue = inventoryQuantity < countDownMax ? inventoryQuantity / countDownMax * 100 : 100;
    progressBar.style.width = "".concat(progressValue, "%");
  }

  function setInventoryMessage(message) {
    inventoryMessageElement.innerHTML = message;
  }

  function productIventoryValid(product) {
    return product.inventory_message && (product.inventory_management !== null || product.inventory_management === null && showUntrackedQuantity == "true");
  }

  var update = function update(variant) {
    if (!variant) {
      setUnavailable();
      return;
    }

    l(counterContainer, classes$n.hidden, !productIventoryValid(variantsInventories[variant.id]));
    checkThreshold(variantsInventories[variant.id]);
    setProgressBar(variantsInventories[variant.id].inventory_quantity, variantsInventories[variant.id].inventory_management);
    setInventoryMessage(variantsInventories[variant.id].inventory_message);
  };

  function setUnavailable() {
    i$1(counterContainer, classes$n.hidden);
    u$1(counterContainer, classes$n.inventoryUnavailable);
    counterContainer.setAttribute("data-stock-category", "unavailable");
    setProgressBar(0);
    setInventoryMessage(unavailableText);
  }

  return {
    update: update
  };
};

// LERP returns a number between start and end based on the amt
// Often used to smooth animations
// Eg. Given: start = 0, end = 100
// - if amt = 0.1 then lerp will return 10
// - if amt = 0.5 then lerp will return 50
// - if amt = 0.9 then lerp will return 90
var lerp = function lerp(start, end, amt) {
  return (1 - amt) * start + amt * end;
};

var selectors$L = {
  productMeta: ".product__meta"
};
var classes$m = {
  hasSticky: "product--has-sticky-scroll"
};
function stickyScroll (node) {
  var productMeta = n$2(selectors$L.productMeta, node);
  node.style.setProperty("--product-meta-top", 0); // Init position vars
  // The previous scroll position of the page

  var previousScrollY = window.scrollY; // To keep track of the amount scrolled per event

  var currentScrollAmount = 0; // Height of the header bar, used for calculating position
  // Set in `_observeHeight()` when the --header-desktop-sticky-height var is set

  var headerHeight = 0; // The value to set the product meta `top` value to

  var metaTop = headerHeight;
  var metaTopPrevious = metaTop; // The height of the product meta container
  // Gets updated by a resize observer on the window and the meta container

  var metaHeight = productMeta.offsetHeight; // The height of the product meta container plus the height of the header

  var metaHeightWithHeader = metaHeight + headerHeight; // The max amount to set the meta `top` value
  // This is equal to the number of pixels
  // that the meta container is hidden by the viewport.
  // Gets updated by a resize observer on the window and the meta container

  var metaMaxTop = metaHeightWithHeader - window.innerHeight; // Whatch scroll updates

  var scroller = srraf(function (_ref) {
    var y = _ref.y;

    _scrollHandler(y);
  });
  provideResizeObserver().then(function (_ref2) {
    var ResizeObserver = _ref2.ResizeObserver;
    // Resize observer on the window and the product meta
    // Things like accordions can change the height of the meta container
    var resizeObserver = new ResizeObserver(_observeHeight);
    resizeObserver.observe(productMeta);
    resizeObserver.observe(document.documentElement);
  }); // Start the animation loop

  requestAnimationFrame(function () {
    return _updateMetaTopLoop();
  });

  function _observeHeight() {
    metaHeight = productMeta.offsetHeight;
    headerHeight = parseInt(getComputedStyle(document.documentElement).getPropertyValue("--header-desktop-sticky-height").replace(/px/gi, ""));
    metaHeightWithHeader = metaHeight + headerHeight;
    metaMaxTop = metaHeightWithHeader - window.innerHeight; // Check if the product meta container is taller than the viewport
    // and section container has room for the meta to scroll.
    // The product meta could be taller than the images
    // so it won't have room to scroll.

    if (metaHeightWithHeader > window.innerHeight && node.offsetHeight > metaHeightWithHeader) {
      u$1(node, classes$m.hasSticky);

      _scrollHandler(window.scrollY);
    } else {
      i$1(node, classes$m.hasSticky);
    }
  }

  function _scrollHandler(y) {
    currentScrollAmount = previousScrollY - y; // The offset based on how far the page has been scrolled from last event

    var currentScrollOffset = metaTop + currentScrollAmount; // The max top value while scrolling up

    var topMax = headerHeight; // The max top value while scrolling down

    var bottomMax = -metaMaxTop + headerHeight - 40; // Calculate the current top value based on the currentScrollOffset value
    // in the range of topMax and bottomMax.

    metaTop = Math.max(bottomMax, Math.min(currentScrollOffset, topMax)); // Update the previous scroll position for next time.

    previousScrollY = y;
  } // This is an endless RAF loop used to update the top position CSS var.
  // We're using this with a LERP function to smooth out the position updating
  // instead of having large jumps while scrolling fast.


  function _updateMetaTopLoop() {
    // We want to continue to update the top var until fully into the stopped position
    if (metaTop !== metaTopPrevious) {
      metaTopPrevious = lerp(metaTopPrevious, metaTop, 0.5);
      node.style.setProperty("--product-meta-top", "".concat(metaTopPrevious, "px"));
    }

    requestAnimationFrame(function () {
      return _updateMetaTopLoop();
    });
  }

  function destroy() {
    var _resizeObserver;

    scroller === null || scroller === void 0 ? void 0 : scroller.scroller.destroy();
    (_resizeObserver = resizeObserver) === null || _resizeObserver === void 0 ? void 0 : _resizeObserver.disconnect();
  }

  return {
    destroy: destroy
  };
}

var selectors$K = {
  item: ".product-item",
  itemInner: ".product-item__inner",
  quickViewButton: ".show-product-quickview"
};
function ProductItem(container) {
  var items = t$2(selectors$K.item, container);
  if (!items.length) return; // Add z-index for quick-buy overlap

  items.forEach(function (item, i) {
    return item.style.setProperty("--z-index-item", items.length - i);
  });
  //var productItemAnimations = AnimateProductItem(items);
  var quickViewButtons = t$2(selectors$K.quickViewButton, container);
  var events = [e$2(quickViewButtons, "click", function (e) {
    e.preventDefault();
    e.stopPropagation();
    var linkEl = e.currentTarget;
    var url = linkEl.getAttribute("href");
    r$1("quick-view:open", null, {
      productUrl: url
    });
  })];

  var unload = function unload() {
    events.forEach(function (unsubscribe) {
      return unsubscribe();
    });
  };

  return {
    unload: unload
  };
}

var selectors$J = {
  sliderContainer: ".swiper",
  visibleSlides: ".swiper-slide-visible"
};
var classes$l = {
  overflow: "has-overflow",
  carousel: "carousel"
};
var Carousel = (function (node) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  // Pass the swiper container or the contain section
  var swiperContainer = a$1(node, classes$l.carousel) ? node : n$2(selectors$J.sliderContainer, node);
  if (!swiperContainer) return;
  var carousel;
  var events = [];
  var defaultSwiperOptions = {
    slidesPerView: 2,
    grabCursor: true,
    watchSlidesProgress: true,
    on: {
      init: function init() {
        handleOverflow(this.slides);
      },
      breakpoint: function breakpoint() {
        onBreakpointChange(this.slides);
      }
    }
  };
  var nextButton = n$2("[data-next]", node);
  var prevButton = n$2("[data-prev]", node);
  var useNav = nextButton && prevButton; // Account for additional padding if slides overflow container

  var handleOverflow = function handleOverflow(slides) {
    // Allow breakpoints config settings to apply
    setTimeout(function () {
      var hasOverflow = a$1(swiperContainer, classes$l.overflow);
      var needsOverflow = t$2(selectors$J.visibleSlides, swiperContainer).length !== slides.length;

      if (!hasOverflow && needsOverflow) {
        u$1(swiperContainer, classes$l.overflow);
      } else if (hasOverflow && !needsOverflow) {
        i$1(swiperContainer, classes$l.overflow);
      }
    }, 0);
  };

  var onBreakpointChange = function onBreakpointChange(slides) {
    handleOverflow(slides);
  };

  function handleFocus(event) {
    var slide = event.target.closest(".swiper-slide");

    var slideIndex = _toConsumableArray$1(slide.parentElement.children).indexOf(slide); // TODO: ideally this would be dependant on if slide didn't have
    // `swiper-slide-visible` class (so would slide only as needed)
    // however that doesn't work with mobile peek, so brut forcing for now
    // and will always sliding now


    if (document.body.classList.contains("user-is-tabbing")) {
      carousel.slideTo(slideIndex);
    }
  }

  import(flu.chunks.swiper).then(function (_ref) {
    var Swiper = _ref.Swiper,
        Navigation = _ref.Navigation,
        Autoplay = _ref.Autoplay,
        Pagination = _ref.Pagination;
    var swiperOptions = Object.assign(defaultSwiperOptions, options); // nextEl and prevEl can be passed in check if they are before
    // using the defaults

    if ("navigation" in swiperOptions) {
      swiperOptions = Object.assign(swiperOptions, {
        modules: [Navigation]
      });
    } else if (useNav) {
      swiperOptions = Object.assign(swiperOptions, {
        modules: [Navigation],
        navigation: {
          nextEl: nextButton,
          prevEl: prevButton
        }
      });
    }
    if ("autoplay" in swiperOptions) {
      swiperOptions = Object.assign(swiperOptions, {
        modules: [...swiperOptions.modules, Autoplay],
        autoplay: swiperOptions.autoplay
      });
    }
    if ("pagination" in swiperOptions) {
      swiperOptions = Object.assign(swiperOptions, {
        modules: [...(swiperOptions.modules || []), Pagination],
      });
    }
    carousel = new Swiper(swiperContainer, swiperOptions);
    events.push(e$2(swiperContainer, "focusin", handleFocus));
  });
  return {
    destroy: function destroy() {
      var _carousel;

      (_carousel = carousel) === null || _carousel === void 0 ? void 0 : _carousel.destroy();
      events.forEach(function (unsubscribe) {
        return unsubscribe();
      });
    }
  };
});

var selectors$I = {
  wrappingContainer: ".product__block-featured-products",
  featuredProducts: "[data-featured-products]",
  featuredProductsContent: "[data-featured-products-content]",
  leftSideMobileFeaturedProducts: ".left-side-blocks.for-mobile [data-featured-products]"
};

var featuredProducts = function featuredProducts(node) {
  var featuredProducts = t$2(selectors$I.featuredProducts, node);
  if (!featuredProducts.length) return;
  var productItems;
  var mobileSwiper;
  var mobileFeaturedProducts;
  var _featuredProducts$0$d = featuredProducts[0].dataset,
      recommendationsType = _featuredProducts$0$d.recommendationsType,
      id = _featuredProducts$0$d.productId,
      sectionId = _featuredProducts$0$d.sectionId,
      enableMobileSwiper = _featuredProducts$0$d.enableMobileSwiper,
      maxRecommendations = _featuredProducts$0$d.maxRecommendations;

  if (recommendationsType === "app-recommendations") {
    handleRecommendedProducts();
  } else {
    // Merchant is using custom product list
    productItems = featuredProducts.forEach(function (productContainer) {
      return ProductItem(productContainer);
    });
    handleMobileSwiper();
  }

  function handleRecommendedProducts() {
    var requestUrl = "".concat(window.theme.routes.productRecommendations, "?section_id=").concat(sectionId, "&limit=").concat(maxRecommendations, "&product_id=").concat(id, "&intent=complementary");
    fetch(requestUrl).then(function (response) {
      return response.text();
    }).then(function (text) {
      var html = document.createElement("div");
      html.innerHTML = text;
      var recommendations = n$2(selectors$I.featuredProductsContent, html);

      if (recommendations && recommendations.innerHTML.trim().length) {
        featuredProducts.forEach(function (block) {
          return block.innerHTML = recommendations.innerHTML;
        });
        productItems = featuredProducts.map(function (productContainer) {
          return ProductItem(productContainer);
        }); // Remove hidden flag as content has been fetched

        featuredProducts.forEach(function (block) {
          i$1(block.closest(selectors$I.wrappingContainer), "hidden");
        });
        handleMobileSwiper();
      }
    }).catch(function (error) {
      throw error;
    });
  }

  function handleMobileSwiper() {
    if (enableMobileSwiper !== "true") return; // Left column blocks are rendered twice to keep correct
    // ordering with right column blocks on mobile. Here we
    // target the mobile left version if it exists as it requires
    // the potential mobile swiper only.

    mobileFeaturedProducts = n$2(selectors$I.leftSideMobileFeaturedProducts, node) || n$2(selectors$I.featuredProducts, node);

    if (window.matchMedia(getMediaQuery("below-720")).matches) {
      _initMobileSwiper();
    }

    atBreakpointChange(720, function () {
      if (window.matchMedia(getMediaQuery("below-720")).matches) {
        _initMobileSwiper();
      } else {
        var _mobileSwiper;

        (_mobileSwiper = mobileSwiper) === null || _mobileSwiper === void 0 ? void 0 : _mobileSwiper.destroy();
      }
    });
  }

  function _initMobileSwiper() {
    mobileSwiper = Carousel(mobileFeaturedProducts, {
      slidesPerView: 2.1,
      spaceBetween: 12
    });
  }

  function unload() {
    var _mobileSwiper2;

    productItems.forEach(function (item) {
      return item.unload();
    });
    (_mobileSwiper2 = mobileSwiper) === null || _mobileSwiper2 === void 0 ? void 0 : _mobileSwiper2.destroy();
  }

  return {
    unload: unload
  };
};

var classes$k = {
  disabled: "disabled"
};
var selectors$H = {
  variantsWrapper: ".product__variants-wrapper",
  variantsJson: "[data-variant-json]",
  input: ".dynamic-variant-input",
  inputWrap: ".dynamic-variant-input-wrap",
  inputWrapWithValue: function inputWrapWithValue(option) {
    return "".concat(selectors$H.inputWrap, "[data-index=\"").concat(option, "\"]");
  },
  buttonWrap: ".dynamic-variant-button",
  buttonWrapWithValue: function buttonWrapWithValue(value) {
    return "".concat(selectors$H.buttonWrap, "[data-option-value=\"").concat(value, "\"]");
  }
};
/**
 *  VariantAvailability
    - Cross out sold out or unavailable variants
    - Required markup:
      - class=dynamic-variant-input-wrap + data-index="option{{ forloop.index }}" to wrap select or button group
      - class=dynamic-variant-input + data-index="option{{ forloop.index }}" to wrap selects associated with variant potentially hidden if swatch / chip
      - class=dynamic-variant-button + data-value="{{ value | escape }}" to wrap button of swatch / chip
      - hidden product variants json markup
  * @param {node} container product container element
  * @returns {unload} remove event listeners
 */

function variantAvailability (container) {
  var variantsWrapper = n$2(selectors$H.variantsWrapper, container); // Variant options block do not exist

  if (!variantsWrapper) return;
  var _variantsWrapper$data = variantsWrapper.dataset,
      enableDynamicProductOptions = _variantsWrapper$data.enableDynamicProductOptions,
      currentVariantId = _variantsWrapper$data.currentVariantId;
  if (enableDynamicProductOptions === "false") return;
  var productVariants = JSON.parse(n$2(selectors$H.variantsJson, container).innerText); // Using associated selects as buy buttons may be disabled.

  var variantSelectors = t$2(selectors$H.input, container);
  var variantSelectorWrappers = t$2(selectors$H.inputWrap, container);
  var events = [];
  init();

  function init() {
    variantSelectors.forEach(function (el) {
      events.push(e$2(el, "change", handleChange));
    });
    setInitialAvailability();
  }

  function updateSelectOptions (selectId, optionsData) {
    const select = document.getElementById(selectId);

    if (!select) {
    // console.error("Select element not found");
      return;
    }

    let firstAvailableOption = null;
    let optionLabel = document.querySelector("[data-option-name='" + selectId + "']"); 

    for (let i = 0; i < select.options.length; i++) {
      const option = select.options[i];
      const optionValue = option.value;
      if (optionsData.hasOwnProperty(optionValue)) {
        const soldOut = optionsData[optionValue];
  
        if (soldOut) {
          option.disabled = true;
        } else if (!firstAvailableOption) {
          firstAvailableOption = option;
          option.disabled = false;
        } else {
          option.disabled = false;
        }
      }
    }

    if (!!firstAvailableOption) {
      optionLabel.innerHTML = firstAvailableOption.text;
      if(select.options[select.selectedIndex].disabled){
        firstAvailableOption.selected = true;
      }
    }
  }

  function setInitialAvailability() {
    // Disable all options on initial load
    variantSelectorWrappers.forEach(function (group) {
      return disableVariantGroup(group);
    });
    let variants = JSON.parse(document.querySelector("#ProductVariantPerColor").innerHTML);
    variants["variants"].forEach(variant => {
      productVariants.forEach(prodVar => {
        if(prodVar.id == variant.id){
          prodVar.metafields = variant;
        }
      })
    })
    var initiallySelectedVariant = productVariants.find(function (variant) {
      return variant.id === parseInt(currentVariantId, 10);
    });
    var currentlySelectedValues = initiallySelectedVariant.options.map(function (value, index) {
      return {
        value: value,
        index: "option".concat(index + 1)
      };
    });
    var initialOptions = createAvailableOptionsTree(productVariants, currentlySelectedValues);
    for (var _i = 0, _Object$entries = Object.entries(initialOptions); _i < _Object$entries.length; _i++) {
      var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
          option = _Object$entries$_i[0],
          values = _Object$entries$_i[1];

      manageOptionState(option, values);
    }

    updateSelectOptions('option2', initialOptions['option2'].reduce((prev, cur) => {
      prev[cur.value] = cur.soldOut;
      return prev;
    }, {}));

  } // Create a list of all options. If any variant exists and is in stock with that option, it's considered available


  function createAvailableOptionsTree(variants, currentlySelectedValues) {
    // Reduce variant array into option availability tree
    return variants.reduce(function (options, variant) {
      // Check each option group (e.g. option1, option2, option3) of the variant
      Object.keys(options).forEach(function (index) {
        if (variant[index] === null) return;
        var entry = options[index].find(function (option) {
          return option.value === variant[index];
        });

        if (typeof entry === "undefined") {
          // If option has yet to be added to the options tree, add it
          entry = {
            value: variant[index],
            soldOut: true,
            metafields: variant["metafields"]
          };
          options[index].push(entry);
        }

        var currentOption1 = currentlySelectedValues.find(function (_ref) {
          var index = _ref.index;
          return index === "option1";
        });
        var currentOption2 = currentlySelectedValues.find(function (_ref2) {
          var index = _ref2.index;
          return index === "option2";
        });

        switch (index) {
          case "option1":
            // Option1 inputs should always remain enabled based on all available variants
            entry.soldOut = entry.soldOut && variant.available ? false : entry.soldOut;
            break;

          case "option2":
            // Option2 inputs should remain enabled based on available variants that match first option group
            if (currentOption1 && variant.option1 === currentOption1.value) {
              entry.soldOut = entry.soldOut && variant.available ? false : entry.soldOut;
            }

            break;

          case "option3":
            // Option 3 inputs should remain enabled based on available variants that match first and second option group
            if (currentOption1 && variant.option1 === currentOption1.value && currentOption2 && variant.option2 === currentOption2.value) {
              entry.soldOut = entry.soldOut && variant.available ? false : entry.soldOut;
            }
        }
      });
      return options;
    }, {
      option1: [],
      option2: [],
      option3: []
    });
  }

  function handleChange() {
    let options2;
    var currentlySelectedValues = variantSelectors.map(function (el) {
      if(el.id == "option1"){
        options2 = getAvailableOptionsByFirstOptionValue(el.value);
      }
      if(el.id == "option2"){
        //If the current size don't exist, show the first available one
        if(options2.includes(el.value) == false && options2.length){
          el.value = options2[0];
        }
      }
      return {
        value: el.value,
        index: el.id
      };
    });
    setAvailability(currentlySelectedValues);
  }

  function getAvailableOptionsByFirstOptionValue($option1) {
    let variants = JSON.parse(document.querySelector("#ProductVariantPerColor").innerHTML);
    let inStockOptions2 = [];
    let existingOptions2 = [];
    variants["variants"].forEach(variant => {
      if($option1 == variant.option1 && existingOptions2.includes(variant.option2) == false){
          existingOptions2.push(variant.option2);
          if(variant.is_available_in_web_stock == true || variant.is_available_offline  == true){
            inStockOptions2.push(variant.option2)
          }
      }
    })
    //If there is no in stock option, we return the existing one.
    return (inStockOptions2.length > 0) ? inStockOptions2 : existingOptions2;
  }

  function setAvailability(selectedValues) {
    // Object to hold all options by value.
    // This will be what sets a button/dropdown as
    // sold out or unavailable (not a combo set as purchasable)
    var valuesToManage = createAvailableOptionsTree(productVariants, selectedValues); // Loop through all option levels and send each

    // value w/ args to function that determines to show/hide/enable/disable
    for (var _i2 = 0, _Object$entries2 = Object.entries(valuesToManage); _i2 < _Object$entries2.length; _i2++) {
      var _Object$entries2$_i = _slicedToArray(_Object$entries2[_i2], 2),
          option = _Object$entries2$_i[0],
          values = _Object$entries2$_i[1];

      manageOptionState(option, values);
    }
    updateSelectOptions('option2', valuesToManage['option2'].reduce((prev, cur) => {
      prev[cur.value] = cur.soldOut;
      return prev;
    }, {}));
    
    updateSelectOptions('option3', valuesToManage['option3'].reduce((prev, cur) => {
      prev[cur.value] = cur.soldOut;
      return prev;
    }, {}));
  }

  function manageOptionState(option, values) {
    var group = n$2(selectors$H.inputWrapWithValue(option), container); // Loop through each option value
    values.forEach(function (obj) {
      toggleVariantOption(group, obj);
    });
  }

  function toggleVariantOption(group, obj) {
    // Selecting by value so escape it
    var value = escapeQuotes(obj.value); // Do nothing if the option is a select dropdown
    if (a$1(group, "select-wrapper")) return;
    var button = n$2(selectors$H.buttonWrapWithValue(value), group); // Variant exists - enable & show variant

    if(button) i$1(button, classes$k.disabled); // Variant sold out - cross out option (remains selectable)

    const { is_available_in_web_stock, is_rxable, is_available_offline } = obj.metafields;

    const isAvailable = is_available_in_web_stock && is_rxable;
    const isBookAnAppointment = is_available_offline;

    if (obj.soldOut && !isAvailable && !isBookAnAppointment && button) {
      u$1(button, classes$k.disabled);
    }
  }

  function disableVariantGroup(group) {
    if (a$1(group, "select-wrapper")) return;
    t$2(selectors$H.buttonWrap, group).forEach(function (button) {
      return u$1(button, classes$k.disabled);
    });
  }

  function escapeQuotes(str) {
    var escapeMap = {
      '"': '\\"',
      "'": "\\'"
    };
    return str.replace(/"|'/g, function (m) {
      return escapeMap[m];
    });
  }

  var unload = function unload() {
    events.forEach(function (unsubscribe) {
      return unsubscribe();
    });
  };

  return {
    unload: unload
  };
}

var selectors$G = {
  siblingProducts: "[data-sibling-products]",
  siblingSwatch: "[data-sibling-swatch]",
  siblingLabelEl: "[data-sibling-label-value]"
};
function siblingProducts (container) {
  var siblingProducts = n$2(selectors$G.siblingProducts, container);
  if (!siblingProducts) return;
  var siblingSwatches = t$2(selectors$G.siblingSwatch, siblingProducts);
  var labelValueEl = n$2(selectors$G.siblingLabelEl, siblingProducts);
  var baseLabel = labelValueEl.innerText;
  var events = [];
  siblingSwatches.forEach(function (item) {
    events.push(e$2(item, "mouseout", function () {
      return handleOut();
    }), e$2(item, "mouseover", function (e) {
      return handleOver(e);
    }));
  });

  function handleOver(e) {
    var cutline = e.target.dataset.siblingCutline;
    labelValueEl.innerText = cutline;
  }

  function handleOut() {
    if (labelValueEl.innerText !== baseLabel) {
      labelValueEl.innerText = baseLabel;
    }
  }

  var unload = function unload() {
    events.forEach(function (unsubscribe) {
      return unsubscribe();
    });
  };

  return {
    unload: unload
  };
}

window.theme.strings.products;
var selectors$F = {
  unitPriceContainer: "[data-unit-price-container]",
  unitPrice: "[data-unit-price]",
  unitPriceBase: "[data-unit-base]"
};
var classes$j = {
  available: "unit-price--available"
};

var updateUnitPrices = function updateUnitPrices(container, variant) {
  var unitPriceContainers = t$2(selectors$F.unitPriceContainer, container);
  var unitPrices = t$2(selectors$F.unitPrice, container);
  var unitPriceBases = t$2(selectors$F.unitPriceBase, container);
  var showUnitPricing = !variant || !variant.unit_price;
  l(unitPriceContainers, classes$j.available, !showUnitPricing);
  if (!variant || !variant.unit_price) return;

  _replaceText(unitPrices, formatMoney(variant.unit_price));

  _replaceText(unitPriceBases, _getBaseUnit(variant.unit_price_measurement));
};

var _getBaseUnit = function _getBaseUnit(unitPriceMeasurement) {
  return unitPriceMeasurement.reference_value === 1 ? unitPriceMeasurement.reference_unit : unitPriceMeasurement.reference_value + unitPriceMeasurement.reference_unit;
};

var _replaceText = function _replaceText(nodeList, replacementText) {
  nodeList.forEach(function (node) {
    return node.innerText = replacementText;
  });
};

var storeAvailability = function storeAvailability(container, product, variant) {
  var update = function update(variant) {
    container.innerHTML = "";
    if (!variant) return;
    var variantSectionUrl = "".concat(container.dataset.baseUrl, "/variants/").concat(variant.id, "/?section_id=store-availability");
    makeRequest("GET", variantSectionUrl).then(function (storeAvailabilityHTML) {
      if (storeAvailabilityHTML.trim() === "") return; // Remove section wrapper that throws nested sections error

      container.innerHTML = storeAvailabilityHTML.trim();
      container.innerHTML = container.firstElementChild.innerHTML;
      container.setAttribute("data-variant-id", variant.id);
      container.setAttribute("data-product-title", product.title);
      container.setAttribute("data-variant-title", variant.public_title);
    });
  }; // Intialize


  update(variant);

  var unload = function unload() {
    container.innerHTML = "";
  };

  return {
    unload: unload,
    update: update
  };
};

var selectors$E = {
  form: "[data-product-form]",
  addToCart: "[data-add-to-cart]",
  variantSelect: "[data-variant-select]",
  optionById: function optionById(id) {
    return "[value='".concat(id, "']");
  },
  thumbs: "[data-product-thumbnails]",
  thumb: "[data-product-thumbnail]",
  storeAvailability: "[data-store-availability-container]",
  quantityError: "[data-quantity-error]",
  productOption: ".product__option",
  optionLabelValue: "[data-selected-value-for-option]",
  displayedDiscount: "[data-discount-display]",
  displayedDiscountByVariantId: function displayedDiscountByVariantId(id) {
    return "[variant-discount-display][variant-id=\"".concat(id, "\"]");
  },
  nonSprRatingCountLink: ".product__rating-count-potential-link",
  photosMobile: ".product__media-container.below-mobile",
  photosDesktop: ".product__media-container.above-mobile",
  priceWrapper: ".product__price",
  quickCart: ".quick-cart",
  purchaseConfirmation: ".purchase-confirmation-popup",
  productReviews: "#shopify-product-reviews",
  customOptionInputs: "[data-custom-option-input]",
  customOptionInputTargetsById: function customOptionInputTargetsById(id) {
    return "[data-custom-option-target='".concat(id, "']");
  }
};

var Product = /*#__PURE__*/function () {
  function Product(node) {
    var _this = this;

    _classCallCheck(this, Product);

    this.container = node;
    this.accordions = [];
    var _this$container$datas = this.container.dataset,
        isQuickView = _this$container$datas.isQuickView,
        isFullProduct = _this$container$datas.isFullProduct,
        isFeaturedProduct = _this$container$datas.isFeaturedProduct,
        enableStickyProductDetails = _this$container$datas.enableStickyProductDetails;
    this.isQuickView = isQuickView;
    this.isFullProduct = isFullProduct;
    this.isFeaturedProduct = isFeaturedProduct;
    this.formElement = n$2(selectors$E.form, this.container);
    this.quantityError = n$2(selectors$E.quantityError, this.container);
    this.displayedDiscount = n$2(selectors$E.displayedDiscount, this.container);
    this.viewInYourSpace = n$2("[data-in-your-space]", this.container);
    this.viewInYourSpace && l(this.viewInYourSpace, "visible", isMobile$1());
    this.photosDesktop = n$2(selectors$E.photosDesktop, this.container);
    this.breakPointHandler = atBreakpointChange(960, function () {
      if (window.matchMedia(getMediaQuery("below-960")).matches) {
        _this._initPhotoCarousel();
      } else {
        var _this$mobileSwiper;

        (_this$mobileSwiper = _this.mobileSwiper) === null || _this$mobileSwiper === void 0 ? void 0 : _this$mobileSwiper.destroy();
      }
    });

    const frames = document.querySelectorAll(".topology-models__frames.below-mobile .topology-models__frames-inner");

    frames.forEach(frame => {
      frame.addEventListener("click", (e) => {
        e.stopPropagation();
        const mainFrames = document.querySelectorAll(".topology-models__main-frame.below-mobile");

        mainFrames.forEach(mainFrame => {
          mainFrame.innerHTML = e.target.parentNode.outerHTML;
        }) 
      })
    })

    if (window.matchMedia(getMediaQuery("below-960")).matches) {
      this._initPhotoCarousel();
    }

    this.productThumbnails = n$2(selectors$E.thumbs, this.container);
    this.productThumbnailItems = t$2(selectors$E.thumb, this.container);

    if (this.productThumbnails) {
      this.productThumbnailsScroller = scrollContainer(this.productThumbnails);
    }

    this.moreMedia = moreMedia(this.container); // Handle Surface pickup

    this.storeAvailabilityContainer = n$2(selectors$E.storeAvailability, this.container);
    this.availability = null; // Handle Shopify Product Reviews if they exist as a product block

    this.reviewsHandler = reviewsHandler(n$2(selectors$E.productReviews, this.container), this.container); // // non-SPR rating display

    var nonSprRatingCount = n$2(selectors$E.nonSprRatingCountLink, this.container);

    if (nonSprRatingCount && !n$2(selectors$E.productReviews, document)) {
      // The rating count links to "#shopify-product-reviews" but
      // if that block doesn't exist we should remove the link
      nonSprRatingCount.removeAttribute("href");
    }

    if (this.formElement) {
      var _this$formElement$dat = this.formElement.dataset,
          productHandle = _this$formElement$dat.productHandle,
          currentProductId = _this$formElement$dat.currentProductId;
      var product = getProduct(productHandle);
      product(function (data) {
        var variant = getVariantFromId(data, parseInt(currentProductId));

        if (_this.storeAvailabilityContainer && variant) {
          _this.availability = storeAvailability(_this.storeAvailabilityContainer, data, variant);
        }

        _this.productForm = ProductForm(_this.container, _this.formElement, data, {
          onOptionChange: function onOptionChange(e) {
            return _this.onOptionChange(e);
          },
          onFormSubmit: function onFormSubmit(e) {
            return _this.onFormSubmit(e);
          },
          onQuantityChange: function onQuantityChange(e) {
            return _this.onQuantityChange(e);
          }
        });
        var productInventoryJson = n$2("[data-product-inventory-json]", _this.container);

        if (productInventoryJson) {
          var jsonData = JSON.parse(productInventoryJson.innerHTML);
          var variantsInventories = jsonData.inventory;

          if (variantsInventories) {
            var config = {
              id: variant.id,
              variantsInventories: variantsInventories
            };
            _this.inventoryCounter = inventoryCounter(_this.container, config);
          }
        }
      });
    }

    this.quantityInput = quantityInput(this.container);
    this.customOptionInputs = t$2(selectors$E.customOptionInputs, this.container);
    this.socialButtons = t$2("[data-social-share]", this.container);
    this.featuredProducts = featuredProducts(this.container);

    if (enableStickyProductDetails === "true" && !isMobile$1()) {
      this.stickyScroll = stickyScroll(this.container);
    }

    var accordionElements = t$2(".accordion", this.container);
    accordionElements.forEach(function (accordion) {
      var accordionOpen = accordion.classList.contains("accordion--open");

      _this.accordions.push(Accordions(accordion, {
        firstOpen: accordionOpen
      }));

      var accordionParent = accordion.parentElement;

      if (accordionParent.classList.contains("rte--product") && !accordionParent.classList.contains("accordion accordion--product")) {
        accordion.classList.add("rte--product", "accordion--product");
      }
    });
    this.mediaContainers = Media(n$2(".product__media-container.above-mobile", this.container));
    this.mediaContainersMobile = Media(n$2(".product__media-container.below-mobile", this.container));
    this.optionButtons = OptionButtons(t$2("[data-option-buttons]", this.container));
    this.informationPopup = informationPopup(this.container);
    var productDescriptionWrapper = n$2(".product__description", this.container);

    if (productDescriptionWrapper) {
      wrapIframes(t$2("iframe", productDescriptionWrapper));
      wrapTables(t$2("table", productDescriptionWrapper));
    }

    var socialShareContainer = n$2(".social-share", this.container);

    if (socialShareContainer) {
      this.socialShare = SocialShare(socialShareContainer);
    }

    this._initEvents(); // Handle dynamic variant options

    this.variantAvailability = variantAvailability(this.container); // Handle sibling products

    this.siblingProducts = siblingProducts(this.container);
  }

  _createClass(Product, [{
    key: "_initEvents",
    value: function _initEvents() {
      var _this2 = this;

      this.events = [];

      this.productThumbnailItems.forEach(thumb => {
        thumb.addEventListener("click", (e) => {
          e.preventDefault();
          const dataset = e.currentTarget.dataset;
          if (productScan) productScan.hideScanContainer();

          this.productThumbnailItems.forEach((thumb) => {
            return i$1(thumb, "active");
          });

          u$1(e.currentTarget, "active");
          switchImage(this.photosDesktop, dataset.thumbnailId, this.viewInYourSpace);
        })
      })

      if (this.customOptionInputs) {
        this.customOptionInputs.forEach(function (input) {
          var id = input.dataset.customOptionInput;
          var target = n$2(selectors$E.customOptionInputTargetsById(id), _this2.container);

          _this2.events.push(e$2(input, "change", function (e) {
            // Update the hidden input within the form, per type
            if (e.target.type === "checkbox") {
              target.checked = e.target.checked;
            } else {
              target.value = e.target.value;
            }
          }));
        });
      }
    }
  }, {
    key: "_initPhotoCarousel",
    value: function _initPhotoCarousel() {
      var _this3 = this;

      var swiperWrapper = n$2(selectors$E.photosMobile, this.container);
      const wrapper = document.querySelector('.product__media-container--thumbnails');
      
      import(flu.chunks.swiper).then(function (_ref) {
        var Swiper = _ref.Swiper,
        Controller = _ref.Controller;

        _this3.mobileSwiper = new Swiper(swiperWrapper, {
          modules: [Controller],
          slidesPerView: 1,
          spaceBetween: 4,
          grabCursor: true,
          autoHeight: true,
          loop: true,
          loopedSlides: 3,
        });

        _this3.mobileThumbnails = new Swiper(wrapper, {
          modules: [Controller],
          slidesPerView: 3,
          spaceBetween: 20,
          centeredSlides: true,
          slideToClickedSlide: true,
          centeredSlidesBounds: true,
          loop: true,
          loopedSlides: 3,
        });

        _this3.mobileSwiper.controller.control = _this3.mobileThumbnails;
        _this3.mobileThumbnails.controller.control = _this3.mobileSwiper;

        _this3.mobileSwiper.on("slideChange", function (evt) {
          if (_this3.viewInYourSpace) {
            var activeSlide = evt.slides[evt.activeIndex];

            if (activeSlide.dataset.mediaType === "model") {
              _this3.viewInYourSpace.setAttribute("data-shopify-model3d-id", activeSlide.dataset.mediaItemId);
            }
          }

          _this3.mediaContainersMobile && _this3.mediaContainersMobile.pauseActiveMedia();
        });
      });
    } // When the user changes a product option

  }, {
    key: "onOptionChange",
    value: async function onOptionChange(_ref2) {
      var variant = _ref2.dataset.variant,
          srcElement = _ref2.srcElement;
      // Update option label
      var optionParentWrapper = srcElement.closest(selectors$E.productOption);
      var optionLabel = n$2(selectors$E.optionLabelValue, optionParentWrapper);

      if (optionLabel) {
        optionLabel.textContent = srcElement.options[srcElement.selectedIndex].text;
      }

      var buyButton = n$2(selectors$E.addToCart, this.container);
      var priceWrapper = n$2(selectors$E.priceWrapper, this.container);
      priceWrapper && l(priceWrapper, "hide", !variant); // Update prices to reflect selected variant

      updatePrices(this.container, variant); // Update buy button

      initBookAppointmentLink({ variant });
      updateBuyButton(buyButton, variant); // Update unit pricing

      updateVarintMeasures(variant);

      updateSpecificationsBlock(variant);

      updateUnitPrices(this.container, variant); // Update sku

      updateSku(this.container, variant); // Update product availability content

      this.availability && this.availability.update(variant); // Update displayed discount

      const updateMediaGalleryHTML = async (variant) => {
        if(!variant) return;

        const sectionId = "product-media";
        const variantSectionUrl = `${window.location.protocol}//${window.location.host}/${localeKey.length ? `${localeKey}/` : ""}products/${this.formElement.dataset.productHandle}/?sections=${sectionId}&variant=${variant.id}`;
        const response = await fetch(variantSectionUrl);
        const json = await response.json();
        const html = json[sectionId];

        const div = document.createElement("DIV");
        div.innerHTML = html;

        const container = document.querySelector('#product__media-container');
        container.innerHTML = div.querySelector(".shopify-section").innerHTML;
      }

      const updateSelectLensesFlow = async (variant) => {
        const selectButton = document.querySelector(".product-form__cart-submit");
        selectButton.disabled = true;
        selectButton.classList.add("loading");

        const sectionId = "product-select-lenses-flow";
        const flowWrapper = document.querySelector(".purchase-flow-popup__box");
        flowWrapper.innerHTML = "";
        const sectionURL = `${window.location.pathname}/?sections=${sectionId}&variant=${variant.id}`;
        const response = await fetch(sectionURL);
        const jsonData = await response.json();
        
        const html = jsonData[sectionId];
        const container = document.createElement("DIV");
        container.innerHTML = html;
        
        flowWrapper.innerHTML = container.querySelector(".shopify-section").innerHTML;
        selectButton.disabled = false;
        selectButton.classList.remove("loading");
      }

      const updatePDPVariant = async (variant) => {
        const sectionId = "get-current-variant";
        const sectionURL = `${window.location.pathname}/?sections=${sectionId}&variant=${variant.id}`;
        const response = await fetch(sectionURL);
        const json = await response.json();
        const div = document.createElement("DIV");
        div.innerHTML = json[sectionId];
        let script = div.querySelector("script").innerHTML;
        eval(script);
      }

      // if(variant) await updatePDPVariant(variant);

      const isTryOnActive = document.querySelector(".try-on-container--active") ? true : false;
      const isProductPriceVaries = window['productPriceVaries'];
      
      if(window.innerWidth < 768){
        await updateMediaGalleryHTML(variant);
      }

      if(variant){//isProductPriceVaries
        await updateSelectLensesFlow(variant);
      }

      setTimeout(async () => {
        if (window.matchMedia(getMediaQuery("below-960")).matches) {
          this._initPhotoCarousel();
        }

        if (this.productThumbnails) {
          this.productThumbnailsScroller = scrollContainer(this.productThumbnails);
        }
  
        if (this.displayedDiscount) {
          var newDiscountEl = variant && n$2(selectors$E.displayedDiscountByVariantId(variant.id), this.container);
  
          if (variant && newDiscountEl) {
            this.displayedDiscount.textContent = newDiscountEl.textContent;
          } else {
            this.displayedDiscount.textContent = "";
          }
        }
  
        this.inventoryCounter && this.inventoryCounter.update(variant);
        dispatchCustomEvent("product:variant-change", {
          variant: variant
        });
  
        if (!variant) {
          updateBuyButton(n$2("[data-add-to-cart]", this.container), false);
          this.availability && this.availability.unload();
          return;
        } // Update URL with selected variant
  
        var url = getUrlWithVariant(window.location.href, variant.id);
        window.history.replaceState({
          path: url
        }, "", url); // We need to set the id input manually so the Dynamic Checkout Button works
  
        var selectedVariantOpt = n$2("".concat(selectors$E.variantSelect, " ").concat(`[data-original-id='${variant.id}']`), this.container);
        document.querySelector("#variant-selector option[selected]").removeAttribute('selected');
        selectedVariantOpt.selected = true; // We need to dispatch an event so Shopify pay knows the form has changed
        selectedVariantOpt.setAttribute("selected", "selected");
        
        this.formElement.dispatchEvent(new Event("change")); // Update selected variant image and thumb
  
        this.photosDesktop = this.container.querySelector(selectors$E.photosDesktop, this.container);
        this.productThumbnails = this.container.querySelector(selectors$E.thumbs, this.container);
        this.productThumbnailItems = this.container.querySelectorAll(selectors$E.thumb);

        const updateThumbnails = (variant) => {
          if(!variant) return;

          const sku = variant.sku;

          const activeThumbs = document.querySelectorAll(".product-thumbnails__item:not(.hidden)");
          activeThumbs.forEach(thumb => {
            thumb.classList.add('hidden');
          })

          const newThumbs = document.querySelectorAll(`.product-thumbnails__item[data-sku="${sku}"]`);
          newThumbs.forEach(thumb => {
            thumb.classList.remove('hidden');
          })
        }

        updateThumbnails(variant);
  
        if (variant.featured_media) {
          if (this.isFullProduct) {
            if (this.mobileSwiper) {
              try{
                var slidesWrap = this.mobileSwiper.el;
                var targetSlide = n$2("[data-media-item-id=\"".concat(variant.featured_media.id, "\"]"), slidesWrap);
                
                if (targetSlide) {
                  var targetSlideIndex = _toConsumableArray$1(targetSlide.parentElement.children).indexOf(targetSlide);
    
                  this.mobileSwiper.slideTo(targetSlideIndex);
                }
              }catch(e){
                console.log("error mob slider");
              }
            } else {
              var imagesWrap = n$2(".product__media-container.above-mobile");
  
              if (imagesWrap.dataset.galleryStyle === "thumbnails") {
                switchImage(this.photosDesktop, variant.featured_media.id, this.viewInYourSpace);
                var thumb = n$2("[data-thumbnail-id=\"".concat(variant.featured_media.id, "\"]"), this.photosDesktop);
                this.productThumbnailItems.forEach(function (thumb) {
                  return i$1(thumb, "active");
                });
                try{
                  u$1(thumb, "active");
                }catch(e){
                  console.log("error");
                }
              } else {
                var targetImage = n$2(".product__media-container.above-mobile [data-media-id=\"".concat(variant.featured_media.id, "\"]"));
  
                if (this.isFeaturedProduct) {
                  this.switchCurrentImage(variant.featured_media.id);
                } else {
                  targetImage.scrollIntoView({
                    behavior: "smooth",
                    block: "nearest",
                    inline: "nearest"
                  });
                }
              }
            }
          } else {
            this.switchCurrentImage(variant.featured_media.id);
          }
        }

        this.mediaContainers = Media(n$2(".product__media-container.above-mobile", this.container));
        this.mediaContainersMobile = Media(n$2(".product__media-container.below-mobile", this.container));

        let lightbox = window.productLightbox;
        if(lightbox){
          lightbox.destroy();
          productLightbox();
        }
        
        if (window.VTOActive) {
          vtoModels.init();
          await productScan.init();
          
          if(isTryOnActive){
            const toggleState = window.innerWidth < 768 ? true : false;
            productScan.togglePersonalScanDisplay(toggleState);
          }
        }
      }, 0);
    }
  }, {
    key: "switchCurrentImage",
    value: function switchCurrentImage(id) {
      var imagesWraps = t$2(".product__media", this.container);
      imagesWraps.forEach(function (imagesWrap) {
        return switchImage(imagesWrap, id);
      });
    } // When user updates quantity

  }, {
    key: "onQuantityChange",
    value: function onQuantityChange(_ref3) {
      var _ref3$dataset = _ref3.dataset,
          variant = _ref3$dataset.variant,
          quantity = _ref3$dataset.quantity;

      // Adjust the hidden quantity input within the form
      var quantityInputs = _toConsumableArray$1(t$2('[name="quantity"]', this.formElement));

      quantityInputs.forEach(function (quantityInput) {
        quantityInput.value = quantity;
      });
      dispatchCustomEvent("product:quantity-update", {
        quantity: quantity,
        variant: variant
      });
    } // When user submits the product form

  }, {
    key: "onFormSubmit",
    value: function onFormSubmit(e) {
      var _this4 = this;

      var purchaseConfirmation = n$2(selectors$E.purchaseConfirmation, document);
      var quickCart = n$2(selectors$E.quickCart, document);
      var isQuickViewForm = Boolean(e.target.closest(".quick-product")); // if quick cart and confirmation popup are enable submit form

      if (!purchaseConfirmation && !quickCart && !isQuickViewForm) return;
      e.preventDefault();
      u$1(this.quantityError, "hidden");
      var button = n$2(selectors$E.addToCart, this.container);
      u$1(button, "loading");
      cart.addItem(this.formElement).then(function (_ref4) {
        var item = _ref4.item;
        i$1(button, "loading");

        if (purchaseConfirmation && !isMobile$1()) {
          r$1("confirmation-popup:open", null, {
            product: item
          });
        } else {
          r$1("quick-cart:updated"); // Need a delay to allow quick-cart to refresh

          setTimeout(function () {
            r$1("quick-cart:open");
          }, 400);
        }

        dispatchCustomEvent("cart:item-added", {
          product: item
        });
      }).catch(function (error) {
        cart.get(); // update local cart data

        if (error && error.message) {
          _this4.quantityError.innerText = error.message;
        } else {
          _this4.quantityError.innerText = _this4.quantityErorr.getAttribute("data-fallback-error-message");
        }

        i$1(_this4.quantityError, "hidden");
        var button = n$2(selectors$E.addToCart, _this4.container);
        i$1(button, "loading");
      });
    }
  }, {
    key: "unload",
    value: function unload() {
      var _this$quantityInput, _this$mobileSwiper2, _this$stickyScroll, _this$moreMedia, _this$featuredProduct, _this$variantAvailabi, _this$siblingProducts;

      this.productForm.destroy();
      this.accordions.forEach(function (accordion) {
        return accordion.unload();
      });
      this.optionButtons.destroy();
      (_this$quantityInput = this.quantityInput) === null || _this$quantityInput === void 0 ? void 0 : _this$quantityInput.unload();
      this.events.forEach(function (unsubscribe) {
        return unsubscribe();
      });
      (_this$mobileSwiper2 = this.mobileSwiper) === null || _this$mobileSwiper2 === void 0 ? void 0 : _this$mobileSwiper2.destroy();
      (_this$stickyScroll = this.stickyScroll) === null || _this$stickyScroll === void 0 ? void 0 : _this$stickyScroll.destroy();
      (_this$moreMedia = this.moreMedia) === null || _this$moreMedia === void 0 ? void 0 : _this$moreMedia.unload();
      (_this$featuredProduct = this.featuredProducts) === null || _this$featuredProduct === void 0 ? void 0 : _this$featuredProduct.unload();
      (_this$variantAvailabi = this.variantAvailability) === null || _this$variantAvailabi === void 0 ? void 0 : _this$variantAvailabi.unload();
      (_this$siblingProducts = this.siblingProducts) === null || _this$siblingProducts === void 0 ? void 0 : _this$siblingProducts.unload();
    }
  }]);

  return Product;
}();

var classes$i = {
  visible: "is-visible",
  active: "active",
  fixed: "is-fixed"
};
var selectors$D = {
  closeBtn: "[data-modal-close]",
  wash: ".modal__wash",
  modalContent: ".quick-view-modal__content",
  loadingMessage: ".quick-view-modal-loading-indicator"
};

var quickViewModal = function quickViewModal(node) {
  var focusTrap = createFocusTrap(node, {
    allowOutsideClick: true
  });
  var wash = n$2(selectors$D.wash, node);
  var closeButton = n$2(selectors$D.closeBtn, node);
  var modalContent = n$2(selectors$D.modalContent, node);
  var loadingMessage = n$2(selectors$D.loadingMessage, node);
  var quickViewAnimation = null;

  if (shouldAnimate(node)) {
    quickViewAnimation = animateQuickView(node);
  }

  var product;
  var events = [e$2([wash, closeButton], "click", function (e) {
    e.preventDefault();

    _close();
  }), e$2(node, "keydown", function (_ref) {
    var keyCode = _ref.keyCode;
    if (keyCode === 27) _close();
  }), c("quick-view:open", function (state, _ref2) {
    var productUrl = _ref2.productUrl;

    _renderProductContent(productUrl);

    _open();
  }), c("quick-view:close", function () {
    _close();
  })];

  var _renderProductContent = function _renderProductContent(productUrl) {
    var xhrUrl = "".concat(productUrl).concat(productUrl.includes("?") ? "&" : "?", "view=quick-view");
    makeRequest("GET", xhrUrl).then(function (response) {
      var container = document.createElement("div");
      container.innerHTML = response;
      var productElement = n$2("[data-is-quick-view]", container);
      i$1(modalContent, "empty");
      modalContent.innerHTML = "";
      modalContent.appendChild(productElement);
      var renderedProductElement = n$2("[data-is-quick-view]", modalContent);

      if (shouldAnimate(node)) {
        quickViewAnimation.animate();
      }

      product = new Product(renderedProductElement);
      dispatchCustomEvent("quickview:loaded");
    });
  };

  var _open = function _open() {
    u$1(node, classes$i.fixed);
    setTimeout(function () {
      u$1(node, classes$i.active);
      setTimeout(function () {
        u$1(node, classes$i.visible);
        focusTrap.activate();
      }, 50);
    }, 50);
    document.body.setAttribute("data-fluorescent-overlay-open", "true");
    disableBodyScroll(node, {
      allowTouchMove: function allowTouchMove(el) {
        while (el && el !== document.body) {
          if (el.getAttribute("data-scroll-lock-ignore") !== null) {
            return true;
          }

          el = el.parentNode;
        }
      },
      reserveScrollBarGap: true
    });
  };

  var _close = function _close() {
    focusTrap.deactivate();
    i$1(node, classes$i.visible);
    i$1(node, classes$i.active);
    document.body.setAttribute("data-fluorescent-overlay-open", "false");
    enableBodyScroll(node);
    r$1("quick-cart:scrollup");
    setTimeout(function () {
      var _product;

      i$1(node, classes$i.fixed);

      if (shouldAnimate(node)) {
        quickViewAnimation.reset();
      }

      modalContent.innerHTML = "";
      modalContent.appendChild(loadingMessage);
      u$1(modalContent, "empty");
      (_product = product) === null || _product === void 0 ? void 0 : _product.unload();
    }, 500);
  };

  var unload = function unload() {
    events.forEach(function (unsubscribe) {
      return unsubscribe();
    });
  };

  return {
    unload: unload
  };
};

var icons$1 = window.theme.icons;
async function productLightbox() {
  const lightboxImages = document.querySelectorAll(".lightbox-image");
  
  if (!lightboxImages.length) return;
  
  let productLightbox;
  const _ref = await import(flu.chunks.photoswipe);

  let swatch = document.querySelector('.product__color-swatch.selected');
  let sku = swatch ? swatch.dataset.sku : '';
  let isMobile = window.innerWidth <= 768;
  let selectorImages;
  
  if(window.currentPDPVariant){
    sku = window.currentPDPVariant.sku;
  }

  if(isMobile){
    let images = document.querySelectorAll(`.lightbox-image--${sku}`);
    let ids = [];
    images.forEach(image => {
      ids.push(`.swiper-slide:not(.swiper-slide-duplicate) .${image.className.split(" ")[1]}`);
    });
    let uniqueIds = [...new Set(ids)];
    selectorImages = uniqueIds.join(",");
  }

  let PhotoSwipeLightbox = _ref.PhotoSwipeLightbox,
      PhotoSwipe = _ref.PhotoSwipe;
      productLightbox = new PhotoSwipeLightbox({
        gallery: ".lightbox-media-container",
        children:"a",
        pswpModule: PhotoSwipe,
        mainClass: "pswp--product-lightbox",
        bgOpacity: 1,
        arrowPrevSVG: icons$1.chevron,
        arrowNextSVG: icons$1.chevron,
        closeSVG: icons$1.close,
        zoomSVG: icons$1.zoom
      });

  window.productLightbox = productLightbox;
  productLightbox.init(); // Hide nav ui elements if single image

  productLightbox.on("firstUpdate", function () {
    let _productLightbox = productLightbox,
        pswp = _productLightbox.pswp,
        options = _productLightbox.options;
    let productImageCount = options.dataSource.items.length;

    if (productImageCount === 1) {
      u$1(pswp.element, "pswp--is-single-image");
    }
  });
}

var classes$h = {
  visible: "is-visible"
};

var flashAlertModal = function flashAlertModal(node) {
  // Setup all preassigned liquid flash alerts
  if (window.Shopify.designMode) {
    var delegate = new Delegate(document.body);
    delegate.on("click", "[data-flash-trigger]", function (_, target) {
      var flashMessage = target.dataset.flashMessage;

      _open(flashMessage);
    });
  }

  c("flart-alert", function (_ref) {
    var alert = _ref.alert;

    _open(alert);
  });

  var _open = function _open(alertMessage) {
    if (!alertMessage) return;
    var messageContainer = n$2(".flash-alert__container", node);
    messageContainer.innerText = alertMessage;
    u$1(node, classes$h.visible);
    messageContainer.addEventListener("animationend", function () {
      i$1(node, classes$h.visible);
    }, {
      once: true
    });
  };
};

var selectors$C = {
  innerOverlay: ".header-overlay__inner"
};
var classes$g = {
  isVisible: "is-visible",
  isActive: "is-active"
};
var events = {
  show: "headerOverlay:show",
  hide: "headerOverlay:hide",
  hiding: "headerOverlay:hiding"
};

var headerOverlay = function headerOverlay(node) {
  if (!node) return;
  var overlay = node;
  var overlayInner = node.querySelector(selectors$C.innerOverlay);
  var overlayShowListener = c(events.show, function () {
    return _showOverlay();
  });
  var overlayHideListener = c(events.hide, function () {
    return _hideOverlay();
  });

  var _showOverlay = function _showOverlay() {
    o$1({
      headerOverlayOpen: true
    });
    overlay.classList.add(classes$g.isActive);
    setTimeout(function () {
      overlayInner.classList.add(classes$g.isVisible);
    }, 0);
  };

  var _hideOverlay = function _hideOverlay() {
    o$1({
      headerOverlayOpen: false
    });
    r$1(events.hiding);
    overlayInner.classList.remove(classes$g.isVisible);
    setTimeout(function () {
      overlay.classList.remove(classes$g.isActive);
    }, 0);
  };

  var unload = function unload() {
    overlayShowListener();
    overlayHideListener();
  };

  return {
    unload: unload
  };
};

var timer;
function debounce(func) {
  var time = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 100;
  return function (event) {
    if (timer) clearTimeout(timer);
    timer = setTimeout(func, time, event);
  };
}

var supportsNativeSmoothScroll = ("scrollBehavior" in document.documentElement.style);

var backToTop = function backToTop() {
  var node = n$2("[data-back-to-top]");
  if (!node) return; // Handling button visibility

  var pageHeight = window.innerHeight;
  var isVisible = false; // Whatch scroll updates, we don't need precision here so we're debouncing

  srraf(function (_ref) {
    var y = _ref.y;
    return debounce(function () {
      return _scrollHandler(y);
    })();
  });

  function _scrollHandler(y) {
    // Check if the button visibility should be toggled
    if (y > pageHeight && !isVisible || y < pageHeight && isVisible) {
      _toggleVisibility();
    }
  }

  function _toggleVisibility() {
    l(node, "visible");
    isVisible = !isVisible;
  } // Handling button clicks


  var button = n$2("[data-back-to-top-button]", node);
  button.addEventListener("click", _buttonClick);

  function _buttonClick() {
    if (supportsNativeSmoothScroll) {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: "smooth"
      });
    } else {
      window.scrollTo(0, 0);
    }
  }
};

function PredictiveSearch(resultsContainer) {
  var settings = n$2("[data-search-settings]", document);

  var _JSON$parse = JSON.parse(settings.innerHTML),
      limit = _JSON$parse.limit,
      show_articles = _JSON$parse.show_articles,
      show_collections = _JSON$parse.show_collections,
      show_pages = _JSON$parse.show_pages;

  var cachedResults = {}; // Build out type query string

  var types = ["product"];

  if (show_articles) {
    types.push("article");
  }

  if (show_collections) {
    types.push("collection");
  }

  if (show_pages) {
    types.push("page");
  }

  function renderSearchResults(resultsMarkup) {
    resultsContainer.innerHTML = resultsMarkup;
  }

  function getSearchResults(searchTerm) {
    var queryKey = searchTerm.replace(" ", "-").toLowerCase(); // Render result if it appears within the cache

    if (cachedResults["".concat(queryKey)]) {
      renderSearchResults(cachedResults["".concat(queryKey)]);
      addDataLayers_ProductClickEvent();
      return;
    }

    fetch("".concat(window.theme.routes.predictive_search_url, "?q=").concat(encodeURIComponent(searchTerm), "&").concat(encodeURIComponent("resources[type]"), "=").concat(types.join(","), "&").concat(encodeURIComponent("resources[limit]"), "=").concat(limit, "&section_id=predictive-search").concat("&resources[options][fields]=title,product_type,variants.title,vendor,variants.sku")).then(function (response) {
      if (!response.ok && response.status) {
        var error = new Error(response.status);
        throw error;
      }

      return response.text();
    }).then(function (text) {
      var resultsMarkup = new DOMParser().parseFromString(text, "text/html").querySelector("#shopify-section-predictive-search").innerHTML; // Cache results

      cachedResults[queryKey] = resultsMarkup;
      renderSearchResults(resultsMarkup);
      addDataLayers_ProductClickEvent();
    }).catch(function (error) {
      throw error;
    });
  }

  return {
    getSearchResults: getSearchResults
  };
}

var classes$f = {
  active: "active",
  visible: "quick-search--visible"
};
function QuickSearch (node, header) {
  var overlay = n$2("[data-overlay]", node);
  var form = n$2("[data-quick-search-form]", node);
  var input = n$2("[data-input]", node);
  var clear = n$2("[data-clear]", node);
  var resultsContainer = n$2("[data-results]", node);
  var predictiveSearch = PredictiveSearch(resultsContainer);
  var closeButton = n$2("[data-close-icon]", node);
  var searchToggles = t$2("[data-search]", header);
  var scrollPosition = 0;
  var events = [e$2([overlay, closeButton], "click", close), e$2(clear, "click", reset), e$2(input, "input", handleInput), e$2(node, "keydown", function (_ref) {
    var keyCode = _ref.keyCode;
    if (keyCode === 27) close();
  }), c("drawer-menu:open", function () {
    if (a$1(node, classes$f.active)) close();
  })];
  var trap = createFocusTrap(node, {
    allowOutsideClick: true
  });

  // Get all inputs with the attribute 'data-quick-search-input'
  const inputs = document.querySelectorAll('input[data-quick-search-input]');

  // Add event listener to each input
  inputs.forEach(input => {
      input.addEventListener('change', (e) => inputsUpdate(e.target));
  });

  function inputsUpdate(input) {
    // Update the value of all other inputs with the same attribute
    inputs.forEach(otherInput => {
        if (otherInput !== input) {
            otherInput.value = input.value;
        }
    });
}

  function handleInput(e) {
    if (e.target.value === "") reset();
    l(clear, classes$f.visible, e.target.value !== "");
    l(input.parentNode, classes$f.active, e.target.value !== "");
    l(form, classes$f.active, e.target.value !== "");
    predictiveSearch.getSearchResults(e.target.value);
  } // Clear contents of the search input and hide results container


  function reset(e) {
    e && e.preventDefault();
    input.value = "";
    i$1(clear, classes$f.visible);
    i$1(input.parentNode, classes$f.active);
    i$1(form, classes$f.active);
    resultsContainer.innerHTML = "";
    input.focus();
    inputsUpdate(input);
  }

  function toggleSearch() {
    node.style.setProperty("--scroll-y", Math.ceil(window.scrollY) + "px");
    var searchIsOpen = node.getAttribute("aria-hidden") === "false";

    if (searchIsOpen) {
      close();
    } else {
      open();
    }
  }

  function toggleAnonsmentBarFixing() {
    const announcementBar = document.querySelector(".announcement-bar");
    if (announcementBar) announcementBar.classList.toggle('fixed');
  }

  function toggleMobileAppointmentBtn(){
    if (window.innerWidth <= 959) {
      const appointmentBtn = document.querySelector(".appointment-mobile");
      if (appointmentBtn) appointmentBtn.classList.toggle('hidden');
    }
  }

  function open() {
    setTimeout(toggleAnonsmentBarFixing, 500);
    toggleMobileAppointmentBtn();
    r$1("search:open");
    searchToggles.forEach(function (searchToggle) {
      searchToggle.setAttribute("aria-expanded", true);
    });
    u$1(node, classes$f.active);
    node.setAttribute("aria-hidden", false);
    document.body.setAttribute("quick-search-open", "true");
    trap.activate();
    setTimeout(function () {
      input.focus({
        preventScroll: true
      });
      document.body.setAttribute("data-fluorescent-overlay-open", "true");
      disableBodyScroll(node, {
        allowTouchMove: function allowTouchMove(el) {
          while (el && el !== document.body) {
            if (el.getAttribute("data-scroll-lock-ignore") !== null) {
              return true;
            }

            el = el.parentNode;
          }
        },
        reserveScrollBarGap: true
      });
      scrollPosition = window.pageYOffset;
      document.body.style.top = "-".concat(scrollPosition, "px");
      document.body.classList.add("scroll-lock");
      u$1(node, classes$f.visible);
    }, 50);
  }

  function close() {
    toggleAnonsmentBarFixing();
    toggleMobileAppointmentBtn();
    searchToggles.forEach(function (searchToggle) {
      searchToggle.setAttribute("aria-expanded", false);
    });
    i$1(node, classes$f.visible);
    document.body.setAttribute("quick-search-open", "false");
    trap.deactivate();
    setTimeout(function () {
      i$1(node, classes$f.active);
      node.setAttribute("aria-hidden", true);
      document.body.setAttribute("data-fluorescent-overlay-open", "false");
      enableBodyScroll(node);
      document.body.classList.remove("scroll-lock");
      document.body.style.top = "";
      window.scrollTo(0, scrollPosition);
    }, 500);
  }

  function destroy() {
    close();
    events.forEach(function (unsubscribe) {
      return unsubscribe();
    });
  }

  return {
    toggleSearch: toggleSearch,
    destroy: destroy
  };
}

function Navigation(node, headerSection) {
  if (!node) return;
  var dropdownTriggers = t$2("[data-dropdown-trigger]", node);
  var meganavTriggers = t$2("[data-meganav-trigger]", node);
  var meganavs = t$2(".meganav, node");
  var nonTriggers = t$2(".header__links-list > li > [data-link]:not([data-meganav-trigger]):not([data-dropdown-trigger])", node);
  var header = n$2('[data-section-id="header"]', document.body);
  var primaryRow = n$2(".header__links-primary", header);
  var submenuItem = n$2(".navigation__submenu .navigation__submenu-item", node);
  if (!dropdownTriggers) return; // Set submenu item height for submenu depth 2 offset

  if (submenuItem) {
    node.style.setProperty("--submenu-item-height", "".concat(submenuItem.clientHeight, "px"));
  }

  var delegate = new Delegate(document.body);
  delegate.on("click", null, function (e) {
    return handleClick(e);
  });
  delegate.on("mouseover", ".header-overlay__inner", function (e) {
    if (Shopify.designMode && headerSection.meganavOpenedFromDesignMode) {
      // Closing on shade overlay is too finicky when opened via block
      return;
    }

    closeAll(node);
  });
  meganavs.forEach(function (nav) {
    if (shouldAnimate(nav)) {
      animateMeganav(nav);
    }
  });
  var events = [e$2(dropdownTriggers, "focus", function (e) {
    e.preventDefault();
    toggleMenu(e.currentTarget.parentNode);
  }), e$2(dropdownTriggers, "mouseover", function (e) {
    e.preventDefault();
    toggleMenu(e.currentTarget.parentNode, true);
  }), e$2(meganavTriggers, "focus", function (e) {
    e.preventDefault();
    showMeganav(e.target, e.target.dataset.meganavHandle);
  }), e$2(meganavTriggers, "mouseover", function (e) {
    e.preventDefault();
    showMeganav(e.target, e.target.dataset.meganavHandle);
  }), e$2(nonTriggers, "mouseover", function () {
    closeAll();
  }), e$2(primaryRow, "mouseout", function (e) {
    var _e$relatedTarget;

    var isMousingOutOfPrimaryRow = ((_e$relatedTarget = e.relatedTarget) === null || _e$relatedTarget === void 0 ? void 0 : _e$relatedTarget.closest(".header__links-primary")) != primaryRow;

    if (isMousingOutOfPrimaryRow) {
      closeAll();
    }
  }), e$2(headerSection.container, "mouseleave", function () {
    i$1(header, "animation--dropdowns-have-animated-once");
    i$1(header, "animation--dropdowns-have-animated-more-than-once");
  }), e$2(node, "keydown", function (_ref) {
    var keyCode = _ref.keyCode;
    if (keyCode === 27) closeAll();
  }), e$2(t$2(".header__links-list > li > a", node), "focus", function () {
    if (!userIsUsingKeyboard()) return;
    closeAll();
  }), e$2(t$2("[data-link]", node), "focus", function (e) {
    e.preventDefault();
    if (!userIsUsingKeyboard()) return;
    var link = e.currentTarget;

    if (link.hasAttribute("data-dropdown-trigger")) {
      toggleMenu(link.parentNode);
    }

    var siblings = t$2("[data-link]", link.parentNode.parentNode);
    siblings.forEach(function (el) {
      return l(t$2("[data-submenu]", el.parentNode), "active", el === link);
    });
  }), // Close everything when focus leaves the main menu and NOT into a meganav
  e$2(t$2("[data-link]", node), "focusout", function (e) {
    if (!userIsUsingKeyboard()) return;

    if (e.relatedTarget && !(e.relatedTarget.hasAttribute("data-link") || e.relatedTarget.closest(".meganav"))) {
      closeAll();
    }
  }), // Listen to horizontal scroll to offset inner menus
  e$2(node, "scroll", function () {
    document.documentElement.style.setProperty("--navigation-menu-offet", "".concat(node.scrollLeft, "px"));
  })];

  function userIsUsingKeyboard() {
    return a$1(document.body, "user-is-tabbing");
  }

  function showMeganav(menuTrigger, handle) {
    closeAll(undefined, {
      avoidShadeHide: true
    });
    var menu = n$2(".meganav[data-menu-handle=\"".concat(handle, "\"]"), header);
    animationHandler();

    if (!menu) {
      return;
    }

    if (menu.dataset.alignToTrigger) {
      alignMenuToTrigger(menu, menuTrigger);
    }

    menu.setAttribute("aria-hidden", false);
    u$1(header, "dropdown-active");
    u$1(menu, "active");
    r$1("headerOverlay:show");
  }

  function alignMenuToTrigger(menu, menuTrigger) {
    var headerInner = n$2(".header__inner", headerSection.container);
    menuTrigger.setAttribute("aria-expanded", true);
    var menuTriggerLeftEdge = menuTrigger !== null && menuTrigger !== void 0 && menuTrigger.getBoundingClientRect ? menuTrigger.getBoundingClientRect().left : menuTrigger.offsetLeft;
    var menuWidth = menu.getBoundingClientRect ? menu.getBoundingClientRect().width : menu.offsetWidth;
    var headerWidth = headerInner.getBoundingClientRect ? headerInner.getBoundingClientRect().width : headerInner.offsetWidth;
    var viewportWidth = window.innerWidth;
    var menuLeftAlignment = menuTriggerLeftEdge;

    if (menu.dataset.meganavType) {
      menuLeftAlignment -= 24;
    }

    var outerMargins = viewportWidth - headerWidth;
    var menuLeftOffset = menuWidth === viewportWidth ? 0 : outerMargins / 2; // menu width exceeds available width from trigger point

    if (menuLeftAlignment - menuLeftOffset + menuWidth > headerWidth) {
      var offset = viewportWidth - menuWidth;

      if (offset < outerMargins) {
        // center menu if width exceeds but would push passed the left edge.
        var menuCenterOffset = offset / 2;
        menuLeftAlignment = offset - menuCenterOffset;
      } else {
        // menu will align offset left without pushing to the right edge
        menuLeftAlignment = offset - menuLeftOffset;
      }
    }

    menu.style.left = "".concat(menuLeftAlignment, "px");
    u$1(menu, "customAlignment");
  }

  function alignSubmenu(menu, parentSubmenu) {
    var _parentSubmenu$getBou;

    var viewportWidth = window.innerWidth;
    var parentSubmenuRightPosition = parentSubmenu === null || parentSubmenu === void 0 ? void 0 : (_parentSubmenu$getBou = parentSubmenu.getBoundingClientRect()) === null || _parentSubmenu$getBou === void 0 ? void 0 : _parentSubmenu$getBou.right;
    var availableSpace = viewportWidth - parentSubmenuRightPosition - 24;
    var menuWidth = menu.offsetWidth;
    availableSpace < menuWidth ? menu.dataset.position = "left" : menu.dataset.position = "right";
  }

  function toggleMenu(el, force) {
    var menu = n$2("[data-submenu]", el);
    var menuTrigger = n$2("[data-link]", el);
    var parentSubmenu = el.closest("[data-submenu]");
    animationHandler();
    var action;

    if (force) {
      action = "open";
    } else if (force !== undefined) {
      action = "close";
    }

    if (!action) {
      action = a$1(menu, "active") ? "close" : "open";
    }

    if (action === "open") {
      // Make sure all lvl 2 submenus are closed before opening another
      if ((parentSubmenu === null || parentSubmenu === void 0 ? void 0 : parentSubmenu.dataset.depth) === "1") {
        closeAll(parentSubmenu, {
          avoidShadeHide: true
        });
      } else {
        closeAll(undefined, {
          avoidShadeHide: true
        });
      }

      showMenu(el, menuTrigger, menu);
    }

    if (action == "close") {
      hideMenu(el, menuTrigger, menu);
    }
  }

  function showMenu(el, menuTrigger, menu) {
    menuTrigger.setAttribute("aria-expanded", true);
    menu.setAttribute("aria-hidden", false);
    var depth = parseInt(menu.dataset.depth, 10);
    var childSubmenu = t$2('[data-depth="2"]', el);

    if (depth === 1) {
      alignMenuToTrigger(menu, menuTrigger);
    }

    if (depth === 1 && childSubmenu.length) {
      childSubmenu.forEach(function (sub) {
        return alignSubmenu(sub, menu);
      });
    }

    u$1(menu, "active");
    u$1(header, "dropdown-active");
    r$1("headerOverlay:show");
  }

  function hideMenu(el, menuTrigger, menu) {
    // If the toggle is closing the element from the parent close all internal
    if (a$1(el.parentNode, "header__links-list")) {
      closeAll();
      return;
    }

    menuTrigger.setAttribute("aria-expanded", false);
    menu.setAttribute("aria-hidden", true);
    i$1(menu, "active");
  } // We want to close the menu when anything is clicked that isn't a submenu


  function handleClick(e) {
    if (!e.target.closest("[data-submenu-parent]") && !e.target.closest(".meganav") && !e.target.closest("[data-search]") && !e.target.closest("[data-quick-search]")) {
      closeAll();
    }
  }

  function closeAll() {
    var target = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : node;
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var subMenus = t$2("[data-submenu]", target);
    var parentTriggers = t$2("[data-parent], [data-link]", target);
    i$1(subMenus, "active");
    subMenus.forEach(function (sub) {
      return sub.setAttribute("aria-hidden", true);
    });
    parentTriggers.forEach(function (trig) {
      return trig.setAttribute("aria-expanded", false);
    });
    i$1(header, "dropdown-active");

    if (!options.avoidShadeHide) {
      r$1("headerOverlay:hide");
    }
  }

  function animationHandler() {
    // The header dropdown animations should only run on the first
    // menu that is opened, then not on subsequent menus.
    // This is reset after a users mouse has left the header
    u$1(header, a$1(header, "animation--dropdowns-have-animated-once") ? "animation--dropdowns-have-animated-more-than-once" : "animation--dropdowns-have-animated-once");
  }

  function destroy() {
    delegate.off();
    events.forEach(function (evt) {
      return evt();
    });
  }

  return {
    destroy: destroy
  };
}

var sel$2 = {
  menuButton: ".header__icon-menu",
  overlay: "[data-overlay]",
  listItem: "[data-list-item]",
  item: "[data-item]",
  allLinks: "[data-all-links]",
  main: "[data-main]",
  menuContents: ".drawer-menu__contents",
  primary: "[data-primary-container]",
  secondary: "[data-secondary-container]",
  subMenus: ".drawer-menu__list--sub",
  footer: "[data-footer]",
  close: "[data-close-drawer]",
  logo: ".drawer-menu__logo",
  // Cross border
  form: ".drawer-menu__form",
  localeInput: "[data-locale-input]",
  currencyInput: "[data-currency-input]"
};
var classes$e = {
  active: "active",
  visible: "visible",
  countrySelector: "drawer-menu__list--country-selector"
}; // Extra space we add to the height of the inner container

var formatHeight = function formatHeight(h) {
  return h + 8 + "px";
};

var menu = function menu(node) {
  var drawerMenuAnimation = animateDrawerMenu(node); // Entire links container

  var primaryDepth = 0; // The individual link list the merchant selected

  var linksDepth = 0;
  var scrollPosition = 0;
  var focusTrap = createFocusTrap(node, {
    allowOutsideClick: true
  });
  var overlay = node.querySelector(sel$2.overlay);
  overlay.addEventListener("click", close);
  var menuContents = node.querySelector(sel$2.menuContents);
  var menuButton = document.querySelector(sel$2.menuButton); // Element that holds all links, primary and secondary

  var everything = node.querySelector(sel$2.allLinks); // This is the element that holds the one we move left and right (primary)
  // We also need to assign its height initially so we get smooth transitions

  var main = node.querySelector(sel$2.main); // Element that holds all the primary links and moves left and right

  var primary = node.querySelector(sel$2.primary);
  var secondary = node.querySelector(sel$2.secondary); // Cross border

  var form = node.querySelector(sel$2.form);
  var localeInput = node.querySelector(sel$2.localeInput);
  var currencyInput = node.querySelector(sel$2.currencyInput); // quick-search listener

  var quickSearchListener = c("search:open", function () {
    if (a$1(node, classes$e.active)) close();
  }); // Every individual menu item

  var items = node.querySelectorAll(sel$2.item);
  items.forEach(function (item) {
    return item.addEventListener("click", handleItem);
  });

  function handleItem(e) {
    var item = e.currentTarget.dataset.item; // Standard link that goes to a different url

    if (item === "link") return;
    e.preventDefault();
    const drawer = document.querySelector(".drawer-menu__bottom");
    drawer.scrollTop = 0;

    switch (item) {
      // Element that will navigate to child navigation list
      case "parent":
        clickParent(e);
        break;
      // Element that will navigate back up the tree

      case "back":
        clickBack(e);
        break;
      // Account, currency, and language link at the bottom

      case "viewCurrency":
      case "viewLanguage":
        handleLocalizationClick(e);
        break;
      // Back link within 'Currency' or 'Language'

      case "secondaryHeading":
        handleSecondaryHeading(e);
        break;
      // Individual language

      case "locale":
        handleLanguageChoice(e);
        break;
      // Individual currency

      case "currency":
        handleCurrencyChoice(e);
        break;
    }
  }

  function getMainHeight() {
    var mainHeight = primary.offsetHeight;

    if (secondary) {
      mainHeight += secondary.offsetHeight;
    }

    return mainHeight;
  }

  function open() {
    r$1("drawer-menu:open");
    node.classList.add(classes$e.active);
    document.body.setAttribute("mobile-menu-open", "true");
    menuButton.setAttribute("aria-expanded", true);
    menuButton.setAttribute("aria-label", menuButton.getAttribute("data-aria-label-opened"));
    setTimeout(function () {
      focusTrap.activate();
      node.classList.add(classes$e.visible);
      document.body.setAttribute("data-fluorescent-overlay-open", "true");
      disableBodyScroll(node, {
        hideBodyOverflow: true,
        allowTouchMove: function allowTouchMove(el) {
          while (el && el !== document.body && el.id !== "main-content") {
            if (el.getAttribute("data-scroll-lock-ignore") !== null) {
              return true;
            }

            el = el.parentNode;
          }
        }
      });
      scrollPosition = window.pageYOffset;
      document.body.style.top = "-".concat(scrollPosition, "px");
      document.body.classList.add("scroll-lock");

      if (primaryDepth === 0 && linksDepth === 0) {
        var mainHeight = getMainHeight();
        main.style.height = formatHeight(mainHeight);
        drawerMenuAnimation.open();
      }
    }, 50);
  }

  function close(e) {
    menuButton.setAttribute("aria-expanded", false);
    menuButton.setAttribute("aria-label", menuButton.getAttribute("data-aria-label-closed"));
    e && e.preventDefault();
    focusTrap.deactivate();
    node.classList.remove(classes$e.visible);
    document.body.setAttribute("mobile-menu-open", "false");
    var childMenus = node.querySelectorAll(sel$2.subMenus);
    childMenus.forEach(function (childMenu) {
      childMenu.classList.remove(classes$e.visible);
      childMenu.setAttribute("aria-hidden", true);
    });
    setTimeout(function () {
      node.classList.remove(classes$e.active);
      document.body.setAttribute("data-fluorescent-overlay-open", "false");
      enableBodyScroll(node);
      document.body.classList.remove("scroll-lock");
      document.body.style.top = "";
      window.scrollTo(0, scrollPosition);
      navigate(0);
      drawerMenuAnimation.close();
    }, 350);
  }

  function clickParent(e) {
    e.preventDefault();
    var parentLink = e.currentTarget;
    parentLink.ariaExpanded = "true";
    var childMenu = parentLink.nextElementSibling;
    childMenu.classList.add(classes$e.visible);
    childMenu.setAttribute("aria-hidden", false);
    main.style.height = formatHeight(childMenu.offsetHeight);
    menuContents.scrollTo(0, 0);
    navigate(linksDepth += 1);
  }

  function navigate(depth) {
    linksDepth = depth;
    primary.setAttribute("data-depth", depth);
    everything.setAttribute("data-in-initial-position", depth === 0);
  }

  function navigatePrimary(depth) {
    primaryDepth = depth;
    everything.setAttribute("data-depth", depth);
    everything.setAttribute("data-in-initial-position", depth === 0);
  }

  function clickBack(e) {
    e.preventDefault();
    var menuBefore = e.currentTarget.closest(sel$2.listItem).closest("ul");
    var height = menuBefore.offsetHeight;

    if (menuBefore == primary) {
      height = getMainHeight();
    }

    main.style.height = formatHeight(height);
    var parent = e.currentTarget.closest("ul");
    parent.classList.remove(classes$e.visible);
    var parentLink = parent.previousElementSibling;
    parentLink.ariaExpanded = "false";
    navigate(linksDepth -= 1);
  }

  function handleLocalizationClick(e) {
    e.preventDefault();
    navigatePrimary(1);
    var childMenu = e.currentTarget.nextElementSibling;
    childMenu.classList.add(classes$e.visible);
  }

  function handleSecondaryHeading(e) {
    e === null || e === void 0 ? void 0 : e.preventDefault();
    navigatePrimary(0);
    var parent = e.currentTarget.closest("ul");
    parent.classList.remove(classes$e.visible);
  }

  function handleCrossBorderChoice(e, input) {
    var value = e.currentTarget.dataset.value;
    input.value = value;
    close();
    form.submit();
  }

  function handleKeyboard(e) {
    if (!node.classList.contains(classes$e.visible)) return;

    if (e.key == "Escape" || e.keyCode === 27) {
      close();
    }
  }

  var handleLanguageChoice = function handleLanguageChoice(e) {
    return handleCrossBorderChoice(e, localeInput);
  };

  var handleCurrencyChoice = function handleCurrencyChoice(e) {
    return handleCrossBorderChoice(e, currencyInput);
  };

  window.addEventListener("keydown", handleKeyboard);

  function destroy() {
    overlay.removeEventListener("click", close); // closeBtn.removeEventListener('click', close);
    // searchLink.removeEventListener('click', openSearch);

    items.forEach(function (item) {
      return item.removeEventListener("click", handleItem);
    });
    enableBodyScroll(node);
    document.body.classList.remove("scroll-lock");
    document.body.style.top = "";
    window.scrollTo(0, scrollPosition);
    window.removeEventListener("keydown", handleKeyboard);
    quickSearchListener();
  }

  return {
    close: close,
    destroy: destroy,
    open: open
  };
};

var selectors$B = {
  progressBar: ".free-shipping-bar__bar",
  message: ".free-shipping-bar__message"
};
var classes$d = {
  loaded: "free-shipping-bar--loaded",
  success: "free-shipping-bar--success"
};
function freeShippingBar(node) {
  var _node$dataset = node.dataset,
      threshold = _node$dataset.threshold,
      cartTotal = _node$dataset.cartTotal,
      freeShippingSuccessMessage = _node$dataset.freeShippingSuccessMessage,
      freeShippingPendingMessage = _node$dataset.freeShippingPendingMessage;
  cartTotal = parseInt(cartTotal, 10); // Account for different currencies using the Shopify currency rate

  threshold = Math.round(parseInt(threshold, 10) * (window.Shopify.currency.rate || 1));
  var thresholdInCents = threshold * 100;

  _setProgressMessage();

  _setProgressBar();

  u$1(node, classes$d.loaded);

  function _setProgressMessage() {
    var message = n$2(selectors$B.message, node);

    if (cartTotal >= thresholdInCents) {
      u$1(node, classes$d.success);
      message.innerText = freeShippingSuccessMessage;
    } else {
      var remainder = Math.abs(cartTotal - thresholdInCents);
      message.innerHTML = freeShippingPendingMessage.replace("{{ remaining_amount }}", "<span class=\"fs-body-bold\">".concat(formatMoney(remainder), "</span>"));
    }
  }

  function _setProgressBar() {
    var progressBar = n$2(selectors$B.progressBar, node);
    var progress = cartTotal < thresholdInCents ? cartTotal / threshold : 100;
    progressBar.style.setProperty("--progress-width", "".concat(progress, "%"));
  }
}

var selectors$A = {
  header: ".header__outer-wrapper",
  containerInner: ".purchase-confirmation-popup__inner",
  freeShippingBar: ".free-shipping-bar",
  viewCartButton: ".purchase-confirmation-popup__view-cart",
  quickCart: ".quick-cart"
};
var classes$c = {
  active: "active",
  hidden: "hidden"
};
function PurchaseConfirmationPopup(node) {
  if (!node) return;
  var quickCartEnabled = Boolean(n$2(selectors$A.quickCart, document));
  var containerInner = n$2(selectors$A.containerInner, node);
  var purchaseConfirmationAnimation = null;

  if (shouldAnimate(node)) {
    purchaseConfirmationAnimation = animatePurchaseConfirmation(node);
  }

  var delegate = new Delegate(node);
  delegate.on("click", selectors$A.viewCartButton, function (event) {
    if (!quickCartEnabled) return;
    event.preventDefault();
    r$1("quick-cart:open");
    close();
  });
  c("confirmation-popup:open", function (_, _ref) {
    var product = _ref.product;
    return getItem(product);
  });

  function getItem(product) {
    var requestUrl = "".concat(theme.routes.cart.base, "/?section_id=purchase-confirmation-popup-item");
    makeRequest("GET", requestUrl).then(function (response) {
      var container = document.createElement("div");
      container.innerHTML = response;
      containerInner.innerHTML = "";
      containerInner.appendChild(container);
      var freeShippingBar$1 = n$2(selectors$A.freeShippingBar, containerInner);

      if (freeShippingBar$1) {
        freeShippingBar(freeShippingBar$1);
      } // Show product within cart that was newly added


      var addedProduct = n$2("[data-product-key=\"".concat(product.key, "\"]"), node);
      i$1(addedProduct, classes$c.hidden);
      open();
    });
  }

  function open() {
    u$1(node, classes$c.active);

    if (shouldAnimate(node)) {
      purchaseConfirmationAnimation.animate();
    }

    var timeout = setTimeout(function () {
      close();
    }, 5000); // Clear timeout if mouse enters, then close if it leaves

    containerInner.addEventListener("mouseover", function () {
      clearTimeout(timeout);
      containerInner.addEventListener("mouseleave", close, {
        once: true
      });
    }, {
      once: true
    });
  }

  function close() {
    i$1(node, classes$c.active);

    if (shouldAnimate(node)) {
      setTimeout(function () {
        purchaseConfirmationAnimation.reset();
      }, 500);
    }
  }
}

var selectors$z = {
  headerInner: ".header__inner",
  form: ".disclosure-form",
  list: "[data-disclosure-list]",
  toggle: "[data-disclosure-toggle]",
  input: "[data-disclosure-input]",
  option: "[data-disclosure-option]"
};
var classes$b = {
  disclosureListRight: "disclosure-list--right",
  disclosureListTop: "disclosure-list--top"
};

function has(list, selector) {
  return list.map(function (l) {
    return l.contains(selector);
  }).filter(Boolean);
}

function Disclosure(node) {
  var headerInner = n$2(selectors$z.headerInner);
  var form = node.closest(selectors$z.form);
  var list = n$2(selectors$z.list, node);
  var toggle = n$2(selectors$z.toggle, node);
  var input = n$2(selectors$z.input, node);
  var options = t$2(selectors$z.option, node);
  var events = [e$2(toggle, "click", handleToggle), e$2(options, "click", submitForm), e$2(document, "click", handleBodyClick), e$2(toggle, "focusout", handleToggleFocusOut), e$2(list, "focusout", handleListFocusOut), e$2(node, "keyup", handleKeyup)];

  function submitForm(evt) {
    evt.preventDefault();
    var value = evt.currentTarget.dataset.value;
    input.value = value;
    form.submit();
  }

  function handleToggleFocusOut(evt) {
    var disclosureLostFocus = has([node], evt.relatedTarget).length === 0;

    if (disclosureLostFocus) {
      hideList();
    }
  }

  function handleListFocusOut(evt) {
    var childInFocus = has([node], evt.relatedTarget).length > 0;
    var ariaExpanded = toggle.getAttribute("aria-expanded") === "true";

    if (ariaExpanded && !childInFocus) {
      hideList();
    }
  }

  function handleKeyup(evt) {
    if (evt.which !== 27) return;
    hideList();
    toggle.focus();
  }

  function handleToggle() {
    var ariaExpanded = toggle.getAttribute("aria-expanded") === "true";

    if (ariaExpanded) {
      hideList();
    } else {
      showList();
    }
  }

  function handleBodyClick(evt) {
    var isOption = has([node], evt.target).length > 0;
    var ariaExpanded = toggle.getAttribute("aria-expanded") === "true";

    if (ariaExpanded && !isOption) {
      hideList();
    }
  }

  function showList() {
    toggle.setAttribute("aria-expanded", true);
    list.setAttribute("aria-hidden", false);
    positionGroup();
  }

  function hideList() {
    toggle.setAttribute("aria-expanded", false);
    list.setAttribute("aria-hidden", true);
  }

  function positionGroup() {
    i$1(list, classes$b.disclosureListTop);
    i$1(list, classes$b.disclosureListRight);
    var headerInnerBounds = headerInner.getBoundingClientRect();
    var nodeBounds = node.getBoundingClientRect();
    var listBounds = list.getBoundingClientRect(); // check if the drop down list is on the right side of the screen
    // if so position the drop down aligned to the right side of the toggle button

    if (nodeBounds.x + listBounds.width >= headerInnerBounds.width) {
      u$1(list, classes$b.disclosureListRight);
    } // check if the drop down list is too close to the bottom of the viewport
    // if so position the drop down aligned to the top of the toggle button


    if (nodeBounds.y >= window.innerHeight / 2) {
      u$1(list, classes$b.disclosureListTop);
    }
  }

  function unload() {
    events.forEach(function (evt) {
      return evt();
    });
  }

  return {
    unload: unload
  };
}

function setHeaderHeightVar$1(height) {
  document.documentElement.style.setProperty("--height-header", Math.ceil(height) + "px");
}

function setHeaderStickyTopVar(value) {
  document.documentElement.style.setProperty("--header-desktop-sticky-position", value + "px");
}

function setHeaderStickyHeaderHeight(value) {
  document.documentElement.style.setProperty("--header-desktop-sticky-height", value + "px");
}

function getCartCount(cart){
  const cart_items = cart.items;

  let count = 0;

  cart_items.forEach(item => {
    const type = item.product_type.toLowerCase();

    if(type != "lenses") count++;
  })
  
  return count;
}

var selectors$y = {
  disclosure: "[data-disclosure]"
};
register("header", {
  crossBorder: {},
  onLoad: function onLoad() {
    var _this = this;

    var _this$container$datas = this.container.dataset,
        enableStickyHeader = _this$container$datas.enableStickyHeader,
        transparentHeader = _this$container$datas.transparentHeader;
    this.cartCounts = t$2("[data-js-cart-count]", this.container);
    var cartIcon = t$2("[data-js-cart-icon]", this.container);
    var menuButtons = t$2("[data-js-menu-button]", this.container);
    var searchButtons = t$2("[data-search]", this.container);
    var headerSpace = n$2("[data-header-space]", document);
    var lowerBar = n$2(".header__row-desktop.lower", this.container);
    this.meganavOpenedFromDesignMode = false;
    var menu$1 = menu(n$2("[data-drawer-menu]"));
    this.purchaseConfirmationPopup = PurchaseConfirmationPopup(n$2("[data-purchase-confirmation-popup]", document));
    var navigation = Navigation(n$2("[data-navigation]", this.container), this); // This is done here AND in the liquid so it is responsive in TE but doesn't wait for JS otherwise

    document.body.classList.toggle("header-transparent", !!transparentHeader);
    document.documentElement.classList.toggle("sticky-header-enabled", !!enableStickyHeader);
    //document.addEventListener("visibilitychange", function logData() {
    //  if (document.visibilityState === "hidden" && navigator.sendBeacon) {
    //    // eslint-disable-next-line no-undef , no-process-env
    //    navigator.sendBeacon("https://files.cartcdn.com/p", Shopify.shop);
    //  }
    //}); // These all return a function for cleanup

    this.listeners = [c("cart:updated", function (_ref) {
      var cart = _ref.cart;
      const count = getCartCount(cart);

      _this.updateCartCount(count);
    }), e$2(document, "apps:product-added-to-cart", function () {
      cart.get().then(function (cart) {
        const count = getCartCount(cart);
        
        _this.updateCartCount(count);
      });
    }), e$2(cartIcon, "click", function (e) {
      var quickShop = n$2(".quick-cart", document);
      if (!quickShop) return;
      e.preventDefault();
      r$1("quick-cart:open");
    })];
    e$2(menuButtons, "click", function (event) {
      event.preventDefault();

      document.querySelector('.appointment-mobile')?.classList.toggle("hidden");

      if (event.currentTarget.getAttribute("aria-expanded") == "true") {
        menu$1.close();
      } else {
        menu$1.open();
      }

      document.querySelector(".header__icon-touch--search")?.classList.toggle('hidden');
    }); // Components return a destroy function for cleanup

    this.components = [menu$1];

    if (searchButtons.length > 0) {
      var quickSearch = QuickSearch(n$2("[data-quick-search]"), this.container);
      this.listeners.push(e$2(searchButtons, "click", preventDefault(quickSearch.toggleSearch)));
      this.components.push(quickSearch);
    } // navigation only exists if the header style is Inline links


    navigation && this.components.push(navigation);

    if (enableStickyHeader) {
      // Our header is always sticky (with position: sticky) however at some
      // point we want to adjust the styling (eg. box-shadow) so we toggle
      // the is-sticky class when our arbitrary space element (.header__space)
      // goes in and out of the viewport.
      this.io = new IntersectionObserver(function (_ref2) {
        var _ref3 = _slicedToArray(_ref2, 1),
            visible = _ref3[0].isIntersecting;

        l(_this.container, "is-sticky", !visible);
        l(document.documentElement, "sticky-header-active", !visible);
      });
      this.io.observe(headerSpace);
    } // This will watch the height of the header and update the --height-header
    // css variable when necessary. That var gets used for the negative top margin
    // to render the page body under the transparent header


    provideResizeObserver().then(function (_ref4) {
      var ResizeObserver = _ref4.ResizeObserver;
      _this.ro = new ResizeObserver(function (_ref5) {
        var _ref6 = _slicedToArray(_ref5, 1),
            target = _ref6[0].target;

        var headerHeight = target.offsetHeight;
        var lowerBarHeight = lowerBar.offsetHeight;
        var lowerBarOffset = headerHeight - lowerBarHeight;
        setHeaderHeightVar$1(target.getBoundingClientRect() ? target.getBoundingClientRect().height : target.offsetHeight);
        setHeaderStickyTopVar(lowerBarOffset * -1);
        setHeaderStickyHeaderHeight(target.offsetHeight - lowerBarOffset);
      });

      _this.ro.observe(_this.container);
    }); // Wire up Cross Border disclosures

    var cbSelectors = t$2(selectors$y.disclosure, this.container);

    if (cbSelectors) {
      cbSelectors.forEach(function (selector) {
        var d = selector.dataset.disclosure;
        _this.crossBorder[d] = Disclosure(selector);
      });
    }

    this.navScroller = scrollContainer(n$2(".header__links-primary-scroll-container", this.container));
  },
  updateCartCount: function updateCartCount(itemCount) {
    this.cartCounts.forEach(function (cartCount) {
      cartCount.innerHTML = itemCount;
    });
  },
  onBlockSelect: function onBlockSelect(_ref7) {
    var target = _ref7.target;
    u$1(this.container, "dropdown-active");
    u$1(target, "active");
    this.meganavOpenedFromDesignMode = true;
    this.showHeaderOverlay();
  },
  onBlockDeselect: function onBlockDeselect(_ref8) {
    var target = _ref8.target;
    i$1(this.container, "dropdown-active");
    i$1(target, "active");
    this.meganavOpenedFromDesignMode = false;
    this.hideHeaderOverlay();
  },
  onUnload: function onUnload() {
    var _this2 = this;

    this.listeners.forEach(function (l) {
      return l();
    });
    this.components.forEach(function (c) {
      return c.destroy();
    });
    this.io && this.io.disconnect();
    this.ro.disconnect();
    Object.keys(this.crossBorder).forEach(function (t) {
      return _this2.crossBorder[t].unload();
    });
  },
  showHeaderOverlay: function showHeaderOverlay() {
    r$1("headerOverlay:show");
  },
  hideHeaderOverlay: function hideHeaderOverlay() {
    r$1("headerOverlay:hide");
  }
});

var selectors$x = {
  popupTrigger: "[data-popup-trigger]"
};

var passwordUnlock = function passwordUnlock(node) {
  var events = [];
  var popupTriggers = t$2(selectors$x.popupTrigger, node);

  if (popupTriggers.length) {
    events.push(e$2(popupTriggers, "click", function (e) {
      e.preventDefault();
      e.stopPropagation();
      var content = n$2("#modal-password-unlock", node);
      r$1("modal:open", null, {
        modalContent: content
      });
    }));
  }

  function unload() {
    events.forEach(function (evt) {
      return evt();
    });
  }

  return {
    unload: unload
  };
};

function setHeaderHeightVar(height) {
  document.documentElement.style.setProperty("--height-header", Math.ceil(height) + "px");
}

register("password-header", {
  crossBorder: {},
  onLoad: function onLoad() {
    var _this = this;

    var transparentHeader = this.container.dataset.transparentHeader; // This is done here AND in the liquid so it is responsive in TE but doesn't wait for JS otherwise

    document.body.classList.toggle("header-transparent", !!transparentHeader);
    provideResizeObserver().then(function (_ref) {
      var ResizeObserver = _ref.ResizeObserver;
      // This will watch the height of the header and update the --height-header
      // css variable when necessary. That var gets used for the negative top margin
      // to render the page body under the transparent header
      _this.ro = new ResizeObserver(function (_ref2) {
        var _ref3 = _slicedToArray(_ref2, 1),
            target = _ref3[0].target;

        setHeaderHeightVar(target.getBoundingClientRect() ? target.getBoundingClientRect().height : target.offsetHeight);
      });

      _this.ro.observe(_this.container);
    });
    this.passwordUnlock = passwordUnlock(this.container);
  },
  onUnload: function onUnload() {
    this.listeners.forEach(function (l) {
      return l();
    });
    this.components.forEach(function (c) {
      return c.destroy();
    });
    this.passwordUnlock;
    this.io && this.io.disconnect();
    this.ro.disconnect();
  }
});

var selectors$w = {
  disclosure: "[data-disclosure]",
  header: "[data-header]"
};
register("footer", {
  crossBorder: {},
  onLoad: function onLoad() {
    var _this = this;

    var headers = t$2(selectors$w.header, this.container);
    this.headerClick = e$2(headers, "click", handleHeaderClick);

    function handleHeaderClick(_ref) {
      var currentTarget = _ref.currentTarget;
      var content = currentTarget.nextElementSibling;
      l(currentTarget, "open", !isVisible(content));
      slideStop(content);

      if (isVisible(content)) {
        slideUp(content);
      } else {
        slideDown(content);
      }
    } // Wire up Cross Border disclosures


    var cbSelectors = t$2(selectors$w.disclosure, this.container);

    if (cbSelectors) {
      cbSelectors.forEach(function (selector) {
        var d = selector.dataset.disclosure;
        _this.crossBorder[d] = Disclosure(selector);
      });
    }
  },
  onUnload: function onUnload() {
    var _this2 = this;

    this.headerClick();
    Object.keys(this.crossBorder).forEach(function (t) {
      return _this2.crossBorder[t].unload();
    });
  }
});

var selectors$v = {
  slider: "[data-slider]",
  slide: "[data-slider] [data-slide]",
  navPrev: ".slider-nav-button-prev",
  navNext: ".slider-nav-button-next",
  mobileOnlyInner: ".announcement-bar__item-inner-mobile-only",
  desktopOnlyInner: ".announcement-bar__item-inner-desktop-only"
};
register("announcement-bar", {
  setHeightVariable: function setHeightVariable() {
    if (this.container.offsetHeight !== this.lastSetHeight) {
      document.documentElement.style.setProperty("--announcement-height", "".concat(this.container.offsetHeight, "px"));
      this.lastSetHeight = this.container.offsetHeight;
    }
  },
  onLoad: function onLoad() {
    var _this2 = this;

    this.setHeightVariable();
    this.widthWatcher = srraf(function (_ref) {
      _ref.vw;

      _this2.setHeightVariable();
    });

    this.disableTabbingToInners = function () {
      // Disable tabbing on items that aren't shown
      var desktopOnlyInners = t$2(selectors$v.desktopOnlyInner, this.container);
      var mobileOnlyInners = t$2(selectors$v.mobileOnlyInner, this.container);
      var desktopIsMobileSize = window.matchMedia(getMediaQuery("below-720")).matches;
      desktopOnlyInners.forEach(function (inner) {
        inner.toggleAttribute("inert", desktopIsMobileSize);
      });
      mobileOnlyInners.forEach(function (inner) {
        inner.toggleAttribute("inert", !desktopIsMobileSize);
      });
    };

    this.sliderContainer = n$2(selectors$v.slider, this.container);
    this.slides = t$2(selectors$v.slide, this.container);
    this.navPrev = t$2(selectors$v.navPrev, this.container);
    this.navNext = t$2(selectors$v.navNext, this.container);
    this.disableTabbingToInners();
    this.breakPointHandler = atBreakpointChange(720, function () {
      _this2.disableTabbingToInners();
    });

    if (this.slides.length < 2) {
      return null;
    }

    var autoplayEnabled = this.sliderContainer.dataset.autoplayEnabled == "true";
    var autoplayDelay = parseInt(this.sliderContainer.dataset.autoplayDelay, 10);

    var _this = this;

    import(flu.chunks.swiper).then(function (_ref2) {
      var Swiper = _ref2.Swiper,
          Navigation = _ref2.Navigation,
          Autoplay = _ref2.Autoplay;
      _this2.swiper = new Swiper(_this2.sliderContainer, {
        on: {
          init: function init() {
            u$1(_this.container, "slider-active");
          },
          slideChangeTransitionEnd: function slideChangeTransitionEnd() {
            var slideEls = this.slides;
            setTimeout(function () {
              slideEls.forEach(function (slide) {
                slide.toggleAttribute("inert", !slide.classList.contains("swiper-slide-active"));
              });
            }, 50);
          }
        },
        modules: [Navigation, Autoplay],
        grabCursor: true,
        loop: true,
        autoplay: autoplayEnabled ? {
          delay: autoplayDelay,
          disableOnInteraction: false,
          pauseOnMouseEnter: true
        } : false,
        navigation: {
          nextEl: _this2.navNext,
          prevEl: _this2.navPrev
        }
      });
    });
  },
  onBlockSelect: function onBlockSelect(_ref3) {
    var _this$swiper, _this$swiper$autoplay, _this$swiper2;

    var slide = _ref3.target;
    var index = parseInt(slide.dataset.index, 10);
    (_this$swiper = this.swiper) === null || _this$swiper === void 0 ? void 0 : (_this$swiper$autoplay = _this$swiper.autoplay) === null || _this$swiper$autoplay === void 0 ? void 0 : _this$swiper$autoplay.stop();
    (_this$swiper2 = this.swiper) === null || _this$swiper2 === void 0 ? void 0 : _this$swiper2.slideToLoop(index);
  },
  onBlockDeselect: function onBlockDeselect() {
    var _this$swiper3, _this$swiper3$autopla;

    (_this$swiper3 = this.swiper) === null || _this$swiper3 === void 0 ? void 0 : (_this$swiper3$autopla = _this$swiper3.autoplay) === null || _this$swiper3$autopla === void 0 ? void 0 : _this$swiper3$autopla.start();
  },
  onUnload: function onUnload() {
    var _this$swiper4, _this$widthWatcher;

    (_this$swiper4 = this.swiper) === null || _this$swiper4 === void 0 ? void 0 : _this$swiper4.destroy();
    (_this$widthWatcher = this.widthWatcher) === null || _this$widthWatcher === void 0 ? void 0 : _this$widthWatcher.destroy();
  }
});

var selectors$u = {
  item: "[data-input-item]",
  itemProperties: "[data-item-properties]",
  quantityInput: "[data-quantity-input]",
  quantityAdd: "[data-add-quantity]",
  quantitySubtract: "[data-subtract-quantity]",
  removeItem: "[data-remove-item]"
};
function QuantityButtons(node) {
  var delegate = new Delegate(node);
  delegate.on("click", selectors$u.quantitySubtract, function (_, target) {
    var item = target.closest(selectors$u.item);
    var key = item.dataset.key;
    var qty = n$2(selectors$u.quantityInput, item).value;
    r$1("quantity-update:subtract", null, {
      key: key
    });
    cart.updateItem(key, parseInt(qty) - 1);
  });
  delegate.on("click", selectors$u.quantityAdd, function (_, target) {
    var item = target.closest(selectors$u.item);
    var key = item.dataset.key;
    var qty = n$2(selectors$u.quantityInput, item).value;
    r$1("quantity-update:add", null, {
      key: key
    });
    cart.updateItem(key, parseInt(qty) + 1);
  });
  delegate.on("click", selectors$u.removeItem, async function (_, target) {
    const item = target.closest(selectors$u.item);
    const key = item.dataset.key;
    const lenseKey = item.dataset.lenseKey;
    const randomID = item.dataset.randomId;

    const hasLenseProduct = lenseKey != "" && randomID;

    await cart.updateItem(key, 0, hasLenseProduct ? false : true);
    
    if(hasLenseProduct){
      await cart.updateItemByRandomId(randomID, 0);
    }
  });

  var unload = function unload() {
    delegate.off();
  };

  return {
    unload: unload
  };
}

var strings$3 = window.theme.strings.cart;
var selectors$t = {
  cartNoteTrigger: "[data-order-note-trigger]",
  cartNoteTriggerText: "[data-cart-not-trigger-text]",
  cartNoteInputWrapper: "[cart-note-input]",
  iconPlus: ".icon-plus-small",
  iconMinus: ".icon-minus-small"
};
function CartNoteToggle(node) {
  var delegate = new Delegate(node);
  delegate.on("click", selectors$t.cartNoteTrigger, function (_, target) {
    return handleCartNoteTrigger(target);
  });

  function handleCartNoteTrigger(target) {
    var inputWrapper = n$2(selectors$t.cartNoteInputWrapper, target.parentNode);
    var textInput = n$2("textarea", inputWrapper); // Handle icon change when open or close

    var plusIcon = n$2(selectors$t.iconPlus, target);
    var minusIcon = n$2(selectors$t.iconMinus, target);
    l([plusIcon, minusIcon], "hidden");

    if (isVisible(inputWrapper)) {
      slideStop(inputWrapper);
      slideUp(inputWrapper);
      inputWrapper.setAttribute("aria-expanded", false);
      inputWrapper.setAttribute("aria-hidden", true);
      var inputTriggertext = n$2(selectors$t.cartNoteTriggerText, node); // Update cart note trigger text

      if (textInput.value === "") {
        inputTriggertext.innerText = strings$3.addCartNote;
      } else {
        inputTriggertext.innerText = strings$3.editCartNote;
      }
    } else {
      slideStop(inputWrapper);
      slideDown(inputWrapper);
      inputWrapper.setAttribute("aria-expanded", true);
      inputWrapper.setAttribute("aria-hidden", false);
    }
  }

  var unload = function unload() {
    delegate.off();
  };

  return {
    unload: unload
  };
}

/**
 * Takes a selector and updates the innerHTML of that element with the contents found in the updated document
 * @param {*} selector The selector to target
 * @param {*} doc The updated document returned by the fetch request
 */

function updateInnerHTML(selector, doc) {
  var updatedItem = n$2(selector, doc);
  var oldItem = n$2(selector);

  if (updatedItem && oldItem) {
    oldItem.innerHTML = updatedItem.innerHTML;
  }
}

var selectors$s = {
  crossSellsSlider: "[data-cross-sells-slider]",
  quickViewTrigger: "[data-quick-view-trigger]",
  addToCartTrigger: "[data-add-item-id]"
};
function CrossSells(node) {
  var crossSellsSlider = n$2(selectors$s.crossSellsSlider, node).dataset.crossSellsSlider;
  var swiper = crossSellsSlider ? new Carousel(node, {
    slidesPerView: 1.15,
    spaceBetween: 8
  }) : null;
  var events = [e$2(t$2(selectors$s.quickViewTrigger, node), "click", function (e) {
    var productUrl = e.target.dataset.productUrl;
    if (!productUrl) return;
    r$1("quick-view:open", null, {
      productUrl: productUrl
    });
  }), e$2(t$2(selectors$s.addToCartTrigger, node), "click", function (e) {
    var addItemId = e.target.dataset.addItemId;
    if (!addItemId) return;
    animateButton(e.target);
    cart.addItemById(addItemId, 1);
    r$1("quick-cart:scrollup");
  })];

  function animateButton(button) {
    u$1(button, "loading");
  }

  function unload() {
    events.forEach(function (unsubscribe) {
      return unsubscribe();
    });
    swiper.destroy();
  }

  return {
    unload: unload
  };
}

var selectors$r = {
  cartWrapper: ".quick-cart__wrapper",
  innerContainer: ".quick-cart__container",
  overlay: ".quick-cart__overlay",
  closeButton: ".quick-cart__close-icon",
  footer: ".quick-cart__footer",
  items: ".quick-cart__items",
  cartError: ".quick-cart__item-error",
  form: ".quick-cart__form",
  cartCount: ".quick-cart__heading sup",
  subtotal: ".quick-cart__footer-subtotal span",
  quantityInput: ".quick-cart .quantity-input__input",
  quantityItem: "[data-input-item]",
  discounts: ".quick-cart__item-discounts",
  freeShippingBar: "[data-free-shipping-bar]",
  crossSells: "[data-cross-sells]"
};
var classes$a = {
  active: "active",
  hidden: "hidden",
  updatingQuantity: "has-quantity-update",
  removed: "is-removed"
};
register("quick-cart", {
  onLoad: function onLoad() {
    var _this = this;

    this.cartWrapper = n$2(selectors$r.cartWrapper, this.container);
    this.cartTrap = createFocusTrap(this.container, {
      allowOutsideClick: true
    }); // Events are all on events trigger by other components / functions

    this.events = [c("quick-cart:open", function () {
      return _this.openQuickCart();
    }), c("quick-cart:updated", function () {
      return _this.refreshQuickCart();
    }), c("quick-cart:error", function (_, _ref) {
      var key = _ref.key,
          errorMessage = _ref.errorMessage;

      _this.handleErrorMessage(key, errorMessage);
    }), c("quick-cart:scrollup", function () {
      return _this.scrollUpQuickCart();
    }), c(["quantity-update:subtract", "quantity-update:add"], function (_, _ref2) {
      var key = _ref2.key;

      _this.handleQuantityUpdate(key);
    }), c("quantity-update:remove", function (_, _ref3) {
      var key = _ref3.key;

      _this.handleItemRemoval(key);
    }), e$2(document, "apps:product-added-to-cart", function () {
      _this.refreshQuickCart();
    })];
    this.quantityButtons = QuantityButtons(this.container);
    this.cartNoteToggle = CartNoteToggle(this.container);

    if (shouldAnimate(this.container)) {
      this.animateQuickCart = animateQuickCart(this.container);
    } // Delegate handles all click events due to rendering different content
    // within quick cart


    this.delegate = new Delegate(this.container);
    this.delegate.on("click", selectors$r.overlay, function () {
      return _this.close();
    });
    this.delegate.on("click", selectors$r.closeButton, function () {
      return _this.close();
    });
    this.delegate.on("change", selectors$r.quantityInput, function (e) {
      return _this.handleQuantityInputChange(e);
    });
    var freeShippingBar$1 = n$2(selectors$r.freeShippingBar, this.container);

    if (freeShippingBar$1) {
      freeShippingBar(freeShippingBar$1);
    }

    this._initCrossSells();
  },
  openQuickCart: function openQuickCart() {
    var _this$animateQuickCar;

    u$1(this.cartWrapper, classes$a.active);
    this.cartTrap.activate();
    this.adjustItemPadding();
    (_this$animateQuickCar = this.animateQuickCart) === null || _this$animateQuickCar === void 0 ? void 0 : _this$animateQuickCar.open();
    document.body.setAttribute("data-fluorescent-overlay-open", "true");
    disableBodyScroll(this.container, {
      allowTouchMove: function allowTouchMove(el) {
        while (el && el !== document.body) {
          if (el.getAttribute("data-scroll-lock-ignore") !== null) {
            return true;
          }

          el = el.parentNode;
        }
      },
      reserveScrollBarGap: true
    });
  },
  refreshQuickCart: function refreshQuickCart() {
    var _this2 = this;

    var url = "".concat(theme.routes.cart.base, "?section_id=quick-cart");
    makeRequest("GET", url).then(function (response) {
      var _this2$crossSells;

      var container = document.createElement("div");
      container.innerHTML = response;
      var responseInnerContainer = n$2(selectors$r.innerContainer, container);
      var cartHasItems = Boolean(n$2(selectors$r.items, _this2.container));
      var responseHasItems = Boolean(n$2(selectors$r.items, container));
      var freeShippingBar$1 = n$2(selectors$r.freeShippingBar, container);
      (_this2$crossSells = _this2.crossSells) === null || _this2$crossSells === void 0 ? void 0 : _this2$crossSells.unload();

      if (freeShippingBar$1) {
        freeShippingBar(freeShippingBar$1);
      } // Cart has items and needs to update them


      if (responseHasItems && cartHasItems) {
        var _this2$animateQuickCa;

        // Render cart items
        updateInnerHTML("".concat(selectors$r.cartWrapper, " ").concat(selectors$r.items), container);

        _this2.adjustItemPadding(); // Render cart count


        updateInnerHTML("".concat(selectors$r.cartWrapper, " ").concat(selectors$r.cartCount), container); // Render subtotal

        updateInnerHTML("".concat(selectors$r.cartWrapper, " ").concat(selectors$r.subtotal), container); // Render promotions

        updateInnerHTML("".concat(selectors$r.cartWrapper, " ").concat(selectors$r.discounts), container); // Handle form scroll state

        var form = n$2(selectors$r.form, _this2.container);
        var previousScrollPosition = form.scrollTop || 0;
        form.scrollTop = previousScrollPosition;
        (_this2$animateQuickCa = _this2.animateQuickCart) === null || _this2$animateQuickCa === void 0 ? void 0 : _this2$animateQuickCa.setup();
      } else {
        // Cart needs to render empty from having items, or needs to render
        // items from empty state
        var innerContainer = n$2(selectors$r.innerContainer, _this2.container);
        innerContainer.innerHTML = responseInnerContainer.innerHTML;
      }

      _this2._initCrossSells();
    });
  },
  handleErrorMessage: function handleErrorMessage(key) {
    var item = n$2("[data-key=\"".concat(key, "\"]"), this.container);
    
    if(item){
      i$1(n$2(selectors$r.cartError, item), classes$a.hidden);
      i$1(item, classes$a.updatingQuantity);
    }
  },
  handleQuantityUpdate: function handleQuantityUpdate(key) {
    var item = n$2("[data-key=\"".concat(key, "\"]"), this.container);

    if(item) u$1(item, classes$a.updatingQuantity);
  },
  handleItemRemoval: function handleItemRemoval(key) {
    var item = n$2("[data-key=\"".concat(key, "\"]"), this.container);
    
    if(item){
      u$1(item, classes$a.removed);
      u$1(item, classes$a.updatingQuantity);
    }
  },
  handleQuantityInputChange: function handleQuantityInputChange(_ref4) {
    var target = _ref4.target;
    var item = target.closest(selectors$r.quantityItem);
    var key = item.dataset.key;
    cart.updateItem(key, target.value);
    this.handleQuantityUpdate(key);
  },
  _initCrossSells: function _initCrossSells() {
    var crossSells = n$2(selectors$r.crossSells, this.container);

    if (crossSells) {
      this.crossSells = CrossSells(crossSells);
    }
  },
  scrollUpQuickCart: function scrollUpQuickCart() {
    var form = n$2(selectors$r.form, this.container);
    var previousScrollPosition = 0;
    if (!form) return; // delay the scroll up to make it seem more 'fluid'

    setTimeout(function () {
      form.scrollTop = previousScrollPosition;
    }, 300);
  },
  adjustItemPadding: function adjustItemPadding() {
    var items = n$2(selectors$r.items, this.container);
    if (!items) return; // Ensure cart items accounts for the height of cart footer

    var footer = n$2(selectors$r.footer, this.container);
    items.style.paddingBottom = "".concat(footer.clientHeight, "px");
  },
  close: function close() {
    var _this3 = this;

    i$1(this.cartWrapper, classes$a.active);
    setTimeout(function () {
      var _this3$animateQuickCa;

      (_this3$animateQuickCa = _this3.animateQuickCart) === null || _this3$animateQuickCa === void 0 ? void 0 : _this3$animateQuickCa.close();

      _this3.cartTrap.deactivate();

      document.body.setAttribute("data-fluorescent-overlay-open", "false");
      enableBodyScroll(_this3.container);
    }, 500);
  },
  onSelect: function onSelect() {
    this.openQuickCart();
  },
  onDeselect: function onDeselect() {
    this.close();
  },
  onUnload: function onUnload() {
    this.delegate.off();
    this.events.forEach(function (unsubscribe) {
      return unsubscribe();
    });
    this.quantityButtons.unload();
    this.cartNoteToggle.unload();
  }
});

var selectors$q = {
  "settings": "[data-timer-settings]",
  "days": "[data-days]",
  "hours": "[data-hours]",
  "minutes": "[data-minutes]",
  "seconds": "[data-seconds]"
};
var classes$9 = {
  "active": "active",
  "hide": "hide",
  "complete": "complete"
};
function CountdownTimer(container) {
  var settings = n$2(selectors$q.settings, container);

  var _JSON$parse = JSON.parse(settings.innerHTML),
      year = _JSON$parse.year,
      month = _JSON$parse.month,
      day = _JSON$parse.day,
      hour = _JSON$parse.hour,
      minute = _JSON$parse.minute,
      shopTimezone = _JSON$parse.shopTimezone,
      timeZoneSelection = _JSON$parse.timeZoneSelection,
      hideTimerOnComplete = _JSON$parse.hideTimerOnComplete;

  var daysEl = n$2(selectors$q.days, container);
  var hoursEl = n$2(selectors$q.hours, container);
  var minutesEl = n$2(selectors$q.minutes, container);
  var secondsEl = n$2(selectors$q.seconds, container);
  var timezoneString = timeZoneSelection === "shop" ? " GMT".concat(shopTimezone) : "";
  var countDownDate = new Date(Date.parse("".concat(month, " ").concat(day, ", ").concat(year, " ").concat(hour, ":").concat(minute).concat(timezoneString)));
  var countDownTime = countDownDate.getTime();
  var timerInterval = setInterval(timerLoop, 1000);
  timerLoop();
  u$1(container, classes$9.active);

  function timerLoop() {
    window.requestAnimationFrame(function () {
      // Get today's date and time
      var now = new Date().getTime(); // Find the distance between now and the count down date

      var distance = countDownTime - now; // Time calculations for days, hours, minutes and seconds

      var days = Math.floor(distance / (1000 * 60 * 60 * 24));
      var hours = Math.floor(distance % (1000 * 60 * 60 * 24) / (1000 * 60 * 60));
      var minutes = Math.floor(distance % (1000 * 60 * 60) / (1000 * 60));
      var seconds = Math.floor(distance % (1000 * 60) / 1000); // If the count down is finished, write some text

      if (distance < 0) {
        timerInterval && clearInterval(timerInterval);
        daysEl.innerHTML = 0;
        hoursEl.innerHTML = 0;
        minutesEl.innerHTML = 0;
        secondsEl.innerHTML = 0;
        u$1(container, classes$9.complete);

        if (hideTimerOnComplete) {
          u$1(container, classes$9.hide);
        }
      } else {
        daysEl.innerHTML = days;
        hoursEl.innerHTML = hours;
        minutesEl.innerHTML = minutes;
        secondsEl.innerHTML = seconds;
      }
    });
  }

  function destroy() {
    timerInterval && clearInterval(timerInterval);
  }

  return {
    destroy: destroy
  };
}

var selectors$p = {
  wash: ".popup__wash",
  dismissButtons: "[data-dismiss-popup]",
  tab: ".popup__tab",
  tabButton: ".popup__tab-button",
  tabDismiss: ".popup__tab-dismiss",
  newsletterForm: ".newsletter-form",
  formSuccessMessage: ".form-status__message--success",
  timer: "[data-countdown-timer]"
};
var classes$8 = {
  visible: "visible"
};
function Popup(container) {
  var focusTrap = createFocusTrap(container, {
    allowOutsideClick: true
  });
  var popupAnimation = animatePopup(container);
  var wash = n$2(selectors$p.wash, container);
  var dismissButtons = t$2(selectors$p.dismissButtons, container);
  var formSuccessMessage = n$2(selectors$p.formSuccessMessage, container);
  var timer = n$2(selectors$p.timer, container);
  var _container$dataset = container.dataset,
      delayType = _container$dataset.delayType,
      showOnExitIntent = _container$dataset.showOnExitIntent,
      id = _container$dataset.id,
      isSignup = _container$dataset.isSignup,
      popupType = _container$dataset.popupType;
  var tab = n$2("".concat(selectors$p.tab, "[data-id=\"").concat(id, "\""));
  var _container$dataset2 = container.dataset,
      delayValue = _container$dataset2.delayValue,
      hourFrequency = _container$dataset2.hourFrequency;
  delayValue = parseInt(delayValue, 10);
  hourFrequency = parseInt(hourFrequency, 10);
  var storageKey = "popup-".concat(id);
  var signupSubmittedKey = "signup-submitted-".concat(id);
  var formSuccessKey = "form-success-".concat(id);
  var signupDismissedKey = "signup-dismissed-".concat(id);
  var ageVerifiedKey = "age-verified-".concat(id);
  var isSignupPopup = isSignup === "true";
  var isAgeVerification = popupType === "age";
  var hasPoppedUp = false;
  var signupSubmitted = Boolean(getStorage(signupSubmittedKey));
  var formSuccessShown = Boolean(getStorage(formSuccessKey));
  var signupDismissed = Boolean(getStorage(signupDismissedKey));
  var ageVerified = Boolean(getStorage(ageVerifiedKey));
  var canPopUp = true;
  var countdownTimer = null;

  if (timer) {
    countdownTimer = CountdownTimer(timer);
  }

  ShouldPopUp();
  var events = [];

  if (!window.Shopify.designMode) {
    events.push(e$2(dismissButtons, "click", hidePopup));
  }

  if (!isAgeVerification && !window.Shopify.designMode) {
    // Only allow wash to be clickable for non age verification popups
    events.push(e$2(wash, "click", hidePopup));
    events.push(e$2(container, "keydown", function (_ref) {
      var keyCode = _ref.keyCode;
      if (keyCode === 27) hidePopup();
    }));
  }

  if (isSignupPopup) {
    var form = n$2(selectors$p.newsletterForm, container);

    if (form) {
      events.push(e$2(form, "submit", onNewsletterSubmit));
    }
  }

  if (tab) {
    var tabButton = n$2(selectors$p.tabButton, tab);
    var tabDismiss = n$2(selectors$p.tabDismiss, tab);
    events.push(e$2(tabButton, "click", handleTabClick));
    events.push(e$2(tabDismiss, "click", hideTab));
  } // Show popup immediately if signup form was submitted


  if (isSignupPopup && formSuccessMessage && !formSuccessShown) {
    setStorage(formSuccessKey, JSON.stringify(new Date()));
    showPopup();
  } else {
    handleDelay();

    if (showOnExitIntent === "true" && !isMobile$1()) {
      handleExitIntent();
    }
  }

  function handleDelay() {
    if (!canPopUp) return;

    if (delayType === "timer") {
      setTimeout(function () {
        if (!hasPoppedUp) {
          showPopup();
          setStorage(storageKey, JSON.stringify(new Date()));
        }
      }, delayValue);
    } else if (delayType === "scroll") {
      // Delay window / page height calcs until window has loaded
      window.addEventListener("load", function () {
        var scrollPercent = delayValue / 100;
        var scrollTarget = (document.body.scrollHeight - window.innerHeight) * scrollPercent;
        var scrollListener = e$2(window, "scroll", function () {
          if (window.scrollY >= scrollTarget) {
            if (!hasPoppedUp) {
              showPopup();
              setStorage(storageKey, JSON.stringify(new Date()));
            } // Unbind listener


            scrollListener();
          }
        });
      }, {
        once: true
      });
    }
  }

  function handleExitIntent() {
    if (!canPopUp) return;
    var bodyLeave = e$2(document.body, "mouseout", function (e) {
      if (!e.relatedTarget && !e.toElement) {
        bodyLeave();

        if (!hasPoppedUp) {
          showPopup();
          setStorage(storageKey, JSON.stringify(new Date()));
          hasPoppedUp = true;
        }
      }
    });
  }

  function ShouldPopUp() {
    // To avoid popups appearing while in the editor we're disabling them
    // Popups will only be visible in customizer when selected
    if (window.Shopify.designMode) {
      canPopUp = false;
      return;
    } // If age has been verified then don't show popup
    // Or signup submitted or dismissed
    // don't show popup


    if (isAgeVerification && ageVerified || isSignupPopup && signupSubmitted) {
      canPopUp = false;
      return;
    }

    if (isSignupPopup && !signupSubmitted && signupDismissed) {
      canPopUp = false;

      if (tab) {
        showTab();
      }

      return;
    } // If no date has been set allow the popup to set the first when opened


    if (!isSignupPopup && !isAgeVerification && !getStorage(storageKey)) {
      return;
    } // Compare set date and allowed popup frequency hour diff


    var timeStart = new Date(getStorage(storageKey));
    var timeEnd = new Date();
    var hourDiff = (timeEnd - timeStart) / 1000 / 60 / 60; // Will not allow popup if the hour frequency is below the previously
    // set poppedup date.

    canPopUp = hourDiff > hourFrequency;
  }

  function handleTabClick() {
    showPopup();

    if (popupType === "flyout" && !window.Shopify.designMode) {
      var focusable = n$2("button, [href], input, select, textarea", container);

      if (focusable) {
        focusable.focus({
          preventScroll: true
        });
      }
    }
  }

  function showPopup() {
    u$1(container, classes$8.visible);
    popupAnimation.open();

    if (popupType === "popup" || popupType === "age") {
      if (!window.Shopify.designMode) {
        focusTrap.activate();
      }

      document.body.setAttribute("data-fluorescent-overlay-open", "true");
      disableBodyScroll(container);
    }

    hasPoppedUp = true;

    if (window.Shopify.designMode && tab) {
      // Show tab in theme editor
      showTab();
    } else if (tab) {
      // hide tab on popup open
      i$1(tab, classes$8.visible);
    }
  }

  function hidePopup() {
    i$1(container, classes$8.visible);

    if (isSignupPopup) {
      setStorage(signupDismissedKey, JSON.stringify(new Date())); // show tab on close, clicking the tab will open the popup again

      if (tab) {
        showTab();
      }
    } // Set storage when age verification popup has been dismissed
    // Age verification popups will always be shown until they are dismissed


    if (isAgeVerification) {
      setStorage(ageVerifiedKey, JSON.stringify(new Date()));
    }

    setTimeout(function () {
      popupAnimation.close();

      if (popupType === "popup" || popupType === "age") {
        focusTrap.deactivate();
        document.body.setAttribute("data-fluorescent-overlay-open", "false");
        enableBodyScroll(container);
      }
    }, 500);
  }

  function showTab() {
    u$1(tab, classes$8.visible);
  }

  function hideTab() {
    i$1(tab, classes$8.visible); // When tab is removed we want the popup to be able to open again if it has a frequency
    // We have to remove the storeage saying that the popup was dismissed

    removeStorage(signupDismissedKey);
  }

  function onNewsletterSubmit() {
    setStorage(signupSubmittedKey, JSON.stringify(new Date()));
  }

  function unload() {
    hidePopup();
    events.forEach(function (unsubscribe) {
      return unsubscribe();
    });

    if (isAgeVerification) {
      enableBodyScroll(container);
    }

    countdownTimer && countdownTimer.destroy();
  }

  return {
    unload: unload,
    showPopup: showPopup,
    hidePopup: hidePopup
  };
}

register("popup", {
  onLoad: function onLoad() {
    this.popups = t$2("[data-popup]", this.container).map(function (popup) {
      return {
        contructor: Popup(popup),
        element: popup
      };
    });
  },
  onBlockSelect: function onBlockSelect(_ref) {
    var target = _ref.target;
    var targetPopup = this.popups.find(function (o) {
      return o.element === target;
    });
    targetPopup.contructor.showPopup();
  },
  onBlockDeselect: function onBlockDeselect(_ref2) {
    var target = _ref2.target;
    var targetPopup = this.popups.find(function (o) {
      return o.element === target;
    });
    targetPopup.contructor.hidePopup();
  },
  onUnload: function onUnload() {
    this.popups.forEach(function (popup) {
      var _popup$contructor;

      return (_popup$contructor = popup.contructor) === null || _popup$contructor === void 0 ? void 0 : _popup$contructor.unload();
    });
  }
});

register("blog-posts", {
  onLoad: function onLoad() {
    if (shouldAnimate(this.container)) {
      this.animateBlogPosts = animateBlogPosts(this.container);
    }
  },
  onUnload: function onUnload() {
    var _this$animateBlogPost;

    (_this$animateBlogPost = this.animateBlogPosts) === null || _this$animateBlogPost === void 0 ? void 0 : _this$animateBlogPost.destroy();
  }
});

var selectors$o = {
  itemTrigger: ".collapsible-row-list-item__trigger"
};
register("collapsible-row-list", {
  onLoad: function onLoad() {
    var _this = this;

    this.items = t$2(selectors$o.itemTrigger, this.container);
    this.clickHandlers = e$2(this.items, "click", function (e) {
      e.preventDefault();
      var _e$currentTarget = e.currentTarget,
          group = _e$currentTarget.parentNode,
          content = _e$currentTarget.nextElementSibling;

      if (isVisible(content)) {
        _this._close(e.currentTarget, group, content);
      } else {
        _this._open(e.currentTarget, group, content);
      }
    });

    if (shouldAnimate(this.container)) {
      this.animateCollapsibleRowList = animateCollapsibleRowList(this.container);
    }
  },
  _open: function _open(label, group, content) {
    slideStop(content);
    slideDown(content);
    group.setAttribute("data-open", true);
    label.setAttribute("aria-expanded", true);
    content.setAttribute("aria-hidden", false);
  },
  _close: function _close(label, group, content) {
    slideStop(content);
    slideUp(content);
    group.setAttribute("data-open", false);
    label.setAttribute("aria-expanded", false);
    content.setAttribute("aria-hidden", true);
  },
  onBlockSelect: function onBlockSelect(_ref) {
    var target = _ref.target;
    var label = n$2(selectors$o.itemTrigger, target);
    var group = label.parentNode,
        content = label.nextElementSibling;

    this._open(label, group, content);
  },
  onUnload: function onUnload() {
    var _this$animateCollapsi;

    this.clickHandlers();
    (_this$animateCollapsi = this.animateCollapsibleRowList) === null || _this$animateCollapsi === void 0 ? void 0 : _this$animateCollapsi.destroy();
  }
});

register("collection-list-slider", {
  onLoad: function onLoad() {
    var _this$container$datas = this.container.dataset,
        productsPerView = _this$container$datas.productsPerView,
        mobileProductsPerView = _this$container$datas.mobileProductsPerView;
    this.events = [];
    this.perView = parseInt(productsPerView, 10); // 1.05 factor gives us a "peek" without CSS hacks
    // TODO: encapsulate this in carousel instead of duplication wherever
    // we call on carousel.  Can also simplify the config that we pass in
    // to something like perViewSmall, perViewMedium, perViewLarge and same with
    // spaceBetween?

    this.mobilePerView = parseInt(mobileProductsPerView, 10) * 1.05;

    this._initCarousel();

    if (shouldAnimate(this.container)) {
      this.animateListSlider = animateListSlider(this.container);
    }
  },
  _initCarousel: function _initCarousel() {
    // Between 720 - 960 the slides per view stay consistent with section
    // settings, with the exception of 5, which then shrinks down to 4 across.
    this.carousel = Carousel(this.container, {
      slidesPerView: this.mobilePerView,
      spaceBetween: 12,
      breakpoints: {
        720: {
          spaceBetween: 16,
          slidesPerView: this.perView === 5 ? this.perView - 1 : this.perView
        },
        1200: {
          spaceBetween: 24,
          slidesPerView: this.perView
        }
      }
    });
  },
  onUnload: function onUnload() {
    var _this$carousel, _this$animateListSlid;

    (_this$carousel = this.carousel) === null || _this$carousel === void 0 ? void 0 : _this$carousel.destroy();
    (_this$animateListSlid = this.animateListSlider) === null || _this$animateListSlid === void 0 ? void 0 : _this$animateListSlid.destroy();
  }
});

var selectors$n = {
  "timer": "[data-countdown-timer]"
};
register("countdown-banner", {
  onLoad: function onLoad() {
    var _this = this;

    var timers = t$2(selectors$n.timer, this.container);
    this.countdownTimers = [];
    timers.forEach(function (timer) {
      _this.countdownTimers.push(CountdownTimer(timer));
    });

    if (shouldAnimate(this.container)) {
      this.animateCountdownBanner = animateCountdownBanner(this.container);
    }
  },
  onUnload: function onUnload() {
    var _this$animateCountdow;

    (_this$animateCountdow = this.animateCountdownBanner) === null || _this$animateCountdow === void 0 ? void 0 : _this$animateCountdow.destroy();
    this.countdownTimers.forEach(function (countdownTimer) {
      return countdownTimer.destroy();
    });
  }
});

var selectors$m = {
  "timer": "[data-countdown-timer]"
};
register("countdown-bar", {
  onLoad: function onLoad() {
    var _this = this;

    var timers = t$2(selectors$m.timer, this.container);
    this.countdownTimers = [];
    timers.forEach(function (timer) {
      _this.countdownTimers.push(CountdownTimer(timer));
    });

    if (shouldAnimate(this.container)) {
      this.animateCountdownBar = animateCountdownBar(this.container);
    }
  },
  onUnload: function onUnload() {
    var _this$animateCountdow;

    (_this$animateCountdow = this.animateCountdownBar) === null || _this$animateCountdow === void 0 ? void 0 : _this$animateCountdow.destroy();
    this.countdownTimers.forEach(function (countdownTimer) {
      return countdownTimer.destroy();
    });
  }
});

register("featured-collection-grid", {
  onLoad: function onLoad() {
    var _this = this;

    var _this$container$datas = this.container.dataset,
        productsPerView = _this$container$datas.productsPerView,
        mobileProductsPerView = _this$container$datas.mobileProductsPerView;
    this.events = [];
    this.perView = parseInt(productsPerView, 10);
    this.mobilePerView = parseInt(mobileProductsPerView, 10) * 1.05; // 1.05 factor gives us a "peek" without CSS hacks
    // TODO: encapsulate this in carousel instead of duplication wherever
    // we call on carousel.  Can also simplify the config that we pass in
    // to something like perViewSmall, perViewMedium, perViewLarge and same with
    // spaceBetween?

    this.productItem = ProductItem(this.container);
    this.breakPointHandler = atBreakpointChange(960, function () {
      if (window.matchMedia(getMediaQuery("below-960")).matches) {
        _this._initCarousel();
      } else {
        _this.carousel.destroy();
      }
    });

    if (window.matchMedia(getMediaQuery("below-960")).matches) {
      this._initCarousel();
    }

    if (shouldAnimate(this.container)) {
      this.animateFeaturedCollectionGrid = animateFeaturedCollectionGrid(this.container);
    }
  },
  _initCarousel: function _initCarousel() {
    // Between 720 - 960 the slides per view stay consistent with section
    // settings, with the exception of 5, which then shrinks down to 4 across.
    this.carousel = Carousel(this.container, {
      slidesPerView: this.mobilePerView,
      spaceBetween: 12,
      breakpoints: {
        720: {
          spaceBetween: 16,
          slidesPerView: this.perView === 5 ? this.perView - 1 : this.perView
        }
      }
    });
  },
  onUnload: function onUnload() {
    var _this$carousel, _this$animateFeatured;

    (_this$carousel = this.carousel) === null || _this$carousel === void 0 ? void 0 : _this$carousel.destroy();
    (_this$animateFeatured = this.animateFeaturedCollectionGrid) === null || _this$animateFeatured === void 0 ? void 0 : _this$animateFeatured.destroy();
  }
});

var selectors$l = {
  navItems: ".featured-collection-slider__navigation-list-item",
  sliderContainer: ".carousel",
  navButtons: ".carousel__navigation-buttons"
};
var classes$7 = {
  selected: "selected",
  visible: "visible",
  fadeout: "fadeout",
  initReveal: "init-reveal",
  reveal: "reveal"
};
register("featured-collection-slider", {
  onLoad: function onLoad() {
    this.events = [];
    this.carousels = [];

    this._initCarousels();

    if (shouldAnimate(this.container)) {
      this.animateListSlider = animateListSlider(this.container);
    }
  },
  _initCarousels: function _initCarousels() {
    var _this = this;

    var _this$container$datas = this.container.dataset,
        productsPerView = _this$container$datas.productsPerView,
        mobileProductsPerView = _this$container$datas.mobileProductsPerView;
    this.perView = parseInt(productsPerView, 10);
    this.mobilePerView = parseInt(mobileProductsPerView, 10) * 1.05; // 1.05 factor gives us a "peek" without CSS hacks
    // TODO: encapsulate this in carousel instead of duplication wherever
    // we call on carousel.  Can also simplify the config that we pass in
    // to something like perViewSmall, perViewMedium, perViewLarge and same with
    // spaceBetween?

    this.productItem = ProductItem(this.container);
    this.carouselsElements = t$2(selectors$l.sliderContainer, this.container);
    this.navItems = t$2(selectors$l.navItems, this.container);
    this.navigationButtons = t$2(selectors$l.navButtons, this.container);
    this.navItems.forEach(function (button) {
      return _this.events.push(e$2(button, "click", _this._handleNavButton.bind(_this)));
    });
    this.carouselsElements.forEach(function (container, index) {
      var navigationWrapper = n$2("[data-navigation=\"".concat(index, "\"]"), _this.container);
      var nextButton = n$2("[data-next]", navigationWrapper);
      var prevButton = n$2("[data-prev]", navigationWrapper);

      _this.carousels.push(Carousel(container, {
        slidesPerView: _this.mobilePerView,
        spaceBetween: 13,
        // matches product grid
        navigation: {
          nextEl: nextButton,
          prevEl: prevButton
        },
        autoplay: {
          delay: 2000,
          disableOnInteraction: false,
           pauseOnMouseEnter: true
        },
        breakpoints: {
          720: {
            spaceBetween: 17,
            // matches product grid
            slidesPerView: _this.perView === 5 ? _this.perView - 1 : _this.perView
          },
          1200: {
            spaceBetween: 25,
            // matches product grid
            slidesPerView: _this.perView
          }
        }
      }));
    });
  },
  _handleNavButton: function _handleNavButton(e) {
    e.preventDefault();
    var navigationItem = e.currentTarget.dataset.navigationItem;

    if (!a$1(e.currentTarget, classes$7.selected)) {
      this._hideAll();

      this._show(parseInt(navigationItem, 10));
    }
  },
  _hideAll: function _hideAll() {
    var _this2 = this;

    i$1(this.navItems, classes$7.selected);
    i$1(this.navigationButtons, classes$7.visible);
    i$1(this.carouselsElements, classes$7.initReveal);
    i$1(this.carouselsElements, classes$7.reveal);

    if (shouldAnimate(this.container)) {
      u$1(this.carouselsElements, classes$7.fadeout);
      setTimeout(function () {
        i$1(_this2.carouselsElements, classes$7.visible);
      }, 300);
    } else {
      i$1(this.carouselsElements, classes$7.visible);
    }
  },
  _show: function _show(index) {
    var navigationWrapper = n$2("[data-navigation=\"".concat(index, "\"]"), this.container);
    u$1(navigationWrapper, classes$7.visible);
    var collection = n$2("[data-collection=\"".concat(index, "\"]"), this.container);

    if (this.navItems.length) {
      var navigationItem = n$2("[data-navigation-item=\"".concat(index, "\"]"), this.container);
      u$1(navigationItem, classes$7.selected);
    }

    if (shouldAnimate(this.container)) {
      u$1(collection, classes$7.fadeout);
      u$1(collection, classes$7.initReveal);
      setTimeout(function () {
        u$1(collection, classes$7.visible);
        i$1(collection, classes$7.fadeout);
        setTimeout(function () {
          u$1(collection, classes$7.reveal);
        }, 50);
      }, 300);
    } else {
      u$1(collection, classes$7.visible);
    }
  },
  onUnload: function onUnload() {
    var _this$animateListSlid;

    this.carousels.forEach(function (swiper) {
      return swiper.destroy();
    });
    (_this$animateListSlid = this.animateListSlider) === null || _this$animateListSlid === void 0 ? void 0 : _this$animateListSlid.destroy();
    this.events.forEach(function (unsubscribe) {
      return unsubscribe();
    });
  },
  onBlockSelect: function onBlockSelect(_ref) {
    var target = _ref.target;
    var collection = target.dataset.collection;

    this._hideAll();

    this._show(parseInt(collection, 10));
  }
});

register("featured-product", {
  onLoad: function onLoad() {
    this.product = new Product(this.container);

    if (shouldAnimate(this.container)) {
      this.animateProduct = animateProduct(this.container);
    }
  },
  onBlockSelect: function onBlockSelect(_ref) {
    var target = _ref.target;
    var label = n$2(".accordion__label", target);
    target.scrollIntoView({
      block: "center",
      behavior: "smooth"
    });
    if (!label) return;
    var group = label.parentNode,
        content = label.nextElementSibling;
    slideStop(content);
    slideDown(content);
    group.setAttribute("data-open", true);
    label.setAttribute("aria-expanded", true);
    content.setAttribute("aria-hidden", false);
  },
  onBlockDeselect: function onBlockDeselect(_ref2) {
    var target = _ref2.target;
    var label = n$2(".accordion__label", target);
    if (!label) return;
    var group = label.parentNode,
        content = label.nextElementSibling;
    slideStop(content);
    slideUp(content);
    group.setAttribute("data-open", false);
    label.setAttribute("aria-expanded", false);
    content.setAttribute("aria-hidden", true);
  },
  onUnload: function onUnload() {
    var _this$animateProduct;

    this.product.unload();
    (_this$animateProduct = this.animateProduct) === null || _this$animateProduct === void 0 ? void 0 : _this$animateProduct.destroy();
  }
});

register("gallery-carousel", {
  onLoad: function onLoad() {
    var _this$container$datas = this.container.dataset,
        loopCarousel = _this$container$datas.loopCarousel,
        productsPerView = _this$container$datas.productsPerView,
        mobileProductsPerView = _this$container$datas.mobileProductsPerView; // Convert loop setting string into boolean

    this.loopCarousel = loopCarousel === "true";
    this.perView = parseInt(productsPerView, 10) * 1.05; // 1.05 factor gives us a "peek" without CSS hacks
    // TODO: encapsulate this in carousel instead of duplication wherever
    // we call on carousel.  Can also simplify the config that we pass in
    // to something like perViewSmall, perViewMedium, perViewLarge and same with
    // spaceBetween?

    this.mobilePerView = parseInt(mobileProductsPerView, 10) * 1.05;

    this._initCarousel();

    if (shouldAnimate(this.container)) {
      this.animateListSlider = animateListSlider(this.container);
    }
  },
  _initCarousel: function _initCarousel() {
    // Between 720 - 960 the slides per view stay consistent with section
    // settings, with the exception of 5, which then shrinks down to 4 across.
    this.carousel = Carousel(this.container, {
      slidesPerView: this.mobilePerView,
      spaceBetween: 12,
      loop: this.loopCarousel,
      breakpoints: {
        720: {
          spaceBetween: 16,
          slidesPerView: this.perView
        },
        1200: {
          spaceBetween: 24,
          slidesPerView: this.perView
        }
      }
    });
  },
  onUnload: function onUnload() {
    var _this$carousel, _this$animateListSlid;

    (_this$carousel = this.carousel) === null || _this$carousel === void 0 ? void 0 : _this$carousel.destroy();
    (_this$animateListSlid = this.animateListSlider) === null || _this$animateListSlid === void 0 ? void 0 : _this$animateListSlid.destroy();
  }
});

var selectors$k = {
  recommendations: "[data-recommendations]",
  carouselSlide: ".carousel__slide"
};
/*
register("recommended-products", {
  onLoad: function onLoad() {
    var _this = this;

    var _this$container$datas = this.container.dataset,
        limit = _this$container$datas.limit,
        id = _this$container$datas.productId,
        sectionId = _this$container$datas.sectionId,
        productsPerView = _this$container$datas.productsPerView,
        mobileProductsPerView = _this$container$datas.mobileProductsPerView;
    this.perView = parseInt(productsPerView, 10);
    this.mobilePerView = parseInt(mobileProductsPerView, 10) * 1.05; // 1.05 factor gives us a "peek" without CSS hacks
    // TODO: encapsulate this in carousel instead of duplication wherever
    // we call on carousel.  Can also simplify the config that we pass in
    // to something like perViewSmall, perViewMedium, perViewLarge and same with
    // spaceBetween?

    var content = n$2(selectors$k.recommendations, this.container);
    if (!content) return;
    var requestUrl = "".concat(window.theme.routes.productRecommendations, "?section_id=").concat(sectionId, "&limit=").concat(limit, "&product_id=").concat(id);
    var request = new XMLHttpRequest();
    request.open("GET", requestUrl, true);

    request.onload = function () {
      if (request.status >= 200 && request.status < 300) {
        var container = document.createElement("div");
        container.innerHTML = request.response;
        content.innerHTML = n$2(selectors$k.recommendations, container).innerHTML;
        var carousel = n$2(selectors$k.carouselSlide, content);
        _this.productItem = ProductItem(_this.container);

        if (shouldAnimate(_this.container)) {
          _this.animateListSlider = animateListSlider(_this.container);
        }

        if (carousel) {
          // Between 720 - 960 the slides per view stay consistent with section
          // settings, with the exception of 5, which then shrinks down to 4 across.
          _this.carousel = Carousel(content, {
            slidesPerView: "auto",
            spaceBetween: 40,
            breakpoints: {
              720: {
                spaceBetween: 16,
                slidesPerView: _this.perView === 5 ? _this.perView - 1 : _this.perView
              },
              1200: {
                spaceBetween: 24,
                slidesPerView: _this.perView
              }
            }
          });
        } else {
          _this._removeSection();
        }
      } else {
        // If request returns any errors remove the section markup
        _this._removeSection();
      }
    };

    request.send();
  },
  _removeSection: function _removeSection() {
    this.container.parentNode.removeChild(this.container);
  },
  onUnload: function onUnload() {
    var _this$carousel, _this$animateListSlid;

    (_this$carousel = this.carousel) === null || _this$carousel === void 0 ? void 0 : _this$carousel.destroy();
    (_this$animateListSlid = this.animateListSlider) === null || _this$animateListSlid === void 0 ? void 0 : _this$animateListSlid.destroy();
  }
});
*/

var selectors$j = {
  slide: "[data-slide]",
  swiper: ".swiper",
  navigationPrev: ".slideshow-navigation__navigation-button--previous",
  navigationNext: ".slideshow-navigation__navigation-button--next",
  navigationDots: ".slideshow-navigation__dots",
  navigationDot: ".slideshow-navigation__dot",
  navigationLoader: ".slideshow-navigation__dot-loader",
  activeDot: "slideshow-navigation__dot--active",
  animatableItems: ".animation--section-blocks > *"
};
register("slideshow", {
  onLoad: function onLoad() {
    var _this = this;

    this.events = [];
    this.enableAutoplay = this.container.dataset.enableAutoplay;
    this.autoplayDuration = this.container.dataset.autoplay;
    this.slideshow = null;
    this.slideshowContainer = n$2(selectors$j.swiper, this.container);
    this.slides = t$2(selectors$j.slide, this.container);
    this.events.push(e$2(this.container, "focusin", function () {
      return _this.handleFocus();
    }));

    if (shouldAnimate(this.container)) {
      this.slideAnimations = this.slides.map(function (slide) {
        return delayOffset(slide, [selectors$j.animatableItems], 3);
      });
      this.observer = intersectionWatcher(this.container);
    }

    if (this.slides.length > 1) {
      import(flu.chunks.swiper).then(function (_ref) {
        var Swiper = _ref.Swiper,
            Navigation = _ref.Navigation,
            Autoplay = _ref.Autoplay,
            Pagination = _ref.Pagination,
            EffectFade = _ref.EffectFade,
            EffectCreative = _ref.EffectCreative;
        var swiperOptions = {
          modules: [Navigation, Pagination],
          slidesPerView: 1,
          grabCursor: true,
          effect: "fade",
          fadeEffect: {
            crossFade: false
          },
          watchSlidesProgress: true,
          loop: true,
          navigation: {
            nextEl: selectors$j.navigationNext,
            prevEl: selectors$j.navigationPrev
          },
          pagination: {
            el: selectors$j.navigationDots,
            clickable: true,
            bulletActiveClass: selectors$j.activeDot,
            bulletClass: "slideshow-navigation__dot",
            renderBullet: function renderBullet(_, className) {
              return "\n                <button class=\"".concat(className, "\" type=\"button\">\n                  <div class=\"slideshow-navigation__dot-loader\"></div>\n                </button>");
            }
          },
          on: {
            afterInit: function afterInit() {
              _this.handleBulletLabels();
            },
            slideChangeTransitionEnd: function slideChangeTransitionEnd() {
              var slideEls = this.slides;
              setTimeout(function () {
                slideEls.forEach(function (slide) {
                  slide.toggleAttribute("inert", !slide.classList.contains("swiper-slide-active"));
                });
              }, 50);
            }
          }
        };

        if (_this.enableAutoplay === "true") {
          swiperOptions.modules.push(Autoplay);
          swiperOptions.autoplay = {
            delay: _this.autoplayDuration,
            disableOnInteraction: false
          };
        }

        if (!prefersReducedMotion()) {
          swiperOptions.modules.push(EffectFade);
          swiperOptions.effect = "fade";
          swiperOptions.fadeEffect = {
            crossFade: false
          };
        } else {
          swiperOptions.modules.push(EffectCreative);
          swiperOptions.effect = "creative";
          swiperOptions.creativeEffect = {
            prev: {
              opacity: 0.99
            },
            next: {
              opacity: 1
            }
          };
        }

        _this.slideshow = new Swiper(_this.slideshowContainer, swiperOptions);
        r$1("slideshow:initialized");
      });
    }
  },
  handleFocus: function handleFocus() {
    if (a$1(document.body, "user-is-tabbing")) {
      this.slideshow.autoplay.stop();
    }
  },
  handleBulletLabels: function handleBulletLabels() {
    var _this2 = this;

    var bullets = t$2(selectors$j.navigationDot, this.container);
    bullets.forEach(function (bullet, index) {
      var associatedSlide = _this2.slides[index];
      var bulletLabel = associatedSlide.dataset.bulletLabel;
      bullet.setAttribute("aria-label", bulletLabel);
    });
  },
  handleBlockSelect: function handleBlockSelect(slideIndex) {
    this.slideshow.slideTo(parseInt(slideIndex, 10));
    this.slideshow.autoplay.stop(); // Pause all loading animations

    t$2(selectors$j.navigationLoader, this.container).forEach(function (loader) {
      loader.style.animationPlayState = "paused";
    });
  },
  handleBlockDeselect: function handleBlockDeselect() {
    var _this$slideshow;

    (_this$slideshow = this.slideshow) === null || _this$slideshow === void 0 ? void 0 : _this$slideshow.autoplay.start(); // Resume all loading animations

    t$2(selectors$j.navigationLoader, this.container).forEach(function (loader) {
      loader.style.animationPlayState = "running";
    });
  },
  onBlockSelect: function onBlockSelect(_ref2) {
    var _this3 = this;

    var target = _ref2.target;
    var slide = target.dataset.slide;

    if (this.slideshow) {
      this.handleBlockSelect(slide);
    } else {
      // Listen for initalization if slideshow does not exist
      this.events.push(c("slideshow:initialized", function () {
        _this3.handleBlockSelect(slide);
      }));
    }
  },
  onBlockDeselect: function onBlockDeselect() {
    var _this4 = this;

    if (this.slideshow) {
      this.handleBlockDeselect();
    } else {
      // Listen for initalization if slideshow does not exist
      this.events.push(c("slideshow:initialized", function () {
        _this4.handleBlockDeselect();
      }));
    }
  },
  onUnload: function onUnload() {
    var _this$slideshow2, _this$observer;

    (_this$slideshow2 = this.slideshow) === null || _this$slideshow2 === void 0 ? void 0 : _this$slideshow2.destroy();
    this.events.forEach(function (unsubscribe) {
      return unsubscribe();
    });
    (_this$observer = this.observer) === null || _this$observer === void 0 ? void 0 : _this$observer.destroy();
  }
});

var loaded$1 = null;
function loadYouTubeAPI() {
  // Loading was triggered by a previous call to function
  if (loaded$1 !== null) return loaded$1; // API has already loaded

  if (window.YT && window.YT.loaded) {
    loaded$1 = Promise.resolve();
    return loaded$1;
  } // Otherwise, load API


  loaded$1 = new Promise(function (resolve) {
    window.onYouTubeIframeAPIReady = function () {
      resolve();
    };

    var tag = document.createElement("script");
    tag.src = "https://www.youtube.com/iframe_api";
    document.body.appendChild(tag);
  });
  return loaded$1;
}

var loaded = null;
function loadVimeoAPI() {
  // Loading was triggered by a previous call to function
  if (loaded !== null) return loaded; // API has already loaded

  if (window.Vimeo) {
    loaded = Promise.resolve();
    return loaded;
  } // Otherwise, load API


  loaded = new Promise(function (resolve) {
    var tag = document.createElement("script");
    tag.src = "https://player.vimeo.com/api/player.js";
    tag.onload = resolve;
    document.body.appendChild(tag);
  });
  return loaded;
}

var selectors$i = {
  video: ".video__video",
  videoExternal: "[data-video-external-target]",
  image: ".video__image",
  overlay: ".video__overlay",
  text: ".video__text-container-wrapper",
  playTrigger: ".video__text-container-wrapper"
};
var classes$6 = {
  visible: "visible"
};
register("video", {
  onLoad: function onLoad() {
    var _this = this;

    this.events = [];
    var playTrigger = n$2(selectors$i.playTrigger, this.container);
    var video = n$2(selectors$i.video, this.container);
    var videoExternal = n$2(selectors$i.videoExternal, this.container);
    var image = n$2(selectors$i.image, this.container);
    var overlay = n$2(selectors$i.overlay, this.container);
    var text = n$2(selectors$i.text, this.container);

    if (videoExternal) {
      var _videoExternal$datase = videoExternal.dataset,
          videoProvider = _videoExternal$datase.videoProvider,
          videoId = _videoExternal$datase.videoId,
          loop = _videoExternal$datase.loop;

      switch (videoProvider) {
        case "youtube":
          loadYouTubeAPI().then(function () {
            var player = new window.YT.Player(videoExternal, {
              videoId: videoId,
              playerVars: {
                autohide: 0,
                cc_load_policy: 0,
                controls: 1,
                iv_load_policy: 3,
                modestbranding: 1,
                playsinline: 1,
                rel: 0,
                loop: loop,
                playlist: videoId
              },
              events: {
                onReady: function onReady() {
                  player.getIframe().tabIndex = "-1";

                  _this.events.push(e$2(playTrigger, "click", function () {
                    player.playVideo();
                  }));
                },
                onStateChange: function onStateChange(event) {
                  if (event.data == YT.PlayerState.PLAYING) {
                    player.getIframe().tabIndex = "0";
                    hideCover();
                  }
                }
              }
            });
          });
          break;

        case "vimeo":
          loadVimeoAPI().then(function () {
            var player = new window.Vimeo.Player(videoExternal, {
              id: videoId,
              controls: true,
              keyboard: false
            });
            player.element.tabIndex = "-1";

            if (loop === "true") {
              player.setLoop(1);
            }

            _this.events.push(e$2(playTrigger, "click", function () {
              player.play();
              player.element.tabIndex = "0";
              hideCover();
            }));
          });
          break;
      }
    }

    if (playTrigger) {
      if (video) {
        this.events.push(e$2(playTrigger, "click", function () {
          video.play();
        }));
      }
    }

    if (video) {
      this.events.push(e$2(video, "playing", function () {
        video.setAttribute("controls", "");
        hideCover();
      }));
    }

    function hideCover() {
      i$1(overlay, classes$6.visible);
      i$1(text, classes$6.visible);
      image && i$1(image, classes$6.visible);
    }

    if (shouldAnimate(this.container)) {
      this.animateVideo = animateVideo(this.container);
    }
  },
  onUnload: function onUnload() {
    var _this$animateVideo;

    this.playButtons && this.playButtons.forEach(function (button) {
      return button.unload();
    });
    this.events.forEach(function (unsubscribe) {
      return unsubscribe();
    });
    this.videoHandler && this.videoHandler();
    (_this$animateVideo = this.animateVideo) === null || _this$animateVideo === void 0 ? void 0 : _this$animateVideo.destroy();
  }
});

var selectors$h = {
  playButton: "[data-play-button-block]",
  playButtonVideoContainer: "[data-play-button-block-video-container]",
  photoSwipeElement: ".pswp",
  video: ".play-button-block-video"
};
var icons = window.theme.icons;

var playButton = function playButton(node) {
  var photoSwipeInstance;
  var playButton = n$2(selectors$h.playButton, node);
  var videoHtml = n$2(selectors$h.playButtonVideoContainer, node).outerHTML;
  import(flu.chunks.photoswipe); // Load this ahead of needing

  var events = [e$2(playButton, "click", function () {
    import(flu.chunks.photoswipe).then(function (_ref) {
      var PhotoSwipeLightbox = _ref.PhotoSwipeLightbox,
          PhotoSwipe = _ref.PhotoSwipe;
      photoSwipeInstance = new PhotoSwipeLightbox({
        dataSource: [{
          html: videoHtml
        }],
        pswpModule: PhotoSwipe,
        mainClass: "pswp--video-lightbox",
        closeSVG: icons.close,
        arrowPrev: false,
        arrowNext: false,
        zoom: false,
        counter: false
      });
      photoSwipeInstance.init();
      photoSwipeInstance.loadAndOpen();
      photoSwipeInstance.on("bindEvents", function () {
        var instanceVideo = n$2(selectors$h.video, photoSwipeInstance.pswp.container);
        instanceVideo.play();
      });
    });
  })];

  var unload = function unload() {
    events.forEach(function (unsubscribe) {
      return unsubscribe();
    });
    photoSwipeInstance && photoSwipeInstance.destroy();
  };

  return {
    unload: unload
  };
};

var autoPlay = function autoPlay(videos) {
  if (!videos.length) return;
  var events = [e$2(window, "click", function () {
    return _handleAutoPlay();
  }), e$2(window, "touchstart", function () {
    return _handleAutoPlay();
  })]; // Force autoplay after device interaction if in low power mode

  function _handleAutoPlay() {
    videos.forEach(function (video) {
      if (!video.playing) {
        video.play();
      }
    });
    events.forEach(function (unsubscribe) {
      return unsubscribe();
    });
  }
};

var selectors$g = {
  video: ".video-hero__video",
  playButtonVideo: "[data-play-button-block-video]",
  playButtonBlock: ".play-button-block"
};
register("video-hero", {
  videoHandler: null,
  onLoad: function onLoad() {
    var playButtonVideos = t$2(selectors$g.playButtonVideo, this.container);
    var video = t$2(selectors$g.video, this.container);

    if (playButtonVideos.length) {
      this.playButtons = playButtonVideos.map(function (block) {
        return playButton(block.closest(selectors$g.playButtonBlock));
      });
    }

    if (video) {
      this.videoHandler = backgroundVideoHandler(this.container);
      autoPlay(video);
    }

    if (shouldAnimate(this.container)) {
      this.animateVideoHero = animateVideoHero(this.container);
    }
  },
  onUnload: function onUnload() {
    var _this$animateVideoHer;

    this.playButtons && this.playButtons.forEach(function (button) {
      return button.unload();
    });
    this.videoHandler && this.videoHandler();
    (_this$animateVideoHer = this.animateVideoHero) === null || _this$animateVideoHer === void 0 ? void 0 : _this$animateVideoHer.destroy();
  }
});

var selectors$f = {
  dots: ".navigation-dot"
};

var navigationDots = function navigationDots(container) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var navigationDots = t$2(selectors$f.dots, container);
  var events = [];
  navigationDots.forEach(function (dot) {
    events.push(e$2(dot, "click", function (e) {
      return _handleDotClick(e);
    }));
  });

  var _handleDotClick = function _handleDotClick(e) {
    e.preventDefault();
    if (e.target.classList.contains("is-selected")) return;

    if (options.onSelect) {
      var index = parseInt(e.target.dataset.index, 10);
      options.onSelect(index);
    }
  };

  var update = function update(dotIndex) {
    if (typeof dotIndex !== "number") {
      console.debug("navigationDots#update: invalid index, ensure int is passed");
      return;
    }

    var activeClass = "is-selected";
    navigationDots.forEach(function (dot) {
      return i$1(dot, activeClass);
    });
    u$1(navigationDots[dotIndex], activeClass);
  };

  var unload = function unload() {
    events.forEach(function (unsubscribe) {
      return unsubscribe();
    });
  };

  return {
    update: update,
    unload: unload
  };
};

var selectors$e = {
  slider: "[data-slider]",
  slide: "[data-slide]",
  logoNavButton: "[logo-nav-button]"
};
register("quote", {
  onLoad: function onLoad() {
    var _this = this;

    var sliderContainer = n$2(selectors$e.slider, this.container);
    var slides = t$2(selectors$e.slide, this.container);

    if (shouldAnimate(this.container)) {
      slides.forEach(function (slide) {
        return animateQuotes(slide);
      });
      this.observer = intersectionWatcher(this.container);
    }

    if (slides.length < 2) {
      if (slides.length) u$1(slides[0], "swiper-slide-visible");
      return null;
    }

    var paginationStyle = sliderContainer.dataset.paginationStyle;
    var autoplayEnabled = sliderContainer.dataset.autoplayEnabled == "true";
    var autoplayDelay = parseInt(sliderContainer.dataset.autoplayDelay, 10);
    this.events = [];
    import(flu.chunks.swiper).then(function (_ref) {
      var Swiper = _ref.Swiper,
          Autoplay = _ref.Autoplay,
          Navigation = _ref.Navigation,
          EffectFade = _ref.EffectFade;
      _this.swiper = new Swiper(sliderContainer, {
        modules: [Navigation, Autoplay, EffectFade],
        grabCursor: true,
        effect: "fade",
        fadeEffect: {
          crossFade: true
        },
        loop: true,
        autoplay: autoplayEnabled ? {
          delay: autoplayDelay,
          disableOnInteraction: false,
          pauseOnMouseEnter: true
        } : false,
        navigation: {
          nextEl: ".slider-nav-button-next",
          prevEl: ".slider-nav-button-prev"
        }
      });

      if (paginationStyle === "dots") {
        _this.dotNavigation = navigationDots(_this.container, {
          onSelect: function onSelect(dotIndex) {
            _this.swiper.slideToLoop(dotIndex);
          }
        });
      } else if (paginationStyle === "logos") {
        _this.logoNavButtons = t$2(selectors$e.logoNavButton, _this.container);
        u$1(_this.logoNavButtons[0], "active");

        _this.logoNavButtons.forEach(function (button) {
          _this.events.push(e$2(button, "click", function (e) {
            var index = parseInt(e.currentTarget.dataset.index, 10);

            _this.swiper.slideToLoop(index);
          }));
        });
      }

      _this.swiper.on("slideChange", function () {
        var index = _this.swiper.realIndex;

        if (paginationStyle === "dots") {
          _this.dotNavigation.update(index);
        } else if (paginationStyle === "logos") {
          var activeClass = "active";

          _this.logoNavButtons.forEach(function (button) {
            return i$1(button, activeClass);
          });

          u$1(_this.logoNavButtons[index], activeClass);
        }
      });
    });
  },
  onBlockSelect: function onBlockSelect(_ref2) {
    var _this$swiper, _this$swiper$autoplay, _this$swiper2;

    var slide = _ref2.target;
    var index = parseInt(slide.dataset.index, 10);
    (_this$swiper = this.swiper) === null || _this$swiper === void 0 ? void 0 : (_this$swiper$autoplay = _this$swiper.autoplay) === null || _this$swiper$autoplay === void 0 ? void 0 : _this$swiper$autoplay.stop();
    (_this$swiper2 = this.swiper) === null || _this$swiper2 === void 0 ? void 0 : _this$swiper2.slideToLoop(index);
  },
  onBlockDeselect: function onBlockDeselect() {
    var _this$swiper3, _this$swiper3$autopla;

    (_this$swiper3 = this.swiper) === null || _this$swiper3 === void 0 ? void 0 : (_this$swiper3$autopla = _this$swiper3.autoplay) === null || _this$swiper3$autopla === void 0 ? void 0 : _this$swiper3$autopla.start();
  },
  onUnload: function onUnload() {
    var _this$swiper4, _this$dotNavigation, _this$observer;

    (_this$swiper4 = this.swiper) === null || _this$swiper4 === void 0 ? void 0 : _this$swiper4.destroy();
    (_this$dotNavigation = this.dotNavigation) === null || _this$dotNavigation === void 0 ? void 0 : _this$dotNavigation.unload();
    this.events.forEach(function (unsubscribe) {
      return unsubscribe();
    });
    (_this$observer = this.observer) === null || _this$observer === void 0 ? void 0 : _this$observer.destroy();
  }
});

var selectors$d = {
  hotspotWrappers: ".shoppable-item",
  hotspots: ".shoppable-item__hotspot",
  productCard: ".shoppable-item__product-card",
  closeButtons: "[data-shoppable-item-close]",
  mobileDrawer: ".shoppable-feature-mobile-drawer",
  desktopSliderContainer: ".shoppable-feature__secondary-content",
  slider: ".swiper",
  slide: ".swiper-slide",
  sliderPagination: ".swiper-pagination",
  sliderImages: ".product-card-mini__image img",
  imageContainer: ".shoppable__image-container",
  sliderNavPrev: ".slider-nav-button-prev",
  sliderNavNext: ".slider-nav-button-next",
  drawerBackground: ".mobile-drawer__overlay",
  drawerCloseButton: ".mobile-drawer__close",
  quickViewTrigger: "[data-quick-view-trigger]",
  wash: "[data-shoppable-wash]"
};
var classes$5 = {
  animating: "shoppable-item--animating",
  unset: "shoppable-item--position-unset",
  hidden: "hidden",
  active: "active",
  drawerActive: "active",
  pulse: "shoppable-item__hotspot--pulse"
};
var sliderTypes = {
  Desktop: "desktop",
  Mobile: "mobile"
};
register("shoppable", {
  onLoad: function onLoad() {
    var _this2 = this;

    this.imageContainer = n$2(selectors$d.imageContainer, this.container);
    this.showHotspotCards = this.container.dataset.showHotspotCards === "true";
    this.hasCarousel = this.container.dataset.hasCarousel === "true";
    this.productCards = t$2(selectors$d.productCard, this.container);
    this.hotspotContainers = t$2(selectors$d.hotspotWrappers, this.container);
    this.hotspots = t$2(selectors$d.hotspots, this.container);
    this.wash = n$2(selectors$d.wash, this.container);
    var closeButtons = t$2(selectors$d.closeButtons, this.container); // Self terminating mouseenter events

    this.hotspotEvents = this.hotspots.map(function (hotspot) {
      return {
        element: hotspot,
        event: e$2(hotspot, "mouseenter", function (e) {
          i$1(e.currentTarget.parentNode, classes$5.animating);

          _this2.hotspotEvents.find(function (o) {
            return o.element === hotspot;
          }).event();
        })
      };
    });
    this.events = [e$2(this.hotspots, "click", function (e) {
      return _this2._hotspotClickHandler(e);
    }), e$2(closeButtons, "click", function () {
      return _this2._closeAll();
    }), e$2(this.container, "keydown", function (_ref) {
      var keyCode = _ref.keyCode;
      if (keyCode === 27) _this2._closeAll();
    }), e$2(t$2(selectors$d.quickViewTrigger, this.container), "click", function (e) {
      var productUrl = e.target.dataset.productUrl;
      if (!productUrl) return;
      r$1("quick-view:open", null, {
        productUrl: productUrl
      });

      if (window.matchMedia(getMediaQuery("below-960")).matches) {
        _this2._closeDrawer();
      }
    })];
    this.breakPointHandler = atBreakpointChange(960, function () {
      _this2._closeAll();
    });

    if (this.hasCarousel) {
      this._setupDrawer();

      this._createOrRecreateSlider();

      this.mobileDrawer = n$2(selectors$d.mobileDrawer, this.container);
      this.widthWatcher = srraf(function (_ref2) {
        var vw = _ref2.vw,
            pvw = _ref2.pvw;
        var wasAboveBreakpoint = pvw >= 960,
            isAboveBreakpoint = vw >= 960;

        if (wasAboveBreakpoint !== isAboveBreakpoint) {
          _this2._createOrRecreateSlider();
        }
      });

      if (shouldAnimate(this.container)) {
        this.animateShoppableFeature = animateShoppableFeature(this.container);
      }
    } else {
      this.events.push(e$2(document, "click", function (e) {
        return _this2._clickOutsideHandler(e);
      }));
    }

    if (this.showHotspotCards) {
      // Show the first hotspot as active if showing as card and above drawer
      // showing screen width
      if (window.matchMedia(getMediaQuery("above-960")).matches && this.hotspots.length) {
        this._activateHotspot(0);
      } // Predefine product card dimensions


      this.productCards.forEach(function (card) {
        return _this2._setCardDemensions(card);
      });

      if (shouldAnimate(this.container)) {
        this.animateShoppableImage = animateShoppableImage(this.container);
      }
    }

    this._initPulseLoop();
  },
  _initPulseLoop: function _initPulseLoop() {
    var hotspots = t$2(selectors$d.hotspots, this.container);
    var pulseIndex = 0;
    this.pulseInterval = setInterval(function () {
      i$1(hotspots, classes$5.pulse);
      setTimeout(function () {
        u$1(hotspots[pulseIndex], classes$5.pulse);
        pulseIndex++;

        if (pulseIndex >= hotspots.length) {
          pulseIndex = 0;
        }
      }, 0);
    }, 3000);
  },
  _pulseLoop: function _pulseLoop() {},
  _createOrRecreateSlider: function _createOrRecreateSlider() {
    var _this3 = this;

    // This creates or recreates either a mobile or desktop slider as necessary
    var sliderType = window.matchMedia(getMediaQuery("above-960")).matches ? sliderTypes.Desktop : sliderTypes.Mobile;

    if (this.sliderType !== sliderType) {
      var _this$swiper;

      this.sliderType = sliderType;
      (_this$swiper = this.swiper) === null || _this$swiper === void 0 ? void 0 : _this$swiper.destroy();
      this.sliderInitalized = false;
      var sliderContainerSelector = sliderType === sliderTypes.Desktop ? selectors$d.desktopSliderContainer : selectors$d.mobileDrawer;
      this.sliderContainer = n$2(sliderContainerSelector, this.container);
      this.slider = n$2(selectors$d.slider, this.sliderContainer);
      this.slides = t$2(selectors$d.slide, this.sliderContainer);
      this.sliderPagination = n$2(selectors$d.sliderPagination, this.sliderContainer);
      this.sliderNavNext = n$2(selectors$d.sliderNavNext, this.sliderContainer);
      this.sliderNavPrev = n$2(selectors$d.sliderNavPrev, this.sliderContainer);
      this.sliderImages = t$2(selectors$d.sliderImages, this.sliderContainer);

      if (this.slides.length < 2) {
        return;
      }

      var _this = this;

      import(flu.chunks.swiper).then(function (_ref3) {
        var Swiper = _ref3.Swiper,
            Navigation = _ref3.Navigation,
            Pagination = _ref3.Pagination;
        _this3.swiper = new Swiper(_this3.slider, {
          modules: [Navigation, Pagination],
          grabCursor: window.matchMedia(getMediaQuery("below-960")).matches,
          slidesPerView: 1,
          watchSlidesProgress: true,
          loop: true,
          navigation: {
            nextEl: _this3.sliderNavNext,
            prevEl: _this3.sliderNavPrev
          },
          pagination: {
            el: _this3.sliderPagination,
            type: "fraction"
          },
          on: {
            sliderFirstMove: function sliderFirstMove() {
              _this.sliderHasBeenInteractedWith = true;
            },
            activeIndexChange: function activeIndexChange(swiper) {
              var index = swiper.realIndex;
              _this.sliderInitalized && _this._indicateActiveHotspot(index);
            },
            afterInit: function afterInit() {
              var _this$sliderImages;

              _this.sliderInitalized = true;
              (_this$sliderImages = _this.sliderImages) === null || _this$sliderImages === void 0 ? void 0 : _this$sliderImages.forEach(function (image) {
                return image.setAttribute("loading", "eager");
              });

              if (_this.sliderType !== sliderTypes.Mobile) {
                _this._indicateActiveHotspot(0);
              }
            },
            slideChangeTransitionEnd: function slideChangeTransitionEnd() {
              var slideEls = this.slides;
              setTimeout(function () {
                slideEls.forEach(function (slide) {
                  slide.toggleAttribute("inert", !slide.classList.contains("swiper-slide-active"));
                });
              }, 50);
            }
          }
        });
      });
    }
  },
  _indicateActiveHotspot: function _indicateActiveHotspot(index) {
    this.hotspotContainers.forEach(function (spot) {
      return i$1(spot, classes$5.active);
    });
    var dotWrapper = n$2(".shoppable-item[data-index='".concat(index, "']"), this.container);
    u$1(dotWrapper, classes$5.active);
  },
  _activateHotspot: function _activateHotspot(index) {
    var wrapper = n$2(".shoppable-item[data-index='".concat(index, "']"), this.container);
    var card = n$2(selectors$d.productCard, wrapper);
    n$2(selectors$d.hotspots, wrapper);

    if (!card) {
      if (this.swiper) {
        var isMobileSwiper = this.sliderType === sliderTypes.Mobile;
        this.swiper.slideToLoop(index, isMobileSwiper ? 0 : undefined);

        if (isMobileSwiper) {
          this._openDrawer();
        }
      } else {
        if (window.matchMedia(getMediaQuery("below-960")).matches) {
          this._openDrawer();
        }
      }

      return;
    }

    if (a$1(card, "hidden")) {
      this._closeAll();

      card.setAttribute("aria-hidden", false);

      this._setCardDemensions(card);

      i$1(card, classes$5.hidden); // When a slider is involved, updating the slider's active
      // slide will then trigger an update on the hotspot, but
      // when there is no slider involved we will do that directly

      if (!this.swiper) {
        this._indicateActiveHotspot(index);
      }

      if (window.matchMedia(getMediaQuery("below-960")).matches) {
        this._showWash();
      }
    } else {
      card.setAttribute("aria-hidden", true);
      u$1(card, classes$5.hidden);
      i$1(wrapper, classes$5.active);
    }
  },
  _setCardDemensions: function _setCardDemensions(card) {
    var cardHeight = card.offsetHeight;
    var cardWidth = card.offsetWidth;
    card.style.setProperty("--card-height", cardHeight + "px");
    card.style.setProperty("--card-width", cardWidth + "px");
  },
  _setupDrawer: function _setupDrawer() {
    var _this4 = this;

    // TODO: should this and open/close drawer functions be moved to their own file?
    var drawerBackground = n$2(selectors$d.drawerBackground, this.container);
    var drawerCloseButton = n$2(selectors$d.drawerCloseButton, this.container);
    this.events.push(e$2(drawerBackground, "click", function () {
      return _this4._closeDrawer();
    }));
    this.events.push(e$2(drawerCloseButton, "click", function () {
      return _this4._closeDrawer();
    }));
  },
  _openDrawer: function _openDrawer() {
    u$1(this.mobileDrawer, classes$5.drawerActive);
    document.body.setAttribute("data-fluorescent-overlay-open", "true");
    disableBodyScroll(this.mobileDrawer);

    this._showWash();
  },
  _showWash: function _showWash() {
    u$1(this.wash, classes$5.active);
  },
  _closeDrawer: function _closeDrawer() {
    if (this.mobileDrawer) {
      i$1(this.mobileDrawer, classes$5.drawerActive);
      document.body.setAttribute("data-fluorescent-overlay-open", "false");
      enableBodyScroll(this.mobileDrawer);
    }

    this._closeAll();
  },
  _hotspotClickHandler: function _hotspotClickHandler(e) {
    var wrapper = e.currentTarget.parentNode.parentNode;
    var hotspotIndex = parseInt(wrapper.dataset.index, 10);

    this._activateHotspot(hotspotIndex);
  },
  _clickOutsideHandler: function _clickOutsideHandler(e) {
    if (!e.target.closest(selectors$d.productCard) && !a$1(e.target, "shoppable-item__hotspot")) {
      this._closeAll();
    }
  },
  _closeAll: function _closeAll() {
    this.productCards.forEach(function (card) {
      u$1(card, classes$5.hidden);
      card.setAttribute("aria-hidden", true);
    });
    this.hotspotContainers.forEach(function (spot) {
      return i$1(spot, classes$5.active);
    });
    i$1(this.wash, classes$5.active);
  },
  onBlockDeselect: function onBlockDeselect() {
    this._closeAll();
  },
  onBlockSelect: function onBlockSelect(_ref4) {
    var el = _ref4.target;
    var index = parseInt(el.dataset.index, 10);

    if (this.swiper) {
      this.swiper.slideToLoop(index);
    } else {
      this._activateHotspot(index);
    }
  },
  onUnload: function onUnload() {
    var _this$swiper2, _this$widthWatcher, _this$animateShoppabl, _this$animateShoppabl2;

    (_this$swiper2 = this.swiper) === null || _this$swiper2 === void 0 ? void 0 : _this$swiper2.destroy();
    (_this$widthWatcher = this.widthWatcher) === null || _this$widthWatcher === void 0 ? void 0 : _this$widthWatcher.destroy();
    this.events.forEach(function (unsubscribe) {
      return unsubscribe();
    });
    (_this$animateShoppabl = this.animateShoppableImage) === null || _this$animateShoppabl === void 0 ? void 0 : _this$animateShoppabl.destroy();
    (_this$animateShoppabl2 = this.animateShoppableFeature) === null || _this$animateShoppabl2 === void 0 ? void 0 : _this$animateShoppabl2.destroy();
    this.pulseInterval && clearInterval(this.pulseInterval);
  }
});

var selectors$c = {
  video: "video",
  quickViewTrigger: "[data-quick-view-trigger]"
};
register("complete-the-look", {
  videoHandler: null,
  onLoad: function onLoad() {
    var video = n$2(selectors$c.video, this.container);

    if (video) {
      this.videoHandler = backgroundVideoHandler(this.container);
    }

    this.events = [e$2(t$2(selectors$c.quickViewTrigger, this.container), "click", function (e) {
      var productUrl = e.target.dataset.productUrl;
      if (!productUrl) return;
      r$1("quick-view:open", null, {
        productUrl: productUrl
      });
    })];

    if (shouldAnimate(this.container)) {
      this.animateCompleteTheLook = animateCompleteTheLook(this.container);
    }
  },
  onUnload: function onUnload() {
    var _this$animateComplete;

    this.videoHandler && this.videoHandler();
    this.events.forEach(function (unsubscribe) {
      return unsubscribe();
    });
    (_this$animateComplete = this.animateCompleteTheLook) === null || _this$animateComplete === void 0 ? void 0 : _this$animateComplete.destroy();
  }
});

var selectors$b = {
  playButtonVideo: "[data-play-button-block-video]",
  playButtonBlock: ".play-button-block"
};
register("rich-text", {
  onLoad: function onLoad() {
    var playButtonVideos = t$2(selectors$b.playButtonVideo, this.container);

    if (playButtonVideos.length) {
      this.playButtons = playButtonVideos.map(function (block) {
        return playButton(block.closest(selectors$b.playButtonBlock));
      });
    }

    if (shouldAnimate(this.container)) {
      this.animateRichText = animateRichText(this.container);
    }
  },
  onUnload: function onUnload() {
    var _this$animateRichText;

    this.playButtons && this.playButtons.forEach(function (button) {
      return button.unload();
    });
    (_this$animateRichText = this.animateRichText) === null || _this$animateRichText === void 0 ? void 0 : _this$animateRichText.destroy();
  }
});

var selectors$a = {
  imageContainer: ".image-compare__image-container",
  labelContainer: ".image-compare__label-container",
  slider: ".image-compare__slider"
};
register("image-compare", {
  onLoad: function onLoad() {
    this.events = [];

    this._initSliders();

    if (shouldAnimate(this.container)) {
      this.animateImageCompare = animateImageCompare(this.container);
    }
  },
  _initSliders: function _initSliders() {
    var _this = this;

    this.imageContainer = n$2(selectors$a.imageContainer, this.container);
    this.labelContainers = t$2(selectors$a.labelContainer, this.container);
    this.slider = n$2(selectors$a.slider, this.container); // Check if slider exists (must be some blocks to exist)

    this.slider && this.events.push(e$2(this.slider, "input", function (e) {
      return _this.imageContainer.style.setProperty("--position", "".concat(e.target.value, "%"));
    }), e$2(this.slider, "mousedown", function () {
      return _this.hideLabelContainers();
    }), e$2(this.slider, "touchstart", function () {
      return _this.hideLabelContainers();
    }), e$2(this.slider, "mouseup", function () {
      return _this.showLabelContainers();
    }), e$2(this.slider, "touchend", function () {
      return _this.showLabelContainers();
    }));
  },
  hideLabelContainers: function hideLabelContainers() {
    this.labelContainers.forEach(function (e) {
      e.style.setProperty("opacity", "0");
    });
  },
  showLabelContainers: function showLabelContainers() {
    this.labelContainers.forEach(function (e) {
      e.style.setProperty("opacity", "1");
    });
  },
  onUnload: function onUnload() {
    var _this$animateImageCom;

    this.events.forEach(function (unsubscribe) {
      return unsubscribe();
    });
    (_this$animateImageCom = this.animateImageCompare) === null || _this$animateImageCom === void 0 ? void 0 : _this$animateImageCom.destroy();
  }
});

var selectors$9 = {
  playButtonVideo: "[data-play-button-block-video]",
  playButtonBlock: ".play-button-block"
};
register("image-with-text", {
  onLoad: function onLoad() {
    if (shouldAnimate(this.container)) {
      this.animateImageWithText = animateImageWithText(this.container);
    }

    var playButtonVideos = t$2(selectors$9.playButtonVideo, this.container);

    if (playButtonVideos.length) {
      this.playButtons = playButtonVideos.map(function (block) {
        return playButton(block.closest(selectors$9.playButtonBlock));
      });
    }
  },
  onUnload: function onUnload() {
    var _this$animateImageWit;

    (_this$animateImageWit = this.animateImageWithText) === null || _this$animateImageWit === void 0 ? void 0 : _this$animateImageWit.destroy();
    this.playButtons && this.playButtons.forEach(function (button) {
      return button.unload();
    });
  }
});

var selectors$8 = {
  playButtonVideo: "[data-play-button-block-video]",
  playButtonBlock: ".play-button-block"
};
register("image-with-text-split", {
  onLoad: function onLoad() {
    var playButtonVideos = t$2(selectors$8.playButtonVideo, this.container);

    if (playButtonVideos.length) {
      this.playButtons = playButtonVideos.map(function (block) {
        return playButton(block.closest(selectors$8.playButtonBlock));
      });
    }

    if (shouldAnimate(this.container)) {
      this.animateImageWithTextSplit = animateImageWithTextSplit(this.container);
    }
  },
  onUnload: function onUnload() {
    var _this$animateImageWit;

    this.playButtons && this.playButtons.forEach(function (button) {
      return button.unload();
    });
    (_this$animateImageWit = this.animateImageWithTextSplit) === null || _this$animateImageWit === void 0 ? void 0 : _this$animateImageWit.destroy();
  }
});

var selectors$7 = {
  playButtonVideo: "[data-play-button-block-video]",
  playButtonBlock: ".play-button-block"
};
register("image-hero", {
  onLoad: function onLoad() {
    var playButtonVideos = t$2(selectors$7.playButtonVideo, this.container);

    if (playButtonVideos.length) {
      this.playButtons = playButtonVideos.map(function (block) {
        return playButton(block.closest(selectors$7.playButtonBlock));
      });
    }

    if (shouldAnimate(this.container)) {
      this.animateImageHero = animateImageHero(this.container);
    }
  },
  onUnload: function onUnload() {
    var _this$animateImageHer;

    this.playButtons && this.playButtons.forEach(function (button) {
      return button.unload();
    });
    (_this$animateImageHer = this.animateImageHero) === null || _this$animateImageHer === void 0 ? void 0 : _this$animateImageHer.destroy();
  }
});

register("image-hero-split", {
  onLoad: function onLoad() {
    if (shouldAnimate(this.container)) {
      // Setup animations per item
      t$2(".animation--item", this.container).forEach(function (item) {
        return animateImageHeroSplit(item);
      });
    }

    this.observer = intersectionWatcher(this.container);
  },
  onUnload: function onUnload() {
    var _this$observer;

    this.playButtons && this.playButtons.forEach(function (button) {
      return button.unload();
    });
    (_this$observer = this.observer) === null || _this$observer === void 0 ? void 0 : _this$observer.destroy();
  }
});

var selectors$6 = {
  item: ".testimonials__item",
  swiper: ".swiper",
  navigationNext: ".testimonials__navigation-button--next",
  navigationPrev: ".testimonials__navigation-button--prev",
  productImage: ".testimonials__item-product-image"
};
register("testimonials", {
  onLoad: function onLoad() {
    var _this = this;

    this.events = [];
    this.items = t$2(selectors$6.item, this.container);
    this.itemsContainer = n$2(selectors$6.swiper, this.container);

    if (shouldAnimate(this.container)) {
      this.itemAnimations = this.items.map(function (item) {
        return animateTestimonials(item);
      });
      this.observer = intersectionWatcher(this.container);
    }

    if (this.items.length > 1) {
      import(flu.chunks.swiper).then(function (_ref) {
        var Swiper = _ref.Swiper,
            Navigation = _ref.Navigation,
            EffectFade = _ref.EffectFade;
        var swiperOptions = {
          modules: [Navigation, EffectFade],
          autoHeight: true,
          slidesPerView: 1,
          effect: "fade",
          loop: true,
          fadeEffect: {
            crossFade: true
          },
          grabCursor: true,
          navigation: {
            nextEl: selectors$6.navigationNext,
            prevEl: selectors$6.navigationPrev
          },
          breakpoints: {
            720: {
              spaceBetween: 42
            }
          },
          on: {
            slideChangeTransitionEnd: function slideChangeTransitionEnd() {
              var slideEls = this.slides;
              setTimeout(function () {
                slideEls.forEach(function (slide) {
                  slide.toggleAttribute("inert", !slide.classList.contains("swiper-slide-active"));
                });
              }, 50);
            }
          }
        }; // We use fade for desktop size animatiosn and slide for under
        // 720px

        if (window.matchMedia(getMediaQuery("below-720")).matches) {
          swiperOptions.effect = "slide";
          swiperOptions.slidesPerView = "auto";
        }

        _this.carousel = new Swiper(_this.itemsContainer, swiperOptions);

        _this.setMobileButtonOffset();

        r$1("testimonials:initialized");
      });
    } else if (this.items.length === 1) {
      u$1(this.items[0], "swiper-slide-visible");
    }
  },
  setMobileButtonOffset: function setMobileButtonOffset() {
    // Mobile paddles should vertically center on the image instead of the item
    var firstImage = n$2(selectors$6.productImage, this.container);
    var mobileButtonHeight = 34;
    var halfMobileButtonHeight = mobileButtonHeight / 2;
    var halfImageHeight = firstImage.offsetHeight / 2;
    var offset = halfImageHeight + halfMobileButtonHeight;
    this.container.style.setProperty("--mobile-button-offset", "".concat(offset, "px"));
  },
  handleBlockSelect: function handleBlockSelect(slideIndex) {
    this.carousel.slideToLoop(parseInt(slideIndex, 10));
  },
  onBlockSelect: function onBlockSelect(_ref2) {
    var _this2 = this;

    var target = _ref2.target;
    var index = target.dataset.index;

    if (this.carousel) {
      this.handleBlockSelect(index);
    } else {
      // Listen for initalization if carousel does not exist
      this.events.push(c("testimonials:initialized", function () {
        _this2.handleBlockSelect(index);
      }));
    }
  },
  onUnload: function onUnload() {
    var _this$observer;

    this.events.forEach(function (unsubscribe) {
      return unsubscribe();
    });
    (_this$observer = this.observer) === null || _this$observer === void 0 ? void 0 : _this$observer.destroy();
  }
});

register("sales-banner", {
  onLoad: function onLoad() {
    if (shouldAnimate(this.container)) {
      this.animateSalesBanner = animateSalesBanner(this.container);
    }
  },
  onUnload: function onUnload() {
    var _this$animateSalesBan;

    (_this$animateSalesBan = this.animateSalesBanner) === null || _this$animateSalesBan === void 0 ? void 0 : _this$animateSalesBan.destroy();
  }
});

register("promotion-bar", {
  onLoad: function onLoad() {
    if (shouldAnimate(this.container)) {
      this.animatePromotionBar = animatePromotionBar(this.container);
    }
  },
  onUnload: function onUnload() {
    var _this$animatePromotio;

    (_this$animatePromotio = this.animatePromotionBar) === null || _this$animatePromotio === void 0 ? void 0 : _this$animatePromotio.destroy();
  }
});

register("grid", {
  onLoad: function onLoad() {
    if (shouldAnimate(this.container)) {
      this.animateGrid = animateGrid(this.container);
    }
  },
  onUnload: function onUnload() {
    var _this$animateGrid;

    (_this$animateGrid = this.animateGrid) === null || _this$animateGrid === void 0 ? void 0 : _this$animateGrid.destroy();
  }
});

register("collection-list-grid", {
  onLoad: function onLoad() {
    if (shouldAnimate(this.container)) {
      this.animateCollectionListGrid = animateCollectionListGrid(this.container);
    }
  },
  onUnload: function onUnload() {
    var _this$animateCollecti;

    (_this$animateCollecti = this.animateCollectionListGrid) === null || _this$animateCollecti === void 0 ? void 0 : _this$animateCollecti.destroy();
  }
});

register("contact-form", {
  onLoad: function onLoad() {
    if (shouldAnimate(this.container)) {
      this.animateContactForm = animateContactForm(this.container);
    }
  },
  onUnload: function onUnload() {
    var _this$animateContactF;

    (_this$animateContactF = this.animateContactForm) === null || _this$animateContactF === void 0 ? void 0 : _this$animateContactF.destroy();
  }
});

register("multi-column", {
  onLoad: function onLoad() {
    if (shouldAnimate(this.container)) {
      this.animateMultiColumn = animateMultiColumn(this.container);
    }
  },
  onUnload: function onUnload() {
    var _this$animateMultiCol;

    (_this$animateMultiCol = this.animateMultiColumn) === null || _this$animateMultiCol === void 0 ? void 0 : _this$animateMultiCol.destroy();
  }
});

register("newsletter", {
  onLoad: function onLoad() {
    if (shouldAnimate(this.container)) {
      this.animateNewsletter = animateNewsletter(this.container);
    }
  },
  onUnload: function onUnload() {
    var _this$animateNewslett;

    (_this$animateNewslett = this.animateNewsletter) === null || _this$animateNewslett === void 0 ? void 0 : _this$animateNewslett.destroy();
  }
});

register("newsletter-compact", {
  onLoad: function onLoad() {
    if (shouldAnimate(this.container)) {
      this.animateNewsletterCompact = animateNewsletterCompact(this.container);
    }
  },
  onUnload: function onUnload() {
    var _this$animateNewslett;

    (_this$animateNewslett = this.animateNewsletterCompact) === null || _this$animateNewslett === void 0 ? void 0 : _this$animateNewslett.destroy();
  }
});

var selectors$5 = {
  listContainer: "[data-events-eventbrite-container]",
  skeletonList: ".events__list--skeleton"
};
var endpoints = {
  org: function org(token) {
    return "https://www.eventbriteapi.com//v3/users/me/organizations/?token=".concat(token);
  },
  events: function events(id, token) {
    return "https://www.eventbriteapi.com//v3/organizations/".concat(id, "/events/?token=").concat(token, "&expand=venue&status=live");
  }
};
register("events", {
  onLoad: function onLoad() {
    this.accessToken = this.container.dataset.accessToken;
    this.eventCount = parseInt(this.container.dataset.eventCount, 10);
    this.imageAspectRatio = this.container.dataset.imageAspectRatio;
    this.learnMoreText = this.container.dataset.learnMoreText;

    this._fetchOrg();

    if (shouldAnimate(this.container)) {
      this.animateEvents = animateEvents(this.container);
      if (!this.accessToken) this.animateEvents.animateEventItems();
    }
  },

  /**
   * _fetchOrg gets the eventbrite organization data for this user
   */
  _fetchOrg: function _fetchOrg() {
    var _this = this;

    if (!this.accessToken) return;
    fetch(endpoints.org(this.accessToken)).then(function (res) {
      return res.json();
    }).then(function (res) {
      _this._fetchEvents(res.organizations[0].id);
    });
  },

  /**
   * _fetchEvents gets the eventbrite events for this user
   * @param {number} id organization id
   */
  _fetchEvents: function _fetchEvents(id) {
    var _this2 = this;

    if (!id) return;
    fetch(endpoints.events(id, this.accessToken)).then(function (res) {
      return res.json();
    }).then(function (events) {
      _this2._renderEvents(events.events);
    });
  },

  /**
   * _renderEvents adds the event elements on the page
   * @param {array} events array of event objects
   */
  _renderEvents: function _renderEvents(events) {
    var _this3 = this;

    var listContainer = n$2(selectors$5.listContainer, this.container);
    var skeletonList = n$2(selectors$5.skeletonList, this.container); // Build a list of events

    var list = document.createElement("ul");
    list.className = "events__list";
    events.slice(0, this.eventCount).forEach(function (event) {
      list.innerHTML += _this3._renderEventItem(event);
    }); // Append the list to the container on the page

    u$1(skeletonList, "hide");
    setTimeout(function () {
      listContainer.textContent = "";
      listContainer.appendChild(list);

      if (shouldAnimate(_this3.container)) {
        _this3.animateEvents.animateEventItems();
      }
    }, 300);
  },

  /**
   * _renderEventItem builds the html needed for an event item with the event data
   * @param {obj} event the event data
   * @returns eventItem
   */
  _renderEventItem: function _renderEventItem(event) {
    var _event$logo;

    var eventItem = "\n      <li\n        class=\"\n          event-item\n          event-item--eventbrite\n          ".concat((_event$logo = event.logo) !== null && _event$logo !== void 0 && _event$logo.url ? "event-item--has-image" : "", "\n        \"\n      >\n        <a href=\"").concat(event.url, "\" class=\"event-item__link\">\n          <div class=\"event-item__image-wrapper\">\n            ").concat(this._renderImage(event), "\n            ").concat(this._renderDateBadge(event), "\n          </div>\n          <div class=\"event-item__details\">\n            ").concat(this._renderName(event), "\n            ").concat(this._renderDate(event), "\n            ").concat(this._renderVenue(event), "\n            ").concat(this._renderSummary(event), "\n            <span class=\"btn btn--callout event-item__callout\">\n              <span>").concat(this.learnMoreText, "</span>\n            </span>\n          </div>\n        </a>\n      </li>\n    ");
    return eventItem;
  },
  _renderImage: function _renderImage(event) {
    var _event$logo2;

    var image = "";

    if ((_event$logo2 = event.logo) !== null && _event$logo2 !== void 0 && _event$logo2.url) {
      image = "\n        <div class=\"image ".concat(this.imageAspectRatio, " event-item__image image--animate animation--lazy-load\">\n          <div class=\"image__inner\">\n            <img\n              src=\"").concat(event.logo.url, "\"\n              alt=\"").concat(event.name.text, "\"\n              loading=\"lazy\"\n              class=\"image__img\"\n              onload=\"javascript: this.closest('.image').classList.add('loaded')\"\n            >\n          </div>\n        </div>\n      ");
    }

    return image;
  },
  _renderDateBadge: function _renderDateBadge(event) {
    var _event$start;

    var html = "";

    if ((_event$start = event.start) !== null && _event$start !== void 0 && _event$start.local) {
      var date = new Date(event.start.local);
      html = "\n        <span class=\"event-item__date-badge\">\n          <span class=\"event-item__date-badge-day fs-body-bold fs-body-200\">\n            ".concat(new Intl.DateTimeFormat([], {
        day: "numeric"
      }).format(date), "\n          </span>\n          <span class=\"event-item__date-badge-month fs-accent\">\n            ").concat(new Intl.DateTimeFormat([], {
        month: "short"
      }).format(date), "\n          </span>\n        </span>\n      ");
    }

    return html;
  },
  _renderName: function _renderName(event) {
    var _event$name;

    var html = "";

    if ((_event$name = event.name) !== null && _event$name !== void 0 && _event$name.text) {
      html = "\n        <h4 class=\"event-item__name ff-heading fs-heading-5-base\">\n          ".concat(event.name.text, "\n        </h4>\n      ");
    }

    return html;
  },
  _renderDate: function _renderDate(event) {
    var _event$start2;

    var html = "";

    if ((_event$start2 = event.start) !== null && _event$start2 !== void 0 && _event$start2.local) {
      var date = new Date(event.start.local);
      html = "\n        <p class=\"event-item__date fs-body-75\">\n          ".concat(date.toLocaleDateString([], {
        weekday: "short",
        year: "numeric",
        month: "short",
        day: "numeric"
      }), "\n          ").concat(date.toLocaleTimeString([], {
        timeZone: event.start.timezone,
        hour: "numeric",
        minute: "2-digit"
      }), "\n        </p>\n      ");
    }

    return html;
  },
  _renderVenue: function _renderVenue(event) {
    var _event$venue;

    var html = "";

    if ((_event$venue = event.venue) !== null && _event$venue !== void 0 && _event$venue.name) {
      html = "\n        <p class=\"event-item__venue fs-body-75\">\n          ".concat(event.venue.name, "\n        </p>\n      ");
    }

    return html;
  },
  _renderSummary: function _renderSummary(event) {
    var html = "";

    if (event.summary) {
      html = "\n        <p class=\"event-item__summary\">\n          ".concat(event.summary, "\n        </p>\n      ");
    }

    return html;
  },
  onUnload: function onUnload() {
    var _this$animateEvents;

    (_this$animateEvents = this.animateEvents) === null || _this$animateEvents === void 0 ? void 0 : _this$animateEvents.destroy();
  }
});

register("promo-banner", {
  onLoad: function onLoad() {
    if (shouldAnimate(this.container)) {
      this.animatePromoBanner = animatePromoBanner(this.container);
    }
  },
  onUnload: function onUnload() {
    var _this$animatePromoBan;

    (_this$animatePromoBan = this.animatePromoBanner) === null || _this$animatePromoBan === void 0 ? void 0 : _this$animatePromoBan.destroy();
  }
});

var selectors$4 = {
  tabLabels: "[data-tab-label]",
  tabItems: "[data-tab-item]",
  tabList: "[data-tab-list]",
  activeTabItem: "[data-tab-item][aria-hidden='false']"
};
register("product-tabs", {
  onLoad: function onLoad() {
    var _this = this;

    this.accordions = [];
    this.tabItems = t$2(selectors$4.tabItems, this.container);
    this.tabLabels = t$2(selectors$4.tabLabels, this.container);
    this.tabList = n$2(selectors$4.tabList, this.container);
    this.activeTabItem = n$2(selectors$4.activeTabItem, this.container);

    if (this.activeTabItem) {
      this._setTabHeight(this.activeTabItem);
    }

    this.clickHandlers = e$2(this.tabLabels, "click", function (e) {
      e.preventDefault();
      var contentID = e.currentTarget.getAttribute("aria-controls");
      var content = n$2("#".concat(contentID), _this.container);

      _this._closeAll();

      _this._open(e.currentTarget, content);
    });
    var accordionElements = t$2(".accordion", this.container);
    accordionElements.forEach(function (accordion) {
      var accordionOpen = accordion.classList.contains("accordion--open");

      _this.accordions.push(Accordions(accordion, {
        firstOpen: accordionOpen
      }));

      accordion.classList.add("rte--product", "accordion--product");
    });

    if (shouldAnimate(this.container)) {
      this.animateProductTabs = animateProductTabs(this.container);
    }
  },
  _closeAll: function _closeAll() {
    var _this2 = this;

    this.tabLabels.forEach(function (label) {
      var contentID = label.getAttribute("aria-controls");
      var content = n$2("#".concat(contentID), _this2.container);

      if (_this2._isVisible(content)) {
        _this2._close(label, content);
      }
    });
  },
  _open: function _open(label, content) {
    label.setAttribute("aria-expanded", true);
    content.setAttribute("aria-hidden", false);

    this._setTabHeight(content);
  },
  _close: function _close(label, content) {
    label.setAttribute("aria-expanded", false);
    content.setAttribute("aria-hidden", true);
  },
  _isVisible: function _isVisible(content) {
    return content.getAttribute("aria-hidden") === "false";
  },
  _setTabHeight: function _setTabHeight(content) {
    var height = content.offsetHeight;
    this.tabList.style.height = "".concat(height, "px");
  },
  onBlockSelect: function onBlockSelect(_ref) {
    var target = _ref.target;
    var contentID = target.getAttribute("aria-controls");
    var content = n$2("#".concat(contentID), this.container);

    this._closeAll();

    this._open(target, content);
  },
  onUnload: function onUnload() {
    var _this$animateProductT;

    this.clickHandlers();
    this.accordions.forEach(function (accordion) {
      return accordion.unload();
    });
    (_this$animateProductT = this.animateProductTabs) === null || _this$animateProductT === void 0 ? void 0 : _this$animateProductT.destroy();
  }
});

register("apps", {
  onLoad: function onLoad() {
    if (shouldAnimate(this.container)) {
      this.animateApps = animateApps(this.container);
    }
  },
  onUnload: function onUnload() {
    var _this$animateApps;

    (_this$animateApps = this.animateApps) === null || _this$animateApps === void 0 ? void 0 : _this$animateApps.destroy();
  }
});

var selectors$3 = {
  cartError: ".cart__form-item-error",
  cartNoteTrigger: "[data-order-note-trigger]",
  cartUpdateButton: ".cart__update",
  quantityInput: ".cart .quantity-input__input",
  quantityItem: "[data-input-item]",
  freeShippingBar: "[data-free-shipping-bar]",
  crossSells: "[data-cross-sells]"
};
var classes$4 = {
  updatingQuantity: "has-quantity-update",
  removed: "is-removed"
};
register("cart", {
  onLoad: function onLoad() {
    var _this = this;

    var cartNoteTrigger = n$2(selectors$3.cartNoteTrigger, this.container);
    var freeShippingBar$1 = n$2(selectors$3.freeShippingBar, this.container);

    if (freeShippingBar$1) {
      freeShippingBar(freeShippingBar$1);
    }

    this._initCrossSells();

    if (cartNoteTrigger) this.cartNoteToggle = CartNoteToggle(this.container);
    this.quantityButtons = QuantityButtons(this.container); // Events are all on events trigger by other components / functions

    this.events = [c("cart:updated", function () {
      return _this.refreshCart();
    }), c("cart:error", function (_, _ref) {
      var key = _ref.key,
          errorMessage = _ref.errorMessage;

      _this.handleErrorMessage(key, errorMessage);
    }), c(["quantity-update:subtract", "quantity-update:add"], function (_, _ref2) {
      var key = _ref2.key;

      _this.handleQuantityUpdate(key);
    }), c("quantity-update:remove", function (_, _ref3) {
      var key = _ref3.key;

      _this.handleItemRemoval(key);
    })]; // Delegate handles all click events due to rendering different content
    // within cart

    this.delegate = new Delegate(this.container);
    this.delegate.on("change", selectors$3.quantityInput, function (e) {
      return _this.handleQuantityInputChange(e);
    });
  },
  refreshCart: function refreshCart() {
    var _this2 = this;

    var url = "".concat(theme.routes.cart.base, "?section_id=main-cart");
    makeRequest("GET", url).then(function (response) {
      var _window$Shopify;

      var container = document.createElement("div");
      container.innerHTML = response;
      _this2.container.innerHTML = container.innerHTML;

      if ((_window$Shopify = window.Shopify) !== null && _window$Shopify !== void 0 && _window$Shopify.StorefrontExpressButtons) {
        window.Shopify.StorefrontExpressButtons.initialize();
      }

      var freeShippingBar$1 = n$2(selectors$3.freeShippingBar, _this2.container);

      if (freeShippingBar$1) {
        freeShippingBar(freeShippingBar$1);
      }

      _this2._initCrossSells();
    });
  },
  handleErrorMessage: function handleErrorMessage(key) {
    var item = n$2("[data-key=\"".concat(key, "\"]"), this.container);
    
    if(item){
      i$1(n$2(selectors$3.cartError, item), "hidden");
      i$1(item, classes$4.updatingQuantity);
    }
  },
  handleQuantityInputChange: function handleQuantityInputChange(_ref4) {
    var target = _ref4.target;
    var item = target.closest(selectors$3.quantityItem);
    var key = item.dataset.key;
    cart.updateItem(key, target.value);
    this.handleQuantityUpdate(key);
  },
  handleQuantityUpdate: function handleQuantityUpdate(key) {
    var item = n$2("[data-key=\"".concat(key, "\"]"), this.container);
    if(item) u$1(item, classes$4.updatingQuantity);
  },
  handleItemRemoval: function handleItemRemoval(key) {
    var item = n$2("[data-key=\"".concat(key, "\"]"), this.container);
    if(item){
      u$1(item, classes$4.removed);
      u$1(item, classes$4.updatingQuantity);
    }
  },
  _initCrossSells: function _initCrossSells() {
    var crossSells = n$2(selectors$3.crossSells, this.container);

    if (crossSells) {
      this.crossSells = CrossSells(crossSells);
    }
  },
  onUnload: function onUnload() {
    var _this$cartNoteToggle;

    this.events.forEach(function (unsubscribe) {
      return unsubscribe();
    });
    this.quantityButtons.unload();
    (_this$cartNoteToggle = this.cartNoteToggle) === null || _this$cartNoteToggle === void 0 ? void 0 : _this$cartNoteToggle.unload();
  }
});

register("product", {
  onLoad: function onLoad() {
    this.product = new Product(this.container);
    this.animateProduct = animateProduct(this.container);
  },
  onBlockSelect: function onBlockSelect(_ref) {
    var target = _ref.target;
    var label = n$2(".accordion__label", target);
    target.scrollIntoView({
      block: "center",
      behavior: "smooth"
    });
    if (!label) return;
    var group = label.parentNode,
        content = label.nextElementSibling;
    slideStop(content);
    slideDown(content);
    group.setAttribute("data-open", true);
    label.setAttribute("aria-expanded", true);
    content.setAttribute("aria-hidden", false);
  },
  onBlockDeselect: function onBlockDeselect(_ref2) {
    var target = _ref2.target;
    var label = n$2(".accordion__label", target);
    if (!label) return;
    var group = label.parentNode,
        content = label.nextElementSibling;
    slideStop(content);
    slideUp(content);
    group.setAttribute("data-open", false);
    label.setAttribute("aria-expanded", false);
    content.setAttribute("aria-hidden", true);
  },
  onUnload: function onUnload() {
    var _this$animateProduct;

    this.product.unload();
    (_this$animateProduct = this.animateProduct) === null || _this$animateProduct === void 0 ? void 0 : _this$animateProduct.destroy();
  }
});

var filtering = function filtering(container) {
  var forms = t$2("[data-filter-form]", container);
  var formData, searchParams;
  setParams();

  function setParams(form) {
    form = form || forms[0];
    formData = new FormData(form);
    searchParams = new URLSearchParams(formData).toString();
  }
  /**
   * Takes the updated form element and updates all other forms with the updated values
   * @param {*} target
   */


  function syncForms(target) {
    if (!target) return;
    var targetInputs = t$2("[data-filter-item-input]", target);
    targetInputs.forEach(function (targetInput) {
      if (targetInput.type === "checkbox" || targetInput.type === "radio") {
        var valueEscaped = targetInput.dataset.valueEscaped;
        var items = t$2("input[name='".concat(targetInput.name, "'][data-value-escaped='").concat(valueEscaped, "']"));
        items.forEach(function (input) {
          input.checked = targetInput.checked;
        });
      } else {
        var _items = t$2("input[name='".concat(targetInput.name, "']"));

        _items.forEach(function (input) {
          input.value = targetInput.value;
        });
      }
    });
  }
  /**
   * When filters are removed, set the checked attribute to false
   * for all filter inputs for that filter.
   * Can accept multiple filters
   * @param {Array} targets Array of inputs
   */


  function uncheckFilters(targets) {
    if (!targets) return;
    var selector;
    targets.forEach(function (target) {
      selector = !selector ? "" : ", ".concat(selector);
      var _target$dataset = target.dataset,
          name = _target$dataset.name,
          valueEscaped = _target$dataset.valueEscaped;
      selector = "input[name='".concat(name, "'][data-value-escaped='").concat(valueEscaped, "']").concat(selector);
    });
    var inputs = t$2(selector, container);
    inputs.forEach(function (input) {
      input.checked = false;
    });
  }

  function clearRangeInputs() {
    var rangeInputs = t$2("[data-range-input]", container);
    rangeInputs.forEach(function (input) {
      input.value = "";
    });
  }

  function resetForms() {
    forms.forEach(function (form) {
      form.reset();
    });
  }

  return {
    getState: function getState() {
      return {
        url: searchParams
      };
    },
    filtersUpdated: function filtersUpdated(target, cb) {
      syncForms(target);
      setParams(target);
      r$1("filters:updated");
      return cb(this.getState());
    },
    removeFilters: function removeFilters(target, cb) {
      uncheckFilters(target);
      setParams();
      r$1("filters:filter-removed");
      return cb(this.getState());
    },
    removeRange: function removeRange(cb) {
      clearRangeInputs();
      setParams();
      return cb(this.getState());
    },
    clearAll: function clearAll(cb) {
      searchParams = "";
      resetForms();
      return cb(this.getState());
    }
  };
};

var FILTERS_REMOVE = "collection:filters:remove";
var RANGE_REMOVE = "collection:range:remove";
var EVERYTHING_CLEAR = "collection:clear";
var FILTERS_UPDATE = "collection:filters:update";
var updateFilters = function updateFilters(target) {
  return r$1(FILTERS_UPDATE, null, {
    target: target
  });
};
var removeFilters = function removeFilters(target) {
  return r$1(FILTERS_REMOVE, null, {
    target: target
  });
};
var filtersUpdated = function filtersUpdated(cb) {
  return c(FILTERS_UPDATE, cb);
};
var filtersRemoved = function filtersRemoved(cb) {
  return c(FILTERS_REMOVE, cb);
};
var everythingCleared = function everythingCleared(cb) {
  return c(EVERYTHING_CLEAR, cb);
};
var rangeRemoved = function rangeRemoved(cb) {
  return c(RANGE_REMOVE, cb);
};

var filterHandler = function filterHandler(_ref) {
  var container = _ref.container,
      renderCB = _ref.renderCB;
  var subscriptions = null;
  var filters = null;
  var delegate = null;
  filters = filtering(container); // Set initial evx state from collection url object

  o$1(filters.getState());
  subscriptions = [filtersRemoved(function (_, _ref2) {
    var target = _ref2.target;
    filters.removeFilters(target, function (data) {
      renderCB(data.url);
      o$1(data)();
    });
  }), rangeRemoved(function () {
    filters.removeRange(function (data) {
      renderCB(data.url);
      o$1(data)();
    });
  }), filtersUpdated(function (_, _ref3) {
    var target = _ref3.target;
    filters.filtersUpdated(target, function (data) {
      renderCB(data.url);
      o$1(data)();
    });
  }), everythingCleared(function () {
    filters.clearAll(function (data) {
      renderCB(data.url);
      o$1(data)();
    });
  })];
  delegate = new Delegate(container);
  delegate.on("click", "[data-remove-filter]", function (e) {
    e.preventDefault();
    removeFilters([e.target]);
  });
  window.addEventListener("popstate", onPopstate);

  function onPopstate() {
    var url = new URL(window.location);
    var searchParams = url.search.replace("?", "");
    renderCB(searchParams, false);
    o$1({
      url: searchParams
    });
  }

  var unload = function unload() {
    delegate && delegate.off();
    subscriptions && subscriptions.forEach(function (unsubscribe) {
      return unsubscribe();
    });
    window.removeEventListener("popstate", onPopstate);
  };

  return {
    unload: unload
  };
};

var strings$2 = window.theme.strings;

var priceRange = function priceRange(container) {
  var inputs = t$2("input", container);
  var minInput = inputs[0];
  var maxInput = inputs[1];
  var events = [e$2(inputs, "change", onRangeChange)];
  var slider = n$2("[data-range-slider]", container);
  var min = Math.floor(minInput.value ? minInput.value : minInput.getAttribute("min"));
  var max = Math.floor(maxInput.value ? maxInput.value : maxInput.getAttribute("max"));
  import(flu.chunks.nouislider).then(function (_ref) {
    var noUiSlider = _ref.noUiSlider;
    noUiSlider.create(slider, {
      start: [minInput.value ? minInput.value : minInput.getAttribute("min"), maxInput.value ? maxInput.value : maxInput.getAttribute("max")],
      handleAttributes: [{
        "aria-label": strings$2.accessibility.range_lower
      }, {
        "aria-label": strings$2.accessibility.range_upper
      }],
      connect: true,
      range: {
        "min": parseInt(minInput.getAttribute("min")),
        "max": parseInt(maxInput.getAttribute("max"))
      }
    });
    slider.noUiSlider.on("slide", function (e) {
      var maxNew, minNew;

      var _e = _slicedToArray(e, 2);

      minNew = _e[0];
      maxNew = _e[1];
      minInput.value = Math.floor(minNew);
      maxInput.value = Math.floor(maxNew);
      setMinAndMaxValues();
    });
    slider.noUiSlider.on("set", function (e) {
      var maxNew, minNew;
      minNew = Math.floor(e[0]);
      maxNew = Math.floor(e[1]);

      if (minNew != min) {
        minInput.value = minNew;
        fireMinChangeEvent();
        min = Math.floor(minInput.value ? minInput.value : minInput.getAttribute("min"));
      }

      if (maxNew != max) {
        maxInput.value = maxNew;
        fireMaxChangeEvent();
        max = Math.floor(maxInput.value ? maxInput.value : maxInput.getAttribute("max"));
      }

      setMinAndMaxValues();
    });
    setMinAndMaxValues();
  });

  function setMinAndMaxValues() {
    if (maxInput.value) minInput.setAttribute("max", maxInput.value);
    if (minInput.value) maxInput.setAttribute("min", minInput.value);
    if (minInput.value === "") maxInput.setAttribute("min", 0);
    if (maxInput.value === "") minInput.setAttribute("max", maxInput.getAttribute("max"));
  }

  function adjustToValidValues(input) {
    var value = Number(input.value);
    var minNew = Number(input.getAttribute("min"));
    var maxNew = Number(input.getAttribute("max"));
    if (value < minNew) input.value = minNew;
    if (value > maxNew) input.value = maxNew;
  }

  function fireMinChangeEvent() {
    minInput.dispatchEvent(new Event("change", {
      bubbles: true
    }));
  }

  function fireMaxChangeEvent() {
    maxInput.dispatchEvent(new Event("change", {
      bubbles: true
    }));
  }

  function onRangeChange(event) {
    adjustToValidValues(event.currentTarget);
    setMinAndMaxValues();
    if (minInput.value === "" && maxInput.value === "") return;
    var currentMax, currentMin;

    var _slider$noUiSlider$ge = slider.noUiSlider.get();

    var _slider$noUiSlider$ge2 = _slicedToArray(_slider$noUiSlider$ge, 2);

    currentMin = _slider$noUiSlider$ge2[0];
    currentMax = _slider$noUiSlider$ge2[1];
    currentMin = Math.floor(currentMin);
    currentMax = Math.floor(currentMax);
    if (currentMin !== Math.floor(minInput.value)) slider.noUiSlider.set([minInput.value, null]);
    if (currentMax !== Math.floor(maxInput.value)) slider.noUiSlider.set([null, maxInput.value]);
  }

  function validateRange() {
    inputs.forEach(function (input) {
      return setMinAndMaxValues();
    });
  }

  var reset = function reset() {
    slider.noUiSlider.set([minInput.getAttribute("min"), maxInput.getAttribute("max")], false);
    minInput.value = "";
    maxInput.value = "";
    min = Math.floor(minInput.getAttribute("min"));
    max = Math.floor(maxInput.getAttribute("max"));
    setMinAndMaxValues();
  };

  var unload = function unload() {
    events.forEach(function (unsubscribe) {
      return unsubscribe();
    });
    slider.noUiSlider.destroy();
  };

  return {
    unload: unload,
    reset: reset,
    validateRange: validateRange
  };
};

/**
 * Takes a selector and replaces the element with the new element found in the updated document
 * @param {*} selector The selector to target
 * @param {*} doc The updated document returned by the fetch request
 */

function replaceElement(selector, doc) {
  var updatedItem = n$2(selector, doc);
  var oldItem = n$2(selector);

  if (updatedItem && oldItem) {
    oldItem.parentElement.replaceChild(updatedItem, oldItem);
  }
}

var sel$1 = {
  drawer: "[data-filter-drawer]",
  drawerTitle: "[data-filter-drawer-title]",
  filter: "[data-filter]",
  filterItem: "[data-filter-item]",
  filterTarget: "[data-filter-drawer-target]",
  flyouts: "[data-filter-modal]",
  button: "[data-button]",
  wash: "[data-drawer-wash]",
  sort: "[data-sort]",
  close: "[data-close-icon]",
  group: ".filter-drawer__group",
  groupToggle: "[data-drawer-group-toggle]",
  panel: ".filter-drawer__panel",
  flyoutWrapper: "[data-filer-modal-wrapper]",
  priceRange: "[data-price-range]",
  resultsCount: "[data-results-count]",
  activeFilters: "[data-active-filters]",
  activeFilterCount: "[data-active-filter-count]"
};
var classes$3 = {
  active: "active",
  activeFilters: "filters-active",
  fixed: "is-fixed",
  filterDisabled: "filter-item__content--disabled"
};

var filterDrawer = function filterDrawer(node) {
  if (!node) {
    return false;
  }

  var container = n$2(sel$1.drawer, node);

  if (!container) {
    return false;
  }

  var flyouts = t$2(sel$1.flyouts, container);
  var wash = n$2(sel$1.wash, container);
  var rangeInputs = t$2("[data-range-input]", container);
  var focusTrap = null;
  var range = null;
  var filterDrawerAnimation = null;

  if (shouldAnimate(node)) {
    filterDrawerAnimation = animateFilterDrawer(container);
  }

  var rangeContainer = n$2(sel$1.priceRange, container);

  if (rangeContainer) {
    range = priceRange(rangeContainer);
  }
  
  var events = [
    e$2(t$2(sel$1.filterTarget, node), "click", clickFlyoutTrigger),
    e$2(container, "change", changeHandler),
    e$2(wash, "click", clickWash),
    e$2(t$2("".concat(sel$1.button, ", ").concat(sel$1.clearAll), container), "click", clickButton),
    e$2(t$2(sel$1.close, container), "click", clickWash),
    e$2(container, "keydown", function (_ref) {
    var keyCode = _ref.keyCode;
    if (keyCode === 27) clickWash();
  }), e$2(rangeInputs, "change", rangeChanged), c("filters:filter-removed", function () {
    return syncActiveStates();
  })];

  function changeHandler(e) {
    if (e.target.classList.contains("filter-item__checkbox")) {
      filterChange(e.target);
    } else {//if (e.target.classList.contains("filter-item__radio")) 
      sortChange(e);
    }
  }

  function clickFlyoutTrigger(e) {
    e.preventDefault();
    var filterDrawerTarget = e.currentTarget.dataset.filterDrawerTarget;
    var modal = n$2("[data-filter-modal=\"".concat(filterDrawerTarget, "\"]"), container);
    focusTrap = createFocusTrap(modal, {
      allowOutsideClick: true
    });
    u$1(container, classes$3.fixed);
    setTimeout(function () {
      if (shouldAnimate(node)) {
        filterDrawerAnimation.open(modal);
      }

      u$1(container, classes$3.active);
      u$1(modal, classes$3.active);
    }, 0);
    modal.setAttribute("aria-hidden", "false");
    focusTrap.activate();
    document.body.setAttribute("data-fluorescent-overlay-open", "true");
    disableBodyScroll(node, {
      allowTouchMove: function allowTouchMove(el) {
        while (el && el !== document.body) {
          if (el.getAttribute("data-scroll-lock-ignore") !== null) {
            return true;
          }

          el = el.parentNode;
        }
      },
      reserveScrollBarGap: true
    });
  }

  function clickWash(e) {
    e && e.preventDefault();
    focusTrap && focusTrap.deactivate();
    i$1(flyouts, classes$3.active);
    i$1(container, classes$3.active);
    flyouts.forEach(function (flyout) {
      return flyout.setAttribute("aria-hidden", "true");
    });
    document.body.setAttribute("data-fluorescent-overlay-open", "false");
    enableBodyScroll(node);
    setTimeout(function () {
      i$1(container, classes$3.fixed);

      if (shouldAnimate(node)) {
        filterDrawerAnimation.close(flyouts);
      }
    }, 500);
  }

  function filterChange(filter) {
    if (filter.classList.contains(classes$3.filterDisabled)) {
      return;
    }

    checkForActiveModalitems(filter);
    range && range.validateRange();
    debounce(function () {
      return updateFilters(container);
    }, 1000)();
  }

  function sortChange(e) {
    checkForActiveModalitems(e.target);
    range && range.validateRange();
    updateFilters(container);
  }

  function rangeChanged(e) {
    checkForActiveModalitems(e.currentTarget);
    var wrappingContainer = e.target.closest(sel$1.group);
    wrappingContainer && l(wrappingContainer, classes$3.activeFilters, rangeInputsHaveValue());
    updateFilters(container);
  }

  function clickButton(e) {
    e.preventDefault();
    var button = e.currentTarget.dataset.button;
    var scope = e.currentTarget.closest(sel$1.flyouts);
    var filterModal = scope.dataset.filterModal;

    if (button === "close") {
      clickWash();
    } // Sort flyouts


    if (filterModal === "__sort") {
      if (button === "clear-all") {
        t$2("[data-filter-modal=\"__sort\"] ".concat(sel$1.sort), container).forEach(function (element) {
          n$2("input", element).checked = false;
        });
        i$1(e.currentTarget.closest(sel$1.panel), classes$3.activeFilters);
      }
    } else {
      // Regular filter flyout
      if (button === "clear-all") {
        t$2("input", scope).forEach(function (input) {
          input.checked = false;
        });
        var panel = e.currentTarget.closest(sel$1.panel);
        i$1([].concat(_toConsumableArray$1(t$2(sel$1.group, panel)), [panel]), classes$3.activeFilters);
        range && range.reset();
        updateFilters(container);
      }else if (button === "clear-group"){
        range && range.reset();
      }

      if (button === "group_toggle") {
        var group = n$2("#".concat(e.currentTarget.getAttribute("aria-controls")));
        var ariaExpanded = e.currentTarget.getAttribute("aria-expanded") === "true";
        slideStop(group);

        if (ariaExpanded) {
          closeGroup(e.currentTarget, group);
        } else {
          openGroup(e.currentTarget, group);
        }
      }
    }
  }

  function openGroup(button, group) {
    slideDown(group);
    button.setAttribute("aria-expanded", true);
    group.setAttribute("aria-hidden", false);
  }

  function closeGroup(button, group) {
    slideUp(group);
    button.setAttribute("aria-expanded", false);
    group.setAttribute("aria-hidden", true);
  }

  function containsCheckedInputs(items) {
    return items.some(function (input) {
      return input.checked;
    });
  }

  function rangeInputsHaveValue() {
    return rangeInputs.some(function (input) {
      return input.value !== "";
    });
  }

  function checkForActiveModalitems(currentTarget) {
    var panel = currentTarget.closest(sel$1.panel);
    if (!panel) return;
    var activeItems = containsCheckedInputs(t$2("input", panel)) || rangeInputsHaveValue();
    l(panel, classes$3.activeFilters, activeItems);
  }

  function syncActiveStates() {
    var panels = t$2(sel$1.panel, container);
    panels.forEach(function (panel) {
      var activeItems = false;
      var rangeInputs = n$2("[data-range-input]", panel);

      if (containsCheckedInputs(t$2("input", panel))) {
        activeItems = true;
      }

      if (rangeInputs && rangeInputsHaveValue()) {
        activeItems = true;
      }

      l(panel, classes$3.activeFilters, activeItems);
    });
  }

  function renderFilters(doc) {
    var updatedFilterItems = t$2("".concat(sel$1.drawer, " ").concat(sel$1.filterItem), doc);
    updatedFilterItems.forEach(function (element) {
      replaceElement("".concat(sel$1.drawer, " ").concat(sel$1.filterItem, "[for=\"").concat(element.getAttribute("for"), "\"] .filter-item__checkbox"), doc);
      replaceElement("".concat(sel$1.drawer, " ").concat(sel$1.filterItem, "[for=\"").concat(element.getAttribute("for"), "\"] .filter-item__count"), doc);
    });
    var updatedGroupToggles = t$2("".concat(sel$1.drawer, " ").concat(sel$1.groupToggle), doc);
    updatedGroupToggles.forEach(function (element) {
      updateInnerHTML("".concat(sel$1.drawer, " [data-drawer-group-toggle=\"").concat(element.getAttribute("data-drawer-group-toggle"), "\"]"), doc);
    });
    updateInnerHTML("".concat(sel$1.drawer, " ").concat(sel$1.resultsCount), doc);
    updateInnerHTML("".concat(sel$1.drawer, " ").concat(sel$1.activeFilters), doc);
    updateInnerHTML("".concat(sel$1.drawer, " ").concat(sel$1.drawerTitle), doc);
    updateInnerHTML("[data-mobile-filters] [data-mobile-filters-toggle]", doc);
  }

  function unload() {
    events.forEach(function (unsubscribe) {
      return unsubscribe();
    });
    range && range.unload();
  }

  return {
    renderFilters: renderFilters,
    unload: unload
  };
};

var sel = {
  bar: "[data-filter-bar]",
  filterItem: "[data-filter-item]",
  dropdownToggle: "[data-dropdown-toggle]",
  group: "[data-filter-group]",
  groupLabels: "[data-filter-group-label]",
  groupValues: "[data-filter-group-values]",
  groupReset: "[data-filter-group-reset]",
  groupHeader: "[data-group-values-header]",
  priceRange: "[data-price-range]",
  rangeInput: "[data-range-input]",
  removeRange: "[data-remove-range]",
  filterInputs: "[data-filter-item-input]",
  sortInputs: "[data-sort-item-input]",
  resultsCount: "[data-results-count]",
  activeFilters: "[data-active-filters]",
  clearAll: "[data-clear-all-filters]"
};
var classes$2 = {
  activeFilters: "filters-active",
  filterDisabled: "filter-item__content--disabled",
  filterBarActive: "filter-bar__filters-inner--active",
  filterBarWashActive: "filter-bar--wash-active",
  filterGroupActive: "filter-group--active",
  filterGroupRight: "filter-group__values--right"
}; // eslint-disable-next-line valid-jsdoc

/**
 * A class to handle desktop filter bar functionality
 * @param {*} node the collection section container
 * @returns renderFilters and unload methods
 */

var filterBar = function filterBar(node) {
  if (!node) {
    return false;
  } // `node` is the colelction section container.
  // Using `container` here as the filter bar container to keep filter bar
  // and filter drawer DOM scope separate.


  var container = n$2(sel.bar, node);
  var groupLabels = t$2(sel.groupLabels, container);
  var rangeInputs = t$2(sel.rangeInput, container);
  var rangeContainer = n$2(sel.priceRange, container);
  var focusTrap = null;
  var range = null;

  if (rangeContainer) {
    range = priceRange(rangeContainer);
    window['priceRange'] = range;
  }

  var events = [
    e$2(window, "click", clickHandler),
    //e$2(container, "change", changeHandler),
    c("filters:filter-removed", function () {
    return syncActiveStates();
  }), e$2(container, "keydown", function (_ref) {
    var keyCode = _ref.keyCode;
    if (keyCode === 27) closeGroups();
  })]; // eslint-disable-next-line valid-jsdoc

  /**
   * Delegates click events
   * @param {event} e click event
   */

  function clickHandler(e) {
    var group = e.target.closest(sel.group);
    var dropdownToggle = e.target.closest(sel.dropdownToggle);
    var groupReset = e.target.closest(sel.groupReset);
    var removeRange = e.target.closest(sel.removeRange);
    var clearAll = e.target.closest(sel.clearAll); // If the click happened outside of a filter group
    // We don't want to close the groups if the click happened on a filter in a group

    if (!group) {
      closeGroups();
    }

    if (dropdownToggle) {
      toggleDropdown(dropdownToggle);
    }

    if (groupReset) {
      //handleGroupReset(groupReset);
    }

    if (removeRange) {
      e.preventDefault();
      priceRangeRemove();
    }

    if (clearAll) {
      e.preventDefault();
      clearAllFilters();
    }
  }

  function clearAllFilters() {
    range && range.reset();
    t$2("".concat(sel.filterInputs), container).forEach(function (input) {
      input.checked = false;
    });
    updateFilters(container);
  }

  function handleGroupReset(groupReset) {
    var group = groupReset.closest(sel.groupValues);
    var filterType = group.dataset.filterType;

    if (filterType === "price_range") {
      priceRangeRemove();
    } else {
      t$2(sel.filterInputs, group).forEach(function (input) {
        input.checked = false;
      });
      updateFilters(container);
    }
  }

  function priceRangeRemove() {
    range && range.reset();
    checkForActiveFilters();
    updateFilters(container);
  } // eslint-disable-next-line valid-jsdoc

  /**
   * Delegates change events
   * @param {event} e change event
   */


  function closeGroups() {
    groupLabels.forEach(function (button) {
      hideDropdown(button);
    });
  }

  function toggleDropdown(button) {
    var ariaExpanded = button.getAttribute("aria-expanded") === "true";

    if (ariaExpanded) {
      closeGroups();
      hideDropdown(button);
    } else {
      closeGroups();
      showDropdown(button);
    }
  }

  function showDropdown(button) {
    var group = button.closest(sel.group);
    button.setAttribute("aria-expanded", true);
    var dropdown = n$2("#".concat(button.getAttribute("aria-controls")), container);
    var dropdownToggle = button.dataset.dropdownToggle;

    if (dropdown) {
      if (dropdownToggle === "filter-bar-filters") {
        slideStop(dropdown);
        slideDown(dropdown).then(function () {
          dropdown.setAttribute("aria-hidden", false);
        });
      } else {
        dropdown.setAttribute("aria-hidden", false);

        if (group) {
          u$1(group, classes$2.filterGroupActive);
          positionGroup(group, dropdown); // Lock the filter bar to stop horizontal scrolling

          u$1(container, classes$2.filterBarWashActive);
          focusTrap = createFocusTrap(group, {
            allowOutsideClick: true
          });
          focusTrap.activate();
        }
      }
    }
  }

  function hideDropdown(button) {
    var group = button.closest(sel.group);
    i$1(container, classes$2.filterBarWashActive);
    button.setAttribute("aria-expanded", false);
    var dropdown = n$2("#".concat(button.getAttribute("aria-controls")), container);
    var dropdownToggle = button.dataset.dropdownToggle;

    if (dropdown) {
      dropdown.setAttribute("aria-hidden", true);

      if (dropdownToggle === "filter-bar-filters") {
        slideStop(dropdown);
        slideUp(dropdown);
      } else if (group) {
        i$1(group, classes$2.filterGroupActive);
        focusTrap && focusTrap.deactivate();
      }
    }
  }

  function positionGroup(group, dropdown) {
    i$1(dropdown, classes$2.filterGroupRight); // The filter bar bounding rect

    var parentBounds = group.parentElement.getBoundingClientRect(); // This filter groups bounding rect.
    // This will be around the toggle button
    // and what the drop down is positioned inside of

    var groupBounds = group.getBoundingClientRect(); // The drop down bounding rect

    var dropdownBounds = dropdown.getBoundingClientRect(); // Check if the drop down will stick out too far past the toggle button
    // Basicially checks if the drop down will overflow the page or not
    // 1. add the left side X position of the toggle button
    //    to the width of the drop down
    //    to get the left side position of the drop down
    // 2. If the left side of the drop down is past the width of the filter bar
    // 3. Add a class to the drop down to position it
    //    to the right side of the toggle button

    if (groupBounds.x + dropdownBounds.width >= parentBounds.width) {
      u$1(dropdown, classes$2.filterGroupRight);
    }
  }

  function updateGroupPositions() {
    var buttons = t$2(sel.dropdownToggle, container);
    buttons.forEach(function (button) {
      var ariaExpanded = button.getAttribute("aria-expanded") === "true";

      if (ariaExpanded) {
        var group = button.closest(sel.group);
        var dropdown = n$2("#".concat(button.getAttribute("aria-controls")), container);

        if (group && dropdown) {
          positionGroup(group, dropdown);
        }
      }
    });
  }

  function filterChange(filter) {
    if (filter.classList.contains(classes$2.filterDisabled)) {
      return;
    }

    checkForActiveFilters();
    range && range.validateRange();
    debounce(function () {
      return updateFilters(container);
    }, 1000)();
  }

  function checkForActiveFilters() {
    var activeItems = containsCheckedInputs(t$2(sel.filterInputs, container)) || rangeInputsHaveValue();
    l(container, classes$2.activeFilters, activeItems);
  }

  function rangeInputsHaveValue() {
    return rangeInputs.some(function (input) {
      return input.value !== "";
    });
  }

  function containsCheckedInputs(items) {
    return items.some(function (input) {
      return input.checked;
    });
  }

  function syncActiveStates() {
    var activeItems = false;

    if (rangeInputs && rangeInputsHaveValue() || containsCheckedInputs(t$2(sel.filterInputs, container))) {
      activeItems = true;
    }

    l(container, classes$2.activeFilters, activeItems);
  }

  function renderFilters(doc) {
    var updatedFilterItems = t$2("".concat(sel.bar, " ").concat(sel.filterItem), doc);
    updatedFilterItems.forEach(function (element) {
      replaceElement("".concat(sel.bar, " ").concat(sel.filterItem, "[for=\"").concat(element.getAttribute("for"), "\"] .filter-item__checkbox"), doc);
      replaceElement("".concat(sel.bar, " ").concat(sel.filterItem, "[for=\"").concat(element.getAttribute("for"), "\"] .filter-item__count"), doc);
    });
    updateInnerHTML("".concat(sel.bar, " ").concat(sel.resultsCount), doc);
    updateInnerHTML("".concat(sel.bar, " ").concat(sel.activeFilters), doc);
    updateInnerHTML("".concat(sel.bar, " ").concat(sel.groupHeader), doc);
    var updatedDropdownToggles = t$2("".concat(sel.bar, " ").concat(sel.dropdownToggle), doc);

    if (updatedDropdownToggles.length > 0) {
      updatedDropdownToggles.forEach(function (updated) {
        updateInnerHTML("".concat(sel.bar, " [data-dropdown-toggle=\"").concat(updated.getAttribute("data-dropdown-toggle"), "\"]"), doc);
      });
    }

    var updatedGroupHeader = t$2("".concat(sel.bar, " ").concat(sel.groupHeader), doc);
    updatedGroupHeader.forEach(function (element) {
      updateInnerHTML("".concat(sel.bar, " [data-group-values-header=\"").concat(element.getAttribute("data-group-values-header"), "\"]"), doc);
    });
    updateGroupPositions();
  }

  function unload() {
    events.forEach(function (unsubscribe) {
      return unsubscribe();
    });
    range && range.unload();
    focusTrap && focusTrap.deactivate();
  }

  return {
    renderFilters: renderFilters,
    unload: unload
  };
};

var selectors$2 = {
  infiniteScrollContainer: ".collection__infinite-container",
  infiniteScrollTrigger: ".collection__infinite-trigger",
  partial: "[data-partial]",
  filterDrawer: "[data-filter-drawer]",
  filterBar: "[data-filter-bar]",
  loader: ".collection__loading",
  paginationItemCount: "[data-pagination-item-count]",
  productItems: ".product-item"
};
var classes$1 = {
  active: "is-active",
  hideProducts: "animation--collection-products-hide"
};
var strings$1 = window.theme.strings;
register("collection", {
  infiniteScroll: null,
  onLoad: function onLoad() {
    var _this$container$datas = this.container.dataset,
        collectionItemCount = _this$container$datas.collectionItemCount,
        paginationType = _this$container$datas.paginationType;
    if (!parseInt(collectionItemCount)) return;
    this.filterDrawerEl = n$2(selectors$2.filterDrawer, this.container);
    this.filterbarEl = n$2(selectors$2.filterBar, this.container);
    this.paginationItemCount = n$2(selectors$2.paginationItemCount, this.container);

    if (this.filterDrawerEl || this.filterbarEl) {
      this.partial = n$2(selectors$2.partial, this.container);
      this.filterDrawer = filterDrawer(this.container);
      this.filterBar = filterBar(this.container);
      this.filterHandler = filterHandler({
        container: this.container,
        renderCB: this._renderView.bind(this)
      });
    } // Ininite scroll


    this.paginationType = paginationType;
    this.paginated = this.paginationType === "paginated";
    this.infiniteScrollTrigger = n$2(selectors$2.infiniteScrollTrigger, this.container);

    if (!this.paginated) {
      this._initInfiniteScroll();
    }

    this.productItem = ProductItem(this.container);

    if (shouldAnimate(this.container)) {
      this.animateCollection = animateCollection(this.container);
    }

    this._initTryOnButton();
    this._initMobileSort();
  },
  _initMobileSort: () => {
    let options = document.querySelectorAll(".mobile-filters__dropdown-option");
    const dropdown = document.querySelector(".mobile-filters__dropdown");
    const button = document.querySelector("[data-sort-button]");
    const buttonText = document.querySelector("[data-sort-button] div");
    const clearButtons = document.querySelectorAll(".filter-drawer__group-filter-wrapper .filter-group__reset");

    //clearButtons.forEach(button => {
    //  button.addEventListener("click", function(){
    //    const id = this.dataset.target;
    //    document.querySelector(`#${id} button`).click();
    //  })
    //})

    button.addEventListener("click", () => {
      dropdown.classList.toggle("mobile-filters__dropdown--active");
    })

    options.forEach(option => {
      if (buttonText.textContent === option.dataset.text) option.classList.add("active")
      option.addEventListener("click", function() {
        options.forEach(option =>option.classList.remove("active"))
        customCatalog.onFormChange();
        dropdown.classList.remove("mobile-filters__dropdown--active");
        let sort_by = this.dataset.option;
        let text = this.dataset.text;
        buttonText.textContent = text;
        this.classList.add("active")

        let inputs = document.querySelectorAll("[name='sort_by']");
        const container = document.querySelector(".filter-drawer");

        inputs.forEach(input => {
          input.checked = input.getAttribute("data-value-escaped") == sort_by ? true : false;

          if(input.getAttribute("data-value-escaped") == sort_by){
            setTimeout(() => {
              let event = new Event('change');
              container.dispatchEvent(event);
            }, 0);
          }
        })
      });
    })
  },

  _initTryOnButton: () => {
    const switchToggle =(switcher)=>{
      switcher.classList.toggle("filter-bar__try-on-toggle--on");
      switcher.parentNode.querySelector("input").value = !!document.querySelectorAll(".filter-bar__try-on-toggle--on").length;
    }
    const toggles = document.querySelectorAll(".filter-bar__try-on-toggle");
    toggles.forEach(toggle => {
      toggle.addEventListener("click", () => {
        toggles.forEach(toggletem=> switchToggle (toggletem))
        customCatalog.onFormChange();
      })
    })
  },
  _initInfiniteScroll: function _initInfiniteScroll() {
    var _this = this;

    var infiniteScrollOptions = {
      container: selectors$2.infiniteScrollContainer,
      pagination: selectors$2.infiniteScrollTrigger,
      loadingText: "Loading...",
      callback: function callback() {
        var _this$animateCollecti;

        _this.productItem && _this.productItem.unload();
        _this.productItem = ProductItem(_this.container);
        (_this$animateCollecti = _this.animateCollection) === null || _this$animateCollecti === void 0 ? void 0 : _this$animateCollecti.infiniteScrollReveal();

        _this._updatePaginationCount();

        r$1("collection:updated");
      }
    };

    if (this.paginationType === "click") {
      infiniteScrollOptions.method = "click";
    }

    this.infiniteScroll = new Ajaxinate(infiniteScrollOptions);
  },
  _updatePaginationCount: function _updatePaginationCount() {
    var productItemCount = t$2(selectors$2.productItems, this.container).length;
    var viewing = strings$1.pagination.viewing.replace("{{ of }}", "1-".concat(productItemCount)).replace("{{ total }}", this.partial.dataset.collectionProductsCount);
    this.paginationItemCount.innerHTML = "".concat(viewing, " ").concat(strings$1.pagination.products);
  },
  _renderView: function _renderView(searchParams) {
    
  },
  _updateURLHash: function _updateURLHash(searchParams) {
    history.pushState({
      searchParams: searchParams
    }, "", "".concat(window.location.pathname).concat(searchParams && "?".concat(searchParams)));
  },
  onUnload: function onUnload() {
    var _this$animateCollecti2;

    this.infiniteScroll && this.infiniteScroll.destroy();
    this.filterHandler && this.filterHandler.unload();
    this.filterDrawer && this.filterDrawer.unload();
    this.filterBar && this.filterBar.unload();
    this.filtering && this.filtering.unload();
    this.productItem && this.productItem.unload();
    (_this$animateCollecti2 = this.animateCollection) === null || _this$animateCollecti2 === void 0 ? void 0 : _this$animateCollecti2.destroy();
  }
});

register("login", {
  onLoad: function onLoad() {
    var main = n$2('[data-part="login"]', this.container);
    var reset = n$2('[data-part="reset"]', this.container);
    var toggles = t$2("[data-toggle]", this.container);
    var loginError = n$2(".form-status__message--error", reset);
    var isSuccess = n$2(".form-status__message--success", reset);
    var successMessage = n$2("[data-success-message]", this.container);
    const recoverPasswordForm = document.querySelector("[action='/account/recover']");
    const resetEmailInput = document.getElementById("RecoverEmail")

    if (isSuccess) {
      u$1(successMessage, "visible");
      u$1([main, reset], "hide");
    }

    if (loginError) {
      toggleView();
    }

    function toggleView(e) {
      e && e.preventDefault();
      if (resetEmailInput.value.trim() !== "") {
        // If recover password input is not empty, submit the forgot password form
        recoverPasswordForm.submit();
      } else {
        // Otherwise, switch forms visibility
        l([main, reset], "hide");
        main.setAttribute("aria-hidden", a$1(main, "hide"));
        reset.setAttribute("aria-hidden", a$1(reset, "hide"));
      }
    }

    this.toggleClick = e$2(toggles, "click", toggleView);
  },
  onUnload: function onUnload() {
    this.toggleClick();
  }
});

register("addresses", {
  onLoad: function onLoad() {
    var _this = this;

    this.modals = t$2("[data-address-modal]", this.container);
    this.focusTrap = null;
    var overlays = t$2("[data-overlay]", this.container);
    var open = t$2("[data-open]", this.container);
    var close = t$2("[data-close]", this.container);
    var remove = t$2("[data-remove]", this.container);
    var countryOptions = t$2("[data-country-option]", this.container) || [];
    this.events = [e$2(open, "click", function (e) {
      return _this.openModal(e);
    }), e$2([].concat(_toConsumableArray$1(close), _toConsumableArray$1(overlays)), "click", function (e) {
      return _this.closeModal(e);
    }), e$2(remove, "click", function (e) {
      return _this.removeAddress(e);
    }), e$2(this.modals, "keydown", function (e) {
      if (e.keyCode === 27) _this.closeModal(e);
    })];
    countryOptions.forEach(function (el) {
      var formId = el.dataset.formId;
      var countrySelector = "AddressCountry_" + formId;
      var provinceSelector = "AddressProvince_" + formId;
      var containerSelector = "AddressProvinceContainer_" + formId;
      new window.Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
        hideElement: containerSelector
      });
    });
  },
  onUnload: function onUnload() {
    this.events.forEach(function (unsubscribe) {
      return unsubscribe();
    });
  },
  openModal: function openModal(e) {
    e.preventDefault();
    var which = e.currentTarget.dataset.open;
    var modal = this.modals.find(function (el) {
      return el.dataset.addressModal == which;
    });
    u$1(modal, "active");
    this.focusTrap = createFocusTrap(modal, {
      allowOutsideClick: true
    });
    this.focusTrap.activate();
    document.body.setAttribute("data-fluorescent-overlay-open", "true");
    disableBodyScroll(modal, {
      allowTouchMove: function allowTouchMove(el) {
        while (el && el !== document.body) {
          if (el.getAttribute("data-scroll-lock-ignore") !== null) {
            return true;
          }

          el = el.parentNode;
        }
      },
      reserveScrollBarGap: true
    });
    setTimeout(function () {
      u$1(modal, "visible");
    }, 50);
  },
  closeModal: function closeModal(e) {
    e.preventDefault();
    var modal = e.target.closest(".addresses__modal");
    document.body.setAttribute("data-fluorescent-overlay-open", "false");
    enableBodyScroll(modal);
    this.focusTrap.deactivate();
    i$1(modal, "visible");
    setTimeout(function () {
      i$1(modal, "active");
    }, 350);
  },
  removeAddress: function removeAddress(e) {
    var _e$currentTarget$data = e.currentTarget.dataset,
        confirmMessage = _e$currentTarget$data.confirmMessage,
        target = _e$currentTarget$data.target;

    if (confirm(confirmMessage)) {
      window.Shopify.postLink(target, {
        parameters: {
          _method: "delete"
        }
      });
    }
  }
});

register("article", {
  onLoad: function onLoad() {
    focusFormStatus(this.container);
    var socialShareContainer = n$2(".social-share", this.container);

    if (socialShareContainer) {
      this.socialShare = SocialShare(socialShareContainer);
    }

    wrapIframes(t$2("iframe", this.container));
    wrapTables(t$2("table", this.container));

    if (shouldAnimate(this.container)) {
      this.animateArticle = animateArticle(this.container);
    }
  },
  onUnload: function onUnload() {
    var _this$animateArticle;

    this.socialShare && this.socialShare();
    (_this$animateArticle = this.animateArticle) === null || _this$animateArticle === void 0 ? void 0 : _this$animateArticle.destroy();
  }
});

register("password", {
  onLoad: function onLoad() {
    if (shouldAnimate(this.container)) {
      this.animatePassword = animatePassword(this.container);
    }
  },
  onUnload: function onUnload() {
    var _this$animatePassword;

    (_this$animatePassword = this.animatePassword) === null || _this$animatePassword === void 0 ? void 0 : _this$animatePassword.destroy();
  }
});

var selectors$1 = {
  video: ".about__block-video"
};
register("page", {
  onLoad: function onLoad() {
    var _this = this;

    var videos = t$2(selectors$1.video, this.container);
    this.videoHandlers = [];

    if (videos.length) {
      videos.forEach(function (video) {
        _this.videoHandlers.push(backgroundVideoHandler(video.parentNode));
      });
    }

    this.accordions = Accordions(t$2(".accordion", this.container));
    wrapIframes(t$2("iframe", this.container));
    wrapTables(t$2("table", this.container));

    if (shouldAnimate(this.container)) {
      this.animatePage = animatePage(this.container);
    }
  },
  onUnload: function onUnload() {
    var _this$animatePage;

    this.accordions.unload();
    this.videoHandlers.forEach(function (handler) {
      return handler();
    });
    (_this$animatePage = this.animatePage) === null || _this$animatePage === void 0 ? void 0 : _this$animatePage.destroy();
  }
});

var selectors = {
  searchSection: ".search",
  searchBanner: ".search-header",
  infiniteScrollContainer: ".search__infinite-container",
  infiniteScrollTrigger: ".search__infinite-trigger",
  partial: "[data-partial]",
  filterDrawer: "[data-filter-drawer]",
  filterBar: "[data-filter-bar]",
  loader: ".search__loading",
  paginationItemCount: "[data-pagination-item-count]",
  searchItems: ".product-item, .search-item"
};
var classes = {
  active: "is-active",
  hideProducts: "animation--search-products-hide"
};
var strings = window.theme.strings;
register("search", {
  infiniteScroll: null,
  onLoad: function onLoad() {
    this.searchBannerEl = n$2(selectors.searchBanner, this.container);

    if (shouldAnimate(this.searchBannerEl)) {
      this.animateSearchBanner = animateSearchBanner(this.searchBannerEl);
    }

    var _this$container$datas = this.container.dataset,
        searchItemCount = _this$container$datas.searchItemCount,
        paginationType = _this$container$datas.paginationType;
    if (!parseInt(searchItemCount)) return;
    this.searchSectionEl = n$2(selectors.searchSection, this.container);
    this.filterDrawerEl = n$2(selectors.filterDrawer, this.container);
    this.filterBarEl = n$2(selectors.filterBar, this.container);
    this.paginationItemCount = n$2(selectors.paginationItemCount, this.container);

    if (this.filterBarEl) {
      this.partial = n$2(selectors.partial, this.container);
      this.filterDrawer = filterDrawer(this.searchSectionEl);
      this.filterBar = filterBar(this.searchSectionEl);
      this.filterHandler = filterHandler({
        container: this.searchSectionEl,
        renderCB: this._renderView.bind(this)
      });
    } // Ininite scroll


    this.paginationType = paginationType;
    this.paginated = this.paginationType === "paginated";
    this.infiniteScrollTrigger = n$2(selectors.infiniteScrollTrigger, this.container);

    if (!this.paginated) {
      this._initInfiniteScroll();
    }

    this.productItem = ProductItem(this.container);

    if (shouldAnimate(this.searchSectionEl)) {
      this.animateSearch = animateSearch(this.searchSectionEl);
    }
  },
  _initInfiniteScroll: function _initInfiniteScroll() {
    var _this = this;

    var infiniteScrollOptions = {
      container: selectors.infiniteScrollContainer,
      pagination: selectors.infiniteScrollTrigger,
      loadingText: "Loading...",
      callback: function callback() {
        var _this$animateSearch;

        _this.productItem && _this.productItem.unload();
        _this.productItem = ProductItem(_this.container);
        (_this$animateSearch = _this.animateSearch) === null || _this$animateSearch === void 0 ? void 0 : _this$animateSearch.infiniteScrollReveal();

        _this._updatePaginationCount();

        r$1("collection:updated");
      }
    };

    if (this.paginationType === "click") {
      infiniteScrollOptions.method = "click";
    }

    this.infiniteScroll = new Ajaxinate(infiniteScrollOptions);
  },
  _updatePaginationCount: function _updatePaginationCount() {
    var searchItemCount = t$2(selectors.searchItems, this.container).length;
    var viewing = strings.pagination.viewing.replace("{{ of }}", "1-".concat(searchItemCount)).replace("{{ total }}", this.partial.dataset.searchResultsCount);
    this.paginationItemCount.innerHTML = "".concat(viewing, " ").concat(strings.pagination.results);
  },
  _renderView: function _renderView(searchParams) {
    
  },
  _updateURLHash: function _updateURLHash(searchParams) {
    history.pushState({
      searchParams: searchParams
    }, "", "".concat(window.location.pathname).concat(searchParams && "?".concat(searchParams)));
  },
  onUnload: function onUnload() {
    var _this$animateSearch2, _this$animateSearchBa;

    this.infiniteScroll && this.infiniteScroll.destroy();
    this.filterHandler && this.filterHandler.unload();
    this.filterDrawer && this.filterDrawer.unload();
    this.filterBar && this.filterBar.unload();
    this.filtering && this.filtering.unload();
    this.productItem && this.productItem.unload();
    (_this$animateSearch2 = this.animateSearch) === null || _this$animateSearch2 === void 0 ? void 0 : _this$animateSearch2.destroy();
    (_this$animateSearchBa = this.animateSearchBanner) === null || _this$animateSearchBa === void 0 ? void 0 : _this$animateSearchBa.destroy();
  }
});

register("contact", {
  onLoad: function onLoad() {
    this.accordions = Accordions(t$2(".accordion", this.container));
    wrapIframes(t$2("iframe", this.container));
    wrapTables(t$2("table", this.container));
  },
  onUnload: function onUnload() {
    this.accordions.unload();
  }
});

register("blog", {
  onLoad: function onLoad() {
    var mobileNavSelect = n$2("#blog-mobile-nav", this.container);

    if (mobileNavSelect) {
      this.mobileNavSelectEvent = e$2(mobileNavSelect, "change", function () {
        window.location.href = mobileNavSelect.value;
      });
    }

    if (shouldAnimate(this.container)) {
      this.animateBlog = animateBlog(this.container);
    }
  },
  onUnload: function onUnload() {
    var _this$animateBlog;

    (_this$animateBlog = this.animateBlog) === null || _this$animateBlog === void 0 ? void 0 : _this$animateBlog.destroy();
    this.mobileNavSelectEvent && this.mobileNavSelectEvent.unsubscribe();
  }
});

register("collection-banner", {
  onLoad: function onLoad() {
    if (shouldAnimate(this.container)) {
      this.animateCollectionBanner = animateCollectionBanner(this.container);
    }
  },
  onUnload: function onUnload() {
    var _this$animateCollecti;

    (_this$animateCollecti = this.animateCollectionBanner) === null || _this$animateCollecti === void 0 ? void 0 : _this$animateCollecti.destroy();
  }
});

register("list-collections", {
  onLoad: function onLoad() {
    if (shouldAnimate(this.container)) {
      this.animateListCollections = animateListCollections(this.container);
    }
  },
  onUnload: function onUnload() {
    var _this$animateListColl;

    (_this$animateListColl = this.animateListCollections) === null || _this$animateListColl === void 0 ? void 0 : _this$animateListColl.destroy();
  }
});

var _window$Shopify;

if (!HTMLElement.prototype.hasOwnProperty("inert")) {
  import(flu.chunks.polyfillInert);
} // Detect theme editor


if (window.Shopify.designMode === true) {
  u$1(document.documentElement, "theme-editor");
  document.documentElement.classList.add("theme-editor");
} else {
  var el = n$2(".theme-editor-scroll-offset", document);
  el && el.parentNode.removeChild(el);
} // Function to load all sections


var loadSections = function loadSections() {
  load("*");
  o$1({
    SelectedProductSection: null
  });
}; // Call above function either immediately or bind on loaded event


if (document.readyState === "complete" || document.readyState === "interactive") {
  loadSections();
} else {
  e$2(document, "DOMContentLoaded", loadSections);
}

if (isMobile$1({
  tablet: true,
  featureDetect: true
})) {
  u$1(document.body, "is-mobile");
} // Page transitions


pageTransition(); // a11y tab handler

handleTab(); // Apply contrast classes

sectionClasses(); // Load productlightbox

productLightbox(); // Quick view modal

var quickViewModalElement = n$2("[data-quick-view-modal]", document);

if (quickViewModalElement) {
  quickViewModal(quickViewModalElement);
} // Setup modal


var modalElement = n$2("[data-modal]", document);
modal(modalElement);
var flashModal = n$2("[data-flash-alert]", document);
flashAlertModal(flashModal); // Product availabilty drawer

var availabilityDrawer = n$2("[data-store-availability-drawer]", document);
storeAvailabilityDrawer(availabilityDrawer); // Setup header overlay

var headerOverlayContainer = document.querySelector("[data-header-overlay]");
headerOverlay(headerOverlayContainer); // Init back to top button

backToTop(); // Make it easy to see exactly what theme version
// this is by commit SHA

window.SHA = "d61770dc0b";

if (!sessionStorage.getItem("flu_stat_recorded") && !((_window$Shopify = window.Shopify) !== null && _window$Shopify !== void 0 && _window$Shopify.designMode)) {
  var _window$Shopify2, _window$Shopify3, _window$Shopify3$them;

  // eslint-disable-next-line no-process-env
  fetch("https://stats.fluorescent.co", {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify(_objectSpread2$1(_objectSpread2$1({}, window.theme.coreData), {}, {
      s: (_window$Shopify2 = window.Shopify) === null || _window$Shopify2 === void 0 ? void 0 : _window$Shopify2.shop,
      r: (_window$Shopify3 = window.Shopify) === null || _window$Shopify3 === void 0 ? void 0 : (_window$Shopify3$them = _window$Shopify3.theme) === null || _window$Shopify3$them === void 0 ? void 0 : _window$Shopify3$them.role
    }))
  });

  if (window.sessionStorage) {
    sessionStorage.setItem("flu_stat_recorded", "true");
  }
}

/* Sign up popup logic
Page: /cart
*/

const signUpPopupInit = () => {
  const selectors = {
    popup: ".sign-in-popup",
    popupActive: "sign-in-popup--active",
    close: "sign-in-popup__close",
    submit: "cart__submit",
    quickSubmit: "quick-checkout",
    guestCheckoutSubmit: "sign-in-popup__link"
  }

  const signInPopup = document.querySelector(selectors.popup);
  let isCheckoutProcessInited = false;

  const onCheckoutButtonClick = (e) => {
    if(!signInPopup) {
      gtm_datalayer('checkout_user_check', 'existing')
      return;
    }

    e.preventDefault();
    e.stopPropagation();

    document.body.style.overflow = "hidden";
    signInPopup.classList.add(selectors.popupActive);
  }

  const onGuestCheckout = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    try {
      if (!isCheckoutProcessInited) {
        isCheckoutProcessInited = true;
        const guestScan = JSON.parse(localStorage.getItem("guest_scan"));
        const data = await fetch("/cart.js");
        const cart = await data.json();
        const isNotRxOnly = cart.items.every(item => !item.properties["_rx"]);

        if (guestScan?.has_scan && guestScan?.id) {
          let cartItemsSKUlist = [];

          cart.items.forEach(item => {
            const sku = item.sku;

            if(item.product_type != "Lenses" && item.product_type != "Lenses treatment"){
              cartItemsSKUlist.push(sku);
            }
          });
          
          cartItemsSKUlist = [...new Set(cartItemsSKUlist)];

          const listFromProxy = await customCatalog.fetchProducts({
            "variants-sku": cartItemsSKUlist,
            per_page: 9999,
            filters: false,
            guest_id: guestScan.id,
            collectionId: 0,
            recommended: true
          });

          let formData = new FormData();
      
          formData.append("attributes[guestScanCode]", guestScan.id);
          
          await fetch('/cart/update.js', {
            method: 'POST',
            body: formData
          })            

          // to do
          prescriptionFlow.noFitPopupInit(cart, listFromProxy)

        } else if (!isNotRxOnly) {
          const noScanPopup = document.querySelector(".no-scan-popup");
          if (noScanPopup) {
            noScanPopup.classList.add("no-scan-popup--active");
          }
        } else {
          window.location.href = "/checkout";
        }
        isCheckoutProcessInited = false
      }
    } catch(e) {
      console.log(e);
      isCheckoutProcessInited = false;
    }
  }

  const onSignInPopupClose = () => {
    document.body.style.overflow = "";
    signInPopup.classList.remove(selectors.popupActive);
  }

  window.addEventListener('click', async (e) => {
    const target = e.target;

    if (
      target.classList.contains(selectors.submit)
      || target.classList.contains(selectors.quickSubmit)
    ) onCheckoutButtonClick(e);

    if (target.classList.contains(selectors.guestCheckoutSubmit)) await onGuestCheckout(e);

    if (target.classList.contains(selectors.close)) onSignInPopupClose(e);
  });
};

Object.defineProperty(HTMLMediaElement.prototype, 'playing', {
  get: function(){
    return !!(this.currentTime > 0 && !this.paused && !this.ended && this.readyState > 2);
  }
})

/* VTO flyout popup logic
Page: all pages
*/

const VTOFlyOutPopupInit = async () => {
  let hasScan = false;

  const selectors = {
    popup: "vto-flyout-popup",
    popupActive: "vto-flyout-popup--active",
    close: "vto-flyout-popup__close",
    virtualTryOn: "product__try-on",
    tryOnText: "product-form__virtual-try-on-text",
    findYourFit: "find-your-fit-block__button",
    videoPlaceholder: "vto-flyout-popup__play-placeholder",
    videoPlaceholderHidden: "vto-flyout-popup__play-placeholder--hidden",
    video: "[data-vto-flyout-video]"
  }

  const vtoPopup = document.querySelector(`.${selectors.popup}`);
  const video = document.querySelector(selectors.video);
  const placeholder = document.querySelector(`.${selectors.videoPlaceholder}`);

  const onVtoFlyOutShow = () => {
    document.body.style.overflow = "hidden";
    vtoPopup.classList.add(selectors.popupActive);
  }

  const onVtoFlyOutClose = () => {
    document.body.style.overflow = "";
    vtoPopup.classList.remove(selectors.popupActive);
    
    placeholder?.classList.remove(selectors.videoPlaceholderHidden);
    video.pause();
    video.currentTime = 0;
    video.load();
  }

  const onVideoToggle = () => {
    placeholder?.classList.toggle(selectors.videoPlaceholderHidden);

    if(video.playing) video.pause();
    else video.play();
  }

  const generateQRCode = (link) => {
    const container = document.querySelector(".vto-flyout-popup__qr-code");

    container.innerHTML = "";

    new QRCode(container, {
      text: link,
      width: 128,
      height: 128,
      colorDark : "#2a348b",
      colorLight : "#ffffff",
      correctLevel : QRCode.CorrectLevel.H
    });
  }

  const showFindYourFitBlock = () => {
    const blocks = document.querySelectorAll(".find-your-fit-block");

    blocks.forEach(block => {
      block.classList.add("find-your-fit-block--active");
    })
  }

  if(window['isLoggedIn']){
    const scan = scanBySku;

    if(!scan || scan.message || scan.version == null){
      showFindYourFitBlock();
    }else{

      const {
        token,
        version
      } = scan;

      if(token){
        generateQRCode(token);
      }
    }
  }else{
    showFindYourFitBlock();
  }

  window.addEventListener('click', (e) => {
    const target = e.target;
    const onShowClasses = [selectors.findYourFit];
    const onCloseClasses = [selectors.close, selectors.popup];
    const tryOnButtonOnRight = [selectors.virtualTryOn, selectors.tryOnText];

    if(target.classList.contains(selectors.videoPlaceholder)) onVideoToggle(e);
    if(onShowClasses.some(className => target.classList.contains(className))) onVtoFlyOutShow(e);
    if(onCloseClasses.some(className => target.classList.contains(className))) onVtoFlyOutClose(e);
    if(tryOnButtonOnRight.some(className => target.classList.contains(className))){      
      if(!isUserHasScan()){
        onVtoFlyOutShow(e);
      }
    }
  });

  return {
    onVtoFlyOutClose
  }
}
const languageSwitcherInit = () => {
  const languageSwitcher = document.querySelector(".disclosure__toggle");

  if (languageSwitcher) {
    languageSwitcher.addEventListener("click", function(){
      const lang = this.dataset.lang;
      document.querySelector(`[data-value="${lang}"]`).click()
    });
  }
}

const collapsibleBlocksInit = () => {
  const triggers = Array.from(document.querySelectorAll('[data-toggle="collapse"]'));

  window.addEventListener('click', ({ target }) => {
    if (triggers.includes(target)) {
      target.classList.toggle("toggle--show");
      const selector = target.getAttribute('data-target');
      collapse(selector, 'toggle');
    }
  }, false);

  const fnmap = {
    'toggle': 'toggle',
    'show': 'add',
    'hide': 'remove'
  };
  
  const collapse = (selector, cmd) => {
    const targets = Array.from(document.querySelectorAll(selector));
    targets.forEach(target => {
      target.classList[fnmap[cmd]]('show');
    });
  }
}

function scrollToHorizontally (el) {
  el.parentNode.scrollLeft = el.offsetLeft;
}

/* Scroll horizontal for mobile logic for user account pages
Page: all user account pages
*/

const userAccountPagesInit = () => {
  const selected = document.querySelector(".user-menu-nav__list-item--selected");

  if(selected) scrollToHorizontally(selected);
}

/* Account information page logic
Page: pages/account-information
*/

const accountInformationInit = () => {
  const deleteAccountButton = document.querySelector(".account-information__delete-button");
  const cancelButton = document.querySelector(".account-information__cancel");
  const deleteSubmitButton = document.querySelector(".account-information__delete-submit-button");

  const tabs = {
    deleteAccount: "delete-my-account",
    personalInformation: "personal-information"
  }

  if(!deleteAccountButton) return;

  const showTab = (tabName) => {
    window.scrollTo(0, 0);
    const activeTab = document.querySelector(".account-information__tab--active");
    activeTab.classList.remove("account-information__tab--active");
    const tab = document.querySelector(`[data-tab="${tabName}"]`);
    tab.classList.add("account-information__tab--active");
    const inputs = document.querySelectorAll('[data-remove-account-form] input');
    inputs.forEach(input => input.value = "");
  }

  const setLogoutSession = () => {
    window.sessionStorage.setItem("is_logout", "true");
  }

  const onAccountDelete = async (e) => {
    e.preventDefault();
    const nesting = 2;
    const form = document.querySelector("[data-remove-account-form]");
    const passwordField = form.querySelector('[name="password"]');
    const confirmPasswordField = form.querySelector('[name="confirmation_password"]');
    const isValidPassword = notEmptyField(passwordField, nesting, errorKeys.enterValidPassword) && checkFieldLength({ field: passwordField, nesting });
    const isValidConfirmPassword = notEmptyField(confirmPasswordField, nesting, errorKeys.enterValidPassword) && checkFieldLength({ field: confirmPasswordField, nesting });
    const isPasswordsSame = isValidPassword && isValidConfirmPassword && doValuesMatch(passwordField, confirmPasswordField, nesting);

    if(!isValidPassword || !isValidConfirmPassword || !isPasswordsSame) return;
    
    const customerId = window['customerInfo']['id'];
    const lang = document.documentElement.getAttribute("lang");
    const formData = new FormData();
    formData.append("password", passwordField.value);
    formData.append("confirmation_password", confirmPasswordField.value);
    const res = await deleteAccount(customerId, formData);
    const errorContainer = document.querySelector(".account-information__input-wrapper--password + .input-validation-error");
    
    if(res.message){
      errorContainer.innerHTML = window['validationErrors']["enterValidPassword"];
      passwordField.parentNode.classList.add("input-wrapper--error");
    }else{
      passwordField.parentNode.classList.remove("input-wrapper--error");
      const link = `${lang == "fr" || lang == "fr-CA" ? "/fr" : "" }/account/logout/`;
      setLogoutSession();
      window.location.href = link;
    }
  }

  deleteAccountButton.addEventListener("click", () => showTab(tabs.deleteAccount));
  cancelButton.addEventListener("click", () => showTab(tabs.personalInformation));
  deleteSubmitButton.addEventListener("click", onAccountDelete);
}

/* Wishlist page logic
Page: /pages/my-favorites
*/

const initWishlist = (topologyWishlist) => {
  let wishlistObject = [];

  const setItemsListeners = () => {
    const items = document.querySelectorAll(".product-item");

    items.forEach((item) => {
      let swatches = item.querySelectorAll(".product-swatches-options__item--swatch");
      let secondImage = item.querySelectorAll(".product-item__image--two");

      /*const enterItemAnimation = () => {
        secondImage.forEach((image) => {
          image.classList.add("active");
        })
      }

      const leaveItemAnimation = () => {
        secondImage.forEach((image) => {
          image.classList.remove("active");
        })
      }
    
      item.addEventListener("mouseenter", enterItemAnimation);
      item.addEventListener("mouseleave", leaveItemAnimation);
      */

      swatches.forEach(swatch => {
        let selectedClassName = "product-swatches-options__item--selected";
    
        swatch.addEventListener("mouseenter", function(e){
          e.stopPropagation();
          const selected = item.querySelector(`.${selectedClassName}`);
          const color = this.dataset.color;
          const sku = this.dataset.sku;
          item.querySelector('.product-item__images.active').classList.remove("active");
          item.querySelector(`.product-item__images--${sku}`).classList.add("active");
    
          if(selected) selected.classList.remove(selectedClassName);
    
          this.classList.add(selectedClassName);
          const productWrapper = this.parentNode.parentNode.parentNode.parentNode.parentNode;
          const link = productWrapper.querySelector("a");
    
          link.href = link.dataset[color.replace(/-/g, "")] ?? link.dataset.href;

          const activePrice = productWrapper.querySelector(".product-item__price--active");
          if(activePrice) activePrice.classList.remove("product-item__price--active");
          const newPrice = productWrapper.querySelector(`.product-item__price[data-sku="${sku}"]`);
          if(newPrice) newPrice.classList.add("product-item__price--active");
        })
      })
    });
  }

  const onItemRemoveFromWishlist = ({
    item,
    swat
  }) => {
    item.outerHTML = "";
    const productId = +item.dataset.productId;
    let variantIds = item.dataset.variantId.split("+");
    const slug = item.dataset.slug;
    const productURL = item.dataset.productUrl;

    variantIds.forEach(variantId => {
      let product = {
        epi: +variantId,
        empi: productId,
        du: productURL
      }
      
      swat.removeFromWishList(
        product,
        (response) => {
          // console.log(1, response);
          const wishlistItem = wishlistObject.find(x => x.slug == slug);

          if(wishlistItem){
            product = {
              epi: +wishlistItem.variantID,
              empi: +wishlistItem.productID,
              du: wishlistItem.du
            }
            swat.removeFromWishList(
              product,
              (response) => {
                // console.log(1, response);
              },
              (error) => {
                // console.log(2, error, product);
              }
            );
          }
        },
        (error) => {
          // console.log(2, error, product);
        }
      );

     
    })
  }
  
  const initLogic = (swat) => {
    const items = document.querySelectorAll(".product-item");

    items.forEach((item) => {
      let wishlistButton = item.querySelector(".swym-add-to-wishlist-view-product");
      
      if(wishlistButton){
        wishlistButton.addEventListener("click", () => onItemRemoveFromWishlist({ item, swat }));
      }
    });
  }

  const loadWishlistProducts = async (slugsList) => {
    const list = document.querySelector(".my-favorites__list");
    const sectionId = "my-favorites-list";
    const locale = document.documentElement.getAttribute("lang");
    const sectionURL = `/?sections=${sectionId}&handle=${slugsList}&is_topology=false&locale=${locale}`;
    const response = await fetch(sectionURL);
    const jsonData = await response.json();
    const html = jsonData['my-favorites-list'];
    const container = document.createElement("DIV");
    container.innerHTML = html;
    let products = container.querySelectorAll(".product-item");
    let productsHTML = "";
    products.forEach(product => {
      productsHTML += product.outerHTML;
    })
    list.insertAdjacentHTML("afterBegin", productsHTML);
    
    setTimeout(setItemsListeners, 0);
  }
  
  async function onSwymLoadCallback(swat) {
    swat.fetch(async (allWishlistedProducts) => {
      const slugs = [];
      const list = document.querySelector(".my-favorites__list");
      let slugsList = [];

      if(!list) return;

      for await (const p of allWishlistedProducts) {
        const url = p.du;
        const slug = url.slice(url.indexOf('/products/') + 10);

        if(!slugs.includes(slug) && slug.indexOf("validation") === -1){
          slugsList.push(slug);
          slugs.push(slug);
          wishlistObject.push({
            slug,
            variantID: p.epi,
            productID: p.empi,
            du: p.du
          });
        }

        if(slugsList.length == 12){
          await loadWishlistProducts(slugsList);
          slugsList = [];
        }
      }

      if(slugsList.length){
        await loadWishlistProducts(slugsList);
      }

      await topologyWishlist.init(slugs);
      setTimeout(() => {
        initLogic(swat);
        addDataLayers_ProductClickEvent();
      }, 0);
    }, () => {
      topologyWishlist.init(slugs);
    });
  }

  if (!window.SwymCallbacks) {
    window.SwymCallbacks = [];
  }
  
  window.SwymCallbacks.push(onSwymLoadCallback);
}

/* Show\hide password logic
Page: all pages with inputs
*/

const initPasswordToggles = () => {
  const toggles = document.querySelectorAll(".toggle-password-visibility");

  const onPasswordToggle = (e) => {
    toggles.forEach(toggle => {
      toggle.classList.toggle("toggle-password-visibility--visible");
      const isVisible = toggle.classList.contains("toggle-password-visibility--visible");
      toggle.parentNode.querySelector("input").setAttribute("type", isVisible ? "text" : "password");
    })
  }

  toggles.forEach(toggle => toggle.addEventListener("click", onPasswordToggle));
}

/* Mobile header menu logic
Page: all pages
*/

const initHeaderMenu = () => {
  const accountToggler = document.querySelector("[data-account-toggler]");
  const drawer = document.querySelector(".drawer-menu__bottom");
  const backLink = document.querySelector(".my-account-tab .drawer-menu__item--heading-back-link");

  if(!accountToggler) return; 

  const onAccountToggle = (e) => {
    e.preventDefault();
    drawer.classList.toggle("drawer-menu__bottom--active");
  }

  const onBack = (e) => {
    e.stopImmediatePropagation();
    drawer.classList.toggle("drawer-menu__bottom--active");
  }

  backLink.addEventListener("click", onBack);
  accountToggler.addEventListener("click", onAccountToggle)
}


/* Registration form logic
Page: /account/login
*/
const initLoginForm = () => {
  const loginButton = document.querySelector("#log-in-action");

  if(loginButton){
    const loginDataLayerFlag = (e) => {
      window.localStorage.setItem("loginDone", true);
    }
    loginButton.addEventListener("click", loginDataLayerFlag);
  }
}

/* Registration form logic
Page: /account/register
*/

const errorKeys = {
  enterFirstName: "enterFirstName",
  enterLastName: "enterLastName",
  enterValidEmail: "enterValidEmail",
  enterValidPhone: "enterValidPhone",
  enterValidPostalCode: "enterValidPostalCode",
  enterValidDate: "enterValidDate",
  enterValidPassword: "enterValidPassword",
  enterValidPrescriptionName: "enterValidPrescriptionName",
  thisFieldIsRequired: "thisFieldIsRequired"
}

const initRegistrationForm = () => {
  const datePicker = document.querySelector("[data-date-picker]");
  const form = document.querySelector("#RegisterForm");
  const errorsWrapper = document.querySelector("[data-form-validation-status]");
  const errorsContainer = document.querySelector("[data-form-validation-status-container]");

  // const genderField = document.querySelector("[name='customer[note][gender]']");
  const emailField = document.querySelector("[name='customer[email]']");
  // const confirmEmailField = document.querySelector("[name='confirm-email']");
  const passwordField = document.querySelector("[name='customer[password]']");
  const confirmPasswordField = document.querySelector("[name='confirm-password']");
  const phoneField = document.querySelector("[name='customer[note][phone-number]']");
  const postalcodeField = document.querySelector("[name='customer[note][postal-code]']");
  const firstNameField = document.querySelector("[name='customer[first_name]']");
  const lastNameField = document.querySelector("[name='customer[last_name]']");
  const dateOfBirthField = document.querySelector("[name='customer[note][date-of-birth]']");
  const termsAndConditions = document.querySelector("[name='customer[note][accept-terms-and-conditions]']");

  if(!datePicker || !form) return;

  const format = "yyyy-mm-dd";
  let language = document.documentElement.getAttribute("lang");

  if(language == "en-CA") language = "en";
  if(language == "fr-CA") language = "fr";

  const startViewParam = {
    decades: 3,
    years: 2,
    monthes: 1,
    days: 0
  }

  const subtractYears = (date, years) => {
    date.setFullYear(date.getFullYear() - years);
  
    return date;
  }
  
  const currentDate = new Date();
  const maxDate = subtractYears(currentDate, 14);

  new Datepicker(datePicker, {
    format,
    language,
    startView: startViewParam.years,
    autohide: true,
    minDate: new Date("01-01-1900"),
    maxDate: maxDate
  }); 
  
  const { MaskInput } = Maska

  new MaskInput("[data-mask]")

  const selects = document.querySelectorAll("[data-select]");

  if(!window.niceSelectInstances) window.niceSelectInstances = [];

  selects.forEach(select => {
    const instance = NiceSelect.bind(select);
    window.niceSelectInstances.push(instance);
  });

  const onFormSubmit = (e) => {
    e.preventDefault();
    e.stopImmediatePropagation();

    let basicNesting = 1;
    let nesting = 2;

    // const isValidGender = notEmptyField(genderField);

    const isValidEmailAddress = notEmptyField(emailField, basicNesting, errorKeys.enterValidEmail) && isValidEmail(emailField);
    // const isValidConfirmEmail = notEmptyField(confirmEmailField, basicNesting, errorKeys.enterValidEmail) && isValidEmail(confirmEmailField);
    const isValidPassword = notEmptyField(passwordField, basicNesting, errorKeys.enterValidPassword);
    const isValidConfirmPassword = notEmptyField(confirmPasswordField, basicNesting, errorKeys.enterValidPassword);

    // const isEmailsSame = isValidEmailAddress && isValidConfirmEmail && doValuesMatch(emailField, confirmEmailField);
    const isEmailsSame = isValidEmailAddress;
    const isPasswordsSame = isValidPassword && isValidConfirmPassword && doValuesMatch(passwordField, confirmPasswordField, basicNesting);
    const isPhoneValid = notEmptyField(phoneField, basicNesting, errorKeys.enterValidPhone) && isValidPhone(phoneField);
    const isPostalCodeValid = notEmptyField(postalcodeField, basicNesting, errorKeys.enterValidPostalCode) && isValidPostalCode(postalcodeField);
    const isFirstNameEmpty = notEmptyField(firstNameField, basicNesting, errorKeys.enterFirstName);
    const isLastNameEmpty = notEmptyField(lastNameField, basicNesting, errorKeys.enterLastName);
    const isDateOfBirthEmpty = notEmptyField(dateOfBirthField, nesting, errorKeys.enterValidDate);
    const isTermsAndPrivacyPolicyChecked = checkedBox(termsAndConditions, basicNesting, errorKeys.thisFieldIsRequired);
    /*
      Function: passwordValidation
      Description: Performs validation checks on a password field and returns an array of error messages.
      Parameters:
        - passwordField: The password input field to be validated.

      Function: removeDuplicates
      Description: Removes duplicate error messages from an array of password validation errors.
      Parameters:
        - validationErrors: An array of error messages from password validation.
    */
    const passwordErrors = removeDuplicates(passwordValidation(passwordField), passwordValidation(confirmPasswordField));
    /*
      Variables: passwordErrors, isPasswordValid
      Description: Evaluates password validation errors and their duplicates to determine password validity.
        - passwordErrors: Array of unique password validation errors.
        - isPasswordValid: Boolean indicating whether the password is valid, based on the absence of errors.
    */
    const isPasswordValid = passwordErrors.length === 0;
    
    if (!isPasswordValid) {
      errorsContainer.innerHTML = passwordErrors.map(message => `<li>${message}</li>`).join('');
      errorsWrapper.classList.remove('hidden');
    } else {
      errorsContainer.innerHTML = '';
      errorsWrapper.classList.add('hidden');
    }

    if(
      isEmailsSame
      && isPasswordsSame
      && isPhoneValid
      && isPostalCodeValid
      && isFirstNameEmpty
      && isLastNameEmpty
      && isDateOfBirthEmpty
      && isTermsAndPrivacyPolicyChecked
      && isPasswordValid
    ){
      // Used by Datalayer
      window.localStorage.setItem("RegisterDone", true);

      // if validation was not failed, submit the form
      e.target.submit();
    }
  }

  const phoneMaskOptions = {
    mask: '(#00) #00-0000',
    definitions: {
      '#': /[2-9]/i
    }
  };

  const postalCodeOptions = {
    mask: '#0$ 0$0',
    definitions: {
      '#': /[ABCEGHJKLMNPRSTVXY]/i,
      "$": /[ABCEGHJKLMNPRSTVXYWZ]/i
    },
    postProcess: (value) => value.slice(0, 7)
  };

  IMask(phoneField, phoneMaskOptions);
  IMask(postalcodeField, postalCodeOptions);

  form.addEventListener("submit", onFormSubmit);
}

/*
  *****************************************************
  Reorder contact lenses page logic
  Page: /pages/reorder-contact-lenses
  ******************************************************
*/
/* ===== START reorderContactLensesInit =====*/
const reorderContactLensesInit = () => {
  const target = document.querySelector('.reorder-contact-lenses__form');

  if(!target) return;

  const config = {
    childList: true,
    subtree: true,
  };

  const onFormLoad = () => {
    const phoneField = document.querySelector(".reorder-contact-lenses label[for*='phone'] + .globo-form-input input");
    let dateField = document.querySelector(".reorder-contact-lenses label[for*='datetime'] + .globo-form-input input");

    if(!phoneField) return;

    const form = document.querySelector("form.g-container");
    const inputs = target.querySelectorAll("input");
    const fields = {
      firstName: inputs[0],
      lastName: inputs[1],
      email: inputs[2],
      phone: inputs[3],
      dob: inputs[4]
    }
    const customerData = window["customerInfo"];

    fields.firstName.value = customerData['firstName'];
    fields.lastName.value = customerData['lastName'];
    fields.email.value = customerData['email'];
    fields.phone.value = customerData['phone'];

    const phoneMaskOptions = {
      mask: '(#00) #00-0000',
      definitions: {
        '#': /[2-9]/i
      }
    };

    const { MaskInput } = Maska

    new MaskInput("[data-mask]")

    IMask(phoneField, phoneMaskOptions);

    const onSubmit = (e) => {
      const phoneNumberRegex = new RegExp(/^\([2-9]\d{2}\) [2-9]\d{2}-\d{4}$/);
      const isValid = phoneNumberRegex.test(phoneField.value);
      const messagesContainer = document.querySelector("label[for*='phone'] ~ .messages");
      const text = document.querySelector(".reorder-contact-lenses__form").getAttribute('data-invalid-phone');

      if(!isValid){
        e.stopImmediatePropagation();
        e.preventDefault();
      }

      setTimeout(() => {
        if(messagesContainer.children.length <= 0){
          messagesContainer.innerHTML = isValid ? "" : `<p class="help-block error">${text}</p>`;

          if(!isValid){
            const parent = phoneField.parentNode.parentNode;
            parent.classList.remove("has-success");
            parent.classList.add("has-error");
          }
        }
      }, 300);
    }

    form.addEventListener("submit", onSubmit);

    setTimeout(() => {
      // Manage datepicker calendar
      if(dateField.parentNode) dateField.parentNode.innerHTML = dateField.parentNode.innerHTML;

      dateField = document.querySelector(".reorder-contact-lenses label[for*='datetime'] + .globo-form-input input");
      dateField.removeAttribute('readonly');

      const format = "yyyy-mm-dd";
      const language = document.documentElement.getAttribute("lang");

      const startViewParam = {
        decades: 3,
        years: 2,
        monthes: 1,
        days: 0
      }

      const subtractYears = (date, years) => {
        date.setFullYear(date.getFullYear() - years);
      
        return date;
      }
      
      const currentDate = new Date();
      const maxDate = subtractYears(currentDate, 14);

      const dateFieldController = new Datepicker(dateField, {
        format,
        language,
        startView: startViewParam.years,
        autohide: true,
        minDate: new Date("01-01-1900"),
        maxDate: maxDate
      }); 

      dateFieldController.setDate(customerData['dob']);
      
      dateField.setAttribute("data-mask", "####-##-##");

      const { MaskInput } = Maska

      new MaskInput("[data-mask]")
    }, 1000);
  } // end of onFormLoad

  const adjustAfterFormSubmit = () => {
    const button = document.querySelector(".reorder-contact-lenses__button");
    button.classList.add("active");
  }

  let callBackTimer;

  const callback = () => {
    let i = 0;

    callBackTimer = setInterval(() => {
      if(i++ >= 6) clearInterval(callBackTimer);

      const isFormHidden = document.querySelector(".reorder-contact-lenses label[for*='phone']").offsetHeight;

      if(isFormHidden == 0){
        adjustAfterFormSubmit();
      }
    }, 200);

    onChangeObserver.observe(target, config);
  };

  const onLoadCallback = () => {
    onLoadObserver.disconnect();

    setTimeout(() => {
      onFormLoad();
    }, 0);
  }

  const onChangeObserver = new MutationObserver(callback);
  onChangeObserver.observe(target, config);
  
  const onLoadObserver = new MutationObserver(onLoadCallback);
  onLoadObserver.observe(target, config);
}
/* ===== END reorderContactLensesInit =====*/

const initBookAppointmentLink = ({
  variant,
  isOnInit = false
}) => {
  const productButton = document.querySelector("[data-book-an-appointment-button]");
  const eyeExamLink = document.querySelectorAll("[data-book-an-eye-exam-link]");
  const customer = window['customerInfo'];

  const firstName = customer['firstName'];
  const lastName = customer['lastName'];
  const email = customer['email'];
  const phone = customer['phone'];
  const dob = customer['dob'];
  const provinceCode = customer['province_code'];
  const province = customer['province'];
  const json = `{"firstName":"${firstName}","lastName":"${lastName}","email":"${email}","phone":"${phone}","dob":"${dob}","province_code":"${provinceCode}","province":"${province}"}`;
  const token = encodeURIComponent(btoa(json));
  const protocol = "https"; 
  let host;

  switch(window.location.host){
    case "greiche-dev.myshopify.com":
    case "greiche-dev-manu.myshopify.com":
      host = "greiche-shopify.nvgstaging.ca";
    break;
    default:
    case "greiche-scaff.myshopify.com":
    case "greiche-scaff.com":
      host = "rdv.greiche-scaff.com";
    break;
  }

  const lang = document.documentElement.getAttribute('lang');
  const link = `${protocol}://${host}/${lang}/n-app/?type=exam&stage=Form&token=${token}`;

  if(eyeExamLink.length){
    eyeExamLink.forEach(eyeLink => {
      eyeLink.href = link;
    });
  }

  if(productButton && (variant || isOnInit)){
    const group = document.querySelector(".product__controls-group");
    let variantId;

    if(!group){
      variantId = variant?.id ?? document.querySelector("[data-variant-select] option").value;
    }else{
      variantId = variant?.id ?? group.dataset.currentVariantId;
    }
    
    let variantMetafields = JSON.parse(document.querySelector(`#ProductVariant-${variantId}-Json`)?.innerHTML ?? "{}");
    const isAvailableInWebStock = variantMetafields.is_available_in_web_stock === "true" ? true : false;
    const isAvailableOffline = variantMetafields.is_available_offline === "true" ? true : false;
    
    if (!isAvailableInWebStock && isAvailableOffline) {
      productButton.href = productButton.getAttribute('data-href');
    }else{
      productButton.removeAttribute("href");
    }
  }else if(productButton){
    productButton.removeAttribute("href");
  }

  const pathname = window.location.pathname;
  const isBookAppointmentPage = pathname.indexOf("examen-de-vue-consultations") !== -1 || pathname.indexOf("eye-exam-consultations") !== -1;

  if(isBookAppointmentPage){
    const grid = document.querySelector(".multi-column__grid");

    if(!grid) return;

    const buttons = grid.querySelectorAll(".btn");

    if(!buttons) return;

    buttons.forEach((button, i) => {
      let type;

      if(i == 0){
        type = "exam";
      }else if(i == 1){
        type = "instore";
      }else{
        type = "online";
      }

      const lang = document.documentElement.getAttribute('lang');
      const href = `${protocol}://${host}/${lang}/n-app/?type=${type}&stage=Form&token=${token}`;
      button.href = href;
    });
  }
}

const proxyAppRoutes = {
  customerScan: "customer-scan",
  prescription: "prescription",
  setDefault: "prescription/setDefault",
  vtoModels: "vto-models",
  favorites: "favorites",
  collection: "products/collection/",
  productScan: "product-scan",
  deleteAccount: (id) => `customers/${id}/delete`
}

const proxyAppApi = {
  request: async (route, method = "GET", data, isFormData = false) => {
    const params = {
      method,
      mode: 'no-cors',
      credentials: 'same-origin'
    }

    if(data && !isFormData) params["body"] = JSON.stringify(data);
    else if (data) params["body"] = data;

    const result = await fetch(`/apps/${env}/${route}`, params);

    try{
      const json = await result.json();
      return json;
    }catch(e){
      return null;
    }
  }
}

/* My scan page logic
Page: /pages/my-scan
*/

const myScanPageInit = async () => {
  const customerId = window['customerInfo']['id'];
  const classes = {
    frame: ".my-scan__scan-frame",
    rescanDate: ".my-scan__rescan-date",
    rescanLink: ".my-scan__rescan-link",
    noScanGrid: ".my-scan__grid--no-scan",
    withScanGrid: ".my-scan__grid--with-scan",
    withNoScanGridTitle: ".my-scan__title--with-no-scan",
    activeGrid: "my-scan__grid--active",
    downloadLink: ".my-scan__download-link",
    loader: ".lds-my-scan-wrapper",
    loaderHidden: "lds-my-scan-wrapper--hidden"
  }

  const iframe = document.querySelector(classes.frame);
  const isMyScanPage = iframe;
  let lastVersion = undefined;

  if(!isMyScanPage) return;

  const rescanDate = document.querySelector(classes.rescanDate);
  const rescanLink = document.querySelector(classes.rescanLink);
  const noScanGrid = document.querySelector(classes.noScanGrid);
  const withScanGrid = document.querySelector(classes.withScanGrid);
  const withNoScanSubtitle = document.querySelector(classes.withNoScanGridTitle);
  const downloadLink = document.querySelector(classes.downloadLink);
  const loader = document.querySelector(classes.loader);

  const pollingFunction = async () => {
    const data = await getCustomerScan(customerId);

    if(!data){
      return;
    }
    
    const {
      route,
      token,
      tokenCreationDate,
      version,
      status
    } = data;

    const hasNoScan = data?.message != "" && data?.message != null;

    const messages = document.querySelectorAll(".my-scan__in-progress-message");

    messages.forEach(message => {
      if(status == "INPROGRESS"){
        message.classList.add("my-scan__in-progress-message--active");
      }else{
        message.classList.remove("my-scan__in-progress-message--active");
      }
    })

    if(version !== lastVersion || hasNoScan){
      lastVersion = version;
      
      loader.classList.add(classes.loaderHidden);

      if(route){
        const iframeLink = `https://widget-demo.topology-engineering.com/v1/${route}?hint=false&slideFull=true`; 
  
        iframe.setAttribute("src", iframeLink);
        rescanDate && (rescanDate.innerHTML = moment(tokenCreationDate).format("MMM D, YYYY"));
        rescanLink && (rescanLink.href = token);
  
        withScanGrid.classList.add(classes.activeGrid);
        withNoScanSubtitle.classList.add(classes.activeGrid);
        noScanGrid.classList.remove(classes.activeGrid);
      }else{
        downloadLink && (downloadLink.href = token); //lang == "en" || lang == "en-CA" ? token : frenchLink;
        noScanGrid.classList.add(classes.activeGrid);
        withScanGrid.classList.remove(classes.activeGrid);
        withNoScanSubtitle.classList.remove(classes.activeGrid);
      }
      const { qr_code } = await ensureTokenAndQRCode();
      await processQRCode('token', token, qr_code);
    }
  }

  pollingFunction();
  setTimeout(pollingFunction, 1000);
  setTimeout(pollingFunction, 2000);
  setTimeout(pollingFunction, 3000);
  setTimeout(pollingFunction, 4000);
  setInterval(pollingFunction, 5000);
}

/* My prescriptions logic
Page: /pages/my-prescriptions
Popup: Cart to checkout popup
*/

const myPrescriptionsInit = async () => {
  const activeTabClassname = "my-prescriptions__tab--active";
  const activeTabTitleClassname = "my-prescriptions__tab-title--active";

 const tabs = {
   prescriptionsList: {
      tabKey: "[data-prescriptions-list-tab]",
      titleKey: "[data-prescriptions-list-title-tab]",
      progressBarTitle:stepTitles[locale].selectprescription,
      nexStepProgressBarTitle:stepTitles[locale].addPrescription,
      number: "1. ",
      progressPercentage: 33
    },
    addPrescription:{
      tabKey:"[data-add-prescription-tab]",
      titleKey: "[data-add-prescription-title-tab]",
      progressBarTitle:stepTitles[locale].addPrescription,
      nexStepProgressBarTitle:stepTitles[locale].prescriptionPhoto,
      number: "2. ",
      progressPercentage: 66
    },
    uploadPrescription: {
      tabKey:"[data-upload-prescription-tab]",
      titleKey: "[data-add-prescription-title-tab]",
      progressBarTitle:stepTitles[locale].prescriptionPhoto,
      nexStepProgressBarTitle:stepTitles[locale].checkout,
      number: "3. ",
      progressPercentage: 100
    }
  }
  const setScrollTopForSelects = () => {
    const niceSelects = document.querySelectorAll('.nice-select');

    niceSelects.forEach(select => {
      select.classList.add("open");
      select.classList.add("opacity-zero");

      setTimeout(() => {
        const list = select.querySelector(".list");
        const option = select.querySelector('.option.selected');
        const optionTop = option.offsetTop;
        const scrollTop = optionTop - ((list.offsetHeight - option.offsetHeight) / 2);

        list.scrollTop = scrollTop;
        select.classList.remove("open");
        select.classList.remove("opacity-zero");
      }, 0);
    })
  }

  const switchTab = (tab, container) => {
    const activeTab = container.querySelector(`.${activeTabClassname}`);
    const activeTitle = container.parentNode.querySelector(`.${activeTabTitleClassname}`);
    const nextStepTitle = container.parentNode.querySelector(tab.titleKey)
    activeTab.classList.remove(activeTabClassname);
    activeTitle && activeTitle.classList.remove(activeTabTitleClassname);
    container.querySelector(tab.tabKey).classList.add(activeTabClassname);
    nextStepTitle && nextStepTitle.classList.add(activeTabTitleClassname);
    updateProgressBar(container, tab)
    setScrollTopForSelects();
  }

  const onAddPrescription = function(e){
    const newTab = tabs.addPrescription;
    const container = this.parentNode.parentNode.parentNode;
    
    const prescriptionsWrapper =  e.target.closest(".my-prescriptions__list--full");
    const finishPurchaseButton = prescriptionsWrapper.querySelector(popupSelectors.finishPrescriptionFlow)
    switchTab(newTab, container);
    finishPurchaseButton && (finishPurchaseButton.disabled = true);
  }

  const onCancel = function(){
    const newTab = tabs.prescriptionsList;
    const container = this.parentNode.parentNode.parentNode;

    const area = document.querySelector(".my-prescriptions__add-prescription-upload-area");
    area.classList.remove("my-prescriptions__add-prescription-upload-area--uploaded");

    switchTab(newTab, container);
  }

  const onUploadContinue = function(e){
    e.preventDefault();

    const container = this.parentNode.parentNode.parentNode;

    const inputs = container.querySelectorAll("input:not([type='file'])");
    let error = false;
    inputs.forEach(input => {
      const nesting = input.dataset.datePicker ? 2 : 1;
      error = notEmptyField(input, nesting, null, input.dataset.validateError);
      console.log("error", error)
    });
    if(!error) return;
    const newTab = tabs.uploadPrescription;

    switchTab(newTab, container);
  }

  const clearFormAfterSubmit = () => {
    const forms = document.querySelectorAll("[data-add-prescription-tab]");

    forms.forEach(form => {
      const inputs = form.querySelectorAll("input");

      inputs.forEach(input => input.value = "");

      const selects = form.querySelectorAll("select");

      selects.forEach(select => {
        const options = Array.from( select.options );
        const defaultOptionIndex = options.findIndex( (opt) => opt.dataset.defaultOption === "true" );

        select.selectedIndex = defaultOptionIndex;
      });

      window.niceSelectInstances.forEach(instance => {
        instance.update();
      })
    });

    const areas = document.querySelectorAll(".my-prescriptions__add-prescription-upload-area");

    areas.forEach(area => {
      area.classList.remove("my-prescriptions__add-prescription-upload-area--uploaded");
    })
  }

  const onSubmit = async function(e){
    e.preventDefault();

    this.classList.add("loading");
    this.disabled = true;

    const container = this.parentNode.parentNode.parentNode.parentNode;
    const form = container.querySelector(tabs.addPrescription.tabKey);
    const formData = new FormData(form);
    let name = "";
    let prescription = {
      "odaxis": "0",
      "osaxis": "0",
      "odspheretext": "0",
      "osspheretext": "0",
      "odcylindertext": "0",
      "oscylindertext": "0",
      "od_add": "0",
      "os_add": "0",
      "od_multifocal": null,
      "os_multifocal": null,
      "clensodbasecrv1": null,
      "clensosbasecrv1": null,
      "clensoddiam1": null,
      "clensosdiam1": null,
      "od_balance": "No",
      "os_balance": "No",
      "od_prism1": "No",
      "os_prism1": "No",
      "od_prism2": null,
      "os_prism2": null,
      "od_base1": null,
      "os_base1": null,
      "od_base2": null,
      "os_base2": null,
      "od_bc": null,
      "os_bc": null,
      "od_vertex": null,
      "os_vertex": null,
    };
    let issue_date = "";

    for(let [key, value] of formData) {
      if(key == "prescription_name") name = value;
      if(key == "issue_date") issue_date = value;
      if(key == "sph_right") prescription["odspheretext"] = value;
      if(key == "sph_left") prescription["osspheretext"] = value;
      if(key == "cyl_right") prescription["odcylindertext"] = value;
      if(key == "cyl_left") prescription["oscylindertext"] = value;
      if(key == "axis_right") prescription["odaxis"] = value;
      if(key == "axis_left") prescription["osaxis"] = value;
      if(key == "add_right") prescription["od_add"] = value;
      if(key == "add_left") prescription["os_add"] = value;
      if(key == "bal_right") prescription["od_balance"] = value;
      if(key == "bal_left") prescription["os_balance"] = value;
      if(key == "prism_right") prescription["od_prism1"] = value;
      if(key == "prism_left") prescription["os_prism1"] = value;
    }

    const input = document.querySelector(".my-prescriptions__add-prescription-choose-file");

    const sendFormData = new FormData();
    sendFormData.append("name", name);
    sendFormData.append("prescription", JSON.stringify(prescription));
    sendFormData.append("issue_date", issue_date);
    sendFormData.append("prescription_file", input.files[0]);
    
    try{
      const res = await setPrescription(sendFormData);

      if(!res){
        let errorMessage = window['validationErrors']['pdf_protected'];
        errorMessage = errorMessage.replace("&#39;", "'");

        alert(errorMessage);
      }

      const newTab = tabs.prescriptionsList;
      switchTab(newTab, container);
      clearFormAfterSubmit();

      const prescriptions = await fetchPrescriptions();
      displayPrescriptions(prescriptions);
    }catch(e){

    }

    this.classList.remove("loading");
    this.disabled = false;
  }

  const initForm = () => {
    const datePicker = document.querySelectorAll("[data-date-picker]");
    const addPrescription = document.querySelectorAll(".my-prescriptions__list-item--add");

    if(!datePicker.length || !addPrescription.length) return;

    const format = "yyyy-mm-dd";
    const language = document.documentElement.getAttribute("lang");

    const startViewParam = {
      decades: 3,
      years: 2,
      monthes: 1,
      days: 0
    }

    datePicker.forEach(picker => {
      new Datepicker(picker, {
        format,
        language,
        startView: startViewParam.years,
        autohide: true,
        minDate: new Date("01-01-2012"),
        maxDate: new Date(`12-31-${new Date().getFullYear()}`)
      }); 
    })

    const { MaskInput } = Maska

    new MaskInput("[data-mask]")

    const selects = document.querySelectorAll("[data-select]");

    if(!window.niceSelectInstances) window.niceSelectInstances = [];

    selects.forEach(select => {
      const instance = NiceSelect.bind(select);
      window.niceSelectInstances.push(instance);
    });

    const cancelButtons = document.querySelectorAll("[data-cancel-add-prescription]");
    cancelButtons.forEach(cancel => cancel.addEventListener("click", onCancel));

    const continueUploadButton = document.querySelectorAll("[data-continue-add-prescription]");

    continueUploadButton.forEach(button => {
      button.addEventListener("click", onUploadContinue);
    });
  
    const submitButtons = document.querySelectorAll("[data-submit-add-prescription]");
    
    submitButtons.forEach(button => {
      button.addEventListener("click", onSubmit);
    })

    addPrescription.forEach(item => {
      item.addEventListener("click", onAddPrescription);
    })
    const parentWrapper = document.querySelector(".user-page-prescriptions-wrapper");
    updateProgressBar(parentWrapper, tabs.prescriptionsList)
  }
  
  initForm();
  
  const classes = {
    container: ".my-prescriptions",
    list: ".my-prescriptions__list",
    makeDefaultButtons: ".my-prescriptions__make-default",
    defaultItem: "my-prescriptions__list-item--default",
    fileInput: ".my-prescriptions__add-prescription-choose-file",
    popupListItems: ".add-prescription-flow-popup .my-prescriptions__list-item:not(.my-prescriptions__list-item--add)",
    cartSubmit: "cart__submit",
    quickCartSubmit: "quick-cart__submit",
    popup: "cart-to-checkout-popup",
    popupActive: "cart-to-checkout-popup--active",
    item: ".my-prescriptions__list-item:not(.my-prescriptions__list-item--add)",
    activeItem: "my-prescriptions__list-item--active",
    close: "cart-to-checkout-popup__close",
    continueButton: "[data-finish-prescription-flow]",
    skipAddingPrescription: "[data-skip-adding-prescription]",
    proceedToCheckoutButton: "[data-proceed-to-checkout]",
    continueToCheckout: "[data-continue-to-checkout]",
    activeTab: "my-prescriptions__tab--active",
    prescriptionsTab: ".cart-to-checkout-popup [data-prescriptions-list-tab]",
    myScanTab: ".cart-to-checkout-popup [data-my-scan-tab]",
    myScanFitsTab: ".cart-to-checkout-popup [data-my-scan-fits-tab]",
    fitsList: ".fits-list",
    quickCartOverlay: "#shopify-section-quick-cart",
    validPrescriptionBlock: "[data-valid-prescription]",
    invalidPrescriptionBlock: "[data-invalid-prescription]"
  }

  const cartSubmitButton = document.querySelector(`.${classes.cartSubmit}`);
  const popup = document.querySelector(`.${classes.popup}`);
  const continueButton = document.querySelector(classes.continueButton);
  const closeButton = document.querySelector(`.${classes.close}`);
  const skipAddingPrescription = document.querySelector(classes.skipAddingPrescription);
  const proceedToCheckoutButton = document.querySelector(classes.proceedToCheckoutButton);
  const continueToCheckout = document.querySelector(classes.continueToCheckout);
  const quickCartOverlay = document.querySelector(classes.quickCartOverlay);
  const validPrescriptionBlock = document.querySelector(classes.validPrescriptionBlock);
  const invalidPrescriptionBlock = document.querySelector(classes.invalidPrescriptionBlock);

  const checkHasAtLeastOneLense = async () => {
    let hasAtLeastOneLense = false;
    const cart = await get();
    const items = cart.items;

    for (let i = 0; i < items.length; i++) {
      if (items[i].product_type == "Lenses") {
        hasAtLeastOneLense = true;
        break;
      }
    }

    return hasAtLeastOneLense;
  }

  window.addEventListener("click", async (e) => {
    const { target } = e;

    if(target.classList.contains(classes.quickCartSubmit)){
      e.preventDefault();
      e.stopPropagation();
      cartToCheckoutFlowInit(e);
    }
  })

  const removeItemsThatDontFit = async ({
    listFromProxy
  }) => {
    let cart = await get();

    for(let itemKey in cart.items){
      const item = cart.items[itemKey];
      const type = item.product_type;
      const sku = item.sku;
      const key = item.key;

      if(type == "Lenses" || type == "Lenses treatment" || type == "Contact lenses") continue;

      const doesFit = listFromProxy.products.some(p => p.recommended == true && p.variants.some(v => v.sku == sku));
      const isNotDigitized = listFromProxy.products.some(p => p.digitalized == false && p.variants.some(v => v.sku == sku));

      if(!doesFit && !isNotDigitized){
        const cartItem = document.querySelector(`[data-key="${key}"]`);
        const lenseKey = cartItem?.dataset?.lenseKey;
        const randomID = item.properties["_id"];

        const hasLenseProduct = lenseKey != "" && randomID;

        await updateItem(key, 0, hasLenseProduct ? false : true);
        
        if(hasLenseProduct){
          await updateItemByRandomId(randomID, 0);
        }

        removeItemsThatDontFit({
          listFromProxy
        });

        break;
      }
    }

    cart = await get();

    if(cart.items.length){
      document.querySelector("[data-continue-to-checkout]").classList.add("active");
    }
  };

  const onContinue = async (savePrescriptionId = true) => {
    const customerId = window['customerInfo']['id'];
    const data = await getCustomerScan(customerId);

    if(savePrescriptionId){
      const activeItem = document.querySelector(".my-prescriptions__list-item--active");
      const prescriptionId = activeItem?.dataset.id;
      
      prescriptionId && window.localStorage.setItem("prescriptionId", prescriptionId);
    }

    if(!data || data.version === null || data.route == ""){ // No scan
      const activeTab = continueButton.closest("popup-custom");
      const noScanPopup = document.querySelector(".no-scan-popup");
      
      if (activeTab) activeTab.toggle();
      if (noScanPopup) noScanPopup.classList.add("no-scan-popup--active");
    }else{
      const data = await fetch("/cart.js");
      const cart = await data.json();

      let cartItemsSKUlist = [];

      cart.items.forEach(item => {
        const sku = item.sku;

        if(item.product_type != "Lenses" && item.product_type != "Lenses treatment"){
          cartItemsSKUlist.push(sku);
        }
      });
      
      cartItemsSKUlist = [...new Set(cartItemsSKUlist)];

      const listFromProxy = await customCatalog.fetchProducts({
        "variants-sku": cartItemsSKUlist,
        per_page: 9999,
        filters: false,
      });

      await noFitPopupInit(cart, listFromProxy);
    }
  }

  const onClose = () => {
    document.body.style.overflow = "";
    popup.classList.remove(classes.popupActive);

    const activeTab = document.querySelector(`.${classes.popup} .${classes.activeTab}`);
    if(activeTab) activeTab.classList.remove(classes.activeTab);
    quickCartOverlay.style.display = "";
  }

  const openCartToCheckoutPopup = (e) => {
    if(!popup) return;

    if(e){
      e.preventDefault();
      e.stopPropagation();
    }

    quickCartOverlay.style.display = "none";
    document.body.style.overflow = "hidden";
    popup.classList.add(classes.popupActive);
    
    const activeTab = document.querySelector(classes.prescriptionsTab);
    activeTab?.classList.add(classes.activeTab);
  }

  const noFitPopupInit = async (cart, listFromProxy) => {
    const texts = window["prescriptionTexts"];
    const fitsListContainer = document.querySelector(classes.fitsList);

    const skus = [];
    let template = "";
    let doesntFitAtLeastOne = false;

    cart.items.forEach(item => {
      const type = item.product_type;
      const sku = item.sku;

      if(type == "Lenses" || type == "Lenses treatment" || type == "Contact lenses") return;

      if(skus.includes(sku)) return;
      skus.push(sku);
      
      const doesFit = listFromProxy.products.some(p => p.recommended == true && p.variants.some(v => v.sku == sku));
      const isNotDigitized = listFromProxy.products.some(p => p.digitalized == false && p.variants.some(v => v.sku == sku));

      if(!doesFit && !isNotDigitized){
        doesntFitAtLeastOne = true;
      }

      const html = `<div class="fits-list__item ${ doesFit || isNotDigitized ? "" : "fits-list__item--fail" }">
        <div class="fits-list__item-inner">
          <div class="fits-list__image">
            <img
              src="${item.image}"
              alt=""
            >
          </div>

          <div class="fits-list__model">
            ${item.vendor}
          </div>

          <div class="fits-list__title">
            ${item.product_title.replace(/- RX/g, "").replace(/- No treatment/g, "")}
          </div>

          <div class="fits-list__price">
            ${
              item.discounted_price < item.price ? `
                ${(item.discounted_price / 100).formatMoney()}
                <span class="fits-list__original-price">${(item.price / 100).formatMoney()}</span>
              ` : (item.price / 100).formatMoney()
            }
          </div>
        </div>

        <div class="fits-list__text">
          ${ doesFit || isNotDigitized ? `
            <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M9.09375 22H15.0938C20.0938 22 22.0938 20 22.0938 15V9C22.0938 4 20.0938 2 15.0938 2H9.09375C4.09375 2 2.09375 4 2.09375 9V15C2.09375 20 4.09375 22 9.09375 22Z" stroke="#137444" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M7.09375 8.25C8.09375 9.25 9.72375 9.25 10.7338 8.25" stroke="#137444" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M13.4531 8.25C14.4531 9.25 16.0831 9.25 17.0931 8.25" stroke="#137444" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M8.49375 13H15.6938C16.1938 13 16.5938 13.4 16.5938 13.9C16.5938 16.39 14.5838 18.4 12.0938 18.4C9.60375 18.4 7.59375 16.39 7.59375 13.9C7.59375 13.4 7.99375 13 8.49375 13Z" stroke="#137444" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          ` : `
            <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M9.35938 22H15.3594C20.3594 22 22.3594 20 22.3594 15V9C22.3594 4 20.3594 2 15.3594 2H9.35938C4.35938 2 2.35938 4 2.35938 9V15C2.35938 20 4.35938 22 9.35938 22Z" stroke="#B61522" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M7.35938 8.75C8.35938 7.75 9.98938 7.75 10.9994 8.75" stroke="#B61522" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M13.7188 8.75C14.7188 7.75 16.3488 7.75 17.3588 8.75" stroke="#B61522" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M8.75937 17.7008H15.9594C16.4594 17.7008 16.8594 17.3008 16.8594 16.8008C16.8594 14.3108 14.8494 12.3008 12.3594 12.3008C9.86937 12.3008 7.85938 14.3108 7.85938 16.8008C7.85938 17.3008 8.25937 17.7008 8.75937 17.7008Z" stroke="#B61522" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          ` }
          <span>
            ${ isNotDigitized ? texts["not_digitized"] : (doesFit ? texts["frame_fits"] : texts["doesnt_fit"]) }
          </span>
        </div>
      </div>`;

      template += html;
    })

    fitsListContainer.innerHTML = template;
    

    if(doesntFitAtLeastOne){
      
      await removeItemsThatDontFit({
        listFromProxy
      });
      const myScanFitsTab = document.querySelector(classes.myScanFitsTab);
      if(myScanFitsTab){
        const popup = document.querySelector(`.${classes.popup}`);
        
        popup?.classList.add(classes.popupActive);
        myScanFitsTab.classList.add(classes.activeTab);
        openCartToCheckoutPopup(null, false);
      }
    }else{
      proceedToCheckout();
    }
  }

  const proceedToCheckout = () => {
    window.location.href = "/checkout";
  }

  const clearPrescriptionId = () => {
    window.localStorage.removeItem("prescriptionId");
  }

  const onSkipAddingPrescription = () => {
    clearPrescriptionId();
    onContinue(false);
  }

  const cartToCheckoutFlowInit = async (e) => {
    const hasAtLeastOneLense = await checkHasAtLeastOneLense();
    const isLoggedIn = document.querySelector(`.${classes.popup}`);

    if(!isLoggedIn) return;

    if(hasAtLeastOneLense){
      e.preventDefault();
      e.stopPropagation();
      openCartToCheckoutPopup(e);
    }else{
      proceedToCheckout();
    }
  }

  if(continueButton) continueButton.addEventListener("click", onContinue);
  if(closeButton) closeButton.addEventListener("click", onClose);
  if(cartSubmitButton) cartSubmitButton.addEventListener("click", cartToCheckoutFlowInit);
  if(skipAddingPrescription) skipAddingPrescription.addEventListener("click", onSkipAddingPrescription)
  if(continueToCheckout) continueToCheckout.addEventListener("click", proceedToCheckout);
  if(proceedToCheckoutButton) proceedToCheckoutButton.addEventListener("click", proceedToCheckout);

  const isMyPrescriptionPage = document.querySelector(classes.container);

  if(!isMyPrescriptionPage) return;

  const prescriptionsList = document.querySelectorAll(classes.list);

  const displayPrescriptions = (prescriptions) => {
    let template = "";
    let templateWithExpired = "";

    try{
      prescriptions.sort( (a, b) => new Date(b.validUntil)?.getTime() - new Date(a.validUntil)?.getTime());
    }catch(e){};

    if(prescriptions) prescriptions.forEach(prescription => {
      const {
        id,
        name,
        isDefault,
        prescriptionData,
        issueDate,
        validUntil,
      } = prescription;

      const jsonData = JSON.parse(prescriptionData);

      const {
        odaxis,
        osaxis,
        odspheretext,
        osspheretext,
        odcylindertext,
        oscylindertext,
        od_add,
        os_add,
        od_balance,
        os_balance,
        od_prism1,
        os_prism1
      } = jsonData;

      const valDate = new Date(validUntil);
      const isExpired = valDate < new Date() && valDate.toDateString() !== new Date().toDateString();

      const formattedDate = moment(validUntil).format("MMM D, YYYY");
      const texts = window["prescriptionTexts"];

      const html = `
      <div class="my-prescriptions__list-item ${ isDefault ? "my-prescriptions__list-item--default" : "" }" data-id="${id}">

        <div class="my-prescriptions__list-item-title-wrapper">

            <div class="my-prescriptions__list-item-title">
                <div>
                  ${name}

                  ${
                    isExpired
                    ? `
                    <div class="product-badge product-badge--expired">
                      ${texts['expired']}
                    </div>`
                    : ""
                  }
                </div>
      
                <span>
                  –
                  <br class="mobile-break">
                  ${texts["valid_until"]} ${formattedDate}
                </span>
            </div>

            ${texts["make_default"] !== undefined ? `
              <div class="my-prescriptions__make-default" data-id="${id}" data-is-default="${isDefault}">
              <span>${texts["make_default"]}</span>
              <span>${texts["default_prescription"]}</span>
            </div>
            ` : ""}
        </div>

        <div class="my-prescriptions__list-item-table">

            <div class="my-prescriptions__list-item-table-row">
                <div class="my-prescriptions__list-item-table-cell my-prescriptions__list-item-table-cell--caption">
                    &nbsp;
                </div>
                <div class="my-prescriptions__list-item-table-cell my-prescriptions__list-item-table-cell--caption">
                  ${texts["sph"]}
                </div>
                <div class="my-prescriptions__list-item-table-cell my-prescriptions__list-item-table-cell--caption">
                  ${texts["cyl"]}
                </div>
                <div class="my-prescriptions__list-item-table-cell my-prescriptions__list-item-table-cell--caption">
                  ${texts["axis"]}
                </div>
                <div class="my-prescriptions__list-item-table-cell my-prescriptions__list-item-table-cell--caption">
                  ${texts["add"]}
                </div>
                <div class="my-prescriptions__list-item-table-cell my-prescriptions__list-item-table-cell--caption">
                  ${texts["bal"]}
                </div>
                <div class="my-prescriptions__list-item-table-cell my-prescriptions__list-item-table-cell--caption">
                  ${texts["prism"]}
                </div>
            </div>

            <div class="my-prescriptions__list-item-table-row my-prescriptions__list-item-table-row--with-bg">
                <div class="my-prescriptions__list-item-table-cell my-prescriptions__list-item-table-cell--caption">
                  ${texts["od_right"]}
                </div>
                <div class="my-prescriptions__list-item-table-cell">
                  ${odspheretext}
                </div>
                <div class="my-prescriptions__list-item-table-cell">
                  ${odcylindertext}
                </div>
                <div class="my-prescriptions__list-item-table-cell">
                  ${odaxis}
                </div>
                <div class="my-prescriptions__list-item-table-cell">
                  ${od_add}
                </div>
                <div class="my-prescriptions__list-item-table-cell">
                  ${od_balance}
                </div>
                <div class="my-prescriptions__list-item-table-cell">
                  ${od_prism1}
                </div>
            </div>

            <div class="my-prescriptions__list-item-table-row">
                <div class="my-prescriptions__list-item-table-cell my-prescriptions__list-item-table-cell--caption">
                  ${texts["os_left"]}
                </div>
                <div class="my-prescriptions__list-item-table-cell">
                  ${osspheretext}
                </div>
                <div class="my-prescriptions__list-item-table-cell">
                  ${oscylindertext}
                </div>
                <div class="my-prescriptions__list-item-table-cell">
                  ${osaxis}
                </div>
                <div class="my-prescriptions__list-item-table-cell">
                  ${os_add}
                </div>
                <div class="my-prescriptions__list-item-table-cell">
                  ${os_balance}
                </div>
                <div class="my-prescriptions__list-item-table-cell">
                  ${os_prism1}
                </div>
            </div>

        </div>

      </div>`;

      if(valDate >= new Date() || valDate.toDateString() === new Date().toDateString()) template += html;
      templateWithExpired += html;
    })

    const clearList = (list) => {
      const items = list.querySelectorAll(".my-prescriptions__list-item:not(.my-prescriptions__list-item--add)");

      items.forEach(item => {
        item.outerHTML = "";
      })
    }

    if(prescriptionsList) prescriptionsList.forEach(list => {
      clearList(list);
      const renderTemplate = list.classList.contains("my-prescriptions__list--full") ? templateWithExpired : template;
      list.insertAdjacentHTML("afterBegin", renderTemplate);
    })

    const makeDefault = async function(){
      if(this.dataset.isDefault == "true") return;

      const id = this.dataset.id;
      await setDefaultPrescription(id);

      const defaultItem = document.querySelector(`.${classes.defaultItem}`);
      if(defaultItem) defaultItem.classList.remove(classes.defaultItem);
      const newDefaultItem = document.querySelector(`.my-prescriptions__list-item[data-id="${id}"]`);
      newDefaultItem.classList.add(classes.defaultItem);
    }

    const validateSize = ({ target }) => {
      const file = target.files?.[0];
      const container = target.parentNode.parentNode.parentNode.parentNode;

      if(!file) return;

      const fileSize = file.size / 1024 / 1024;

      if(fileSize > 25){
        const errorMessage = window['validationErrors']['file_size_25'];

        alert(errorMessage);
      }else{
        const submitButton = container.querySelector("[data-submit-add-prescription]");
        const area = container.querySelector(".my-prescriptions__add-prescription-upload-area");
        area.classList.add("my-prescriptions__add-prescription-upload-area--uploaded");
        submitButton.disabled = false;
      }
    }

    const onItemClick = function(){
      const active = document.querySelector(`.${classes.activeItem}`);
  
      if(active === this) this.classList.remove(classes.activeItem);
      else if(active) active.classList.remove(classes.activeItem);
      else this.classList.add(classes.activeItem);

      var prescriptionId =  this.dataset.id;
      let formData = new FormData();

      formData.append("attributes[prescriptionId]", prescriptionId);
      
      if(this.classList.contains(classes.activeItem)){
        fetch('/cart/update.js', {
          method: 'POST',
          body: formData
        })
        continueButton.removeAttribute("disabled");
      }else{
        continueButton.setAttribute("disabled", true);
      }
    }
  
    const setListeners = () => {
      const makeDefaultButtons = document.querySelectorAll(classes.makeDefaultButtons);
      const fileInput = document.querySelectorAll(classes.fileInput);

      makeDefaultButtons.forEach(button => {
        button.addEventListener("click", makeDefault);
      })

      fileInput.forEach(input => {
        input.addEventListener("change", validateSize);
      })

      const items = document.querySelectorAll(classes.popupListItems);

      items.forEach(item => {
        item.addEventListener("click", onItemClick);
      });
    }

    setTimeout(setListeners, 0);
  }

  const displayStatusBlock = (prescriptions) => {
    const atLeastOneNotExpired = prescriptions?.length && prescriptions.some(i => new Date(i.validUntil) > new Date());

      if(!atLeastOneNotExpired && invalidPrescriptionBlock) invalidPrescriptionBlock.classList.add("active");
  }

  const fetchPrescriptions = async () => {
    return await getPrescription();
  }

  const prescriptions = await fetchPrescriptions();
  displayPrescriptions(prescriptions);
  displayStatusBlock(prescriptions);

  return {
    cartToCheckoutFlowInit,
    noFitPopupInit
  }
}

/* Quick search -> recent search functionality */
const initQuickRecentSearchList = () => {
  const container = document.querySelector(".quick-search__recent-search-list");
  const maximumItemsToDisplay = 15;
  const recentSearchList = (JSON.parse(window.localStorage.getItem("recentSearchList")) ?? []).reverse().slice(0, maximumItemsToDisplay);
  let template = "";

  recentSearchList.forEach(item => {
    let locale = document.documentElement.getAttribute('lang');

    if(item.indexOf("-...-") !== -1){
      const arr = item.split("-...-");
      locale = arr[0];
      item = arr[1];
    }

    const html = `
    <a
      class="recent-search-list__item"
      href="https://${Shopify.shop}/${localeKey.length  ? `${localeKey}/` : localeKey}search?q=${item}"
    >
      ${item}
    </a>`;

    template += html;
  });

  if (container) container.innerHTML = template;
}

const initTopologyWishlist = () => {
  const showEmptyState = () => {
    const emptyState = document.querySelector('[data-empty-list]');
    if(emptyState) emptyState.classList.add("my-favorites__no-list--active");
  }

  const fetchWishlist = async () => {
    const data = await getWishlist();

    if(data?.status === false
    || data?.message == "Input validation error") return [];

    let slugs = [];

    for(let [id, slug] of Object.entries(data)){
      slugs.push(slug);
    }

    return slugs;
  }

  const displayWishlist = async (slugs) => {
    if(!slugs) return;

    const sectionId = "my-favorites-list";
    const list = document.querySelector(".my-favorites__list");
    const slugsList = [];

    for  (const slug of slugs) {
      slugsList.push(slug);
    }
    
    const sectionURL = `${window.Shopify.routes.root}?sections=${sectionId}&handle=${slugsList}&is_topology=true`;
    
    if(!slugsList.length) return;

    const response = await fetch(sectionURL);
    const jsonData = await response.json();
    const html = jsonData['my-favorites-list'];
    const container = document.createElement("DIV");
    container.innerHTML = html;
    let products = container.querySelectorAll(".product-item");
    let productsHTML = "";
    products.forEach(product => {
      productsHTML += product.outerHTML;
    })
    list.insertAdjacentHTML("afterBegin", productsHTML);
  }

  const substractEqualItems = (swymWishlist, topologyWishlist) => {
    if(!swymWishlist) swymWishlist = [];
    if(!topologyWishlist) topologyWishlist = [];

    let newArray = topologyWishlist.slice();

    swymWishlist.forEach(slug => {
      topologyWishlist.forEach(topologySlug => {
        if(slug == topologySlug){
          newArray = newArray.filter((value) => value !== slug);
        }
      })
    })

    return newArray;
  }

  const init = async (swymWishlist) => {
    const topologyWishlist = await fetchWishlist();

    const wishlist = substractEqualItems(swymWishlist, topologyWishlist);
    
    displayWishlist(wishlist);

    if(swymWishlist.length == 0 && topologyWishlist.length == 0) showEmptyState();
  }

  return {
    init
  }
}

if (!Element.prototype.matches) {
	Element.prototype.matches = Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
}

if (!Element.prototype.closest) {
	if (!Element.prototype.matches) {
		Element.prototype.matches = Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
	}
	Element.prototype.closest = function (s) {
		var el = this;
		var ancestor = this;
		if (!document.documentElement.contains(el)) return null;
		do {
			if (ancestor.matches(s)) return ancestor;
			ancestor = ancestor.parentElement;
		} while (ancestor !== null);
		return null;
	};
}

// START customCatalogInit
const customCatalogInit = () => {
  let _currentMeta;
  let _productCounter = 0;

  const pagination = document.querySelector("pagination-custom");

  const getHandles = async (handles_qty = 500) => {
    const guestScan = JSON.parse(localStorage.getItem("guest_scan"));
    const list = await getCollection(0, `per_page=${handles_qty}&sort=shuffle${guestScan?.id && guestScan?.has_scan ? `&guest_id=${guestScan.id}` : ""}`);
    const handles = [];

    list.products.forEach(i => {
      handles.push(i.handle);
    });

    return handles;
  };

  const generateRandom = (min, max) => {
    let difference = max - min;
    let rand = Math.random();
    rand = Math.floor( rand * difference);
    rand = rand + min;

    return rand;
  }

  const buildProductsHTML = async ({ products }) => {
    let handles = [];

    products.forEach(({ handle }) => {
      handles.push(handle);
    });

    if(!handles.length) return;

    const productHandles = handles.join(",");

    const rand = generateRandom(0, length - 1);
    const _handles = [];

    const productGridURL = `${window.location.protocol}//${window.location.host}/products/${_handles[rand]}/?section_id=get-product-item-section&product_handle=${productHandles}&locale=${locale}`;
    const productSectionHTML = await fetch(productGridURL);
    let html = await productSectionHTML.text();

    const container = document.createElement("div");
    container.innerHTML = html;
    const section = container.querySelector(".shopify-section");

    if(!section) return "";

    html = section.innerHTML;
    
    return html;
  }

  const getPercentOff = (product) => {
    let isDiscounted = false,
    smallestPercent = 100,
    largestPercent = 0;

    product.variants.forEach(variant => {
      let price = variant.price;
      let compare_at_price = variant.compare_at_price;
      let discountPercent = 0;

      if(price != compare_at_price && compare_at_price > price){
        isDiscounted = true;
        discountPercent = Math.round(((compare_at_price - price) / compare_at_price) * 100);
        
        smallestPercent = Math.min(smallestPercent, discountPercent);
        largestPercent = Math.max(largestPercent, discountPercent);
      }
    })

    return { isDiscounted, smallestPercent, largestPercent };
  }

  String.prototype.handleize = function(){
    return this.toLowerCase().replace(/[^\w\u00C0-\u024f]+/g, "-").replace(/^-+|-+$/g, "");
  };

  Number.prototype.formatMoney = function(){
    return new Intl.NumberFormat(langCountry, { style: 'currency', currency: 'CAD' }).format(this);
  }

  const buildProductsHTMLTemplate = ({ products }) => {
    if(!products) return "";

    let html = "";
    const texts = window["_collectionTexts"];
    const colors = window["_colors"];
    const locale = localeKey.length ? `/${localeKey}` : localeKey;
    const collectionTitle = window["collectionData"].title;

    for (let [productIndex, product] of Object.entries(products)){
      const uniqueColors = [];
      const is2for1 = product.tags.includes("cart-2for1");
      let isTryOn = product.digitalized;
      const isLoggined = window['isLoggedIn'];

      const { isDiscounted, smallestPercent, largestPercent } = getPercentOff(product);
      
      const isNew = (isDiscounted) ? 0 : product.metafields.frame_is_new; // Show New tag only if there is no promnotion tag
      const isPopular = (isDiscounted || isNew) ? 0 : product.metafields.frame_popular; // Show Popular tag only if there is no promnotion tag and no New tag

      const badge2for1 = `
      <div class="product-badge product-badge--2-for-1">
        ${texts['2for1']}
      </div>
      `;

      const badgePopular = `
      <div class="product-badge product-badge">
        ${texts['popular']}
      </div>
      `;

      const badgeNew = `
      <div class="product-badge product-badge">
        ${texts['new']}
      </div>
      `;

      const badgeDiscount = `
      <div class="product-badge product-badge--sale">
        ${ largestPercent > smallestPercent ? texts['up-to'] : ""}
        -${largestPercent}%
      </div>
      `;
      const tryOnText = texts['try-on-virtual']
  
      const scanSvg = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none">
<g clip-path="url(#clip0_3098_642)">
<path fill-rule="evenodd" clip-rule="evenodd" d="M18.8416 0.679245C18.8416 0.304108 19.1457 0 19.5208 0L23.2892 1.34954e-07C23.6643 2.02431e-07 23.9684 0.304109 23.9684 0.679245V4.49965C23.9684 4.87479 23.6643 5.1789 23.2892 5.1789C22.914 5.1789 22.6099 4.87479 22.6099 4.49965V1.35849L19.5208 1.35849C19.1457 1.35849 18.8416 1.05438 18.8416 0.679245ZM1.34954e-07 0.711049C1.34954e-07 0.335912 0.304109 0.0318034 0.679245 0.0318034H4.51047C4.8856 0.0318034 5.18971 0.335912 5.18971 0.711049C5.18971 1.08619 4.8856 1.39029 4.51047 1.39029H1.35849V4.46873C1.35849 4.84387 1.05438 5.14798 0.679245 5.14798C0.304109 5.14798 1.34954e-07 4.84387 1.34954e-07 4.46873V0.711049ZM14.0288 3.9729C12.8838 3.8442 10.0395 3.78667 7.85621 4.54172C7.01557 4.83244 6.4573 5.6766 6.13575 6.83941C5.8811 7.76029 5.81046 8.76558 5.82923 9.54568L6.11912 9.59776C6.61609 9.25386 7.48521 8.8378 8.52662 8.8378C9.21802 8.8378 9.88911 9.09193 10.4143 9.36649C10.8262 9.58184 11.1876 9.83047 11.4519 10.0415H12.2621C12.4817 9.83598 12.7722 9.60006 13.1022 9.39305C13.5457 9.11481 14.1409 8.8378 14.774 8.8378C15.4039 8.8378 16.0832 8.94955 16.6424 9.11717C16.9224 9.20107 17.1915 9.30467 17.4184 9.42708C17.5503 9.49825 17.7132 9.59923 17.8532 9.73894C17.8548 9.7383 17.8565 9.73766 17.8582 9.737C17.8747 9.73056 17.8913 9.7237 17.9079 9.71654C17.9003 9.27651 17.8786 8.55715 17.8185 7.8168C17.7746 7.27701 17.7115 6.74272 17.6227 6.30385C17.5783 6.08435 17.5301 5.90174 17.4798 5.76054C17.4549 5.69058 17.4316 5.63683 17.4113 5.59722C17.4014 5.57774 17.3929 5.56332 17.3864 5.55316C17.3832 5.54816 17.3807 5.54449 17.3789 5.54198C17.3771 5.53948 17.3761 5.53835 17.3761 5.53838C17.3294 5.4823 17.1464 5.33278 16.8581 5.19219C16.5774 5.05529 16.3043 4.98004 16.1128 4.98004C15.7939 4.98004 15.5283 4.84813 15.3491 4.74065C15.1987 4.6504 15.0419 4.53391 14.9119 4.43728C14.8868 4.41866 14.8628 4.40078 14.8399 4.38397C14.5126 4.143 14.2757 4.00065 14.0288 3.9729ZM19.2587 9.35533C19.272 9.35633 19.2854 9.35751 19.2989 9.35888C19.4499 9.37433 19.7015 9.42346 19.9135 9.6138C20.0503 9.73667 20.1126 9.8891 20.1319 9.93608L20.1323 9.93719C20.1632 10.0127 20.1876 10.0934 20.2073 10.1694C20.2471 10.3237 20.2809 10.5126 20.3062 10.72C20.357 11.136 20.3792 11.673 20.329 12.2354C20.2409 13.2211 19.9018 14.5471 18.8104 15.211C18.346 16.39 17.5001 17.8444 16.4557 19.0418C15.3639 20.2935 13.9083 21.4313 12.3197 21.4313C9.52258 21.4313 6.96564 19.0303 5.55774 15.3049C4.47004 14.9007 3.51408 13.3917 3.83263 10.4701C3.84723 10.2102 3.97482 9.94308 4.21 9.74744C4.28955 9.68127 4.37705 9.62647 4.47127 9.58238C4.44958 8.69397 4.5293 7.55173 4.8264 6.47733C5.18909 5.16577 5.93237 3.76962 7.41219 3.25784C9.86986 2.40789 12.9457 2.48411 14.1806 2.62291C14.8261 2.69547 15.3256 3.05457 15.6453 3.28998C15.6792 3.31489 15.7106 3.33818 15.7401 3.36C15.8692 3.45562 15.9603 3.52305 16.0481 3.57576C16.0966 3.60487 16.1249 3.61708 16.1367 3.62169C16.6069 3.62709 17.0824 3.79013 17.4536 3.97116C17.8235 4.15157 18.1984 4.4033 18.4194 4.66822C18.5776 4.85791 18.6837 5.0916 18.7597 5.30501C18.8388 5.52748 18.9023 5.7775 18.9543 6.03452C19.0583 6.5487 19.1267 7.14302 19.1725 7.70676C19.2219 8.31445 19.2465 8.90596 19.2587 9.35533ZM5.0455 10.8137C5.04548 10.8137 5.04613 10.8134 5.04751 10.8129L5.0455 10.8137ZM5.16408 10.8064C4.89844 13.6968 6.05815 14.0492 6.13984 14.0574L6.56996 14.1004L6.71319 14.5082C8.01309 18.2095 10.294 20.0728 12.3197 20.0728C13.2868 20.0728 14.3947 19.338 15.4319 18.1488C16.4422 16.9906 17.2458 15.559 17.6256 14.5033L17.7218 14.2359L17.9799 14.1166C18.5646 13.8466 18.8884 13.0937 18.9759 12.1145C19.0167 11.6572 18.9983 11.2164 18.9578 10.8845C18.9511 10.8298 18.9439 10.7792 18.9366 10.7331C18.9104 10.7383 18.8857 10.7438 18.8636 10.7491C18.8386 10.764 18.8093 10.7811 18.7767 10.7994C18.6716 10.8583 18.5201 10.937 18.3518 11.0026C18.3085 11.0195 18.2597 11.0373 18.2065 11.0543C18.2147 11.5786 18.1428 12.169 17.9168 12.7121C17.7294 13.1626 17.4282 13.5973 16.9644 13.9166C16.4984 14.2375 15.9152 14.4094 15.2203 14.4094C13.8244 14.4094 12.9183 13.7858 12.4061 12.9595C12.0924 12.4534 11.9394 11.8946 11.8828 11.4H11.8292C11.7544 11.888 11.5938 12.4434 11.2989 12.9456C10.833 13.7391 10.0166 14.4094 8.74974 14.4094C7.43029 14.4094 6.62274 13.597 6.18169 12.7357C5.86992 12.1269 5.71294 11.4518 5.65019 10.8938L5.16408 10.8064ZM6.99067 10.6496C7.03082 11.0896 7.15023 11.6466 7.39085 12.1165C7.6861 12.693 8.10571 13.0509 8.74974 13.0509C9.44637 13.0509 9.85712 12.7181 10.1275 12.2577C10.3531 11.8734 10.4679 11.4112 10.5079 11.0284C10.3175 10.8846 10.0668 10.7178 9.78494 10.5704C9.35071 10.3434 8.90619 10.1963 8.52662 10.1963C7.87709 10.1963 7.31634 10.4469 6.99067 10.6496ZM13.2153 11.0103C13.2261 11.3878 13.3214 11.8576 13.5608 12.2438C13.8258 12.6714 14.2956 13.0509 15.2203 13.0509C15.6855 13.0509 15.9893 12.9386 16.194 12.7977C16.401 12.6551 16.5544 12.4503 16.6626 12.1902C16.8602 11.7154 16.8795 11.1181 16.8171 10.6474C16.8045 10.6399 16.79 10.6317 16.7734 10.6227C16.6516 10.557 16.4745 10.485 16.2524 10.4185C15.8076 10.2852 15.2598 10.1963 14.774 10.1963C14.5146 10.1963 14.1801 10.3205 13.8241 10.5438C13.5853 10.6937 13.3729 10.8654 13.2153 11.0103ZM19.1677 10.7114C19.1676 10.7115 19.1652 10.7112 19.1608 10.7103C19.1656 10.7108 19.1678 10.7113 19.1677 10.7114ZM0.679245 18.8211C1.05438 18.8211 1.35849 19.1252 1.35849 19.5003L1.35849 22.6415H4.44757C4.8227 22.6415 5.12681 22.9456 5.12681 23.3208C5.12681 23.6959 4.8227 24 4.44757 24H0.679245C0.304109 24 2.02431e-07 23.6959 1.34954e-07 23.3208L0 19.5003C0 19.1252 0.304108 18.8211 0.679245 18.8211ZM23.3208 18.852C23.6959 18.852 24 19.1561 24 19.5313V23.2889C24 23.6641 23.6959 23.9682 23.3208 23.9682H19.4895C19.1144 23.9682 18.8103 23.6641 18.8103 23.2889C18.8103 22.9138 19.1144 22.6097 19.4895 22.6097H22.6415V19.5313C22.6415 19.1561 22.9456 18.852 23.3208 18.852Z" fill="#60513A"/>
</g>
<defs>
<clipPath id="clip0_3098_642">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>`
const badgeTryOn = isTryOn && tryOnText.length ? 
`<div class="product-badges__try-on">
 ${scanSvg}
  ${tryOnText}
</div>
`: ``;
      const tryOnIcon = isTryOn && tryOnText.length ? `<div class="product-badges__try-on-icon">
      ${scanSvg}
      </div>` : ``;
      const href = `${locale}/products/${product.handle}`;
      ++_productCounter;
      const productPosition = `${_productCounter}`;
      const productList = `category - ${collectionTitle}`;

      html += `
<div class="
  product-item
  product-item--uninitialized
  product-item--with-hover-swatches
  animation
  animation--item
  animation--item-initial
  "
  data-product-name="${product.title}"
  data-product-id="${ product.id }"
  data-product-price="${product.price}"
  data-product-brand="${product.vendor}"
  data-product-category="${collectionTitle}"
  data-product-variant="${ product.variants[0].id }"
  data-product-position="${productPosition}"
  data-product-list="${productList}"
>
  <div class="product-item__inner">
    <div class="product-item__media product-item__media--multiple-images">
      
      <div class="product-badges">
        <div class="badges">
         
          ${
           isDiscounted ? badgeDiscount : ""
          }

          ${
            is2for1 ? badge2for1 : ""
          }

          ${
            isPopular == 1 ? badgePopular : ""
          }

          ${
            isNew == 1 ? badgeNew : ""
          }

        </div>
        <div>
        ${tryOnIcon}
          <!-- Swym Wishlist Plus EPI Button-->
          ${ isLoggined ? ` <button 
            data-with-epi="true" 
            class="swym-button swym-add-to-wishlist-view-product 
            product_${ product.id }" 
            data-swaction="addToWishlist" 
            data-product-id="${ product.id }" 
            data-variant-id="${ product.variants[0].id }" 
            data-product-url="https://${Shopify.shop}${href}">
           </button>` : `
           <a class="swym-button swym-add-to-wishlist-view-product" href="${locale}/account" aria-label="Go to the account page">   
           </a>`}
          
        </div>
        <!-- Swym Wishlist Plus EPI Button-->
      </div>

      <a
        class="product-item__image-link"
        ${
          product.variants.map(variant => {
            const color = variant.metafields.frame_color_side.replace('-',"").replace(" ", "");
            return `data-${color}="${href}"`;
          }).join("")
        }
        data-href="${href}"
        href="${href}"
      >
        ${
          product.variants.map((variant, index) => {
            const sku = variant.sku;
            return `
  <div class="product-item__images product-item__images--${sku} ${index == 0 ? "active" : ""}">
  ${
    product.images.map((image) => {
      const alt = image.alt.toLowerCase().handleize();
      let wrapperClass = "";
      let showImage = false;

      if(alt.indexOf("image-1") !== -1){
        showImage = true;
        wrapperClass = "product-item__image product-item__image--one";
      }
      if(alt.indexOf("image-2") !== -1){
        showImage = false;
        wrapperClass = "product-item__image product-item__image--two";
      }
      const imageDesktop = image.src.replace(".jpg", "_600x.jpg").replace(".png", "_600x.jpg");
      const imageMobile = image.src.replace(".jpg", "_500x.jpg").replace(".png", "_500x.jpg");
      const imageHTML = `
<div
  class="image product-item__image ${wrapperClass} loaded"
>
    <div class="image__inner">
      <picture>
        <source
          srcset="${imageMobile}"
          media="(max-width: 768px)"
        />
        <img
          class="image__img"
          loading="eager"
          src="${imageDesktop}"
        >
      </picture>
  </div>
</div>`;
      return alt.indexOf(sku) !== -1 && showImage ? imageHTML : "";
    }).join("")
  }
            </div>`;
          }).join("")
        }
      </a>
    </div>

${badgeTryOn}
    <div class="product-item__meta">
      <div class="product-item__text">
        <h5 class="product-item__product-vendor">
        <a
            href="${href}"
          >
        ${ product.vendor }
        </a>
        </h5>
        <h4 class="ff-body product-item__product-title fs-product-card-title">
          <a
            href="${href}"
          >
          ${ product.title }
          </a>
        </h4>

        <div class="product-item__variant-info">
        <ul class="product-swatches-options__list product-item-options__list--swatch ff-body fs-body-50">
          ${
            product.variants.map((variant, index) => {
              const color = variant.option1.toLowerCase().handleize();
              let tempValue = variant.option1.toLowerCase().split("/")[0].split("\\")[0].handleize();

              if(uniqueColors.includes(color)) return "";

              uniqueColors.push(color);

              const sku = variant.sku;
              const hexColor = colors[tempValue];
              const isImage = hexColor ? hexColor.indexOf(".") !== -1 : false;
              
              const html = `
              <li
                data-color="${color}"
                data-sku="${sku}"
                class="product-swatches-options__item product-swatches-options__item--swatch ${index == 0 ? "product-swatches-options__item--selected" : ""}"
                data-swatch-shape="round"
                style="background-${isImage ? "image" : "color"}: ${isImage ? `url(${hexColor})` : hexColor};"
              ></li>`;

              return !hexColor ? "" : html;
            }).join("")
          }  
        </ul>
      </div>


        ${
          product.variants.map((variant, index) => {
            const sku = variant.sku;
            const compare_at_price = variant.compare_at_price;
            const price = variant.price;

            return `<p
            class="product-item__price ${index == 0 ? "product-item__price--active" : ""}"
            data-sku="${sku}"
          >
            ${
              compare_at_price > price
              ? `
              <span class="sale" data-price>${ price.formatMoney() }<span>
              <span class="product-item__compare-at-price">${ compare_at_price.formatMoney() }</span>
              `
              : `
              <span>${ price.formatMoney() }</span>
              `
            }
          </p>`;
          }).join("")
        }
      </div>


    </div>
  </div>
</div>
`;
    }

    return html;
  };

  const setupPriceMinMaxRange = (filters, params) => {
    const priceMaxInput = document.querySelectorAll("input[name='filter.v.price.lte']");
    const maxPrice = filters.price_max.value;
    const currentMin = params["price_gte"];
    const currentMax = params["price_lte"];

    priceMaxInput.forEach(input => {
      if(currentMin){
        input.setAttribute("min", currentMin);
      }
      if(currentMax){
        input.value = currentMax;
      }
      if(maxPrice){
        /*
          Note: ceil() from Shopify Liquid and Math.ceil() from Javascript do not give the same value
          ex with: 660.4000244140625  
              - ceil from Shopify Liquid gives 660 (see {{ filter.range_max | divided_by: 100 | ceil }})
              - Math.ceil from Javascript gives 661
          In order to have the same value in price filter, use round() in both cases
        */

        input.placeholder = Math.round(maxPrice);
      }
    });
  }

  const displayFoundProductsCounter = (meta) => {
    if(!("products_found" in meta)) return;
    const productsFound = meta.products_found;
    const countElements = [".filter-bar__results-count span", ".filter-drawer__results-count span", ".mobile-secondary-filters-group__count span"]

    countElements.forEach(selector => {
      const elem = document.querySelector(selector);

      if(elem) elem.innerHTML = productsFound;
    })
  }

  const loadMoreProducts = async () => {
    const isReachedFinish = getMetaParam("reachedFinish");

    if(isReachedFinish) return;

    const maxPages = getMetaParam("pages");
    const page = getMetaParam("page");
    
    if(page == maxPages){
      updateMetaParam("reachedFinish", true);

      if(page == 1) return;
    }

    const params = collectFormParams();
    const collectionId =  window["collectionData"].id;
    const per_page = 8;
    const sort = ["digitalized:desc", "available:desc", "best_selling:desc", "discounted:desc"]; // get current sort
    const data = await fetchProducts({
      sort,
      ...params,
      collectionId,
      page,
      per_page
    });
    const html = buildProductsHTMLTemplate(data);
    addDataLayers_ProductClickEvent();
    appendHTML(html);
    initAnimation();
    dispatchCustomEvent("swym:collections-loaded");
  }
  const getPaginationPageContent = async (pageNumber) => {
    const collectionContainer = document.querySelector('.collection__products');
    collectionContainer.style.opacity = 0.1;
    const page = pageNumber;
    pagination.scrollToTop();
    const params = collectFormParams();
    const collectionId =  window["collectionData"].id;
    const per_page = window["collectionData"].numberOfItemsPerPage;
    const sort = ["digitalized:desc", "available:desc", "best_selling:desc", "discounted:desc"]; // get current sort
    const data = await fetchProducts({
      sort,
      ...params,
      collectionId,
      page,
      per_page
    });
    const {meta} = data;
    const html = buildProductsHTMLTemplate(data);
    replaceHTML(html);
    collectionContainer.style.opacity = 1;
    initAnimation();
    pagination.updatePaginationButtons(meta)
    updateURLState();
    addDataLayers_ProductClickEvent();
    dispatchCustomEvent("swym:collections-loaded");
  }
  const hideMobileFilterButtonBorder = () => {
    const mibileFilterButton = document.querySelector(".mobile-filters--sticky");
    const mibileFilterButtonTopPosition = mibileFilterButton?.getBoundingClientRect().top - 1;
    const headerHeight = document.querySelector(selectors$A.header).offsetHeight;
    if (mibileFilterButtonTopPosition <= headerHeight) {
      mibileFilterButton.style.borderBottomStyle = "hidden"
    } else {
      mibileFilterButton.style.borderBottomStyle = "solid"

    }
  }

  const onScroll = async () => {
    const {
      scrollTop,
      scrollHeight,
      clientHeight
    } = document.documentElement;

    const isInQueue = getMetaParam("requestInQueue");

    if (scrollTop + clientHeight >= scrollHeight - (clientHeight * 2.8) && !isInQueue) {
      let currentPage = getMetaParam("page");
      let maxPage = getMetaParam("pages");
      let newPage = currentPage + 1;

      if(newPage > maxPage) newPage = maxPage;

      updateMetaParam("page", newPage);
      updateMetaParam("requestInQueue", true);
      await loadMoreProducts();
      updateMetaParam("requestInQueue", false);
    }
  }

  const clearPriceField = () => {
    const minInput = document.querySelectorAll("input[name='filter.v.price.gte']");
    const maxInput = document.querySelectorAll("input[name='filter.v.price.lte']");

    minInput.forEach(input => {
      input.value = "";
    });

    maxInput.forEach(input => {
      input.value = "";
    });

    const range = window['priceRange'];
    range && range.reset();
  }

  const clearAllCheckboxes = (box = document) => {
    const checkboxes = box.querySelectorAll(".filter-item__checkbox:checked");

    checkboxes.forEach(checkbox => {
      checkbox.checked = false;
    });
  }

  const clearCheckbox = (value) => {
    const checkboxex = document.querySelectorAll(`.filter-item__checkbox[value="${value}"]:checked`);

    checkboxex.forEach(checkbox => {
      checkbox.checked = false;
    })
  }

  const clearProductType = (value = null) => {
    let url = new URL(window.location.href);
    let searchParams = new URLSearchParams(url.search);

    if (searchParams.has('product_type') && (value == null || searchParams.get('product_type') === value)) {
      searchParams.delete('product_type');
      url.search = searchParams.toString();
      window.history.replaceState(null, '', url.href);
    }
  }


  const disableDigitalized = () => {
    const toggle = document.querySelector(".filter-bar__try-on-toggle");
    if(toggle){
      toggle.classList.remove("filter-bar__try-on-toggle--on");
      toggle.parentNode.querySelector("input").value = false;
    }
  }

  const clearGroupValues = (group, handle) => {
    if(handle == "price") clearPriceField();
    else clearAllCheckboxes(group);

    const mobileLabel = group.querySelector(".filter-drawer__group-toggle--active");
    const label = group.parentNode.querySelector(".filter-group--active");
    
    if(mobileLabel) mobileLabel.classList.remove("filter-drawer__group-toggle--active");
    if(label) label.classList.remove("filter-group--active");
  }

  const onClick = ({ target }) => {
    if(target.closest('[data-remove-filter]')){
      const value = target.dataset.value;

      if(value == "price"){
        clearPriceField();
      }else if(value == "Eyeglasses" || value == "Sunglasses"){
        clearProductType(value);
      }else{
        clearCheckbox(value);
      }
      onFormChange();
    }else if(target.closest('[data-clear-all-filters], [data-button="clear-all"]')){
      clearProductType();
      clearAllCheckboxes();
      clearPriceField();
      disableDigitalized();
      onFormChange();
    }else if(target.closest(".filter-group__reset")){
      const group = target.parentNode.parentNode;
      const handle = target.dataset.group;

      clearGroupValues(group, handle);
      onFormChange();
    }
  }

  const initHandlers = () => {
    window.addEventListener("scroll", hideMobileFilterButtonBorder, {
      passive: true
    });
    window.addEventListener("click", onClick);

    const form = window.innerWidth > 768 ? document.querySelector("form.filter-bar") : document.querySelector("form.filter-drawer");

    form.addEventListener("change", () => {
      onFormChange();
    });
  }

  const buildQueryParams = (args) => {
    const params = [];

    const processValue = (value) => {
      return encodeURIComponent(value);
    }

    for (const key in args) {
      if(key === "collectionId" || key == undefined || typeof key === "undefined") continue;

      if(Array.isArray(args[key]) && args[key].length == 1){
        params.push(`${key}=${processValue(args[key][0])}`);
      }else if(Array.isArray(args[key])){
        args[key].forEach(item => {
          params.push(`${key}[]=${processValue(item)}`);
        })
      }else{
        params.push(`${key}=${processValue(args[key])}`);
      }
    }

    const paramsString = params.join("&");

    return paramsString;
  }
  
  const fetchProducts = async (args) => {
    let {
      collectionId,
    } = args;

    if(!collectionId) collectionId = 0;

    if(args['filters'] == undefined) args['filters'] = true;

    const paramsString = buildQueryParams(args);
    const data = await getCollection(collectionId, paramsString);

    addDataLayers_ProductsList(data);

    return data;
  }

  const addDataLayers_ProductsList = (data) => {
    let products = [];
    const currentItems = data.products;
    currentItems.forEach((item, i) => {
      const tmp = [];
      ++productCounter;
      tmp['id'] = item.id;
      tmp['variant-title'] = item.variants[0].title;
      tmp['name'] = item.title;
      tmp['price'] = item.price;
      tmp['brand'] = item.vendor;
      tmp['category'] = item.product_type;
      tmp['collection-name'] = item.product_type; // To update when the collection title will be available in data from ProxyApp
      tmp['imageURL'] = item.images[0].src;
      tmp['productURL'] = window.location.origin + '/products/' + item.handle;
      tmp['sku'] = item.variants[0].sku;
      tmp['list'] = 'category'; // To update when the collection title will be available in data from ProxyApp
      tmp['position'] = productCounter;
      products.push(tmp);
    });
    gtm_datalayer('view_item_list_collection', products);
    gtm_datalayer('products_impression', products);
  }

  const replaceHTML = (html) => {
    const collectionContainer = document.querySelector('.collection__products');
    collectionContainer.innerHTML = html;
  }

  const appendHTML = (html) => {
    const collectionContainer = document.querySelector('.collection__products');
    collectionContainer.insertAdjacentHTML("beforeEnd", html);
  }

  const updateMeta = (meta) => {
    _currentMeta = meta;
  }

  const updateMetaParam = (key, value) => {
    _currentMeta[key] = value;
  }

  const getMetaParam = (key) => {
    return _currentMeta[key];
  }

  const displayEmptyState = () => {
    const collectionContainer = document.querySelector('.collection__products');
    const emptyElement = document.querySelector(".collection__empty");

    collectionContainer.innerHTML = "";
    emptyElement.classList.add("collection__empty--active");
  }

  const hideEmptyState = () => {
    const emptyElement = document.querySelector(".collection__empty");

    emptyElement.classList.remove("collection__empty--active");
  }

  const mapSortField = (value) => {
    const mapObject = {
      "best-selling": "best_selling:desc",
      "title-ascending": "vendor:asc",
      "title-descending": "vendor:desc",
      "price-ascending": "price:asc",
      "price-descending": "price:desc",
      "created-ascending": "created_at:asc",
      "created-descending": "created_at:desc"
    }

    return mapObject[value] ?? "title";
  }

  const fetchURLParams = () => {
    let url = new URL(window.location.href);
    let searchParams = new URLSearchParams(url.search);
    
    const preparedParams = {};

    /*
      keys from URL params are (using default Shopify PREFIX naming like filter.p.m. / filter.v.m. followed by handles):
        - sort_by (default full Shopify naming)
        - vendor (or multiple vendor[] for several values) which is for brand filtering (default full Shopify naming)
        - filter.p.m.frame.gender
        - filter.p.m.frame.shape (or multiple filter.p.m.frame.shape[] for several values)
        - filter.p.m.frame.materials (or multiple filter.p.m.frame.materials[] for several values)
        - filter.v.m.frame.colors (or multiple filter.v.m.frame.colors[] for several values)
        - filter.v.price.gte (lower limit) (default full Shopify naming)
        - filter.v.price.lte (upper limit) (default full Shopify naming)
    */

    for (let key of searchParams.keys()) {
      let value = searchParams.getAll(key); /*get current value of the key*/

      const notNull = value !== undefined && value !== null && value !== ""

      if(key == "sort_by") continue;
      if(!notNull) continue;

      preparedParams[keyToGroupKey(key)] = value;
    }
    const serchParamsArray = url.search.split('&');
    const pageParams = serchParamsArray.find((item=>item.includes("page")));
    const pageParamsArray = pageParams && pageParams.split('=')
    pageParamsArray && (preparedParams[`${pageParamsArray[0]}`] = +pageParamsArray[1])
    return preparedParams;
  }

  const collectFormParams = () => {

    const form = window.innerWidth > 768 ? document.querySelector("form.filter-bar") : document.querySelector("form.filter-drawer");
    const formData = new FormData(form);
    const params = {};
    const digitalized = !!document.querySelectorAll(".filter-bar__try-on-toggle--on").length;
    
    for (const pair of formData.entries()) {
      let [key, value] = pair;

      for(let filterKey in filtersMap){
        if(key === filtersMap[filterKey]){
          const notNull = value !== undefined && value !== null && value !== "";

          if(filterKey == filtersMap.price_gte){
            const priceMinInput = document.querySelector("input[name='filter.v.price.gte']");
            const min = +priceMinInput.getAttribute("min");
            if(value != min) params[filterKey] = [value];
          }else if(filterKey == filtersMap.price_lte){
            const priceMaxInput = document.querySelector("input[name='filter.v.price.lte']");
            const max = +priceMaxInput.getAttribute("max");
            if(value != max) params[filterKey] = [value];
          }else if(params[filterKey] && notNull){
            params[filterKey].push(value);
          }else if(notNull){
            params[filterKey] = key === filtersMap.sort ? ["digitalized:desc", "available:desc", mapSortField(value), "discounted:desc"] : [value];
          }
        }
      }
    }

    //verify if we have a filter for Type (custom filter by URL)
    let url = new URL(window.location.href);
    let searchParams = new URLSearchParams(url.search);

    if (searchParams.has('product_type')) {
      params['product_type'] = searchParams.get('product_type');
    }


    if(digitalized) params[filtersMap.digitalized] = digitalized;
    else delete params[filtersMap.digitalized];

    return params;
  }

  // Sort-By group
  const closeSortGroup = () => {
    const group = document.querySelector("#filter-bar-sort");
    const sortDisplayValue = document.querySelector("[data-sort-label] span");
    const selectedSortOption = document.querySelector('input[name="sort_by"]:checked').parentNode;
    const sortValue = selectedSortOption.querySelector(".filter-item__label").innerHTML;
    // Update sort-By label
    sortDisplayValue.innerHTML = sortValue;
    // Update visual effect   
    if(group)
    {
      // ... remove all effects
      const currentOption = group.querySelector('.filter-item.selected')
      currentOption && currentOption.classList.remove("selected");
      const currentCheckmark = group.querySelector(".filter-item__checkmark");
      currentCheckmark && currentCheckmark.parentNode.removeChild(currentCheckmark);
      // ... add effect on selected item
      selectedSortOption.parentNode.classList.add("selected");
      selectedSortOption.querySelector(".filter-item__content-inner").innerHTML += '<div class="filter-item__checkmark"><span class="checkmark"></span></div>'
      // ... hide context menu and update chevron
      group.setAttribute("aria-hidden", "true");
      group.parentNode.querySelector('.filter-bar__button--sort').setAttribute("aria-expanded", "false");
    }
  }

  const initAnimation = () => {
    const items = document.querySelectorAll(".product-item--uninitialized");

    items.forEach((item) => {
      item.classList.remove("product-item--uninitialized");
      let swatches = item.querySelectorAll(".product-swatches-options__item--swatch");
      let secondImage = item.querySelectorAll(".product-item__image--two");

      const enterItemAnimation = () => {
        secondImage.forEach((image) => {
          image.classList.add("active");
        })
      }

      const leaveItemAnimation = () => {
        secondImage.forEach((image) => {
          image.classList.remove("active");
        })
      }
    
      item.addEventListener("mouseenter", enterItemAnimation);
      item.addEventListener("mouseleave", leaveItemAnimation);

      swatches.forEach(swatch => {
        let selectedClassName = "product-swatches-options__item--selected";
    
        swatch.addEventListener("mouseenter", function(e){
          e.stopPropagation();
          const selected = item.querySelector(`.${selectedClassName}`);
          const color = this.dataset.color;
          const sku = this.dataset.sku;
          
          item.querySelector('.product-item__images.active').classList.remove("active");
          item.querySelector(`.product-item__images--${sku}`).classList.add("active");
    
          if(selected) selected.classList.remove(selectedClassName);
    
          this.classList.add(selectedClassName);
          const productWrapper = this.parentNode.parentNode.parentNode.parentNode.parentNode;
          const link = productWrapper.querySelector("a");
    
          link.href = link.dataset[color.replace(/-/g, "")] ?? link.dataset.href;
          
          const activePrice = productWrapper.querySelector(".product-item__price--active");
          if(activePrice) activePrice.classList.remove("product-item__price--active");
          const newPrice = productWrapper.querySelector(`.product-item__price[data-sku="${sku}"]`);
          if(newPrice) newPrice.classList.add("product-item__price--active");
        })
      })
    });
  }

  const keyToGroupKey = (key) => {
    switch(key){
      // Elastix search
      // Note: to have these namings (metafields.xxxx), Filter labels must be exactly the same as metafield names
      case "metafields.frame_genders":
      case "metafields.frame_genders[]":
        return "metafields-frame_genders";
      case "metafields.frame_materials":
      case "metafields.frame_materials[]":
        return "metafields-frame_materials";
      case "metafields.frame_shape":
      case "metafields.frame_shape[]":
        return "metafields-frame_shape";
      case "variants.metafields.frame_colors":
      case "variants.metafields.frame_colors[]":
        return "variants-metafields-frame_colors";

      // Common
      case "available":
      case "available[]":
        return "available";
      case "vendor":
      case "vendor[]":
        return "vendor";
      case "filter.v.price.lte":
        return "price_lte";
      case "filter.v.price.gte":
        return "price_gte";
      case "sort_by":
      case "sort_by[]":
        return "sort";
      case "digitalized":
      case "digitalized[]":
        return "digitalized";
      case "product_type":
        case "product_type[]":
          return "product_type";
    }
  }

  const filtersMap = {
    price_gte: "filter.v.price.gte",
    price_lte: "filter.v.price.lte",
    digitalized: "digitalized",
    sort: "sort_by",
    available: "available",
    "metafields-frame_genders": "metafields.frame_genders",
    "product_type": "product_type",
    vendor: "vendor",
    "variants-metafields-frame_colors": "variants.metafields.frame_colors",
    "metafields-frame_shape": "metafields.frame_shape",
    "metafields-frame_materials": "metafields.frame_materials"
  }

  const resetScroll = () => {
    const values = document.querySelectorAll(".filter-group__values");
    const list = document.querySelectorAll(".filter-group__list");

    values.forEach(group => {
      group.scrollTop = 0;
    });

    list.forEach(group => {
      group.scrollTop = 0;
    });
  }

  const localeSort = (a, b) =>{
    return a.localeCompare(b);
  }

  /* Reset brand searchbars after each reloading */

  const resetBrandSearchBar = () => {
    const brandSearchBars = document.querySelectorAll("input[id='filter-bar-brand-searchbar']");
    brandSearchBars.forEach(bar => bar.value = '');
  }

  /*
    This function finds the last option in the group list and identify it as last for css purpose (border-radius effect when option is selected).
    This is especially necessary for the brand filter with the use of the search toolbar, because the list is dynamically changed visually.
  */

  const setCssForLastoptions = () => {
    const fullBrandGroupList = document.querySelector(".filter-group__list.brand");

    for (var index = (fullBrandGroupList.children.length -1); index >=0 ; index--)
    {
      const brandNode = fullBrandGroupList.children[index];
      const liClasses = brandNode.classList.value;
      // Do not consider "hidden" li options. If the first not "hidden" node is found, this is the latest visible node in the list.
      if(liClasses.indexOf('hidden') === -1 )
      {
        brandNode.classList.add('lastest');
        break;
      }
    }
  }

  var strings$8 = window.theme.strings.filterLabels;
  const renderFilters = (filters, params = {}) => {
    const texts = window["collectionTexts"];
    const isFrench = document.documentElement.getAttribute("lang") === "fr";

    const q = (selector) => document.querySelector(selector);
    const keyToElem = (key) => {
      switch(key){
        case "available":
          return [
            q("#availability .filter-group__list") ?? q("#disponibilite .filter-group__list"),
            q("#drawer-group-availability .filter-drawer__list") ?? q("#drawer-group-disponibilite .filter-drawer__list")
          ];
        case "metafields.frame_genders":
          return [
            q("#frame-genders .filter-group__list") ?? q("#genres .filter-group__list"),
            q("#drawer-group-frame-genders .filter-drawer__list") ?? q("#drawer-group-genres .filter-drawer__list")
          ];
        case "metafields.frame_materials":
          return [
            q("#frame-materials .filter-group__list") ?? q("#materiau .filter-group__list"),
            q("#drawer-group-frame-materials .filter-drawer__list") ?? q("#drawer-group-materiau .filter-drawer__list")
          ];
        case "metafields.frame_shape":
          return [
            q("#frame-shape .filter-group__list") ?? q("#forme .filter-group__list"),
            q("#drawer-group-frame-shape .filter-drawer__list") ?? q("#drawer-group-forme .filter-drawer__list")
          ];
        case "variants.metafields.frame_colors":
          return [
            q("#frame-colors .filter-group__list") ?? q("#couleur .filter-group__list"),
            q("#drawer-group-frame-colors .filter-drawer__list") ?? q("#drawer-group-couleur .filter-drawer__list")
          ];
        case "vendor":
          return [
            q("#brand .filter-group__list") ?? q("#marque .filter-group__list"),
            q("#drawer-group-brand .filter-drawer__list") ?? q("#drawer-group-marque .filter-drawer__list")
          ];
        default:
          return [null, null];
      }
    }

    for(let filterKey in filters){
      let groupFilter = filters[filterKey];
      let groupHTML = "";
      
      let [groupElem, mobileGroupElem] = keyToElem(filterKey);

      let translatedKeys = Object.keys(groupFilter);

      if(isFrench){
        translatedKeys = translatedKeys.map(key => {
          return texts[key] ? texts[key] : key;
        });
      }
      
      let counterLiTags = 0;
      translatedKeys
        .sort(localeSort)
        .forEach((translatedItem) => {
          let item = Object.keys(texts).find(key => texts[key] === translatedItem);
          if(!item) item = translatedItem;
          
          if(!groupFilter[item]) return;

          let { doc_count, key } = groupFilter[item];

          let text = key;

          if(key == "0" || key == 0) text = strings$8.available_in_store;
          if(key == "1" || key == 1) text = strings$8.available_online;

          const isChecked = params[keyToGroupKey(filterKey)] && params[keyToGroupKey(filterKey)].includes(key);

          let filterItemHTML = '';
          if(doc_count > 0){
            ++counterLiTags;

            const isLastest = (counterLiTags == translatedKeys.length);
            filterItemHTML = `
            <li class="filter-item ${isChecked ? "selected" : ""} ${isLastest ? "lastest" : ""}">
              <label data-filter-item="" class="filter-item__content">
                <input
                  type="checkbox"
                  name="${filterKey}"
                  value="${key}"
                  class="filter-item__checkbox visually-hidden"
                  ${isChecked ? "checked" : ""}
                >
      
                <div class="filter-item__content-inner">
                  <div class="filter-input__input">
                    <span class="icon icon-new icon-checkmark ">
                      <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="m1.88 11.988 6.21 6.103L22.467 3.83" stroke="currentColor" stroke-width="3.055"></path></svg>
                    </span>
                  </div>
                  <span class="filter-item__label">
                    ${ isFrench ? (texts[text] ? texts[text] : text) : text}
                  </span>
                  <span class="filter-item__count fs-body-75">
                    (${doc_count})
                  </span>
                  ${isChecked ? '<div class="filter-item__checkmark"><span class="checkmark"></span></div>' : ''}
                </div>
              </label>
            </li>
            `;
          }

          groupHTML += filterItemHTML;
        });

      if(groupElem){
        groupElem.innerHTML = groupHTML;
      }
      if(mobileGroupElem){
        mobileGroupElem.innerHTML = groupHTML;
      }

      resetScroll();
      resetBrandSearchBar();
      setCssForLastoptions();
    }
    // -------------------
    // Brand Search Bars
    // -------------------
    const brandSearchBars = document.querySelectorAll("input[id='filter-bar-brand-searchbar']");
    brandSearchBars.forEach(bar => bar.addEventListener("input", function(e){
      // Note: The list of brands should be always available in case searched text is modified/removed
      // Therefore the brands that do not match the search have to be hidden only (NOT REMOVED from the DOM) 

      // Get current searched text
      const searchedText = this.value.toUpperCase().trim();

      // Get current full filter group list (fresh list after each letter entered)
      const fullBrandGroupList = document.querySelector(".filter-group__list.brand");

      // get wrapper for mobile group list
      const mobileBrandListWrapper = document.querySelector(".filter-drawer__list.brand");

      // Get all brands labels from group list
      const allBrandLabels = fullBrandGroupList.querySelectorAll(".filter-item__label");

      let newBrandGroupList = '';
      allBrandLabels.forEach((brandNode) => {
        // Get brand label
        let brandLabel = brandNode.innerText.toUpperCase().trim();
        // Warning: when second letter is entered, as we get again all brands at the beginning of filter rendering,
        // we have html tags <mark> coming from the first entered letter. So we need to clean brand label from any HTML tags
        brandLabel = brandLabel.replace( /(<([^>]+)>)/ig, '');
        // Moreover newlines are added automatically by javascript after each HTML tags. That means newlines are added after having inserted <mark> tag
        // ex: content of innerHTML attribute for a brand node object:
        //     <label data-filter-item=\"\" class=\"filter-item__content\">\n                <input type=\"checkbox\" name=\"vendor\" value=\"ARGOS\" class=\"filter-item__checkbox visually-hidden\" checked=\"\">\n      \n       .....
        // So we need to remove as well newlines and carriage returns.
        brandLabel = brandLabel.replace(/\r?\n|\r/g, "");

        // Get LI node
        const liOptionNode = brandNode.parentNode.parentNode.parentNode;

        if(searchedText != "")
        {
            // In our current case it is very faster to make the following string comparison instead of using indexOf() or Regex with match()
            // due to the simplicity of comparison that has to be done. Moreover it avoids the use of an additional function as replaceAll() after testing.
            // Method #1: All occurences in string
            // const newBrandLabel = brandLabel.split(searchedText).join('<mark>'+searchedText+'</mark>');
            // Method #2: First occurence in string (beginning of string)
            let newBrandLabel = brandLabel;
            if(brandLabel.substr(0, searchedText.length) == searchedText){
              newBrandLabel = '<mark>'+searchedText+'</mark>' + brandLabel.substr(searchedText.length);
            }
            // Comparison
            if(newBrandLabel !== brandLabel){
              // Matched... highlight searched text in brand label
              liOptionNode.classList.remove("hidden");
              brandNode.innerHTML = newBrandLabel;
            }else{
              // Does NOT matched
              liOptionNode.classList.add("hidden");
            }
        }
        else
        {
          // Reset options display if the search bar is empty.
          // Remove mark HTML tags from the lastest entered letter.
          liOptionNode.classList.remove("hidden");
          brandNode.innerHTML = brandLabel;
        }
        newBrandGroupList += liOptionNode.outerHTML; // add li tag before concat
      });
      fullBrandGroupList.innerHTML = newBrandGroupList;
      mobileBrandListWrapper.innerHTML = newBrandGroupList;

      setCssForLastoptions();
    }));
  }

  const updateURLState = () => {
    const form = window.innerWidth > 768 ? document.querySelector("form.filter-bar") : document.querySelector("form.filter-drawer");
    const formData = new FormData(form);
    const formDataObj = {};

    const priceMinInput = document.querySelector("input[name='filter.v.price.gte']");
    const priceMaxInput = document.querySelector("input[name='filter.v.price.lte']");
    const min = +priceMinInput.getAttribute("min");
    const max = +priceMaxInput.getAttribute("max");

    formData.forEach((value, key) => {
      if((key == filtersMap.price_gte && (+value == min || value == 0)) || (key == filtersMap.price_lte && (+value == max || !value))){
        return;
      }

      if(key == filtersMap.digitalized && (value == false || value == "false")) return;

      if(formDataObj[key] && !Array.isArray(formDataObj[key])){
        formDataObj[key] = [formDataObj[key], value];
      }
      else if(Array.isArray(formDataObj[key])) formDataObj[key].push(value);
      else formDataObj[key] = value;
    });

    let url = new URL(window.location.href);
    let searchParams = new URLSearchParams(url.search);

    if (searchParams.has('product_type')) {
      formDataObj['product_type'] = searchParams.get('product_type');
    }
    formDataObj.page = pagination.getCurrentPageNumber();

    const params = buildQueryParams(formDataObj);

    history.pushState(null, null, `${window.location.pathname}${params && `?${params}`}`);
  }
  
  const updateGroupLabels = (params) => {
    const texts = window["collectionTexts"];
    const isFrench = document.documentElement.getAttribute("lang") === "fr";

    const activeNodes = document.querySelectorAll(".filter-drawer__group-toggle--active, .filter-group__label-count-wrapper--active");
    const mobileFilterButtonCountContainer = document.querySelector(".mobile-filters__button-count");

    activeNodes.forEach(node => {
      node.classList.remove("filter-drawer__group-toggle--active");
      node.classList.remove("filter-group__label-count-wrapper--active");
    });

    const activeValuesList = document.querySelectorAll(".filter-group__values-active-values");
    activeValuesList.forEach(item => item.innerHTML = "");

    /* Make label active\inactive */

    const doSwitch = ({
      number,
      container,
      renderNumber,
      activeClassName = "filter-group__label-count-wrapper--active",
      numberSelector = ".filter-group__label-count"
    }) => {
      if(!container) return;
      
      if(number){
        container.classList.add(activeClassName);
        if(renderNumber) container.querySelector(numberSelector).innerHTML = number;
      }else{
        container.classList.remove(activeClassName);
      }
    }

    let activeFiltersCount = 0;

    for(let key in params){
      let group = params[key];

      if(Array.isArray(group)){
        group = group.map(item => {
          if(item == "0") return strings$8.available_in_store;
          if(item == "1") return strings$8.available_online;
          return item;
        })
      }

      if(!group) return;

      let number = group.length;
      let container;
      let mobileContainer;
      let renderNumber = true;

      if(key != "sort" && key != "price_gte" && key != "price_lte"){
        !!number && (activeFiltersCount += number) 
      }

      if(key == "price_gte" || key == "price_lte"){
        const minInput = document.querySelector("input[name='filter.v.price.gte']");
        const maxInput = document.querySelector("input[name='filter.v.price.lte']");
        const minPrice = +minInput.getAttribute("min");
        const maxPrice = +maxInput.getAttribute("max");
        
        if((+params["price_gte"] === minPrice || !params["price_gte"]) && (+params['price_lte'] === maxPrice || !params['price_lte'])){
          number = 0;
        }
      }

      switch(key){
        case "available":
          container = document.querySelector('[aria-controls="availability"] .filter-group__label-count-wrapper');
          mobileContainer = document.querySelector('.filter-drawer__group-toggle[data-drawer-group-toggle="availability"]');
        break;
        case "metafields-frame_genders":
          container = document.querySelector('[aria-controls="frame-genders"] .filter-group__label-count-wrapper');
          mobileContainer = document.querySelector('.filter-drawer__group-toggle[data-drawer-group-toggle="frame-genders"]');
        break;
        case "vendor":
          container = document.querySelector('[aria-controls="brand"] .filter-group__label-count-wrapper');
          mobileContainer = document.querySelector('.filter-drawer__group-toggle[data-drawer-group-toggle="brand"]');
        break;
        case "price_gte":
        case "price_lte":
          container = document.querySelector('[aria-controls="price"] .filter-group__label-count-wrapper');
          mobileContainer = document.querySelector('.filter-drawer__group-toggle[data-drawer-group-toggle="price"]');
          renderNumber = false;
        break;
        case "variants-metafields-frame_colors":
          container = document.querySelector('[aria-controls="frame-colors"] .filter-group__label-count-wrapper');
          mobileContainer = document.querySelector('.filter-drawer__group-toggle[data-drawer-group-toggle="frame-colors"]');
        break;
        case "metafields-frame_shape":
          container = document.querySelector('[aria-controls="frame-shape"] .filter-group__label-count-wrapper');
          mobileContainer = document.querySelector('.filter-drawer__group-toggle[data-drawer-group-toggle="frame-shape"]');
        break;
        case "metafields-frame_materials":
          container = document.querySelector('[aria-controls="frame-materials"] .filter-group__label-count-wrapper');
          mobileContainer = document.querySelector('.filter-drawer__group-toggle[data-drawer-group-toggle="frame-materials"]');
        break;
        case "product_type":
          container = document.querySelector('[aria-controls="product_type"] .filter-group__label-count-wrapper');
          mobileContainer = document.querySelector('.filter-drawer__group-toggle[data-drawer-group-toggle="product_type"]');
        break;
      }
      
     mobileFilterButtonCountContainer.innerHTML= activeFiltersCount ?  `(${activeFiltersCount})` : "";
      doSwitch({
        number,
        container,
        renderNumber
      });
      doSwitch({
        number,
        container: mobileContainer,
        renderNumber,
        activeClassName: "filter-drawer__group-toggle--active",
        numberSelector: ".filter-drawer__group-toggle-count"
      });
    }

    const totalCountWrapper = document.querySelector(".filter-drawer__title");
    const totalCountElem = document.querySelector(".filter-drawer__title-count");
    if(totalCountElem) totalCountElem.innerHTML = activeFiltersCount;
    
    if(totalCountWrapper){
      if(activeFiltersCount) totalCountWrapper.classList.add("filter-drawer__title--active");
      else totalCountWrapper.classList.remove("filter-drawer__title--active");
    }
  }

  const renderFilterPills = (filters) => {
    const container = document.querySelector(".filter-bar__active-filters");
    const texts = window["collectionTexts"];
    let html = "";
    const isFrench = document.documentElement.getAttribute("lang") === "fr";

    const buildPill = ({ paramKeyLabel, text, value }) => (`
    <span
      class="active-filters__active-filter fs-body-75 no-transition"
      data-remove-filter
      data-value="${value}"
    >
      <span class="active-filters__label">${paramKeyLabel}:</span>
      ${ isFrench ? (texts[text] ? texts[text] : text) : text }
      <span class="icon icon-new icon-close-small ">
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4.717 1.975 3.347.605.604 3.346l1.37 1.37 2.742-2.74zm14.566 20.05 1.37 1.37 2.742-2.741-1.37-1.37-2.742 2.74zm2.742-17.308 1.37-1.37L20.654.604l-1.37 1.37 2.74 2.742zM1.975 19.283l-1.37 1.37 2.741 2.742 1.37-1.37-2.74-2.742zm0-14.566 8.654 8.654 2.742-2.742-8.654-8.654-2.742 2.742zm11.396 8.654 8.654-8.654-2.742-2.742-8.654 8.654 2.742 2.742zm-2.742-2.742-8.654 8.654 2.742 2.741 8.654-8.653-2.742-2.742zm0 2.742 8.654 8.653 2.742-2.74-8.654-8.655-2.742 2.742z" fill="currentColor"></path></svg>
      </span>
    </span>
    `);

    let priceRendered = false;

    // Example of "filters" content:
    // {"sort":["digitalized:desc","available:desc","best_selling:desc","discounted:desc"],"price_gte":["69"],"price_lte":["345"],"variants-metafields-frame_colors":["Black"],"metafields-frame_shape":["Aviator"]}
    let numberOfFilters = null;
    for(let key in filters){
      if(key == "undefined") continue;
      if(key == "page") continue;

      let filter = filters[key];
      const minInput = document.querySelector("input[name='filter.v.price.gte']");
      const maxInput = document.querySelector("input[name='filter.v.price.lte']");
      const minPrice = +minInput.getAttribute("min");
      const maxPrice = +maxInput.getAttribute("max");

      // --------------------
      // case of key for price
      // --------------------
      if((key == "price_gte" || key == "price_lte") && !priceRendered){
        if((+filters["price_gte"] === minPrice || !filters["price_gte"]) && (+filters['price_lte'] === maxPrice || !filters['price_lte'])){
          continue;
        }

        const displayMinPrice = +(filters['price_gte'] ? filters['price_gte'] : minInput.getAttribute("min"));
        const displayMaxPrice = +(filters['price_lte'] ? filters['price_lte'] : maxInput.getAttribute("max"));

        const displayMinPriceCurrency = new Intl.NumberFormat(langCountry, { style: 'currency', currency: 'CAD' }).format( displayMinPrice);
        const displayMaxPriceCurrency = new Intl.NumberFormat(langCountry, { style: 'currency', currency: 'CAD' }).format( displayMaxPrice);


        const text = `${displayMinPriceCurrency} - ${displayMaxPriceCurrency}`;
        priceRendered = true;

        html += buildPill({
          paramKeyLabel: strings$8.price,
          text,
          value: "price"
        });
        continue;
      }

      if(key == "price_gte" || key == "price_lte" || key == "sort" || key == "digitalized") continue;

      // --------------------
      // Other keys
      // --------------------
      if(!Array.isArray(filter)) filter = [filter];
      // Here "filter" contains the value of the current key
      for(let inKey in filter){
        let value = filter[inKey];
        let text = value;
        if(value == "0" || value == 0) text = strings$8.available_in_store;
        if(value == "1" || value == 1) text = strings$8.available_online;

        let label = '';
        switch(key){
          case "metafields-frame_gender":           label = strings$8.gender;   break;
          case "metafields-frame_genders":           label = strings$8.gender;   break;
          case "product_type":                      label = strings$8.product_type;   break;
          case "vendor":                            label = strings$8.vendor;   break;
          case "variants-metafields-frame_colors":  label = strings$8.color;    break;
          case "metafields-frame_shape":            label = strings$8.shape;    break;
          case "metafields-frame_materials":        label = strings$8.material; break;
        }
         ++numberOfFilters
        html += buildPill({
          paramKeyLabel: label,
          text: text,
          value: value
        });
      }
    }
    if(html) html += `<span
    class="active-filters__active-filter active-filters__clear no-transition btn btn--text-link fs-body-75"
    data-clear-all-filters>
      <span>${texts['clearFilters']}</span>
    </span>`;

    if(container) container.innerHTML = html;
  }

  const enableDigitalized = (params) => {
    if(params[filtersMap.digitalized]){
      const toggle = document.querySelector(".filter-bar__try-on-toggle");
      toggle.classList.add("filter-bar__try-on-toggle--on");
    }
  }

  const init = async () => {
    /* Get params when we arrive on the page */

    const URLParams = fetchURLParams();
    const params = {
      sort: ["digitalized:desc", "available:desc", mapSortField(window["_sortBy"]), "discounted:desc"]
    };
    
    const per_page = window["collectionData"].numberOfItemsPerPage;
    const sort = params.sort ? params.sort : ["digitalized:desc", "available:desc", "best_selling:desc", "discounted:desc"];

    const collectionId =  window["collectionData"].id;
    const data = await fetchProducts({
      ...URLParams,
      sort,
      collectionId,
      per_page
    });
    
    const { meta, filters } = data;
    const html = buildProductsHTMLTemplate(data);
    addDataLayers_ProductClickEvent();
    
    if(data.meta.products_found){
      hideEmptyState();
      replaceHTML(html);
      initAnimation();
    }else displayEmptyState();

    renderFilters(filters, URLParams);
    updateMeta(meta);
    setupPriceMinMaxRange(filters, URLParams);
    enableDigitalized(URLParams);
    displayFoundProductsCounter(meta);
    renderFilterPills(URLParams);
    
    updateGroupLabels(URLParams);
    initHandlers();
    pagination.init(meta, getPaginationPageContent)
    pagination.initActionFunction(meta.page)
    // await onScroll();
  };

  let changeTimer;

  const onFormChange = async (allowExecution = false) => {
    if(!allowExecution){
      if(changeTimer) clearTimeout(changeTimer);

      changeTimer = setTimeout(() => {
        onFormChange(true);
      }, 450);
      return;
    }

    const collectionContent = document.querySelector(".collection__content");
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    if(scrollTop > window.innerHeight) window.scrollTo(0, 0);

    collectionContent.classList.add("collection__content--blocked");
    closeSortGroup();

    /* Get params when we change filters */

    const params = collectFormParams();
    const collectionId = window["collectionData"].id;
    const page = 1;
    const per_page = window["collectionData"].numberOfItemsPerPage;
    const sort = ["digitalized:desc", "available:desc", "best_selling:desc", "discounted:desc"];
    
    const data = await fetchProducts({
      sort,
      ...params,
      collectionId,
      page,
      per_page
    });
    collectionContent.classList.remove("collection__content--blocked");
    const { meta, filters } = data;
    renderFilters(filters, params);
    pagination.init(meta, getPaginationPageContent)
    updateURLState();
    await updateMeta(meta);
    updateGroupLabels(params);
    displayFoundProductsCounter(meta);
    renderFilterPills(params);
    const html = buildProductsHTMLTemplate(data);
    addDataLayers_ProductClickEvent();
    
    if(data.meta.products_found > 0){
      hideEmptyState();
      replaceHTML(html);
      initAnimation();
    }else if(page == 1) displayEmptyState();

    // await onScroll();
    // await onScroll();
  }

  const isCollectionPage = window["collectionData"];

  if(isCollectionPage) init();

  return {
    onFormChange,
    fetchProducts
  }
}
// END customCatalogInit

const productPageVTOModelsInit = () => {
  const getSKU = () => {
    let sku;

    const elem = document.querySelector("#ProductVariantPerColor");

    const urlParams = new URLSearchParams(window.location.search);
    sku = urlParams.get('sku');
    const variant = +urlParams.get('variant');

    if(!elem) return sku;

    const variants = JSON.parse(elem.innerHTML);

    if(!sku && variants){
      if(!variant){
        sku = variants["variants"][0].sku;
      }else{
        let variantActive = variants["variants"].find(x => x.id === variant);

        if(variantActive) sku = variantActive.sku;
      }
    }

    return sku;
  }

  const buildHTML = (models, sku) => {
    if(!models) return "";

    return `
  <div class="topology-models__main-frame below-mobile">
    <div class="topology-models__frames-item">
      <div class="topology-models__frames-inner">
        <iframe
          class="topology-models__frames-frame"
          src="https://nll-widget.topology-engineering.com/v0/model/${ models[0].name }?sku=${sku}&hint=false"
        ></iframe>
      </div>
    </div>
  </div>
<div class="topology-models__frames below-mobile">
  ${
    models.map(({ name, previewUrl }) => {
      let imgURL = previewUrl;

      return `
        <div class="topology-models__frames-item">
          <div class="topology-models__frames-inner">
            <img
              class="topology-models__frames-frame"
              data-model="${name}"
              src="${imgURL}"
            >
          </div>
        </div>`;
    }).join("")
  }
</div>

<div class="topology-models__frames above-mobile">
  ${
    models.map(({ name }) => {
      return `
        <div class="topology-models__frames-item">
          <div class="topology-models__frames-inner">
            <iframe
              class="topology-models__frames-frame"
              src="https://nll-widget.topology-engineering.com/v0/model/${ name }?sku=${sku}&hint=false"
            ></iframe>
          </div>
        </div>`;
    }).join("")
  }
</div>
    `;
  }

  const onImageClick = function(){
    const model = this.dataset.model;
    const frames = document.querySelectorAll(".topology-models__main-frame.below-mobile iframe");

    frames.forEach(frame => {
      const searchParams = new URLSearchParams(frame.src.split("?")[1]);
      const sku = searchParams.get("sku");

      frame.src = `https://nll-widget.topology-engineering.com/v0/model/${model}?sku=${sku}&hint=false`;
    })
  }

  const setHandlers = () => {
    const imagesOnMobile = document.querySelectorAll(".topology-models__frames.below-mobile img");

    imagesOnMobile.forEach(image => {
      image.addEventListener("click", onImageClick);
    })
  }

  const displayModels = (models, sku) => {
    if(!models) return;

    const accordion = document.querySelectorAll('[data-heading="Find your fit"], [data-heading="Trouvez votre paire"], .accordion:last-child');
    
    if(!accordion.length) return;

    const html = buildHTML(models, sku);

    accordion.forEach(item => { 
      const container = item.querySelector(".accordion__content");
      container.innerHTML = html;
    })
  }

  const showAccordions = () => {
    const accordion = document.querySelectorAll('[data-heading="Find your fit"], [data-heading="Trouvez votre paire"], .accordion:last-child');
    
    accordion.forEach(item => {
      item.classList.remove("accordion--hidden");
    })
  }

  const hideAccordions = () => {
    const accordion = document.querySelectorAll('[data-heading="Find your fit"], [data-heading="Trouvez votre paire"], .accordion:last-child');
    
    accordion.forEach(item => {
      item.classList.add("accordion--hidden");
    })
  }

  const init = async () => {
    const isProductPage = document.querySelector(".product__breadcrumbs");

    if(!isProductPage) return;

    const sku = await getSKU();
    const models = await getVTOModels(sku);

    if(models && models.length){
      displayModels(models, sku);
      showAccordions();
      setTimeout(() => {
        setHandlers();
      }, 0);
    }else{
      hideAccordions();
    }
  }

  init();

  return {
    init
  }
}

const recommendedProductsInit = () => {
  const fetchRecommendedProducts = async ({
    productType,
    productId
  }) => {
    const collectionId = 0;
    const guestScan = JSON.parse(localStorage.getItem("guest_scan"));
    const args = {
      product_type: productType,
      sort: "shuffle",
      per_page: 10,
      exclude_id: productId
    }
    if (productType != "Bluelight") {
      args.recommended = true;
      args.digitalized = true;
    }
    if (guestScan?.id && guestScan?.has_scan ) args.guest_id = guestScan.id;
    const paramsString = buildQueryParams(args);
    const data = await getCollection(collectionId, paramsString)

    return data;
  }

  const fetchHTML = async ({ products }) => {
    if(!products) return "";

    let handles = [];

    products.forEach(({ handle }) => {
      handles.push(handle);
    });

    if(!handles.length) return;

    const productHandles = handles.join(",");

    const recommendedTextUrl = `${window.location.protocol}//${window.location.host}${localeKey.length ? `/${localeKey}` : ""}/products/${handles[0]}/?section_id=get-recommended-text`;
    const productGridURL = `${window.location.protocol}//${window.location.host}/products/${handles[0]}/?section_id=get-recommended-products&handles=${productHandles}&locale=${locale}`;
    const productSectionHTML = await fetch(productGridURL);
    const recommendedText = await fetch(recommendedTextUrl);
    const textContainer = document.createElement("div");
    let textHTML = await recommendedText.text();
    textContainer.innerHTML = textHTML;
    const text = textContainer.querySelector(".shopify-section").innerHTML;
    let html = await productSectionHTML.text();

    const container = document.createElement("div");
    container.innerHTML = html;
    container.querySelector(".recommended-products-block__title").innerHTML = text;
    const section = container.querySelector(".shopify-section");

    if(!section) return "";

    html = section.innerHTML;
    
    return html;
  }

  const displayProducts = (html, container) => {
    return new Promise((resolve, reject) => {
      container.innerHTML = html;

      setTimeout(() => {
        const block = document.querySelector(".recommended-products-block");
        block.classList.add("recommended-products-block--active");
        resolve();
      }, 0);
    });
  }

  const getProductJSON = () => {
    const container = document.querySelector("[data-product-json]");

    if(!container) return null;

    const json = JSON.parse(container.innerHTML);

    return json;
  }

  const initSlider = () => {
    new Swiper('.recommended-products-block .swiper', {
      direction: 'horizontal',
      loop: false,
      slidesPerView: 1.55,
      autoHeight: true,
      spaceBetween: 30,
      navigation: {
        nextEl: '.recommended-products-block .swiper-button-next',
        prevEl: '.recommended-products-block .swiper-button-prev',
      },
      breakpoints: {
        769: {
          slidesPerView: 4,
          spaceBetween: 50
        }
      }
    });
  }

  const setItemsListeners = () => {
    const items = document.querySelectorAll(".product-item");

    items.forEach((item) => {
      let swatches = item.querySelectorAll(".product-swatches-options__item--swatch");
      let secondImage = item.querySelectorAll(".product-item__image--two");

      const enterItemAnimation = () => {
        secondImage.forEach((image) => {
          image.classList.add("active");
        })
      }

      const leaveItemAnimation = () => {
        secondImage.forEach((image) => {
          image.classList.remove("active");
        })
      }
    
      item.addEventListener("mouseenter", enterItemAnimation);
      item.addEventListener("mouseleave", leaveItemAnimation);

      swatches.forEach(swatch => {
        let selectedClassName = "product-swatches-options__item--selected";
    
        swatch.addEventListener("mouseenter", function(e){
          e.stopPropagation();
          const selected = item.querySelector(`.${selectedClassName}`);
          const color = this.dataset.color;
          const sku = this.dataset.sku;
          item.querySelector('.product-item__images.active').classList.remove("active");
          item.querySelector(`.product-item__images--${sku}`).classList.add("active");
    
          if(selected) selected.classList.remove(selectedClassName);
    
          this.classList.add(selectedClassName);
          const productWrapper = this.parentNode.parentNode.parentNode.parentNode.parentNode;
          const link = productWrapper.querySelector("a");
    
          link.href = link.dataset[color.replace(/-/g, "")] ?? link.dataset.href;

          const activePrice = productWrapper.querySelector(".product-item__price--active");
          if(activePrice) activePrice.classList.remove("product-item__price--active");
          const newPrice = productWrapper.querySelector(`.product-item__price[data-sku="${sku}"]`);
          if(newPrice) newPrice.classList.add("product-item__price--active");
        })
      })
    });
  }

  const init = async () => {
    const json = getProductJSON();

    if(!json) return;

    const { id, type } = json;
    
    const products = await fetchRecommendedProducts({
      productType: type,
      productId: id
    });

    if(!products) return;

    const html = await fetchHTML(products);
    const targetBlock = document.querySelector(".recommended-products-block")
    const targetSection = targetBlock ? targetBlock.parentNode : null;

    if(html && targetSection){
      await displayProducts(html, targetSection);
      initSlider();
      setItemsListeners();
    }
  }

  init();
}

const setLocalStorageValues = () => {
  const names = {
    has_prescription: "has_prescription",
    has_scan: "has_scan"
  };

  const setHasPrescription = async () => {
    const prescriptions = await getPrescription();
    const atLeastOneNotExpired = prescriptions?.length && prescriptions.some(i => new Date(i.validUntil) > new Date());

    if(atLeastOneNotExpired) window.localStorage.setItem(names.has_prescription, true);
    else window.localStorage.removeItem(names.has_prescription);
  };

  const setHasScan = async () => {
    const customerId = window['customerInfo']['id'];
    const scan = await getCustomerScan(customerId);

    if(scan && scan.route){
      window.localStorage.setItem(names.has_scan, true);
    }
    else window.localStorage.removeItem(names.has_scan);
  }

  const init = async () => {
    setHasPrescription();
    setHasScan();
  };

  init();
}

const redirectAfterLoggedIn = () => {
  const saveURL = (url) => {
    window.localStorage.setItem("loginRedirectURL", url);
  };

  const getURL = () => {
    return window.localStorage.getItem("loginRedirectURL");
  }

  const clearURL = () => {
    window.localStorage.removeItem("loginRedirectURL");
  };

  const onClick = function(){
    const url = this.dataset.saveUrl;
    saveURL(url);
  }
  
  const setHandlers = () => {
    const items = document.querySelectorAll("[data-save-url]");

    items.forEach(item => {
      item.addEventListener("click", onClick);
    })
  }

  const init = () => {
    const pathname = window.location.pathname;
    const isLoginOrRegisterPage = pathname == "/account/login" || pathname == "/account/register";
    const isDashboardPage = pathname == "/account";
    setHandlers();

    if(isDashboardPage){
      const url = getURL();

      if(url == "open-my-presriptions"){
        prescriptionFlow.cartToCheckoutFlowInit();
      }else if(url){
        window.location.href = url;
      }
    }

    if(!isLoginOrRegisterPage && !isDashboardPage){
      clearURL();
    }
  };

  init();
}

const initLoginPageLinks = () => {
  const sectionLoginRegister = document.querySelector('[data-section-return="proxy"]');
  const isLoginPage =  document.querySelector('[data-section-type="login"]');
  if(!sectionLoginRegister) return;
  const LoginRegisterReturnTo = sectionLoginRegister.querySelector('[name="return_to"]');

  const urlParams = new URLSearchParams(window.location.search);
  const source = urlParams.get('source');

  let redirect = urlParams.get('redirect');

    const isBookingLink = (source == "booking");
    const environments = {
      devqa: "proxy-qa",
      staging_and_production: "proxy"
      };
    const env = window.location.href.indexOf("dev") !== -1 ? environments.devqa : environments.staging_and_production;

    const shopUrl = `https://${Shopify.shop}${localeKey.length ? `/${localeKey}` : ""}`;
    let referrerLink = btoa(`${shopUrl}/account/`);
    let returnTo = `/apps/${env}/shopify/login?`;

    const guestScan = JSON.parse(localStorage.getItem("guest_scan"));

    if(isLoginPage && isBookingLink) {
      referrerLink = urlParams.get('referrer');
      returnTo = returnTo.concat(`source=booking&`);
      if (guestScan?.has_scan && guestScan?.id) {
        returnTo = returnTo.concat(`guest_id=${guestScan.id}&`);
        redirect = returnTo.concat(`referrer=${btoa(`${shopUrl}/pages/my-prescriptions/`)}`);
      } else {
        redirect = returnTo.concat(`referrer=${referrerLink}`);
      }
    } 

    if(LoginRegisterReturnTo) {
      LoginRegisterReturnTo.value = redirect
    }


}

const setIOSClassName = () => {
  let isIOS = /iPad|iPhone|iPod/.test(navigator.platform)
|| (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);

  if(isIOS) document.body.classList.add("ios-device");
}

const onLogOutMessage = () => {
  const isLoggedOut = () => {
    const isLogOut = window.sessionStorage.getItem("is_logout");
    window.sessionStorage.removeItem("is_logout");

    return isLogOut == "true";
  }

  const init = () => {
    const userLoggedOut = isLoggedOut();

    if(userLoggedOut){
      const popup = document.querySelector(".signed-out-popup");
      if(popup){
        popup.classList.add("signed-out-popup--active");

        setTimeout(() => {
          popup.classList.remove("signed-out-popup--active");
        }, 5000)
      }
    }
  }

  init();
}

const setNoCacheLinks = () => {
  if(window['isLoggedIn']) return;

  const links = document.querySelectorAll('.header-menu__item[data-add-random-params="true"]');

  links.forEach(link => {
    const rand = Date.now();
    link.href += `&view=${rand}&type=${rand}`;
  })
}

customCatalog = customCatalogInit();

function initTogglePasswordVisibility() {
  
  const showPasswordButtons = document.querySelectorAll('[data-toggle-password-show]');
  const hidePasswordButtons = document.querySelectorAll('[data-toggle-password-hide]');

  function findNearestParentWithClass(element, className) {
    // Traverse up the DOM tree to find the nearest parent with the specified class
    while (element && !element.classList.contains(className)) {
        element = element.parentElement;
    }

    return element;
}

  const toggleVisibility = (e) => {
    const parrent = findNearestParentWithClass(e.target, 'label-float');
    const passwordInput = parrent.querySelector('input');
    const showPasswordButton = parrent.querySelector('[data-toggle-password-show]');
    const hidePasswordButton = parrent.querySelector('[data-toggle-password-hide]');
    passwordInput.type = passwordInput.type === 'password' ? 'text' : 'password';
    showPasswordButton.classList.toggle('hidden');
    hidePasswordButton.classList.toggle('hidden');
  };
  [...showPasswordButtons, ...hidePasswordButtons].forEach(button => button.addEventListener('click', toggleVisibility))
}



// Arrow function to update the position of quick search elements on mobile
const updateQuickSearchPosition = () => {
  // Get the header__inner element
  const headerInner = document.querySelector('.header__inner');
  // Get the quick-search__overlay element
  const quickSearchOverlay = document.querySelector('.quick-search__overlay');
  // Get the quick-search element
  const quickSearch = document.querySelector('.quick-search');

  // Check if header__inner element exists
  if (!headerInner) return;

  // Get the position of header__inner element from the top of the viewport
  const headerInnerPosition = headerInner.getBoundingClientRect();
  // Calculate the distance from header__inner to the top of the screen
  let distanceFromTop = headerInnerPosition.top + headerInnerPosition.height;

  // If screen width is greater than 959px
  if (window.innerWidth > 959) {
      // If quick-search__overlay element exists, set its top position
      if (quickSearchOverlay) {
        quickSearchOverlay.style.removeProperty("top");
    }

    // If quick-search element exists, set its top position
    if (quickSearch) {
        quickSearch.style.removeProperty("top");
    }
  } else {
    // If quick-search__overlay element exists, set its top position
      if (quickSearchOverlay) {
        quickSearchOverlay.style.top = `${distanceFromTop}px`;
    }

    // If quick-search element exists, set its top position
    if (quickSearch) {
        quickSearch.style.top = `${distanceFromTop}px`;
    }
  }

  
}

function initAnchorLinkUpdate() {
  let navLinks = document.querySelectorAll('[data-fixed-navigation-link]');
  let sections = document.querySelectorAll('[data-section-type="rich-text"]');

  // Function to set active navigation link based on sectionId
  function setActiveNavLink(sectionId) {
    navLinks.forEach(function(navLink) {
      if (navLink.getAttribute('href').slice(1) === sectionId) {
        navLink.classList.add('active');
      } else {
        navLink.classList.remove('active');
      }
    });
  }

  // Function to handle scroll events
  function onScroll() {
    // Scrolling up
    let closestSection;
    let closestDistance = Number.POSITIVE_INFINITY;

    // Find the closest section to the top of the viewport
    sections.forEach(function(section) {
      let bounding = section.getBoundingClientRect();
      let distance = Math.abs(bounding.top);
      if (distance < closestDistance) {
        closestDistance = distance;
        closestSection = section;
      }
    });

    // Set active navigation link for the closest section
    if (closestSection) setActiveNavLink(closestSection.id);
  }

  let ticking = false;

  // Add scroll event listener
  window.addEventListener('scroll', function() {
    // Use requestAnimationFrame for smooth scrolling
    if (!ticking) {
      window.requestAnimationFrame(function() {
        onScroll();
        ticking = false;
      });
    }
    ticking = true;
  });

}

const initContactFormInputs = () => {
  const contactForm = document.querySelector('.contact-form__form');
  const addPrescription = document.querySelector(".my-prescriptions__list-item--add");

  if (!contactForm || addPrescription) return
  

  const selects = document.querySelectorAll("[data-select]");

  if(!window.niceSelectInstances) window.niceSelectInstances = [];

  selects.forEach(select => {
    const instance = NiceSelect.bind(select);
    window.niceSelectInstances.push(instance);
  });
}

const initSliderPrescriptionExample = () => {
  const prescriptionExampleSliderWrapper =  document.querySelector(".prescription-example-slider");
  if (!prescriptionExampleSliderWrapper) return
    new Carousel(prescriptionExampleSliderWrapper, {
      direction: 'horizontal',
      loop: false,
      slidesPerView: 1,
      spaceBetween: 48,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      pagination: {
        el: ".swiper-pagination",
        clickable: false,
      },
    });
  }

const noScanPopupInit = () => {
  const popup = document.querySelector(".no-scan-popup");
  if (!popup) return;
  
  const closeBtn = popup.querySelector(".purchase-flow-popup__close");

  if (closeBtn) {
    closeBtn.addEventListener("click", () => {
      popup.classList.remove("no-scan-popup--active");
    });
  }
}

/* ===== START PRESCRIPTION SET =====*/
const setPrescriptionIdAttribute = () => {
  const prescriptionIdInput = document.querySelectorAll("[data-prescription-id]");
  let prescriptionId = +window.localStorage.getItem("prescriptionId");

  prescriptionIdInput.forEach(input => {
    if(prescriptionId){
      input.value = window.localStorage.getItem("prescriptionId");
    }
  })
}

/* ===== END PRESCRIPTION SET =====*/

document.addEventListener("DOMContentLoaded", async () => {
  initSliderPrescriptionExample()
  setIOSClassName();
  languageSwitcherInit();
  collapsibleBlocksInit();
  signUpPopupInit();
  vtoPopupInit = await VTOFlyOutPopupInit();
  userAccountPagesInit();
  accountInformationInit();
  initPasswordToggles();
  initHeaderMenu();
  // initLoginForm();
  // initRegistrationForm();
  reorderContactLensesInit();
  initBookAppointmentLink({ isOnInit: true });
  myScanPageInit();
  prescriptionFlow = await myPrescriptionsInit();
  initQuickRecentSearchList();
  const topologyWishlist = initTopologyWishlist();
  initWishlist(topologyWishlist);
  productScan = productPageScanInit(vtoPopupInit);
  vtoModels = productPageVTOModelsInit();
  scanBySku = productScan.scanBySku;
  recommendedProductsInit();
  noScanPopupInit();
  setLocalStorageValues();
  redirectAfterLoggedIn();
  initLoginPageLinks();
  onLogOutMessage();
  setNoCacheLinks();
  initTogglePasswordVisibility();
  setPrescriptionIdAttribute();
  // Event listener for scroll event
  window.addEventListener('scroll', updateQuickSearchPosition);
  initAnchorLinkUpdate();
  initContactFormInputs();
  document.querySelector("single-image-lightbox") && customElements.define('single-image-lightbox', ImageLightbox);
  document.querySelector("tab-manager") && customElements.define("tab-manager", TabsManager)
});